webpackJsonp([5],{

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 24/11/2013
 * Time: 15:53
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('CompanyMigrationSettings_Resource', ["$resource", "$location", function ($resource, $location) {
  var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
  return $resource(baseUrl + 'rest/company-migration-settings/:id', {}, {
    query: { method: 'GET', isArray: false },
    get: { method: 'GET' },
    displayBannerPopUp: { method: 'POST', url: baseUrl + 'rest/company-migration-settings/display-banner-pop-up' }
  });
}]);

angular.module('FlexyBeautyApp.services').factory('CompanyMigrationSettings', ["CompanyMigrationSettings_Resource", function (CompanyMigrationSettings_Resource) {
  var CompanyMigrationSettings = function CompanyMigrationSettings(resource) {
    this.companyCode = null;
    this.forceMigrationDate = null;
    this.migrationInformationDate = null;
    this.displayBannerPopUp = null;
    if (resource !== undefined && resource != null) {
      this.loadObject(resource);
    }
  };

  CompanyMigrationSettings.prototype.loadObject = function (object) {
    this.companyCode = object.companyCode;
    this.forceMigrationDate = object.forceMigrationDate;
    this.displayBannerPopUp = object.displayBannerPopUp;
    this.migrationInformationDate = object.migrationInformationDate;
  };
  return CompanyMigrationSettings;
}]);

angular.module('FlexyBeautyApp.services').factory('CompanyMigrationSettingsSrv', ["$log", "CompanyMigrationSettings_Resource", "CompanyMigrationSettingsData", "CompanyMigrationSettings", "ServerSrv", function ($log, CompanyMigrationSettings_Resource, CompanyMigrationSettingsData, CompanyMigrationSettings, ServerSrv) {
  var companyMigrationSettingsSrv = {};

  companyMigrationSettingsSrv.query = function (successFunction, errorFunction) {
    CompanyMigrationSettings_Resource.query({}, //params
    function (data) {
      CompanyMigrationSettingsData.companyMigrationSettings = new CompanyMigrationSettings(data);

      if (successFunction !== undefined) successFunction();
    }, function (data) {
      $log.error(data);
      if (errorFunction !== undefined) errorFunction(data);
    });
  };

  companyMigrationSettingsSrv.displayBannerPopUp = function (displayBannerPopUp, successFunction, errorFunction) {
    var companyMigrationSettingsResource = new CompanyMigrationSettings_Resource();
    companyMigrationSettingsResource.displayBannerPopUp = displayBannerPopUp;
    companyMigrationSettingsResource.$displayBannerPopUp({}, function () {
      try {
        if (successFunction != undefined) {
          successFunction();
        }
      } finally {
        ServerSrv.endSavingProcess(true);
      }
    }, function () {
      if (errorFunction != undefined) {
        errorFunction();
      }
    });
  };

  return companyMigrationSettingsSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('CompanyMigrationSettingsData', ["$log", function ($log) {
  var companyMigrationSettingsData = {
    companyMigrationSettings: null
  };
  companyMigrationSettingsData.getCompanyMigrationSettings = function () {
    return this.companyMigrationSettings;
  };

  return companyMigrationSettingsData;
}]);

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.Specification = __webpack_require__(215);
module.exports.SpecificationSync = __webpack_require__(214);


/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var config = {
    /* List all the roles you wish to use in the app
    * You have a max of 31 before the bit shift pushes the accompanying integer out of
    * the memory footprint for an integer
    */
    roles: ['public', 'user', 'admin'],

    /*
    Build out all the access levels you want referencing the roles listed above
    You can use the "*" symbol to represent access to all roles
     */
    accessLevels: {
        'public': "*",
        'anon': ['public'],
        'user': ['user', 'admin'],
        'admin': ['admin']
    }
};

/*
    Method to build a distinct bit mask for each role
    It starts off with "1" and shifts the bit to the left for each element in the
    roles array parameter
 */

function buildRoles(roles) {
    var bitMask = "01";
    var userRoles = {};

    for (var role in roles) {
        var intCode = parseInt(bitMask, 2);
        userRoles[roles[role]] = {
            bitMask: intCode,
            title: roles[role]
        };
        bitMask = (intCode << 1).toString(2);
    }

    return userRoles;
}

/*
This method builds access level bit masks based on the accessLevelDeclaration parameter which must
contain an array for each access level containing the allowed user roles.
 */
function buildAccessLevels(accessLevelDeclarations, userRoles) {

    var accessLevels = {};
    for (var level in accessLevelDeclarations) {

        if (typeof accessLevelDeclarations[level] === 'string') {
            if (accessLevelDeclarations[level] === '*') {
                var resultBitMask = '';
                for (var role in userRoles) {
                    resultBitMask += "1";
                }
                //accessLevels[level] = parseInt(resultBitMask, 2);
                accessLevels[level] = {
                    bitMask: parseInt(resultBitMask, 2),
                    title: accessLevelDeclarations[level]
                };
            }
        } else {
            var _resultBitMask = 0;
            for (var _role in accessLevelDeclarations[level]) {
                if (userRoles.hasOwnProperty(accessLevelDeclarations[level][_role])) {
                    _resultBitMask = _resultBitMask | userRoles[accessLevelDeclarations[level][_role]].bitMask;
                }
            }

            accessLevels[level] = {
                bitMask: _resultBitMask,
                title: accessLevelDeclarations[level]
            };
        }
    }

    return accessLevels;
};

var userRoles = buildRoles(config.roles);
var accessLevels = buildAccessLevels(config.accessLevels, userRoles);

var routingConfig = {
    userRoles: userRoles,
    accessLevels: accessLevels
};

exports.routingConfig = routingConfig;

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Specification base class
 * @class
 */
var Specification = {
  and: function(spec) {
    return new AndSpecification(this, spec);
  },
  or: function(spec) {
    return new OrSpecification(this, spec);
  },
  not: function(spec) {
    return new NotSpecification(spec);
  }
}


/**
 * And specification class
 * @class
 * @param {Specification} left  Specification
 * @param {Specification} right Specification
 */
function AndSpecification(left, right) {
  this.leftSpec = left;
  this.rightSpec = right;
}
AndSpecification.prototype = Object.create(Specification);
AndSpecification.prototype.isSatisfiedBy = function(obj) {
  var leftSat = false, rightSat = false;
  if (this.leftSpec && this.leftSpec.isSatisfiedBy) {
    leftSat = this.leftSpec.isSatisfiedBy(obj);
  }
  if (this.rightSpec && this.rightSpec.isSatisfiedBy) {
    rightSat = this.rightSpec.isSatisfiedBy(obj);
  }
  return leftSat && rightSat;
};


/**
 * Or specification class
 * @class
 * @param {Specification} left  Specification
 * @param {Specification} right Specification
 */
function OrSpecification(left, right) {
  this.leftSpec = left;
  this.rightSpec = right;
}
OrSpecification.prototype = Object.create(Specification);
OrSpecification.prototype.isSatisfiedBy = function(obj) {
  var leftSat = false, rightSat = false;
  if (this.leftSpec && this.leftSpec.isSatisfiedBy) {
    leftSat = this.leftSpec.isSatisfiedBy(obj);
  }
  if (this.rightSpec && this.rightSpec.isSatisfiedBy) {
    rightSat = this.rightSpec.isSatisfiedBy(obj);
  }
  return leftSat || rightSat;
};


/**
 * Not specification
 * @class
 * @param {Specification} spec  Specification
 */
function NotSpecification(spec) {
  this.spec = spec;
}
NotSpecification.prototype = Object.create(Specification);
NotSpecification.prototype.isSatisfiedBy = function(obj) {
  if (!this.spec || !this.spec.isSatisfiedBy) {
    return false;
  }
  return !this.spec.isSatisfiedBy(obj);
};


module.exports = Specification;


/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Specification base class
 * @class
 */
var Specification = {
  and: function(spec) {
    return new AndSpecification(this, spec);
  },
  or: function(spec) {
    return new OrSpecification(this, spec);
  },
  not: function(spec) {
    return new NotSpecification(spec);
  }
}


/**
 * And specification class
 * @class
 * @param {Specification} left  Specification
 * @param {Specification} right Specification
 */
function AndSpecification(left, right) {
  this.leftSpec = left;
  this.rightSpec = right;
}
AndSpecification.prototype = Object.create(Specification);
AndSpecification.prototype.isSatisfiedBy = function(obj, cb) {
  var self = this;
  if (self.leftSpec && self.leftSpec.isSatisfiedBy) {
    self.leftSpec.isSatisfiedBy(obj, function(err, satisfiesLeft) {
      if (self.rightSpec && self.rightSpec.isSatisfiedBy) {
        self.rightSpec.isSatisfiedBy(obj, function(err, satisfiedRight) {
          return cb(null, satisfiesLeft && satisfiedRight);
        });
      } else {
        return cb(null, false);
      }
    });
  } else {
    return cb(null, false);
  }
};


/**
 * Or specification class
 * @class
 * @param {Specification} left  Specification
 * @param {Specification} right Specification
 */
function OrSpecification(left, right) {
  this.leftSpec = left;
  this.rightSpec = right;
}
OrSpecification.prototype = Object.create(Specification);
OrSpecification.prototype.isSatisfiedBy = function(obj, cb) {
  var self = this;
  if (self.leftSpec && self.leftSpec.isSatisfiedBy) {
    self.leftSpec.isSatisfiedBy(obj, function(err, satisfiesLeft) {
      if (self.rightSpec && self.rightSpec.isSatisfiedBy) {
        self.rightSpec.isSatisfiedBy(obj, function(err, satisfiedRight) {
          return cb(null, satisfiesLeft || satisfiedRight);
        });
      } else {
        return cb(null, false);
      }
    });
  } else {
    return cb(null, false);
  }
};


/**
 * Not specification
 * @class
 * @param {Specification} spec  Specification
 */
function NotSpecification(spec) {
  this.spec = spec;
}
NotSpecification.prototype = Object.create(Specification);
NotSpecification.prototype.isSatisfiedBy = function(obj, cb) {
  if (!this.spec || !this.spec.isSatisfiedBy) {
    return false;
  }
  this.spec.isSatisfiedBy(obj, function(err, satisfies) {
    cb(err, !satisfies);
  });
};


module.exports = Specification;


/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _authorizationConfig = __webpack_require__(19);

//we load the library "search" even if we don't use it. The aim is to respect the order in the loading
//initialy, we shoud load the "visualize" library but in order to do the translation of the application
//we need to load this library after the local was get with angular


// Declare app level module which depends on filters, and services
angular.module('FlexyBeautyApp', ['ngResource', 'ngRoute', 'ngCookies', 'ngTouch', 'FlexyBeautyApp.filters', 'FlexyBeautyApp.services', 'FlexyBeautyApp.directives', 'FlexyBeautyApp.controllers', 'ui.bootstrap', 'ui.bootstrap.dropdownToggle' /* load  this file only for textangular*/
, 'ui.bootstrap.dialog', 'ui.bootstrap.bindHtml', 'ui.sortable', 'angularSpinner', 'ivpusic.cookie', 'infinite-scroll', 'flow', 'ui.slider', 'textAngular', 'angular-bugsnag', 'shoppinpal.mobile-menu', 'gettext', 'tmh.dynamicLocale', 'base64', 'anguFixedHeaderTable', 'ngSanitize', 'ngTagsInput', 'angularMoment', 'ngIdle']).config(['$compileProvider', '$routeProvider', '$locationProvider', '$httpProvider', '$logProvider', '$provide', 'tmhDynamicLocaleProvider', 'IdleProvider', 'Constants', function ($compileProvider, $routeProvider, $locationProvider, $httpProvider, $logProvider, $provide, tmhDynamicLocaleProvider, IdleProvider, Constants) {

    /* fix as angular.lowercase & angular.uppercase is removed from v1.7.x and breaking textAngular dependence */
    angular.lowercase = angular.$$lowercase;
    angular.uppercase = angular.$$uppercase;

    $compileProvider.debugInfoEnabled(false);
    $locationProvider.hashPrefix('');

    tmhDynamicLocaleProvider.localeLocationPattern('/lib/angular-i18n/angular-locale_{{locale}}.js');
    var access = _authorizationConfig.routingConfig.accessLevels;
    $logProvider.debugEnabled(false);
    $routeProvider.when('/app/:domain/:ssDomain', {
        templateUrl: 'partials/app.html',
        controller: 'AppCtrl',
        access: access.user,
        reloadOnSearch: false
    });
    $routeProvider.when('/app/:domain', {
        templateUrl: 'partials/app.html',
        controller: 'AppCtrl',
        access: access.user,
        reloadOnSearch: false
    });
    $routeProvider.when('/login', {
        templateUrl: 'partials/login.html',
        controller: 'LoginCtrl',
        access: access.anon
    });
    $routeProvider.when('/register', {
        templateUrl: 'partials/register.html',
        controller: 'LoginCtrl',
        access: access.anon
    });
    $routeProvider.when('/register/model', {
        templateUrl: 'partials/register.html',
        controller: 'LoginCtrl',
        access: access.anon
    });
    $routeProvider.when('/registerTranslate', {
        templateUrl: 'partials/registerTranslate.html',
        controller: 'LoginCtrl',
        access: access.anon
    });
    $routeProvider.when('/register/:offer', {
        templateUrl: 'partials/register.html',
        controller: 'LoginCtrl',
        access: access.anon
    });
    $routeProvider.when('/register/:offer/:manager', {
        templateUrl: 'partials/register.html',
        controller: 'LoginCtrl',
        access: access.anon
    });
    $routeProvider.when('/forgotPwd/:email/:token', {
        templateUrl: 'partials/forgotPwd.html',
        controller: 'ForgotPwdCtrl',
        access: access.anon
    });
    $routeProvider.when('/404', {
        templateUrl: 'partials/404.html',
        access: access.public
    });
    $routeProvider.when('/report/:idReport/:beginDayId/:endDayId/:dashboardId/:indexReport', {
        templateUrl: 'partials/statistics/report/reportAlone.html',
        access: access.user
    });
    /*$routeProvider.when('/dashboardSchedulerOverview/:dashboardTitle/:beginDayId/:endDayId/:dashboardId/:indexReport', {
        templateUrl:    'partials/statistics/report/overviewDashboardMail.html',
        access: access.public,
    });*/
    $routeProvider.otherwise({ redirectTo: '/app/planningPos' });

    $provide.decorator('taOptions', ['taRegisterTool', '$delegate', function (taRegisterTool, taOptions) {
        // $delegate is the taOptions we are decorating
        // register the tool with textAngular
        taRegisterTool('fontName', {
            display: "<span class='bar-btn-dropdown dropdown'>" + "<button class='btn btn-blue dropdown-toggle' type='button' ng-disabled='showHtml()' style='padding-top: 4px'><i class='fal fa-font'></i><i class='fal fa-angle-down'></i></button>" + "<ul class='dropdown-menu'><li ng-repeat='o in options'><button class='btn btn-blue checked-dropdown' style='font-family: {{o.css}}; width: 100%' type='button' ng-click='action($event, o.css)'><i ng-if='o.active' class='fal fa-check'></i >{{o.name}}</button></li></ul></span>",
            action: function action(event, font) {
                //Ask if event is really an event.
                if (!!event.stopPropagation) {
                    //With this, you stop the event of textAngular.
                    event.stopPropagation();
                    //Then click in the body to close the dropdown.
                    $("body").trigger("click");
                }
                return this.$editor().wrapSelection('fontName', font);
            },
            options: [{ name: 'Abril', css: "'Abril Fatface', cursive", size: 100 }, { name: 'Arial', css: "Arial, Helvetica, sans-serif", size: 100 }, { name: 'Arvo', css: "'Arvo', serif" }, { name: 'Comic Sans MS', css: "'comic sans ms', sans-serif", size: 95 }, { name: 'Damion', css: "'Damion', cursive", size: 110 }, { name: 'Droid Sans', css: "'Droid Sans', sans-serif", size: 100 }, { name: 'Parisienne', css: "'Parisienne', cursive", size: 110 }, { name: 'Georgia', css: 'georgia, serif', size: 100 }, { name: 'IM Fell French', css: "'IM Fell French Canon', serif", size: 100 }, { name: 'Josefin', css: "'Josefin Slab', serif", size: 115 }, { name: 'Lato', css: 'Lato, sans-serif', size: 100 }, { name: 'Lucida Su', css: '"Lucida Sans Unicode", "Lucida Grande", sans-serif', size: 100 }, { name: 'Open Sans', css: "'Open Sans', sans-serif", size: 100 }, { name: 'Old Standard', css: "'Old Standard TT', serif", size: 100 }, { name: 'Palatino', css: "'Palatino Linotype', 'Book Antiqua', Palatino, serif", size: 100 }, { name: 'Playball', css: "'Playball', cursive ", size: 110 }, { name: 'Pinyon Script', css: "'Pinyon Script', cursive;line-height: 1.35", size: 120 }, { name: 'Times New Roman', css: "'Times New Roman', Times, serif", size: 100 }, { name: 'Trebuchet MS', css: "'trebuchet ms', sans-serif", size: 100 }, { name: 'Petit Formal S', css: "'Petit Formal Script', cursive", size: 95 }, { name: 'PT Sans', css: "'PT Sans', sans-serif", size: 100 }, { name: 'PT Serif', css: "'PT Serif', serif", size: 100 }, { name: 'Tahoma', css: 'Tahoma, Geneva, sans-serif', size: 100 }, { name: 'Tangerine', css: "'Tangerine', cursive;line-height: 1", size: 160 }, { name: 'Verdana', css: 'Verdana, Geneva, sans-serif', size: 100 }, { name: 'Vollkorn', css: "'Vollkorn', serif", size: 100 }]
        });

        // add the button to the default toolbar definition
        taOptions.toolbar[1].push('backgroundColor', 'fontColor', 'fontName', 'fontSize');
        return taOptions;
    }]);

    // TODO ANALYSE $locationProvider.html5Mode(true);
    //$locationProvider.html5Mode(true);
    //$locationProvider.hashPrefix('!');

    //initialize get if not there
    if (!$httpProvider.defaults.headers.get) $httpProvider.defaults.headers.get = {};
    //disable IE ajax request caching
    //TODO
    //$httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';

    var interceptor = ['$location', '$q', function ($location, $q) {
        function success(response) {
            return response;
        }

        function error(response) {

            if (response.status === 401) {
                $location.path('/login');
                return $q.reject(response);
            } else {
                return $q.reject(response);
            }
        }

        return function (promise) {
            return promise.then(success, error);
        };
    }];

    IdleProvider.idle(Constants.IDLE_TIME_START_IN_SECONDS);
    IdleProvider.timeout(false);
}]).run(['$rootScope', '$location', 'Auth', '$templateCache', '$window', 'AppRedirectionFactory', function ($rootScope, $location, Auth, $templateCache, $window, AppRedirectionFactory) {
    Auth.init(true);
    $rootScope.$on("$routeChangeStart", function (event, next, current) {
        $rootScope.error = null;
        AppRedirectionFactory.needRedirectionAppUrl($location);
        if (!Auth.authorize(next.access)) {
            if (Auth.isLoggedIn()) {
                $location.path('/');
            } else {
                $location.path('/login');
            }
        }
    });
    $rootScope.online = navigator.onLine;
    $window.addEventListener("offline", function () {
        if (!$rootScope.$$phase || $rootScope.$$phase != '$apply' && $rootScope.$$phase != '$digest') $rootScope.$apply(function () {
            $rootScope.online = false;
        });else $rootScope.online = false;
    }, false);
    $window.addEventListener("online", function () {
        if (!$rootScope.$$phase || $rootScope.$$phase && $rootScope.$$phase != '$apply' && $rootScope.$$phase != '$digest') $rootScope.$apply(function () {
            $rootScope.online = true;
        });else $rootScope.online = true;
    }, false);

    $rootScope.versionInterval = undefined;
}]);

angular.module('exceptionOverride', []).factory('$exceptionHandler', function () {
    return function (exception, cause) {
        Bugsnag.notifyException(exception, { diagnostics: { cause: cause } });
    };
});
angular.module('FlexyBeautyApp.controllers', []); //Declare controllers
angular.module('FlexyBeautyApp.services', []); //Declare services
angular.module('FlexyBeautyApp.directives', []); //Declare directives

angular.element(function () {
    angular.bootstrap(document, ['FlexyBeautyApp'], { strictDi: true });
});

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.controllers').controller('AppCtrl', ["$rootScope", "$scope", "$routeParams", "$location", "$sce", "$window", "$timeout", "$dialog", "$http", "$filter", "Loader", "Auth", "UserData", "AppData", "SiteData", "Helper", "MessageSrv", "CompanyView", "CompanyData", "StoreAppView", "StoreAppData", "DateSrv", "App", "AppAttribute", "AppSrv", "NotificationView", "NotificationData", "UserActionManager", "AuditTrailSrv", "LanguageManager", "gettextCatalog", "$locale", "DayData", "$route", "ReportModelData", "$templateCache", "CurrencyManager", "HumanResourceData", "CureCategoryView", "ProductCategoryView", "LoyaltyCardCategoryView", "TreeMovementDirection", "PeriodType", "TypeOfModification", "PeriodStat", "StatPeriodType", "UserActionSrv", "DayHrData", "PhysicalResourceData", "DayPrData", "CustomerData", "BookingData", "LaunchDarklyFeatureFlagData", "LaunchDarklyFeatureFlagSrv", "MonitoringApplication", "MonitoringSrv", "MonitoringHealthState", "CompanyTypes", "StoreAppCode", "Countries", "ExternalServiceLoader", "MonitoringUsageDataSrv", "MonitoringUsageConstants", "MeasureStore", "TimeMeasures", "Decorators", "moment", "Constants", "AppCode", "EnvironmentSrv", "Environment_Constant", "$interval", "bugsnag", "NotificationSrv", "Brand", "Timers", "OfferManager", "BillingManagerSrv", "MarketPlaceSpecifications", "Idle", "Offers", "Images", "CustomerSrv", "CompanyMigrationSettingsData", "CompanyMigrationSettingsSrv", "PaymentServiceSrv", function ($rootScope, $scope, $routeParams, $location, $sce, $window, $timeout, $dialog, $http, $filter, Loader, Auth, UserData, AppData, SiteData, Helper, MessageSrv, CompanyView, CompanyData, StoreAppView, StoreAppData, DateSrv, App, AppAttribute, AppSrv, NotificationView, NotificationData, UserActionManager, AuditTrailSrv, LanguageManager, gettextCatalog, $locale, DayData, $route, ReportModelData, $templateCache, CurrencyManager, HumanResourceData, CureCategoryView, ProductCategoryView, LoyaltyCardCategoryView, TreeMovementDirection, PeriodType, TypeOfModification, PeriodStat, StatPeriodType, UserActionSrv, DayHrData, PhysicalResourceData, DayPrData, CustomerData, BookingData, LaunchDarklyFeatureFlagData, LaunchDarklyFeatureFlagSrv, MonitoringApplication, MonitoringSrv, MonitoringHealthState, CompanyTypes, StoreAppCode, Countries, ExternalServiceLoader, MonitoringUsageDataSrv, MonitoringUsageConstants, MeasureStore, TimeMeasures, Decorators, moment, Constants, AppCode, EnvironmentSrv, Environment_Constant, $interval, bugsnag, NotificationSrv, Brand, Timers, OfferManager, BillingManagerSrv, MarketPlaceSpecifications, Idle, Offers, Images, CustomerSrv, CompanyMigrationSettingsData, CompanyMigrationSettingsSrv, PaymentServiceSrv) {

    console.time("Application");
    gettextCatalog.debug = false;
    $scope.isUnsavedBookingView = false;
    var IS_PERIODIC_GET_USER_ACTION_ACTIVATED = true;
    var timers = [];
    var intervals = [];

    //surcharge de la directive permettant de ssaisir des emails
    $templateCache.put('ngTagsInput/tags-input.html', "<div class=\"host\" tabindex=\"-1\" ng-click=\"eventHandlers.host.click()\" ti-transclude-append><div class=\"tags\" ng-class=\"{focused: hasFocus}\"><input class=\"input\" autocomplete=\"off\" ng-model=\"newTag.text\" ng-model-options=\"{getterSetter: true}\" ng-keydown=\"eventHandlers.input.keydown($event)\" ng-focus=\"eventHandlers.input.focus($event)\" ng-blur=\"eventHandlers.input.blur($event)\" ng-paste=\"eventHandlers.input.paste($event)\" ng-trim=\"false\" ng-class=\"{'invalid-tag': newTag.invalid}\" ng-disabled=\"disabled\" ti-bind-attrs=\"{type: options.type, placeholder: options.placeholder, tabindex: options.tabindex, spellcheck: options.spellcheck}\" ti-autosize><ul class=\"tag-list\"><li class=\"tag-item\" ng-repeat=\"tag in tagList.items track by track(tag)\" ng-class=\"getTagClass(tag, $index)\" ng-click=\"eventHandlers.tag.click(tag)\"><ti-tag-item scope=\"templateScope\" data=\"::tag\"></ti-tag-item></li></ul></div></div>");

    $scope.ad = {
        domain: null,
        sDm: null,
        ssDomain: null,
        themeClass: '',
        showSubMenu: null,
        index: 0,
        showSubMenuPromise: null,
        subMenuLeft: 0,
        firstLoadingProcess: !Loader.loaded,
        dataLoaded: Loader.loaded,
        dataLoadedError: false,
        unauthorizedUser: false,
        loggedUser: null,
        smsReminder: null,
        currentUser: Auth.getCurrentUser(),
        companyName: Auth.getCompanyName(),
        companyCode: Auth.getCompanyCode(),
        currentSiteName: "",
        companyMigrationSettings: CompanyMigrationSettingsData.companyMigrationSettings,
        headerTopStyle: null,
        webSiteAdminUrl: $sce.trustAsResourceUrl("/" + Auth.getCompanyCode() + "/admin/" + Auth.getToken()),
        kiuteProAppIframeUrl: '',
        isMobileOrPadTouchScreen: false,
        displayStartWindow: Helper.displayStartWindow,
        managerMode: Helper.managerMode,
        isMarketplaceCompliant: null,
        isAlreadyOpenTab: false,
        topHeaderPixel: '0px',
        bodyPixel: '41px',
        isAdminNotGroup: Auth.isAdminNotGroup(),
        view: {
            companyView: null,
            storeAppsView: [],
            subscriptions: {
                sub: { annual: null }
            },
            notificationsView: [],
            notificationsIsLoading: false,
            nbNotificationsUnread: 0,
            notificationDisplayParameters: null,
            userActions: [],
            typeOfModification: TypeOfModification
        },
        addons: {
            sub: {
                smsCampaign: false,
                giftItem: false,
                loyaltyCard: false,
                cure: false,
                bookingSmsSecurity: false,
                optionReserveWithGoogle: false,
                optionLeCiseau: false,
                optionLeCiseauLight: false,
                withoutTill: false,
                clientFullAccess: false,
                onlineReservationAccess: false,
                websiteAccess: false,
                websitePaymentAccess: false,
                statisticsAccess: false,
                statisticsFullAccess: false,
                nativeAppAccess: false,
                posAccess: false,
                booksyButtonAccess: false
            },
            options: {
                iZettlePayment: false
            }
        },
        absUrl: $location.absUrl(),
        treeMovementDirection: TreeMovementDirection,
        dialog: {
            website: false,
            marketplace: false
        },
        brand: Brand,
        offerManager: OfferManager,
        offers: Offers,
        billingManager: {
            managementTool: null,
            companyId: null,
            loading: false,
            loaded: false
        },
        bookingStatusImage: Images.saleStatus,
        companyTypes: CompanyTypes,
        areMigrationInformationComplete: false,
        migrationInfoCountdownDate: null,
        monitoringUsageConstants: MonitoringUsageConstants
    };
    $scope.ngAppCustomerIframe = undefined;
    $scope.popInterval = null;

    window.hideElementsForSelenium = function () {
        $("#chmln").hide();
        $("#intercom-container").hide();
    };

    window.goToReport = function (reportId, beginDayId, endDayId, dashboardId, reportIndex) {
        $location.path("/report/" + reportId + "/" + beginDayId + "/" + endDayId + "/" + dashboardId + "/" + reportIndex);
        $route.reload();
        return "OK";
    };

    window.getReportInfo = function (reportId) {
        var report = ReportModelData.getById(reportId);
        report.height = $(".chart-zone:first") && $(".chart-zone:first").height() ? $(".chart-zone:first").height() : $(".flexy-report-detail:first").height();
        return angular.toJson(report);
    };

    var onNotificationDestroy = $rootScope.$on('onNotification', function (_, notification) {
        if (NotificationData.isLoaded) {
            $scope.loadNotificationIfStatusValid(notification);
            $scope.updateNbNotificationsUnread();
            $scope.safeApply();
        } else {
            $scope.countUnreadNotifications();
        }
    });

    var fxbInvalidTokenDestroy = $rootScope.$on('fxbInvalidToken', function () {
        var opts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: '/partials/global/invitationDialog.html',
            controller: 'DialogCtrl',
            resolve: {
                dialogsModel: function dialogsModel() {
                    var tableModel = [];
                    tableModel["title"] = gettextCatalog.getString("Information");
                    tableModel["label"] = gettextCatalog.getString("Vous n'êtes plus identifé. Nous vous invitons à vous reconnecter.");
                    tableModel["buttonLabel"] = gettextCatalog.getString("Se reconnecter");
                    tableModel["buttonClass"] = "btn btn-success";
                    tableModel["dialogId"] = "refreshDialogInvalidToken";
                    return tableModel;
                }
            }
        };
        $dialog.dialog(opts).open().then(function (result) {
            if (result) {
                Auth.afterLogout(Auth.getCompanyCode());
            }
        });
    });

    var fxbInvalidChannelDestroy = $rootScope.$on('fxbInvalidChannel', function () {
        var errorMessage = gettextCatalog.getString("Votre session a expiré");

        var opts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: '/partials/global/refreshDialog.html',
            controller: 'DialogCtrl',
            resolve: {
                dialogsModel: function dialogsModel() {
                    var tableModel = [];
                    tableModel["label"] = errorMessage + ". " + gettextCatalog.getString("Nous vous invitons à rafraîchir la page.");
                    tableModel["dialogId"] = "refreshDialogInvalidChannel";
                    return tableModel;
                }
            }
        };
        $dialog.dialog(opts).open().then(function (result) {
            if (result) {
                location.reload();
            }
        });
    });

    if (navigator.userAgent.indexOf("Android") != -1 || navigator.userAgent.indexOf("iPhone OS") != -1 || navigator.userAgent.indexOf("iPad") != -1) $scope.ad.isMobileOrPadTouchScreen = true;

    $scope.canAccessLiveEdit = function () {
        return LanguageManager.canAccessLiveEdit();
    };

    $scope.isEnglishLanguage = function () {
        return LanguageManager.isEnglishLanguage();
    };

    $scope.isFrenchLanguage = function () {
        return LanguageManager.isFrenchLanguage();
    };

    $scope.isEuroCurrency = function () {
        return CurrencyManager.isEuroCurrency();
    };

    $scope.isFrance = function () {
        var countryCode = LanguageManager.getCountryCode();
        return Countries.FRANCE.countryCode === countryCode;
    };

    $scope.getCurrencySymbol = function () {
        return CurrencyManager.getCurrencySymbol();
    };

    $scope.$watch('online', function (newStatus) {
        if (!newStatus) {
            //offline
            var msgSrv = gettextCatalog.getString("Attention, votre connexion internet est inactive");
            MessageSrv.send("alert", msgSrv + " !");
        } else if ($scope.ad.loggedUser) MessageSrv.cleanMessage();
    });

    $scope.emitUserActionAction = function (userAction) {
        if (userAction) {
            $rootScope.$emit("onNotificationAction", userAction);
        }
    };

    $scope.emitNotificationAction = function (notificationView) {
        if (notificationView) {
            notificationView.updateAsRead();
            $scope.updateNbNotificationsUnread();
            $rootScope.$emit("onNotificationAction", notificationView);
        }
    };
    $scope.emitNotificationAction = function (notificationView) {
        if (notificationView && notificationView.data) {
            notificationView.updateAsRead();
            $scope.updateNbNotificationsUnread();
            if ($scope.ad.domain != "planningPos") {
                if (notificationView.data.globalObjectType == "Booking") $scope.goToDomain("planningPos", "planning");else $scope.goToDomain("planningPos", "pos");
                var timer = $timeout(function () {
                    $rootScope.$emit("onNotificationAction", notificationView);
                }, 1000);
                timers.push(timer);
            } else $rootScope.$emit("onNotificationAction", notificationView);
        }
    };

    $scope.getTooltip = function (selectedCategoryView, rootCategoryView) {
        var tooltipText = null,
            tooltipName = null;
        if (selectedCategoryView instanceof CureCategoryView) {
            tooltipName = gettextCatalog.getString("une cure");
        } else if (selectedCategoryView instanceof LoyaltyCardCategoryView) {
            tooltipName = gettextCatalog.getString("une carte de fidélité");
        } else if (selectedCategoryView instanceof ProductCategoryView) {
            tooltipName = gettextCatalog.getString("un produit");
        } else {
            tooltipName = gettextCatalog.getString("une prestation");
        }
        if (selectedCategoryView === rootCategoryView) {
            tooltipText = gettextCatalog.getString("à la racine");
        } else {
            tooltipText = gettextCatalog.getString(" dans ") + " " + selectedCategoryView.label;
        }
        if (!selectedCategoryView && !rootCategoryView) {
            return gettextCatalog.getString("Ajouter une catégorie") + " " + tooltipText;
        } else {
            return gettextCatalog.getString("Ajouter") + " " + tooltipName + " " + tooltipText;
        }
    };
    $scope.getGiftItemTooltip = function (editionType, customerView) {
        var giftItemType = null,
            giftItemCustomer = null,
            tooltipText = null;
        if (editionType === "printOnTicket") {
            giftItemType = gettextCatalog.getString("à imprimer");
        } else if (editionType === "email") {
            giftItemType = gettextCatalog.getString("envoyé par email");
        } else {
            giftItemType = '';
        }
        if (customerView != null && customerView !== undefined) {
            giftItemCustomer = customerView.label;
            tooltipText = gettextCatalog.getString("attribué à");
        } else {
            giftItemCustomer = '';
        }
        return gettextCatalog.getString("Chèque cadeau") + " " + giftItemType + " " + tooltipText + " " + giftItemCustomer;
    };

    $scope.getCategorytTooltip = function (parentCategoryView, categoryRootView, direction) {
        var tooltipText = null,
            tooltipLabel = parentCategoryView.label;

        if (parentCategoryView === categoryRootView) {
            tooltipText = gettextCatalog.getString("à la racine");
            tooltipLabel = "";
        } else {
            tooltipText = gettextCatalog.getString("à la catégorie");
        }
        return direction.action + " " + tooltipText + " " + tooltipLabel;
    };

    $scope.updateAsUnRead = function (notificationView) {
        if (notificationView) {
            notificationView.updateAsUnRead();
            $scope.updateNbNotificationsUnread();
        }
    };

    $scope.updateNbNotificationsUnread = function () {
        $scope.ad.view.nbNotificationsUnread = 0;
        for (var i = 0; i < $scope.ad.view.notificationsView.length; i++) {
            if ($scope.ad.view.notificationsView[i].status != "read") $scope.ad.view.nbNotificationsUnread++;
        }
    };

    $scope.countUnreadNotifications = function () {
        NotificationSrv.countUnread().then(function (data) {
            if (data && data.notificationNumber !== undefined) {
                var timer = $timeout(function () {
                    NotificationData.unreadNotifications = data.notificationNumber;
                    $scope.ad.view.nbNotificationsUnread = data.notificationNumber;
                }, 100);
                timers.push(timer);
            }
        }).catch(function (error) {
            bugsnag.notify("NotificationSrv.countUnread - Error during fetching notification number", 'NotificationSrv countUnread failure. Error : ' + error.message, {}, Constants.BUGSNAG_NOTIFICATION_LEVEL);
        });
    };

    $scope.readAllNotifications = function () {
        for (var i = 0; i < $scope.ad.view.notificationsView.length; i++) {
            if ($scope.ad.view.notificationsView[i].status != "read") $scope.ad.view.notificationsView[i].updateAsRead();
        }$scope.updateNbNotificationsUnread();
    };

    $scope.loadNotifications = function () {
        if (NotificationData.isLoaded) {
            $scope.loadNotificationViews();
        } else {
            $scope.ad.view.notificationsIsLoading = true;
            NotificationSrv.query(function (data) {
                $scope.loadNotificationViews();
                $scope.ad.view.notificationsIsLoading = false;
            }, function (data) {
                $scope.ad.view.notificationsIsLoading = false;
            });
        }
    };

    $scope.goToNotificationPage = function () {
        if ($scope.ad.domain === 'planningPos') {
            $scope.goToSubDomain('notification');
            $scope.loadNotifications();
        } else if ($scope.ad.sDm !== 'notification') {
            $scope.goToDomain('planningPos', 'notification');
        }
    };

    $scope.loadOrCountNotification = function () {
        if (!NotificationData.isLoaded) {
            if ($scope.ad.domain === "planningPos" && $scope.ad.sDm === "notification") {
                $scope.loadNotifications();
            } else {
                $scope.countUnreadNotifications();
            }
        } else {
            $scope.loadNotificationViews();
        }
    };

    $scope.loadNotificationViews = function () {
        var notifications = NotificationData.indexNotifications;
        $scope.ad.view.notificationsView = [];
        for (var i = 0; i < notifications.length; i++) {
            $scope.loadNotificationIfStatusValid(notifications[i]);
        }
        $scope.updateNbNotificationsUnread();
        $scope.loadAgendaNotificationParameters('internet');
    };

    $scope.loadNotificationIfStatusValid = function (notification) {
        var notificationView = new NotificationView(notification, NotificationData.getIndexOf(notification));
        if (notificationView.data && notificationView.data.status != "soldProcess" && notificationView.data.status != "advanceProcess" && notificationView.data.status != "failed") {
            $scope.ad.view.notificationsView.push(notificationView);
        }
    };

    $scope.handleIntercomAndSdm = function (domain, sDm) {
        $scope.manageIntercomVisbility(domain, sDm);

        if (sDm !== undefined && sDm) {
            $scope.ad.sDm = sDm;
        } else {
            $scope.ad.sDm = null;
        }
        $location.search("sDm", $scope.ad.sDm);
        $rootScope.$emit("goToDomainCalled");

        var timer = $timeout(function () {
            $scope.clearDailyStatPrecalculatedDatas();
        });
        timers.push(timer);

        document.dispatchEvent(new Event("lokalise-update-elements"));
    };

    $scope.$on("editedBookingStatusToAppCtrl", function (evt, data) {
        $scope.isUnsavedBookingView = data;
    });

    $scope.goToDomain = function (domain, sDm) {
        if ($scope.ad.domain !== domain || $scope.ad.sDm !== sDm) {
            if ($scope.ad.sDm !== 'planning') {
                $scope.isUnsavedBookingView = false;
            } else {
                $scope.$broadcast("editedBookingStatusOnPlanningPosCtrl");
            }

            if ($scope.isUnsavedBookingView) {
                $scope.$broadcast("displayUnsavedMessageOnPlanningPosCtrl");
            } else {
                if ($scope.ad.domain !== domain) {
                    if ($scope.ad.domain === "webSite") {
                        Loader.forceReload = true;
                    }
                    $location.path("/app/" + domain);
                }
                $scope.handleIntercomAndSdm(domain, sDm);
            }
        }
    };

    $scope.monitoringUsage = function (nameMonitoring) {
        MonitoringUsageDataSrv.logUsageData(nameMonitoring);
    };
    $scope.goToCustomerOrDownload = function () {
        if ($scope.ad.loggedUser.company.type === CompanyTypes.CANCELED.value) {
            $rootScope.isDownloadCustomers = true;
            var format = Constants.EXPORT_FORMAT.XLSX;
            CustomerSrv.getCustomerExport().then(function (content) {
                var hiddenElement = document.createElement('a');
                var blob = new Blob([content.data], { type: format.hrefAttachment });
                hiddenElement.href = URL.createObjectURL(blob);
                hiddenElement.download = 'kiute-pro-clients.' + format.fileExtension;
                document.body.appendChild(hiddenElement);
                hiddenElement.click();
                $rootScope.isDownloadCustomers = false;
            });
        } else {
            $scope.goToDomain('planningPos', 'customer');
        }
    };

    $scope.goToSSDomain = function (domain, sDm, ssDm) {
        if ($scope.ad.domain !== domain) {
            if ($scope.ad.domain === "webSite") {
                Loader.forceReload = true;
            }
            if (ssDm) {
                $location.path("/app/" + domain + "/" + ssDm);
            } else {
                $location.path("/app/" + domain);
            }
        }
        $scope.handleIntercomAndSdm(domain, sDm);
    };

    $scope.clearDailyStatPrecalculatedDatas = function () {
        console.info("clearDailyStatPrecalculatedDatas");
        for (var i = 0; i < DayData.indexDays.length; i++) {
            DayData.indexDays[i].clearPrecalculatedStatDatas();
        }
    };

    $scope.goToSubDomain = function (sDm) {
        if (sDm !== undefined && sDm) $scope.ad.sDm = sDm;else $scope.ad.sDm = null;
        $location.search("sDm", $scope.ad.sDm);

        $scope.manageIntercomVisbility($scope.ad.domain, sDm);

        document.dispatchEvent(new Event("lokalise-update-elements"));
    };

    $scope.toggleSubMenu = function (showSubMenu, now, event) {
        if (event && event.currentTarget) {
            $scope.ad.subMenuLeft = event.currentTarget.offsetLeft + "px";
        }
        if ($scope.ad.showSubMenu == showSubMenu) {
            $scope.showSubMenu(null, now);
        } else {
            $scope.showSubMenu(showSubMenu, now);
        }
    };

    $scope.reloadPage = function () {
        window.location.reload(false);
    };

    $scope.showSubMenu = function (showSubMenu, now) {
        if ($scope.ad.showSubMenuPromise) $timeout.cancel($scope.ad.showSubMenuPromise);
        if (showSubMenu) {
            if (now) $scope.ad.showSubMenu = showSubMenu;else $scope.ad.showSubMenuPromise = $timeout(function () {
                $scope.ad.showSubMenu = showSubMenu;
            }, 10000);
        } else if (now) $scope.ad.showSubMenu = null;else $scope.ad.showSubMenuPromise = $timeout(function () {
            $scope.ad.showSubMenu = null;
        }, 10000);
    };
    $scope.onExit = function () {
        AuditTrailSrv.createAndSave("40"); //Stop usage
    };

    $scope.generateAuditTrail = function (code) {
        AuditTrailSrv.createAndSave(code); //Stop usage
    };

    $window.onbeforeunload = $scope.onExit;

    $scope.logout = function (alreadyDisconnected) {
        $dialog.dialog({
            backdrop: true,
            backdropClick: false,
            keyboard: !alreadyDisconnected,
            templateUrl: alreadyDisconnected ? '/partials/global/infoDialog.html' : '/partials/global/generalConfirm.html',
            controller: 'DialogCtrl',
            resolve: {
                dialogsModel: function dialogsModel() {
                    var tableModel = [];
                    if (alreadyDisconnected) {
                        tableModel.label = gettextCatalog.getString("Votre session a expiré. Veuillez vous connecter à nouveau.");
                    } else {
                        tableModel.question = gettextCatalog.getString("Souhaitez-vous vous déconnecter") + " ?";
                        tableModel.isEnglishLanguage = $scope.isEnglishLanguage; // FIXME not used in generalConfirm.html model
                    }
                    return tableModel;
                }
            }
        }).open().then(function (result) {
            if (result) {
                Auth.logout();
            }
        });
    };

    /**
     * TODO purge (ad.loggedUser and company checks ?) and simplify code
     */
    $scope.loadSubscriptionStoreAppActivities = function () {
        $scope.loadSubApp(StoreAppCode.OPTION_WITHOUT_TILL_STORE_APP_CODE);
        $scope.loadSubApp(StoreAppCode.OPTION_POS_APP_CODE);
        $scope.loadSubApp(StoreAppCode.OPTION_SMS_CAMPAIGN_APP_CODE);
        $scope.loadSubApp(StoreAppCode.OPTION_SMS_REMINDER_APP_CODE);
        $scope.loadSubApp(StoreAppCode.OPTION_GIFT_ITEM_APP_CODE);
        $scope.loadSubApp(StoreAppCode.OPTION_LOYALTY_CARD_APP_CODE);
        $scope.loadSubApp(StoreAppCode.OPTION_CURE_APP_CODE);
        $scope.loadSubApp(StoreAppCode.OPTION_BOOKING_SMS_SECURITY_APP_CODE);
        $scope.loadSubApp(StoreAppCode.OPTION_RESERVE_WITH_GOOGLE_STORE_APP_CODE);
        $scope.loadSubApp(StoreAppCode.OPTION_LE_CISEAU_STORE_APP_CODE);

        $scope.loadFeaturesAccess();
    };

    $scope.loadSubApp = function (code) {
        if ($scope.ad.loggedUser && $scope.ad.loggedUser.company) {
            if (code === StoreAppCode.OPTION_POS_APP_CODE) {
                $scope.ad.addons.sub[code] = $scope.ad.loggedUser.company.hasSubscriptionActive(code) && !$scope.ad.loggedUser.company.hasSubscriptionActive(StoreAppCode.OPTION_WITHOUT_TILL_STORE_APP_CODE);
            } else {
                $scope.ad.addons.sub[code] = $scope.ad.loggedUser.company.hasSubscriptionActive(code);
            }
        }
    };

    $scope.loadFeaturesAccess = function () {
        if ($scope.ad.loggedUser && $scope.ad.loggedUser.company) {
            $scope.ad.addons.sub.clientFullAccess = OfferManager.hasCompanyAccessToFeature($scope.ad.loggedUser.company, StoreAppCode.OPTION_CLIENT_FULL);
            $scope.ad.addons.sub.onlineReservationAccess = OfferManager.hasCompanyAccessToOnlineReservation($scope.ad.loggedUser.company);
            $scope.ad.addons.sub.websiteAccess = OfferManager.hasCompanyAccessToFeature($scope.ad.loggedUser.company, StoreAppCode.OPTION_WEBSITE);
            $scope.ad.addons.sub.websitePaymentAccess = OfferManager.hasCompanyAccessToFeature($scope.ad.loggedUser.company, StoreAppCode.OPTION_WEBSITE_PAYMENT);
            $scope.ad.addons.sub.statisticsAccess = OfferManager.hasCompanyAccessToFeature($scope.ad.loggedUser.company, StoreAppCode.OPTION_STATISTICS);
            $scope.ad.addons.sub.statisticsFullAccess = OfferManager.hasCompanyAccessToFeature($scope.ad.loggedUser.company, StoreAppCode.OPTION_STATISTICS_FULL);
            $scope.ad.addons.sub.nativeAppAccess = OfferManager.hasCompanyAccessToFeature($scope.ad.loggedUser.company, StoreAppCode.OPTION_NATIVE_APP_APP_CODE);
            $scope.ad.addons.sub.posAccess = OfferManager.hasCompanyAccessToFeature($scope.ad.loggedUser.company, StoreAppCode.OPTION_POS_APP_CODE);
            $scope.ad.addons.sub.booksyButtonAccess = OfferManager.hasCompanyAccessToFeature($scope.ad.loggedUser.company, StoreAppCode.OPTION_BOOKSY_BUTTON);
        }
    };

    $scope.loadIZettleAppAttribute = function () {
        $scope.loadAppAttribute(AppCode.POS_APP, AppCode.POS_ATTRIBUTE_IZETTLE_PAYMENT);
    };

    $scope.loadAppAttribute = function (appCode, appAttributeCode) {
        if ($scope.ad.loggedUser && $scope.ad.loggedUser.company) {
            var app = AppData.getAppByCode(appCode);
            if (app) {
                var appAttribute = app.getAppAttribute(appAttributeCode);
                if (appAttribute) {
                    if (appAttribute.value === "true") {
                        $scope.ad.addons.options[appAttributeCode] = true;
                    } else if (appAttribute.value === "false") {
                        $scope.ad.addons.options[appAttributeCode] = false;
                    } else {
                        $scope.ad.addons.options[appAttributeCode] = appAttribute.value;
                    }
                }
            }
        }
    };

    $scope.reloadApplication = function () {
        var absUrl = $location.absUrl();
        if (absUrl.indexOf("/connect/") != -1) $window.open("/connect/" + Auth.getCompanyCode(), "_self"); //clear page
        else if (absUrl.indexOf("/fxbAdmin/") != -1) $window.open("/fxbAdmin/" + Auth.getCompanyCode(), "_self"); //clear page
            else $window.open("/", "_self"); //clear page
    };

    $scope.reactivateAccount = function () {
        $window.open("https://calendly.com/d/z3j-9ns-wdn/booksy-reactivation-mon-abonnement-kiute?month=2023-02");
    };

    $scope.manageIntercomVisbility = function (domain, sDm) {
        if (domain === "planningPos" && sDm === "planning") {
            $scope.setIntercomSettings(false);
        } else {
            $scope.setIntercomSettings(true);
        }
    };

    $scope.setIntercomSettings = function (isVisible) {
        if (window.Intercom) {
            window.intercomSettings = {
                app_id: this.getIntercomAppId(),
                hide_default_launcher: !isVisible
            };
            window.Intercom('update', intercomSettings);
        }
    };

    $scope.getIntercomAppId = function () {
        var appId = null;
        if ($scope.ad.loggedUser.serverIdentification.applicationId === "bsiflexyprod") {
            appId = "xxmtyv4q";
        } else {
            appId = "hnour6wu";
        }
        return appId;
    };

    $scope.initDisplayStartWindow = function (type) {
        if (!$scope.ad.isAlreadyOpenTab) {
            $scope.setDisplayStartWindow(null, true);

            if ($scope.ad.loggedUser.company.type === CompanyTypes.MIGRATION.value || $scope.ad.loggedUser.company.type === CompanyTypes.BILLINGISSUE.value || $scope.ad.loggedUser.company.type === CompanyTypes.BLOCKED.value || $scope.ad.loggedUser.company.type === CompanyTypes.BILLINGBLOCKED.value || $scope.ad.loggedUser.company.type === CompanyTypes.CANCELED.value) {
                if ($scope.ad.loggedUser.company.companyPaymentData && $scope.ad.loggedUser.company.type !== CompanyTypes.MIGRATION.value && $scope.ad.loggedUser.company.type !== CompanyTypes.CANCELED.value) {
                    $scope.ad.loggedUser.company.companyPaymentData.isValid = false; //force invalid payment
                }
                $scope.setDisplayStartWindow($scope.ad.loggedUser.company.type);
            } else {
                if (type !== undefined && type != null) $scope.setDisplayStartWindow(type);else if ($scope.ad.loggedUser.company.type == "newAccount") {
                    var appMessage = AppData.getAppByCode("appMessage");
                    if (!appMessage) {
                        appMessage = new App();
                        appMessage.setCode("appMessage");
                    }
                    var appAttrVideo = appMessage.getAppAttribute("hasStarted");
                    if (!appAttrVideo || appAttrVideo.value != "true") //direct access on agenda
                        {
                            appMessage.addAppAttribute(new AppAttribute("hasStarted", "true"));
                            AppSrv.save(appMessage);
                        } else $scope.setDisplayStartWindow("newAccount");
                }
            }
        }
    };

    $scope.setAppValue = function (appCode, attrCode, value) {
        var appMessage = AppData.getAppByCode(appCode);
        if (!appMessage) {
            appMessage = new App();
            appMessage.setCode(appCode);
        }
        var appAttr = appMessage.getAppAttribute(attrCode);
        if (!appAttr) appMessage.addAppAttribute(new AppAttribute(attrCode, value));else appAttr.value = value;
        AppSrv.save(appMessage);
    };

    $scope.closeAnnualMessage = function () {
        $scope.setDisplayStartWindow(null);
        $scope.setAppValue('appMessage', 'annualMode', 'true');
        var msgLabel = gettextCatalog.getString("Si vous souhaitez l'activer plus tard, rendez-vous dans votre espace facturation");
        var opts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: '/partials/global/infoDialog.html',
            controller: 'DialogCtrl',
            resolve: {
                dialogsModel: function dialogsModel() {
                    var tableModel = [];
                    tableModel["label"] = msgLabel + ".";
                    tableModel["isEnglishLanguage"] = $scope.isEnglishLanguage;
                    return tableModel;
                }
            }
        };

        var d = $dialog.dialog(opts);
        d.open();
    };

    $scope.safeApply = function (fn) {
        if ($scope.$root) {
            var phase = $scope.$root.$$phase;
            if (phase == '$apply' || phase == '$digest') {
                if (fn && typeof fn === 'function') {
                    fn();
                }
            } else {
                $scope.$apply(fn);
            }
        } else $scope.$apply(fn);
    };

    $scope.setDisplayStartWindow = function (displayStartWindow, isFirstInit) {
        Helper.displayStartWindow = displayStartWindow;
        $scope.ad.displayStartWindow = displayStartWindow;
        if (displayStartWindow === null && !isFirstInit) {
            ExternalServiceLoader.initChameleon($scope.ad.loggedUser, OfferManager.computeCompanyOfferCode($scope.ad.loggedUser.company));
        }
    };

    $scope.closeStartWindowAndGoToBilling = function () {
        $scope.setDisplayStartWindow(null);
        $scope.goToBilling();
    };

    $scope.goToBilling = function () {
        $scope.ad.managerMode ? $scope.goToDomain('flexyBeauty', 'invoice') : $scope.toggleManagerMode(true);
    };

    $scope.filterInvoicesView = function (invoicesView) {
        if (invoicesView && $scope.ad.billingManager.managementTool) {
            invoicesView = invoicesView.filter(function (invoice) {
                return invoice.type === 'onlinePayment';
            });
        }
        return invoicesView;
    };

    $scope.redirectToAlma = function () {
        window.open("https://link.booksy.com/e/I7P7dF7qPzb?c=" + $scope.ad.loggedUser.company.code, "_blank");
    };

    $scope.loadBillingManagerIfNeeded = function () {
        if (!$scope.ad.billingManager.loaded) {
            $scope.ad.billingManager.loading = true;
            return BillingManagerSrv.getBillingManager().then(function (data) {
                if (data) {
                    $scope.ad.billingManager.managementTool = data.managementTool;
                    $scope.ad.billingManager.companyId = data.managerCompanyId;
                    $scope.ad.billingManager.loading = false;
                    $scope.ad.billingManager.loaded = true;
                }
            }, function (data) {
                if (data.status === 404) {
                    $scope.ad.billingManager.loaded = true;
                }
                $scope.ad.billingManager.loading = false;
            });
        } else {
            return Promise.resolve();
        }
    };

    $scope.getStoreAppView = function (storeApp) {
        for (var i = 0; i < $scope.ad.view.storeAppsView.length; i++) {
            if ($scope.ad.view.storeAppsView[i].getModel() === storeApp) return $scope.ad.view.storeAppsView[i];
        }return null;
    };

    $scope.toggleManagerMode = function (nextIsInvoice) {
        var opts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: '/partials/managerMode.html',
            controller: 'ManagerModeCtrl',
            resolve: {
                dialogsModel: function dialogsModel() {
                    var tableModel = [];
                    tableModel["ad"] = $scope.ad;
                    var timer = $timeout(function () {
                        angular.element('#input-focus').trigger('focus');
                    }, 250);

                    timers.push(timer);
                    return tableModel;
                }
            }
        };

        var d = $dialog.dialog(opts);
        d.open().then(function (result) {
            if (result) {
                //toggle accepted
                $scope.ad.managerMode = !$scope.ad.managerMode;
                Helper.managerMode = $scope.ad.managerMode;
                if ($scope.ad.managerMode) {
                    $scope.goToDomain('flexyBeauty', 'onlinePayment');
                } else {
                    if ($scope.ad.domain !== "planningPos") {
                        $scope.goToDomain("planningPos");
                    } else {
                        $scope.loadAgendaNotificationParameters('internet');
                    }
                }
            } else {
                if (nextIsInvoice) {
                    $scope.initDisplayStartWindow();
                }

                if ($scope.ad.domain !== "planningPos" && !$scope.ad.managerMode) {
                    $scope.goToDomain("planningPos", "dashboard");
                }
            }
        });
    };

    // CODE CONTROLLER START
    if (Loader.forceReload) {
        $window.location.reload();
        return;
    }
    $scope.ad.domain = $routeParams.domain;
    $scope.ad.ssDomain = $routeParams.ssDomain;

    $scope.loadDomainAndSubDomain = function () {

        var search = $location.search();

        if (search && search.sDm) {

            $scope.ad.sDm = search.sDm;
        } else if ($scope.ad.domain === "planningPos") {

            $scope.ad.sDm = "dashboard"; //default

            $location.search("sDm", "dashboard");
        } else if ($scope.ad.domain === "flexyBeauty") {

            $scope.ad.sDm = "flexyStore"; //default

            $location.search("sDm", "flexyStore");
        } else if ($scope.ad.domain === "humanResource") {

            $scope.ad.sDm = "team"; //default

            $location.search("sDm", "team");
        }
    };

    $scope.getStoreAppsView = function () {
        return $scope.ad.view.storeAppsView;
    };

    $scope.initCompanyView = Decorators.timeMeasureDecorator(function () {
        var storeApps = StoreAppData.getActiveList();
        for (var i = 0; i < storeApps.length; i++) {
            $scope.ad.view.storeAppsView.push(new StoreAppView(storeApps[i], StoreAppData.getIndexOf(storeApps[i]), $scope));
        }$scope.ad.view.companyView = new CompanyView($scope.ad.loggedUser.company, CompanyData.getIndexOf($scope.ad.loggedUser.company), $scope);
        $scope.ad.view.subscriptions.sub.annual = $scope.ad.view.companyView.getSubscriptionViewByStoreAppViewCode('annual');
        $scope.ad.view.companyView.updateSubscriptions();
        var companyType = $scope.ad.loggedUser.company.type;
        $rootScope.readOnly = companyType === CompanyTypes.MIGRATION.value || companyType === CompanyTypes.CANCELED.value;
        $rootScope.isCancel = companyType === CompanyTypes.CANCELED.value;
        $rootScope.isBlockedOrBillingBlocked = companyType === CompanyTypes.BLOCKED.value || companyType === CompanyTypes.BILLINGBLOCKED.value;
    }, TimeMeasures.INIT_COMPANY_VIEW);

    $scope.initTheme = function () {
        var agendaApp = AppData.getAppByCode('agenda');
        var themeName = Constants.defaultTheme;

        if (agendaApp !== null) {
            var selectedTheme = agendaApp.getAppAttribute('themeName');
            if (selectedTheme !== null && selectedTheme.value) {
                themeName = selectedTheme.value;
            }
        }

        $scope.ad.themeClass = Constants.themes[themeName] || "theme-" + Constants.defaultTheme;
        $scope.changeTheme(themeName);
    };

    $scope.changeTheme = function (themeName) {
        if (themeName) {
            var head = top.document.getElementsByTagName("head")[0];
            if (head) {
                var styles = top.document.getElementsByName("theme");
                if (styles && styles.length != 0) {
                    for (var i = 0; i < styles.length; i++) {
                        if (styles[i].getAttribute("id") !== themeName) {
                            styles[i].setAttribute("disabled", "true");
                        } else {
                            styles[i].removeAttribute("disabled");
                        }
                    }
                }
            }
        }
    };

    $scope.loadExternalServices = Decorators.timeMeasureDecorator(function () {
        var activeOffer = $scope.ad.loggedUser.company ? $scope.ad.loggedUser.company.activeOffer : null;
        ExternalServiceLoader.initFullStory($scope.ad.loggedUser, $scope.ad.currentUser);
        ExternalServiceLoader.initBugsnag($scope.ad.loggedUser);
        ExternalServiceLoader.initChameleon($scope.ad.loggedUser, activeOffer ? activeOffer.offerCode : null);
        ExternalServiceLoader.initLokalise();
        ExternalServiceLoader.initIntercom($scope.ad.loggedUser, activeOffer, $scope.getIntercomAppId());
    }, TimeMeasures.EXTERNAL_SERVICES_LOADING);

    $scope.registerEndForGlobalTimeOnFailure = function () {
        if ($rootScope.canAccessNewLoading) {
            MeasureStore.registerEnd(TimeMeasures.MODEL_GLOBAL_TIME_STARTUP);
        } else {
            MeasureStore.registerEnd(TimeMeasures.MODEL_GLOBAL_TIME);
        }
        MonitoringSrv.logHealth(MonitoringApplication.PROBACKOFFICE, MonitoringHealthState.KO, JSON.stringify(MeasureStore));
    };

    $scope.errorAuthentication = function (securityError, unauthorizedUser) {
        $scope.registerEndForGlobalTimeOnFailure();

        $scope.ad.dataLoadedError = true;
        $scope.ad.unauthorizedUser = unauthorizedUser;
        if (securityError) {
            Auth.logout();
            var absUrl = $location.absUrl();
            if (absUrl.indexOf("/connect/") !== -1) {
                $window.open("/connect", "_self");
            } else {
                $window.open("/", "_self");
            }
        }
    };

    $scope.checkVersion = function () {
        if (angular.isDefined($rootScope.versionInterval)) {
            return;
        }

        $rootScope.versionInterval = $interval(function () {
            EnvironmentSrv.getVersion().then(function (version) {
                if ($scope.ad.loggedUser.serverIdentification.version !== version) {
                    $rootScope.displayReloadMessage = true;
                    $scope.stopCheckVersion();
                }
            }, function (error) {
                if (error.status === 401) {
                    $scope.stopCheckVersion();
                    Auth.logout();
                } else {
                    console.warn("FlexyBeautyApp.controllers - checkVersion " + error.message);
                }
            });
        }, Environment_Constant.VERSION_CHECK_FREQUENCY_MILLISECOND);
    };

    $scope.stopCheckVersion = function () {
        if (angular.isDefined($rootScope.versionInterval)) {
            $interval.cancel($rootScope.versionInterval);
            $rootScope.versionInterval = undefined;
        }
    };

    $scope.onAuthenticationLost = function () {
        $scope.logout(true);
    };

    $scope.hideNewLoadingAlert = function () {
        var hideTextTimer = $timeout(function () {
            $rootScope.hideNewLoadingText = true;
        }, 1500);

        var hideAlertTimer = $timeout(function () {
            $rootScope.hideNewLoadingPop = true;
            $timeout.cancel(hideTextTimer);
            $timeout.cancel(hideAlertTimer);
        }, 2500);
    };

    $scope.getKiuteProAppIframeUrl = function () {
        var iframeUrl = Constants.KIUTE_PRO_APP.local;

        if (!$scope.ad.loggedUser.serverIdentification) {
            return $sce.trustAsResourceUrl(iframeUrl);
        }

        if ($scope.ad.loggedUser.serverIdentification.applicationId === 'bsiflexyprod') {
            iframeUrl = Constants.KIUTE_PRO_APP.prod;
        } else {
            iframeUrl = Constants.KIUTE_PRO_APP.staging;
        }
        return $sce.trustAsResourceUrl(iframeUrl);
    };

    $scope.loadData = function () {
        Loader.load(function () {
            $scope.ad.loggedUser = UserData.getLoggedUser();

            // FIXME: OneA-in-Core feauture
            // $scope.ad.kiuteProAppIframeUrl = $scope.getKiuteProAppIframeUrl();

            Auth.createChannel($scope.ad.currentUser).then(function (user) {

                $scope.loadDomainAndSubDomain();
                $scope.ad.currentUser = user;
                var afterLocalLoad = function afterLocalLoad() {
                    try {
                        CurrencyManager.setByCurrency($scope.ad.loggedUser.company.currency);
                        $scope.initCompanyView();
                        DateSrv.doReload();
                        if ($scope.ad.loggedUser.serverIdentification && $scope.ad.loggedUser.serverIdentification.currentDate && IS_PERIODIC_GET_USER_ACTION_ACTIVATED) {
                            UserActionManager.currentPopDate = $scope.ad.loggedUser.serverIdentification.currentDate;
                            $scope.applyNewUserActionPopInterval(Constants.USER_ACTION_DATE_INTERVAL_NORMAL_ACTIVITY_IN_MILLI_SECONDS);
                            Idle.watch();
                        }

                        $scope.ad.managerMode = !$scope.ad.loggedUser.hasManagerPassword || Auth.isAdmin();
                        Helper.managerMode = $scope.ad.managerMode;
                        $scope.loadSubscriptionStoreAppActivities();
                        $scope.loadIZettleAppAttribute();
                        $scope.ad.currentSiteName = SiteData.defaultSite.name;
                        $scope.ad.companyMigrationSettings = CompanyMigrationSettingsData.companyMigrationSettings;
                        $scope.displayNeedToUpdateMangopay();
                        $scope.displayBannerPopUp();
                        $scope.initBannerStyle();
                        $scope.ad.dataLoaded = true;
                        $scope.initTheme();
                        $scope.initDisplayStartWindow();
                        $scope.loadOrCountNotification();

                        $(document).ready(function () {
                            if ($scope.ad.currentSiteName && $scope.ad.currentSiteName != undefined) var titlePart = gettextCatalog.getString("Application");
                            document.title = $scope.ad.currentSiteName + " - " + $scope.ad.brand.label + " - " + titlePart;
                            $scope.removeMetaDescription();
                        });

                        var setAttributeOnLiveEdit = function setAttributeOnLiveEdit() {
                            if ($('#lokalise-live-js-panel').is(':visible')) {
                                //if the container is visible on the page
                                $("#lokalise-live-js-panel").attr("generalliveedit", true);
                            } else {
                                setTimeout(setAttributeOnLiveEdit, 50); //wait 50 ms, then try again
                            }
                        };
                        angular.element(document).ready(function () {
                            setAttributeOnLiveEdit();
                        });

                        //End activate
                        if ($scope.ad.loggedUser.company.type === CompanyTypes.BLOCKED || $scope.ad.loggedUser.company.type === CompanyTypes.BILLINGBLOCKED) {
                            $scope.goToDomain(Constants.APP_SUB_DOMAIN.flexyBeauty, Constants.APP_SUB_DOMAIN.paymentMode);
                        } else {
                            $scope.displayMigrationInfoCountdown('appLoading');
                            var isPlanningPosDomain = $scope.ad.absUrl.indexOf("/app/" + Constants.APP_DOMAIN.planningPos) !== -1;
                            var isPlanningSubDomain = $scope.ad.absUrl.indexOf("sDm=" + Constants.APP_SUB_DOMAIN.planning) !== -1;
                            if (isPlanningPosDomain && !isPlanningSubDomain) {
                                $scope.goToSubDomain(Constants.APP_SUB_DOMAIN.planning);
                            } else if (!isPlanningPosDomain) {
                                $scope.goToDomain(Constants.APP_DOMAIN.planningPos, Constants.APP_SUB_DOMAIN.planning);
                            }
                        }

                        var isChromium = window.chrome,
                            vendorName = window.navigator.vendor;
                        var isWebkit = 'WebkitAppearance' in document.documentElement.style;
                        if (navigator.userAgent.indexOf("Mobile") !== -1) {
                            if (!isWebkit) //no webkit on mobile alert !
                                MessageSrv.send("alert", gettextCatalog.getString("Vous n'utilisez pas Chrome !") + '<br/>' + gettextCatalog.getString("{{brandLabel}} nécessite le navigateur Chrome.", { brandLabel: $scope.ad.brand.label }) + '<a href="https://www.google.fr/chrome" target="_blank"><i class="fal fa-download"></i>' + gettextCatalog.getString("Télécharger") + '</a>');
                        } else if (!(isChromium !== null && isChromium !== undefined && vendorName === "Google Inc.") && navigator.userAgent.indexOf("Chrome") === -1 && navigator.userAgent.indexOf("CriOS") === -1) MessageSrv.send("alert", gettextCatalog.getString("Vous n'utilisez pas Chrome !") + '<br/>' + gettextCatalog.getString("{{brandLabel}} nécessite le navigateur Chrome.", { brandLabel: $scope.ad.brand.label }) + '<a href="https://www.google.fr/chrome" target="_blank"><i class="fal fa-download"></i>' + gettextCatalog.getString("Télécharger") + '</a>');
                        console.timeEnd("Application");

                        var timer = $timeout(function () {
                            var warning = gettextCatalog.getString('Vous devez recharger l\'application');
                            MessageSrv.send("warning", warning + " !");
                        }, 86400000);

                        timers.push(timer);

                        $scope.loadAgendaNotificationParameters('internet');

                        var currentperiod = new PeriodStat(StatPeriodType.CURRENT, new moment(), new moment(), PeriodType.DAY);
                        $scope.loadAgendaNotification(currentperiod);

                        $scope.checkVersion();

                        if ($rootScope.canAccessNewLoading) {
                            MeasureStore.registerEnd(TimeMeasures.MODEL_GLOBAL_TIME_STARTUP);
                        } else {
                            MeasureStore.registerEnd(TimeMeasures.MODEL_GLOBAL_TIME);
                        }
                    } catch (e) {
                        $scope.registerEndForGlobalTimeOnFailure();
                    }

                    $scope.loadExternalServices();
                };

                if ($scope.ad.loggedUser) {
                    afterLocalLoad();
                } else {
                    $scope.ad.dataLoadedError = true;
                    $scope.registerEndForGlobalTimeOnFailure();
                }
            }, function () {
                $scope.errorAuthentication(false);
            });
        }, function (securityError, companyTypeCanceled) {
            $scope.errorAuthentication(securityError, companyTypeCanceled);
        }, function () {
            $rootScope.newLoadingInProgress = false;
            $scope.hideNewLoadingAlert();

            if (Loader.loaded) {
                $rootScope.$broadcast('onGlobalLoadingFinished');
            }
        });
    };

    $scope.removeMetaDescription = function () {
        var metaTags = document.getElementsByTagName('meta');
        if (metaTags) {
            var metaDescription = metaTags['description'];
            if (metaDescription) {
                metaDescription.remove();
            }
        }
    };

    $scope.getUserTooltip = function () {
        var noPaimentWay = gettextCatalog.getString('Aucun moyen de paiement!');
        var userTooltip = '';
        if ($scope.ad && $scope.ad.loggedUser) {
            var company = $scope.ad.loggedUser.company;
            var currentUserEmail = $scope.ad.currentUser ? $scope.ad.currentUser.email : '';
            if (company) {
                if (company.companyPaymentData != null && company.companyPaymentData.isValid) {
                    userTooltip = currentUserEmail;
                } else {
                    userTooltip = noPaimentWay + ' ' + loggedUser.company.name + ' ' + currentUserEmail;
                }
            }
        }
        return userTooltip;
    };
    $scope.formatTime = function (time) {
        var timeMoment = new moment().hour(time.hour).minute(time.minute);
        return timeMoment.format("LT");
    };

    $scope.loadAgendaNotificationParameters = function (type) {
        $scope.ad.view.notificationDisplayParameters = {
            type: type,
            beginMoment: new moment(),
            endMoment: new moment(),
            periodType: PeriodType.DAY,
            typeModification: TypeOfModification.ALL,
            displayAgendaNotifs: true
        };
    };

    $scope.loadAgendaNotification = function (currentPeriod) {
        $scope.userActions = [];

        var currentDate = $filter('date')(currentPeriod.arrayOfDays[0].getDate(), 'yyyy-MM-dd');

        var todayDate = new Date();
        var twoWeeksAgoDate = $filter('date')(todayDate.setDate(todayDate.getDate() - 14), 'yyyy-MM-dd');

        var absUrl = $location.absUrl();

        if (currentDate <= twoWeeksAgoDate && absUrl.indexOf("/fxbAdmin/") === -1) $scope.ad.view.notificationDisplayParameters.displayAgendaNotifs = false;else {
            $scope.ad.view.notificationDisplayParameters.displayAgendaNotifs = true;

            UserActionSrv.getUserActionBooking(currentDate).then(function (data) {
                var userActionsRes = data ? data.userActions : {};
                if (userActionsRes) {
                    var k;

                    (function () {
                        var labelHrModified = gettextCatalog.getString("Modification du personnel de la prestation"),
                            labelPrModified = gettextCatalog.getString("Modification de l'équipement de la prestation"),
                            labelTimeBsModified = gettextCatalog.getString("Modification de l'horaire de la prestation"),
                            labelBsAdded = gettextCatalog.getString("Ajout d'une prestation à la réservation"),
                            labelBsDeleted = gettextCatalog.getString("Suppression d'une prestation de la réservation"),
                            labelNotFoundCustomer = gettextCatalog.getString("Client introuvable"),
                            labelPassageCustomer = gettextCatalog.getString("Un client de passage"),
                            labelDateServiceModified = gettextCatalog.getString("Modification du jour de la réservation"),
                            labelTimeServiceModified = gettextCatalog.getString("Modification de l'horaire de la réservation");

                        var _loop = function _loop(i) {

                            var ua = {
                                globalType: userActionsRes[i].globalType,
                                hr: HumanResourceData.getById(userActionsRes[i].authorId),
                                actionDate: new Date(userActionsRes[i].actionDate),
                                booking: {
                                    currentVersion: null,
                                    previousVersion: null
                                },
                                updateType: null,
                                isLastmodification: true
                            };

                            var _loop2 = function _loop2(j) {
                                var currentDayHr = void 0,
                                    previousDayHr = void 0,
                                    previousDayPr = void 0,
                                    currentDayPr = void 0,
                                    currentHr = void 0,
                                    previousHr = void 0,
                                    currentPr = void 0,
                                    previousPr = void 0,
                                    objModifications = userActionsRes[i].objectModifications[j];

                                try {
                                    var addServiceModifications = function addServiceModifications(currentBookingService, previousBookingService) {
                                        try {

                                            if (previousBookingService == null) {
                                                currentDayHr = DayHrData.getById(currentBookingService.dayHrId);
                                                if (currentDayHr && currentDayHr.humanResourceId != null) {
                                                    currentHr = HumanResourceData.getById(currentDayHr.humanResourceId);
                                                    ua.updateType += (ua.updateType !== "" ? ".<br />" : "") + labelBsAdded + ": '" + currentBookingService.label + "' : " + currentHr.label + " " + $scope.formatTime(currentBookingService.period.start) + "-" + $scope.formatTime(currentBookingService.period.end);
                                                }
                                            } else if (currentBookingService && previousBookingService && currentBookingService.isDeleted) {
                                                currentDayHr = DayHrData.getById(currentBookingService.dayHrId);
                                                if (currentDayHr && currentDayHr.humanResourceId != null) {
                                                    currentHr = HumanResourceData.getById(currentDayHr.humanResourceId);
                                                    ua.updateType += (ua.updateType !== "" ? ".<br />" : "") + labelBsDeleted + ": '" + currentBookingService.label + "' : " + currentHr.label + " " + $scope.formatTime(previousBookingService.period.start) + "-" + $scope.formatTime(previousBookingService.period.end);
                                                }
                                            } else {
                                                if (currentBookingService.dayHrId && previousBookingService.dayHrId && currentBookingService.dayHrId !== previousBookingService.dayHrId) {
                                                    currentDayHr = DayHrData.getById(currentBookingService.dayHrId);
                                                    previousDayHr = DayHrData.getById(previousBookingService.dayHrId);
                                                    if (currentDayHr && previousDayHr && currentDayHr.humanResourceId !== previousDayHr.humanResourceId) {
                                                        currentHr = HumanResourceData.getById(currentDayHr.humanResourceId);
                                                        previousHr = HumanResourceData.getById(previousDayHr.humanResourceId);
                                                        ua.updateType += (ua.updateType !== "" ? ".<br />" : "") + labelHrModified + " '" + currentBookingService.label + "' : " + previousHr.label + "&nbsp;<i class='fa fa-arrow-right'></i>&nbsp;" + currentHr.label;
                                                    }
                                                } else if (previousBookingService.dayHrId && !currentBookingService.dayHrId) {
                                                    previousDayHr = DayHrData.getById(previousBookingService.dayHrId);
                                                    if (previousDayHr && previousDayHr.humanResourceId) {
                                                        previousHr = HumanResourceData.getById(previousDayHr.humanResourceId);
                                                        ua.updateType += (ua.updateType !== "" ? ".<br />" : "") + labelHrModified + " '" + previousBookingService.label + "' : " + previousHr.label + "&nbsp;<i class='fa fa-arrow-right'></i>&nbsp;" + "???";
                                                    }
                                                } else if (currentBookingService.dayHrId && previousBookingService.period && !$scope.comparePeriods(previousBookingService.period, currentBookingService.period)) {
                                                    ua.updateType += (ua.updateType !== "" ? ".<br />" : "") + labelTimeBsModified + " : " + $scope.formatTime(previousBookingService.period.start) + "-" + $scope.formatTime(previousBookingService.period.end) + "&nbsp;<i class='fa fa-arrow-right'></i>&nbsp;" + $scope.formatTime(currentBookingService.period.start) + "-" + $scope.formatTime(currentBookingService.period.end);
                                                }

                                                if (currentBookingService.dayPrId && previousBookingService.dayPrId && currentBookingService.dayPrId !== previousBookingService.dayPrId) {
                                                    currentDayPr = DayPrData.getById(currentBookingService.dayPrId);
                                                    previousDayPr = DayPrData.getById(previousBookingService.dayPrId);
                                                    if (currentDayPr && previousDayPr && currentDayPr.physicalResourceId !== previousDayPr.physicalResourceId) {
                                                        currentPr = PhysicalResourceData.getById(currentDayPr.physicalResourceId);
                                                        previousPr = PhysicalResourceData.getById(previousDayPr.physicalResourceId);
                                                        ua.updateType += (ua.updateType !== "" ? ".<br />" : "") + labelPrModified + " '" + currentBookingService.label + "' : " + previousPr.label + "&nbsp;<i class='fa fa-arrow-right'></i>&nbsp;" + currentPr.label;
                                                    }
                                                } else if (previousBookingService.dayPrId && !currentBookingService.dayPrId) {
                                                    previousDayPr = DayPrData.getById(previousBookingService.dayPrId);
                                                    if (previousDayPr && previousDayPr.physicalResourceId) {
                                                        previousPr = PhysicalResourceData.getById(previousDayPr.physicalResourceId);
                                                        ua.updateType += (ua.updateType !== "" ? ".<br />" : "") + labelPrModified + " '" + previousBookingService.label + "' : " + previousPr.label + "&nbsp;<i class='fa fa-arrow-right'></i>&nbsp;" + "???";
                                                    }
                                                } else if (currentBookingService.dayPrId && previousBookingService.period && !$scope.comparePeriods(previousBookingService.period, currentBookingService.period)) {
                                                    ua.updateType += (ua.updateType !== "" ? ".<br />" : "") + labelTimeBsModified + " : " + $scope.formatTime(previousBookingService.period.start) + "-" + $scope.formatTime(previousBookingService.period.end) + "&nbsp;<i class='fa fa-arrow-right'></i>&nbsp;" + $scope.formatTime(currentBookingService.period.start) + "-" + $scope.formatTime(currentBookingService.period.end);
                                                }
                                            }
                                        } catch (err) {
                                            console.error("Error while processing the userAction : CurrentBookingServiceId : " + (currentBookingService ? currentBookingService.id : "null ") + ", PreviousBookingServiceId : " + (previousBookingService ? previousBookingService.id : "null "));
                                        }
                                    };

                                    if (objModifications.currentVersion.objectType === "Booking") {
                                        ua.booking.currentVersion = objModifications.currentVersion;
                                        ua.booking.currentVersion.date = DayData.getById(objModifications.currentVersion.dayId).getDate();

                                        var currentCustomer = objModifications.currentVersion.customerId ? CustomerData.getById(objModifications.currentVersion.customerId) : null;

                                        ua.booking.currentVersion.customerLabel = objModifications.currentVersion.customerId ? currentCustomer ? currentCustomer.firstName + " " + currentCustomer.lastName : labelNotFoundCustomer : labelPassageCustomer;
                                        ua.booking.previousVersion = objModifications.previousVersion;
                                        if (objModifications.previousVersion) {
                                            var previousCustomer = objModifications.previousVersion.customerId ? CustomerData.getById(objModifications.previousVersion.customerId) : null;

                                            ua.booking.previousVersion.customerLabel = objModifications.previousVersion.customerId ? previousCustomer ? previousCustomer.firstName + " " + previousCustomer.lastName : labelNotFoundCustomer : labelPassageCustomer;
                                            ua.booking.previousVersion.date = DayData.getById(objModifications.previousVersion.dayId).getDate();
                                        }

                                        if (userActionsRes[i].globalType === "update" && objModifications.currentVersion && objModifications.previousVersion) {
                                            ua.updateType = "";

                                            var indexBooking = BookingData.getIndexOf(BookingData.getById(objModifications.currentVersion.id));
                                            if (indexBooking === -1) {
                                                ua.isLastmodification = false;
                                            }

                                            if (objModifications.currentVersion.dayId !== objModifications.previousVersion.dayId) {

                                                var currentDay = DayData.getById(objModifications.currentVersion.dayId),
                                                    previousDay = DayData.getById(objModifications.previousVersion.dayId);
                                                if (currentDay && previousDay) {
                                                    var currentMoment = currentDay.getMomentDate(),
                                                        previousMoment = previousDay.getMomentDate();
                                                    if (currentMoment && previousMoment) {
                                                        ua.updateType += (ua.updateType !== "" ? ".<br />" : "") + labelDateServiceModified + " : " + previousMoment.format("L") + "&nbsp;<i class='fa fa-arrow-right'></i>&nbsp;" + currentMoment.format("L");
                                                    }
                                                }
                                            }
                                            if (objModifications.currentVersion.period.start.hour !== objModifications.previousVersion.period.start.hour || objModifications.currentVersion.period.start.minute !== objModifications.previousVersion.period.start.minute || objModifications.currentVersion.period.end.hour !== objModifications.previousVersion.period.end.hour || objModifications.currentVersion.period.end.minute !== objModifications.previousVersion.period.end.minute) {
                                                ua.updateType += (ua.updateType !== "" ? ".<br />" : "") + labelTimeServiceModified + " : " + $scope.formatTime(objModifications.previousVersion.period.start) + "-" + $scope.formatTime(objModifications.previousVersion.period.end) + "&nbsp;<i class='fa fa-arrow-right'></i>&nbsp;" + $scope.formatTime(objModifications.currentVersion.period.start) + "-" + $scope.formatTime(objModifications.currentVersion.period.end);
                                            }

                                            for (var _k = 0; _k < objModifications.currentVersion.bookingServicesDetail.length; _k++) {
                                                var currentBookingService = objModifications.currentVersion.bookingServicesDetail[_k];
                                                if (currentBookingService.isPackage === false) {
                                                    for (var l = 0; l < objModifications.previousVersion.bookingServicesDetail.length; l++) {
                                                        var previousBookingService = objModifications.previousVersion.bookingServicesDetail[l];

                                                        if (currentBookingService.idInBooking === previousBookingService.idInBooking) {
                                                            addServiceModifications(currentBookingService, previousBookingService);
                                                            break;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        ua.booking.currentVersion.bookingLabels = "";
                                        for (k = 0; k < objModifications.currentVersion.bookingServicesDetail.length; k++) {
                                            ua.booking.currentVersion.bookingLabels += (ua.booking.currentVersion.bookingLabels !== "" ? ", " : "") + objModifications.currentVersion.bookingServicesDetail[k].label;
                                        }
                                        if (ua.booking.previousVersion) {
                                            ua.booking.previousVersion.bookingLabels = "";
                                            for (var _k2 = 0; _k2 < objModifications.previousVersion.bookingServicesDetail.length; _k2++) {
                                                ua.booking.previousVersion.bookingLabels += (ua.booking.previousVersion.bookingLabels !== "" ? ", " : "") + objModifications.previousVersion.bookingServicesDetail[_k2].label;
                                            }
                                        }
                                    } else if (objModifications.currentVersion.objectType === "BookingService") {
                                        if (userActionsRes[i].globalType === "update" && objModifications.currentVersion && objModifications.previousVersion) {
                                            if (objModifications.currentVersion.isPackage === false && objModifications.currentVersion.pkgId) {
                                                addServiceModifications(objModifications.currentVersion, objModifications.previousVersion);
                                            }
                                        }
                                    }
                                } catch (err) {
                                    console.info("Error getting planning update " + err);
                                }
                            };

                            for (var j = 0; j < userActionsRes[i].objectModifications.length; j++) {
                                _loop2(j);
                            }
                            $scope.userActions.push(ua);
                        };

                        for (var i = 0; i < userActionsRes.length; i++) {
                            _loop(i);
                        }
                    })();
                }
            }).catch(function (error) {
                bugsnag.notify("UserActionSrv.getUserActionBooking - Error during fetching userAction booking", 'GetUserActionBooking failure. Error : ' + error.message, {}, Constants.BUGSNAG_NOTIFICATION_LEVEL);
            });
        }
    };

    $scope.comparePeriods = function (period1, period2) {
        return period1 != null && period2 != null && $scope.compareTimes(period1.start, period2.start) && $scope.compareTimes(period1.end, period2.end);
    };

    $scope.compareTimes = function (time1, time2) {
        return time1 && time2 && time1.hour === time2.hour && time1.minute === time2.minute;
    };

    $scope.toggleLiveEdit = function () {
        if ($scope.ad.domain !== 'webSite') {
            $("div[generalliveedit=true]").toggle();
        } else {
            $("div[generalliveedit=true]").hide();
            //$("div[websiteliveedit=true]", $('#webSiteFrame').html()).toggle();
            $('#webSiteFrame').contents().find("div[websiteliveedit=true]").toggle();
        }
    };

    $scope.hideGeneralLiveEdit = function () {
        $("div[generalliveedit=true]").hide();
    };

    $scope.goToWebSiteDomain = function () {
        if (OfferManager.hasCompanyAccessToFeature($scope.ad.loggedUser.company, StoreAppCode.OPTION_WEBSITE)) {
            $scope.hideGeneralLiveEdit();
            $scope.goToDomain('webSite');
        }
    };

    $scope.checkMarketplaceComplianceIfNeeded = function () {
        if (!$scope.ad.isMarketplaceCompliant && $scope.ad.loggedUser.company) {
            var marketPlaceCompliant = new MarketPlaceSpecifications.MarketPlaceCompliant();
            $scope.ad.isMarketplaceCompliant = marketPlaceCompliant.isSatisfiedBy($scope.ad.loggedUser.company, $scope.ad.managerMode);
        }
        return $scope.ad.isMarketplaceCompliant;
    };

    $scope.navigateToNgApp = function (data) {
        $scope.ngAppCustomerIframe = document.getElementById("ngAppCustomerIframe");
        if ($scope.ngAppCustomerIframe && $scope.ngAppCustomerIframe.contentWindow) {
            $scope.ngAppCustomerIframe.contentWindow.postMessage(data, "*");
        }
    };

    $scope.tabAlreadyOpen = function () {
        if ($rootScope.canAccessDoubleTabBlocked) {
            localStorage.openpages = Date.now();
            window.addEventListener('storage', function (event) {
                var localStorageVariable = 'page_available_' + Auth.getCompanyCode() + '_admin_' + Auth.isAdmin();
                if (event.key == "openpages") {
                    localStorage[localStorageVariable] = Date.now();
                    $scope.ad.isAlreadyOpenTab = false;
                }
                if (event.key == localStorageVariable) {
                    $scope.ad.isAlreadyOpenTab = true;
                    $scope.setDisplayStartWindow(true);
                }
            }, false);
        }
    };

    if (!$scope.ad.dataLoaded) {
        LaunchDarklyFeatureFlagSrv.query(function () {
            $rootScope.canAccessNewLoading = LaunchDarklyFeatureFlagData.canAccessNewLoading;
            $rootScope.canAccessKiuteProApp = LaunchDarklyFeatureFlagData.canAccessKiuteProApp;
            $rootScope.canAccessDoubleTabBlocked = LaunchDarklyFeatureFlagData.canAccessDoubleTabBlocked;

            if ($rootScope.canAccessNewLoading) {
                $rootScope.newLoadingInProgress = true;
                MeasureStore.registerStart(TimeMeasures.MODEL_GLOBAL_TIME_STARTUP);
            } else {
                MeasureStore.registerStart(TimeMeasures.MODEL_GLOBAL_TIME);
            }

            $scope.tabAlreadyOpen();
            if (!$scope.ad.isAlreadyOpenTab) {
                $scope.loadData();
            }
        }, function (error) {
            $scope.ad.dataLoadedError = true;
            $scope.registerEndForGlobalTimeOnFailure();
            if (error.status === 401) {
                Auth.logout();
            }
        });
    } else {
        $scope.loadDomainAndSubDomain();
        $scope.ad.loggedUser = UserData.getLoggedUser();
        $scope.loadSubscriptionStoreAppActivities();
        $scope.ad.currentSiteName = SiteData.defaultSite.name;
        if (NotificationData.unreadNotifications !== undefined) {
            $scope.ad.view.nbNotificationsUnread = NotificationData.unreadNotifications;
        } else {
            $scope.loadOrCountNotification();
        }
        $scope.initCompanyView();
        $scope.initTheme();
    }

    $scope.copyToClipboard = function (name) {
        var copyElement = document.getElementById(name);
        copyElement.select();
        document.execCommand('copy');
    };

    $scope.$on('$destroy', function () {
        onNotificationDestroy();
        fxbInvalidTokenDestroy();
        fxbInvalidChannelDestroy();

        Timers.cancel(timers, intervals);
    });

    $scope.$on('IdleStart', function () {
        console.info('Idle time detected : change interval to userAction date from ' + Constants.USER_ACTION_DATE_INTERVAL_NORMAL_ACTIVITY_IN_MILLI_SECONDS + ' ms to ' + Constants.USER_ACTION_DATE_INTERVAL_LOW_ACTIVITY_IN_MILLI_SECONDS + ' ms');
        $scope.applyNewUserActionPopInterval(Constants.USER_ACTION_DATE_INTERVAL_LOW_ACTIVITY_IN_MILLI_SECONDS);
    });

    $scope.$on('IdleEnd', function () {
        console.info('Activity renew detected: change interval to userAction date from ' + Constants.USER_ACTION_DATE_INTERVAL_LOW_ACTIVITY_IN_MILLI_SECONDS + ' ms to ' + Constants.USER_ACTION_DATE_INTERVAL_NORMAL_ACTIVITY_IN_MILLI_SECONDS + ' ms');
        $scope.applyNewUserActionPopInterval(Constants.USER_ACTION_DATE_INTERVAL_NORMAL_ACTIVITY_IN_MILLI_SECONDS);
    });

    $scope.applyNewUserActionPopInterval = function (interval) {
        UserActionManager.userActionDateIntervalInMilliSecond = interval;
        UserActionManager.stopPopInterval();
        intervals.splice(timers.indexOf($scope.popInterval), 1);
        UserActionManager.executeUserActionPop($scope.onAuthenticationLost);
        $scope.popInterval = UserActionManager.startUserActionPop($scope.onAuthenticationLost, interval);
        intervals.push($scope.popInterval);
    };

    $scope.isReadOnly = function () {
        return $rootScope.readOnly;
    };

    $scope.isCanceled = function () {
        return $rootScope.isCancel;
    };

    $scope.isBlockedOrBillingBlocked = function () {
        return $rootScope.isBlockedOrBillingBlocked;
    };

    $scope.getBooksyUrl = function () {
        var owner = $scope.ad.loggedUser;
        if (owner != null) {
            var companyCode = owner.company ? owner.company.code : null;

            var booksyUrl = $scope.ad.brand.url.booksyUrl + '?companyCode=' + companyCode;
            return $sce.trustAsResourceUrl(booksyUrl);
        }
    };

    $scope.openBooksyLandingPage = function () {
        var link = $scope.getBooksyUrl();
        $window.open(link, '_blank');
    };

    $scope.isAdminNotGroup = function () {
        return Auth.isAdminNotGroup();
    };

    $scope.setMigrationDisplayBanner = function (displayBanner) {
        if ($scope.ad.companyMigrationSettings) {
            CompanyMigrationSettingsSrv.displayBannerPopUp(displayBanner, function () {
                $scope.ad.companyMigrationSettings.displayBannerPopUp = displayBanner;
            });
        }
    };

    $scope.displayNeedToUpdateMangopay = function () {
        PaymentServiceSrv.getNeedToUpdateMangopay(function (response) {
            if (response && response.needUpdateMangopay === true && !$scope.ad.loggedUser.company.type !== CompanyTypes.MIGRATION.value && !$scope.ad.loggedUser.company.type !== CompanyTypes.CANCELED.value) {
                $dialog.dialog({
                    backdrop: true,
                    backdropClick: false,
                    keyboard: true,
                    templateUrl: '/partials/global/generalConfirmWithSpecificText.html',
                    controller: 'DialogCtrl',
                    resolve: {
                        dialogsModel: function dialogsModel() {
                            var tableModel = [];
                            tableModel.important = gettextCatalog.getString("Suite à la fusion entre les banques Crédit du Nord et Société Général, vos coordonnées bancaires ne sont plus valides. Veuillez mettre à jour votre IBAN avant le ");
                            tableModel.importantBold = gettextCatalog.getString("le 1er Juillet 2024");
                            tableModel.importantBody = gettextCatalog.getString(" pour éviter toute interruption de service.");
                            tableModel.subtext = gettextCatalog.getString("Attention, il faut être connecté en mode gestionnaire pour modifier ses coordonnées bancaires !");

                            tableModel.yesMessage = $scope.ad.managerMode ? "Je modifie mon IBAN" : "Je me connecte en gestionnaire et je modifie mon IBAN";
                            return tableModel;
                        }
                    }
                }).open().then(function (result) {
                    if (result) {
                        $scope.ad.managerMode ? $scope.goToDomain('flexyBeauty', 'onlinePayment') : $scope.toggleManagerMode(true);
                    }
                });
            }
        }, function () {
            return null;
        });
    };

    $scope.displayBannerPopUp = function () {
        if ($scope.ad.companyMigrationSettings && $scope.ad.companyMigrationSettings.displayBannerPopUp && $scope.showBanner()) {
            var migrationDate = new Date($scope.ad.companyMigrationSettings.forceMigrationDate);
            var options = { day: 'numeric', month: 'long', year: 'numeric' };
            var formatedDate = migrationDate.toLocaleDateString('fr-FR', options);
            $dialog.dialog({
                backdrop: true,
                backdropClick: false,
                keyboard: true,
                templateUrl: '/partials/global/generalConfirmWithSpecificText.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel.important = gettextCatalog.getString("Cette version du logiciel ");
                        tableModel.importantBold = gettextCatalog.getString("Kiute by Booksy");
                        tableModel.importantBody = gettextCatalog.getString(" s’arrête bientôt ! Afin de vous faire bénéficier de la nouvelle version de l’interface ");
                        tableModel.importantSecondBold = gettextCatalog.getString("Booksy,");
                        tableModel.importantEnd = gettextCatalog.getString(" votre compte sera migré le " + formatedDate + ".");
                        tableModel.yesMessage = "J'ai compris";
                        return tableModel;
                    }
                }
            }).open().then(function (result) {
                if (result) {
                    $scope.setMigrationDisplayBanner(false);
                }
            });
        }
    };

    $scope.computeDayDiffWithToday = function (date) {
        var oneDayMilliSeconds = 24 * 60 * 60 * 1000;
        return Math.floor((date - new Date()) / oneDayMilliSeconds);
    };

    $scope.numberDaysBeforeMigration = function () {
        return $scope.computeDayDiffWithToday($scope.ad.companyMigrationSettings.forceMigrationDate);
    };

    $scope.showBanner = function () {
        return $scope.ad.companyMigrationSettings && $scope.ad.companyMigrationSettings.forceMigrationDate && LaunchDarklyFeatureFlagData.forceMigrationDate && $scope.numberDaysBeforeMigration() > 0;
    };

    $scope.initBannerStyle = function () {
        if ($scope.showBanner()) {
            $scope.ad.topHeaderPixel = '61px';
            $scope.ad.bodyPixel = '101px';
        }
    };

    $scope.initBannerStyle();

    $scope.displayMigrationInfoCountdown = function (origin) {
        var currentSite = SiteData.defaultSite;
        var migrationInformationDate = $scope.ad.companyMigrationSettings ? $scope.ad.companyMigrationSettings.migrationInformationDate : null;
        var areMigrationInformationComplete = currentSite ? currentSite.areMigrationInformationComplete($scope.ad.addons.sub.websiteAccess, AppData.getAppByCode(AppCode.POS_APP)) : true;
        var provideMigrationInfos = migrationInformationDate && LaunchDarklyFeatureFlagData.forceMigrationInfos;
        var forcedToMigrate = $scope.ad.companyMigrationSettings && $scope.ad.companyMigrationSettings.forceMigrationDate && LaunchDarklyFeatureFlagData.forceMigrationDate;
        if ($scope.ad.loggedUser.company.type !== CompanyTypes.CANCELED.value && $scope.ad.loggedUser.company.type !== CompanyTypes.MIGRATION.value && $scope.ad.companyMigrationSettings && (forcedToMigrate == null || !$scope.ad.companyMigrationSettings.displayBannerPopUp) && !areMigrationInformationComplete && (provideMigrationInfos || forcedToMigrate)) {
            var countdown = $scope.computeDayDiffWithToday(migrationInformationDate);
            var forcedRedirectionToSite = countdown <= 0 || forcedToMigrate;
            if (forcedRedirectionToSite) {
                $scope.goToDomain('site');
            } else if (origin === 'pos') {
                $scope.goToDomain('planningPos', 'pos');
            }
            $dialog.dialog({
                backdrop: true,
                backdropClick: false,
                keyboard: true,
                templateUrl: '/partials/global/generalConfirmWithSpecificText.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        if (countdown > 15 && !forcedRedirectionToSite) {
                            tableModel.important = gettextCatalog.getString("Vous avez ");
                            tableModel.importantBold = gettextCatalog.getString(countdown - 15 + " jours");
                            tableModel.importantEnd = gettextCatalog.getString(" pour remplir les informations obligatoires dans la partie Établissement - Fiche descriptive");
                        } else {
                            tableModel.important = !forcedRedirectionToSite ? gettextCatalog.getString("Vous devez dès maintenant remplir les informations obligatoires dans la partie Établissement - Fiche descriptive") : gettextCatalog.getString("Afin de pouvoir utiliser votre caisse, merci de bien vouloir remplir les informations obligatoires dans la partie Établissement - Fiche descriptive");
                        }
                        tableModel.noMessage = !forcedRedirectionToSite ? "Plus Tard" : null;
                        tableModel.yesMessage = "Mettre à jour";
                        return tableModel;
                    }
                }
            }).open().then(function (action) {
                if (action && !forcedRedirectionToSite) {
                    $scope.goToDomain('site');
                }
            });
        } else if (origin === 'pos') {
            $scope.goToDomain('planningPos', 'pos');
        }
    };
}]);

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* Controllers */

angular.module('FlexyBeautyApp.controllers').controller('LoginCtrl', ['$rootScope', '$scope', '$location', '$window', '$routeParams', '$timeout', 'Auth', 'User', 'UserSrv', 'LanguageManager', 'gettextCatalog', 'Countries', 'LocaleList', 'CompanyType', 'Brand', 'Offers', 'OfferManager', function ($rootScope, $scope, $location, $window, $routeParams, $timeout, Auth, User, UserSrv, LanguageManager, gettextCatalog, Countries, LocaleList, CompanyType, Brand, Offers, OfferManager) {
    //Language.init();
    gettextCatalog.debug = false;
    if (navigator.language.toLowerCase() === "en" || navigator.language.toLowerCase() === "en-gb") {
        LanguageManager.initLanguageManager("en-GB");
    }
    $scope.rememberme = true;
    $scope.processingLogin = false;
    $scope.processingRegister = false;

    $scope.alertsLogin = [];
    $scope.alertsRegister = [];
    $scope.displayErrorMessage = false;
    $scope.languages = [];
    $scope.currencies = [];
    $scope.companyTypes = CompanyType;

    $scope.showPassword = false;

    $scope.brand = Brand;
    $scope.offers = Offers;

    $scope.userLogin = {
        offer: $routeParams.offer && $routeParams.offer !== '' ? $routeParams.offer : OfferManager.computeDefaultRegisterOfferCode(),
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        password: "",
        companyName: "",
        legalType: false,
        companyModel: "",
        localeCode: "fr-FR",
        currencyCode: "EUR",
        countryCode: "FR",
        companyDiscountCode: "",
        companyTypeId: "",
        isModel: false,
        companyManager: $routeParams.manager && $routeParams.manager != '' ? $routeParams.manager : null,
        role: Auth.userRoles.user
    };

    var path = $location.path();

    if (path.indexOf("model") != -1) {
        $scope.userLogin.isModel = true;
    }

    if ($routeParams.login != null && $routeParams.login != '') {
        //try to login
        var user = new User();
        user.email = $routeParams.login;
        $scope.processingLogin = true;
        $scope.addAlertLogin = [];
        Auth.loginToProSiteFromMaster(user, function (res) {
            $scope.processingLogin = false;
            var msg = gettextCatalog.getString("Connexion sécurisée établie");
            $scope.addAlertLogin('success', msg);
            $location.path('/');
        }, function (errorMessage) {
            $scope.addAlertLogin('error', errorMessage);
            $scope.processingLogin = false;
        });
    }

    $scope.getCountriesList = function () {
        return Countries.list;
    };

    $scope.getLocalesList = function () {
        return LocaleList;
    };

    $scope.getLocaleSeparator = function () {
        return LanguageManager.LOCALE_SEPARATOR;
    };

    $scope.toggleShowPassword = function () {
        $scope.showPassword = !$scope.showPassword;
    };

    $scope.ifSwitzerland = function () {
        if ($scope.userLogin.countryCode === "CH") {
            return true;
        } else {
            return false;
        }
    };
    $scope.login = function () {
        $scope.alertsLogin = [];

        if ($scope.userLogin.email == "" || $scope.userLogin.password == "") {
            var msg = gettextCatalog.getString("Merci de renseigner les champs obligatoires");
            $scope.addAlertLogin('error', msg);
            return;
        }
        var user = new User($scope.userLogin);
        $scope.processingLogin = true;

        Auth.loginToProSite(user, function (res) {
            $scope.processingLogin = false;
            var absUrl = $location.absUrl();
            if (absUrl.indexOf("/connect#/login") != -1) $window.open('/connect/' + user.companyCode, "_self");else {
                var msg = gettextCatalog.getString("Connexion sécurisée établie");
                $scope.addAlertLogin('success', msg);
                $location.path('/');
            }
        }, function (errorMessage) {
            $scope.addAlertLogin('error', errorMessage);
            $scope.processingLogin = false;
        });
    };

    $scope.register = function () {
        if ($scope.userLogin.email == "" || $scope.userLogin.companyName == "" || $scope.userLogin.companyTypeId == "" || $scope.userLogin.password == "" || $scope.userLogin.firstName == "" || $scope.userLogin.lastName == "" || $scope.userLogin.phone == "" || $scope.userLogin.displayPhoneError || !$scope.userLogin.countryCode || !$scope.userLogin.currencyCode || !$scope.userLogin.localeCode) {
            var msg = gettextCatalog.getString("Merci de renseigner les champs obligatoires");
            $scope.addAlertRegister('error', msg);
            return;
        }
        var user = new User($scope.userLogin);
        $scope.processingRegister = true;
        $scope.alerts = [];
        Auth.registerToProSite(user, function (res) {
            var msg = gettextCatalog.getString("Compte créé avec succès");
            $scope.addAlertRegister('success', msg);
            $location.path('/');
            $scope.processingRegister = false;
        }, function (errorMessage) {
            $scope.addAlertRegister('error', errorMessage);
            $scope.processingRegister = false;
        });
    };

    $scope.forgotPwd = function () {
        if ($scope.userLogin.email == "") {
            var msg = gettextCatalog.getString("Merci de renseigner l'email");
            $scope.addAlertLogin('error', msg);
            return;
        }
        var user = new User($scope.userLogin);
        $scope.processingLogin = true;
        $scope.alertsLogin = [];
        UserSrv.forgotPwd(user, function (res) {
            $scope.processingLogin = false;
            var msg = gettextCatalog.getString("Un email permettant de réinitialiser votre mot de passe vous a été envoyé");
            $scope.addAlertLogin('success', msg);
        }, function (errorMessage) {
            $scope.addAlertLogin('error', errorMessage);
            $scope.processingLogin = false;
        });
    };

    $scope.addAlertLogin = function (type, msg) {
        $scope.alertsLogin.push({ type: type, msg: msg });
    };

    $scope.closeAlertLogin = function (index) {
        $scope.alertsLogin.splice(index, 1);
    };
    $scope.addAlertRegister = function (type, msg) {
        $scope.alertsRegister.push({ type: type, msg: msg });
    };

    $scope.closeAlertRegister = function (index) {
        $scope.alertsRegister.splice(index, 1);
    };
}]);

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* Controllers */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

angular.module('FlexyBeautyApp.controllers').controller('ManagerModeCtrl', ["$scope", "$rootScope", "dialog", "dialogsModel", "UserSrv", "$window", function ($scope, $rootScope, dialog, dialogsModel, UserSrv, $window) {
    $scope.ad = dialogsModel.ad;
    $scope.dd = {
        alerts: [],
        mode: "quit", // quit / login / register
        processing: false,
        user: {
            password: "",
            passwordManager: "",
            passwordManagerConfirm: ""
        }
    };
    if ($scope.ad.managerMode && !$scope.ad.loggedUser.hasManagerPassword) $scope.dd.mode = "register";else if (!$scope.ad.managerMode) $scope.dd.mode = "login";

    $scope.dialog = dialog;
    $scope.cancel = function () {
        dialog.close(false);
    };

    $scope.updateKiuteProUser = function (managerMode) {
        if ($window['kiuteProUser']) {
            var newKiuteProUser = _extends({}, $window['kiuteProUser'], { managerMode: managerMode });
            $window['kiuteProUser'] = newKiuteProUser;
        }
    };

    $scope.quitManagerMode = function () {
        $scope.updateKiuteProUser(false);
        dialog.close(true);
    };
    $scope.loginManagerMode = function () {
        $scope.dd.alerts = [];
        if ($scope.dd.user.passwordManager == "" && $scope.ad.loggedUser.hasManagerPassword) {
            $scope.addAlert('error', "Merci de renseigner les champs obligatoires");
            return;
        }
        if (!$scope.ad.loggedUser.hasManagerPassword) {
            $scope.updateKiuteProUser(true);
            dialog.close(true);
        } else {
            $scope.dd.processing = true;

            UserSrv.loginManagerMode($scope.ad.loggedUser, $scope.dd.user.passwordManager, function (res) {
                $scope.dd.processing = false;
                dialog.close(true);
                $scope.updateKiuteProUser(true);
            }, function (errorMessage) {
                $scope.addAlert('error', errorMessage);
                $scope.dd.processing = false;
            });
        }
    };

    $scope.registerManagerMode = function () {
        $scope.dd.alerts = [];
        if ($scope.dd.user.password == "") {
            $scope.addAlert('error', "Merci de renseigner les champs obligatoires");
            return;
        }
        if ($scope.dd.user.passwordManager != $scope.dd.user.passwordManagerConfirm) {
            $scope.addAlert('error', "Les mots de passe « Gestionnaire » ne sont pas identiques");
            return;
        }
        $scope.dd.processing = true;

        UserSrv.registerManagerMode($scope.ad.loggedUser, $scope.dd.user.password, $scope.dd.user.passwordManager, function (res) {
            $scope.dd.processing = false;
            $scope.updateKiuteProUser(false);
            if ($scope.dd.user.passwordManager != null && $scope.dd.user.passwordManager != "") {
                $scope.ad.loggedUser.hasManagerPassword = true;
            } else {
                $scope.ad.loggedUser.hasManagerPassword = false;
            }
            dialog.close(true);
        }, function (errorMessage) {
            $scope.addAlert('error', errorMessage);
            $scope.dd.processing = false;
        });
    };

    $scope.addAlert = function (type, msg) {
        $scope.dd.alerts.push({ type: type, msg: msg });
    };

    $scope.closeAlert = function (index) {
        $scope.dd.alerts.splice(index, 1);
    };
}]);

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('WorkingPeriodCtrl', ["$scope", function ($scope) {

    $scope.workingPeriods = [];
    $scope.inCreationWorkingPeriod = null;

    $scope.endCellSelection = function () {
        if ($scope.inCreationWorkingPeriod) $scope.endWorkingPeriod();
        if ($scope.inCreationBookingFree) $scope.endBookingFree();
    };

    $scope.startWorkingPeriod = function (day, hourPart, humanResource) {
        if ($scope.currentWorkingPeriod) {
            //TODO cancel modif ?
        }
        $scope.inCreationWorkingPeriod = new WorkingPeriod(null, day, humanResource, hourPart.startTime, hourPart.endTime);
        $scope.currentWorkingPeriod = $scope.inCreationWorkingPeriod;
        $scope.inCreationWorkingPeriod.addHourPart(day, hourPart, humanResource);
    };
    $scope.setWorkingPeriod = function (day, hourPart, humanResource) {
        if ($scope.inCreationWorkingPeriod) $scope.inCreationWorkingPeriod.addHourPart(day, hourPart, humanResource);else hourPart._display = humanResource;
    };

    $scope.endWorkingPeriod = function () {
        if ($scope.inCreationWorkingPeriod) {
            $scope.inCreationWorkingPeriod.finalize($scope);
            $scope.inCreationWorkingPeriod = null;
            $scope.currentWorkingPeriod = null;
        }
    };
    $scope.workingPeriodClicked = function (workingPeriod) {
        $scope.currentWorkingPeriod = workingPeriod;
    };

    $scope.workingPeriodEditedValidation = function () {
        $scope.currentWorkingPeriod = null;
    };
    $scope.workingPeriodEditedRemove = function (mustRemoveFromInternet, bookingDay) {
        if (mustRemoveFromInternet) $scope.currentWorkingPeriod.removeFromInternet(bookingDay);else $scope.currentWorkingPeriod.remove(bookingDay);
        $scope.currentWorkingPeriod = null;
    };

    $scope.getWorkingPeriodSelectionClass = function (day, hourPart, humanResource, className) {
        //if ($scope.inCreationWorkingPeriod)
        {
            if (humanResource) {
                if (hourPart._selectedForHr && hourPart._selectedForHr === humanResource) return className;else if (hourPart.workingHr.indexOf(humanResource) != -1) return className;
            } else if (hourPart._selectedForDefault || hourPart._activeForDefault) return className;

            if (day.referenceDay) return $scope.getWorkingPeriodSelectionClass(day.referenceDay, day.referenceDay.hourParts[day.hourParts.indexOf(hourPart)], humanResource, className);
        }
        return "";
    };
    $scope.getWorkingPeriodClassNotInherit = function (workingPeriod, className) {
        if (workingPeriod.humanResource && !workingPeriod.inherit) {
            return className;
        }
        return "";
    };

    $scope.getWorkingPeriodTopPos = function (workingPeriod) {
        if (workingPeriod == null) return 0;
        var startDateTime = new Date(workingPeriod.startDateTime);
        var pixelByMinute = $scope.periodHeight * 4 / 60;
        return (startDateTime.getHours() * 60 + startDateTime.getMinutes() - 60 * 10) * pixelByMinute;
    };
    $scope.getWorkingPeriodInternetTopPos = function (workingPeriod) {
        if (workingPeriod == null) return 0;
        var startDateTime = new Date(workingPeriod.internetStartDateTime);
        var pixelByMinute = $scope.periodHeight * 4 / 60;
        return (startDateTime.getHours() * 60 + startDateTime.getMinutes() - 60 * 10) * pixelByMinute;
    };
    $scope.getWorkingPeriodLeftPos = function (workingPeriod) {
        if (workingPeriod == null) return 0;
        var resource = workingPeriod.humanResource;
        if (resource != null) {
            var indexResource = $scope.humanResourcesToDisplay.indexOf(resource);
            return ($scope.bookingServiceWidth + 9.5) * ($scope.displaySiteTime + indexResource);
        }
        return 0;
    };
    $scope.getWorkingPeriodHeight = function (workingPeriod) {
        if (workingPeriod == null) return 0;
        var duration = workingPeriod.endDateTime - workingPeriod.startDateTime; //ms
        var pixelByMinute = $scope.periodHeight * 4 / 60;
        return duration * pixelByMinute / (1000 * 60) - 6;
    };
    $scope.getWorkingPeriodInternetHeight = function (workingPeriod) {
        if (workingPeriod == null) return 0;
        var duration = workingPeriod.internetEndDateTime - workingPeriod.internetStartDateTime; //ms
        var pixelByMinute = $scope.periodHeight * 4 / 60;
        return duration * pixelByMinute / (1000 * 60) - 6;
    };

    $scope.getWorkingPeriodDetailsLeftPos = function (workingPeriod) {
        if (workingPeriod == null) return 0;
        var resource = workingPeriod.humanResource;
        if (resource != null) {
            var indexResource = $scope.humanResourcesToDisplay.indexOf(resource);
            var leftPos = ($scope.bookingServiceWidth + 10) * (1 + indexResource);
        }
        return 0;
    };
    $scope.getPeriodTimeFromPixelOnY = function (pixel) {
        var pixelByMinute = $scope.periodHeight * 4 / 60;
        return Math.round(pixel / pixelByMinute * (1000 * 60));
    };
}]);

/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by mathieudeumie on 30/04/2014.
 */

angular.module('FlexyBeautyApp.controllers').controller('AppConfigCtrl', ["$scope", "App", "AppSrv", "AppData", "AppAttribute", "$location", function ($scope, App, AppSrv, AppData, AppAttribute, $location) {
    $scope.dd = {
        appList: [],
        newAppCode: "",
        newAppCreating: null,
        newAppAttribute: {
            code: "",
            value: "",
            text: ""
        },
        edited: null,
        once: 0
    };

    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue) {
            $scope.dd.appList = AppData.getAppList();
        }
    });

    $scope.createApp = function (appCode) {
        var newApp = new App();
        newApp.setCode(appCode);

        return newApp;
    };
    $scope.addAttribute = function () {
        var newAppAttribute;
        if ($scope.dd.newAppCode && !$scope.dd.newAppCreating && !$scope.dd.edited) {
            // New app not yet saved
            $scope.dd.newAppCreating = $scope.createApp($scope.dd.newAppCode);
            if ($scope.dd.newAppAttribute.code !== "" && ($scope.dd.newAppAttribute.value !== "" || $scope.dd.newAppAttribute.text !== "")) {
                newAppAttribute = new AppAttribute($scope.dd.newAppAttribute.code, $scope.dd.newAppAttribute.value, $scope.dd.newAppAttribute.text);
                $scope.dd.newAppCreating.addAppAttribute(newAppAttribute);
            }
            $scope.dd.newAppAttribute.code = "";
            $scope.dd.newAppAttribute.value = "";
            $scope.dd.newAppAttribute.text = "";
        } else if ($scope.dd.newAppCreating && !$scope.dd.edited) {
            // New app instanciated (if attribute allready added by example) but not yet saved
            if ($scope.dd.newAppAttribute.code !== "" && ($scope.dd.newAppAttribute.value !== "" || $scope.dd.newAppAttribute.text !== "")) {
                newAppAttribute = new AppAttribute($scope.dd.newAppAttribute.code, $scope.dd.newAppAttribute.value, $scope.dd.newAppAttribute.text);
                $scope.dd.newAppCreating.addAppAttribute(newAppAttribute);
            }
            $scope.dd.newAppAttribute.code = "";
            $scope.dd.newAppAttribute.value = "";
            $scope.dd.newAppAttribute.text = "";
        } else if ($scope.dd.edited) {
            // app existing and now being edited
            if ($scope.dd.newAppAttribute.code !== "" && ($scope.dd.newAppAttribute.value !== "" || $scope.dd.newAppAttribute.text !== "")) {
                newAppAttribute = new AppAttribute($scope.dd.newAppAttribute.code, $scope.dd.newAppAttribute.value, $scope.dd.newAppAttribute.text);
                $scope.dd.edited.addAppAttribute(newAppAttribute);
            }
            $scope.dd.newAppAttribute.code = "";
            $scope.dd.newAppAttribute.value = "";
            $scope.dd.newAppAttribute.text = "";
        }
    };
    $scope.removeAttribute = function (app, appAttribute) {
        app.removeAppAttribute(appAttribute);
    };
    $scope.saveApp = function () {
        if ($scope.dd.newAppCreating) AppSrv.save($scope.dd.newAppCreating);else if ($scope.dd.edited) AppSrv.save($scope.dd.edited);else if ($scope.dd.newAppCode) {
            var newApp = new App();
            newApp.setCode($scope.dd.newAppCode);
            AppSrv.save(newApp);
        }

        $scope.dd.newAppCode = "";
        $scope.dd.newAppAttribute.code = "";
        $scope.dd.newAppAttribute.value = "";
        $scope.dd.newAppCreating = null;
        $scope.dd.edited = null;
    };
    $scope.removeApp = function (app) {
        AppSrv.remove(app);
    };
    $scope.setEditedApp = function (app) {
        $scope.dd.edited = app;
    };
    $scope.reload = function () {
        $location.path();
    };
}]);

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.controllers').controller('BooksyCtrl', ["$scope", "$sce", "SiteData", "Brand", function ($scope, $sce, SiteData, Brand) {
    $scope.dd = {
        booksyUrl: null
    };

    $scope.init = function () {
        $scope.getBooksyUrl();
    };

    $scope.getBooksyUrl = function () {
        if ($scope.dd.booksyUrl === null) {
            var owner = $scope.ad.loggedUser;
            if (owner) {
                var booksyUrl = $scope.ad.addons.sub.booksyButtonAccess ? Brand.url.booksyUrl : Brand.url.discoverBooksyUrl;
                var companyCode = owner.company ? owner.company.code : null;
                booksyUrl += '?id=' + companyCode;
                if (!$scope.ad.addons.sub.booksyButtonAccess) {
                    booksyUrl += '&c=' + $scope.ad.loggedUser.company.country;
                }
                $scope.dd.booksyUrl = $sce.trustAsResourceUrl(booksyUrl);
            }
        }
    };

    $scope.init();
}]);

/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by mathieudeumie on 30/04/2014.
 */

angular.module('FlexyBeautyApp.controllers').controller('FlexyBeautyCtrl', ["$scope", "$dialog", "$window", "$location", "$sce", "SubscriptionView", "UserSrv", "DateSrv", "SubscriptionSrv", "CompanyView", "CompanyData", "StoreAppData", "StoreAppView", "$filter", "CompanySrv", "App", "AppSrv", "AppData", "AppAttribute", "GlobalVariable", "HumanResourceData", "HumanResourceView", "CurrencyManager", "gettextCatalog", "LanguageManager", "NumberSeparatorType", "Countries", "StoreAppCode", "LoaderKyc", "KycDocumentData", "KycDocumentStatus", "KycRefusedReason", "KycDocumentType", "Auth", "LegalType", "UboStatementSrv", "UboStatementData", "UboStatementView", "UboView", "UboStatus", "DateFormator", "KycSpecifications", "KycStatusConstants", "KycStatusSrv", "AppCode", "StoreAppCodeFactory", "SmsReminderSettingsSrv", "SmsReminderSettings", "Constants", "BillingManagerSrv", "PaymentServiceSrv", function ($scope, $dialog, $window, $location, $sce, SubscriptionView, UserSrv, DateSrv, SubscriptionSrv, CompanyView, CompanyData, StoreAppData, StoreAppView, $filter, CompanySrv, App, AppSrv, AppData, AppAttribute, GlobalVariable, HumanResourceData, HumanResourceView, CurrencyManager, gettextCatalog, LanguageManager, NumberSeparatorType, Countries, StoreAppCode, LoaderKyc, KycDocumentData, KycDocumentStatus, KycRefusedReason, KycDocumentType, Auth, LegalType, UboStatementSrv, UboStatementData, UboStatementView, UboView, UboStatus, DateFormator, KycSpecifications, KycStatusConstants, KycStatusSrv, AppCode, StoreAppCodeFactory, SmsReminderSettingsSrv, SmsReminderSettings, Constants, BillingManagerSrv, PaymentServiceSrv) {

    mangoPay.cardRegistration.clientId = "flexybeauty";
    this.link = "";

    $scope.dd = {
        kycDocumentsConst: {
            MAX_FILE_SIZE: 7 * 1024 * 1024,
            LEGAL_TYPE: LegalType,
            EXTENSIONS: ['pdf', 'png', 'jpg', 'jpeg']
        },
        kycStatusConstants: KycStatusConstants,
        view: {
            icalUrl: "",
            legalType: null,
            kycDocumentsType: KycDocumentType,
            kycStatus: null,
            kycDocuments: [],
            humanResourcesView: [],
            kycDocumentStatus: KycDocumentStatus,
            uboStatus: UboStatus,
            kycRefusedReason: KycRefusedReason,
            numberOfUploadedDocuments: KycDocumentData.kycDocuments.length,
            storeAppsView: [],
            companyView: null,
            displaySubConf: 1,
            cStorePanel: 2,
            cAppStorePanel: 1,
            flexyStoreHelp: false,
            hasSmsReminder: false,
            cSubscriptionView: null,
            displayErrors: false,
            link: "",
            subTotalHT: 0,
            totalHT: 0,
            nbDaysTrial: -1,
            smsReminderSettings: null,
            hoursToSend: [],
            isLoadingSmsReminderSettings: false,
            subscriptions: {
                base: {
                    filterPricePayed: true,
                    filterPriceFree: true,
                    filterCoupon: true,
                    filterOperationnal: true,
                    filterBeta: false,
                    filterFuture: false
                },
                baseList: [],
                sub: {
                    annual: null
                },
                subList: [],
                configList: [],
                activeRecurringList: [],
                activeNoRecurringList: [],
                activeCouponList: []
            },
            invoice: {
                loading: false,
                errorMessage: null,
                currentAnnualInvoiceView: null,
                billingManager: {
                    loading: false,
                    creatingPortalSession: false,
                    errorWithPortalSession: false,
                    instanceInitialized: false
                }
            },
            card: {
                loading: false,
                cardRegistrationLoaded: false,
                data: {
                    cardNumber: "",
                    cardExpirationDateMonth: "00",
                    cardExpirationDateYear: "00",
                    cardCvx: "",
                    cardType: "CB_VISA_MASTERCARD"
                },
                datePickerOpened: false,
                dateOptions: {
                    startingDay: 1,
                    showWeeks: false,
                    datepickerMode: 'year',
                    yearRange: 20
                },
                displayErrorMessage: false,
                registerSuccess: false
            },
            errors: {
                alertMessage: "",
                EXTENSION_ERROR_MESSAGE: gettextCatalog.getString("Impossible d'importer le fichier sélectionné. Le fichier doit être au format .png / .jpg / .jpeg / .pdf"),
                MAX_FILE_SIZE_ERROR_MESSAGE: gettextCatalog.getString("Le fichier est trop volumineux. La taille du fichier ne doit pas dépasser 7MB"),
                OTHER_KYC_ERROR_MESSAGE: gettextCatalog.getString("Impossible d'importer le fichier sélectionné")
            },
            uploadedDocuments: {
                identityProof: false,
                registrationProof: false,
                shareholdersDeclaration: false,
                articleOfAssociation: false
            },
            flowConfig: {
                kycDocumentType: null,
                target: null,
                headers: { Authorization: null },
                testChunks: false
            },

            onlinePayment: {
                tab: 1,
                editedUboView: null,
                uboStatementsView: [],
                editedUboStatementView: new UboStatementView(),
                uboStatementSubmitted: false,
                uboStatementErrorMsg: null,
                currentUboStatus: null,
                uboLoading: false,
                isUboForm: false,
                isValidKycDocuments: false,
                certification: {
                    s1: true,
                    s2: true,
                    s3: true
                },
                payOutAmount: 0,
                payOutAmountInput: "0",
                payOutSuccessMessage: false,
                onPayOutAmountInputChange: function onPayOutAmountInputChange() {
                    if (this.payOutAmountInput != null && typeof this.payOutAmountInput === 'string') {
                        var priceStr = CurrencyManager.getPriceFromPriceInput(this.payOutAmountInput);
                        var price = parseFloat(priceStr);
                        if (price !== "NaN") this.payOutAmount = price;else this.payOutAmount = null;
                    }
                },
                updatePayOutAmountInputArrow: function updatePayOutAmountInputArrow(number) {
                    if (this.payOutAmountInput != null && typeof this.payOutAmountInput === 'string') {
                        var priceStr = CurrencyManager.getPriceFromPriceInput(this.payOutAmountInput);
                        var price = parseFloat(priceStr);
                        if (price !== "NaN") if (price + number <= $scope.dd.view.wallet.walletAmount) price += number;else price = $scope.dd.view.wallet.walletAmount;

                        this.payOutAmountInput = $filter('currencyFormatFilter')(price);
                        this.payOutAmount = price;
                    }
                }
            },
            bankAccount: {
                ownerName: "",
                ownerAddressLine1: "",
                ownerPostalCode: "",
                ownerCity: "",
                ownerCountry: "FR",
                bankAccountDetails: {
                    iban: "",
                    bic: "",
                    accountNumber: "",
                    sortCode: ""
                },
                loading: false,
                errorMessage: null,
                redirectURL: null
            },
            bankAccountTypes: {
                iban: "IBAN",
                gb: "GB",
                us: "US"
            },
            wallet: {
                loaded: false,
                walletAmount: 0,
                payInsPage: 1,
                currency: 'EUR',
                payIns: [],
                payOuts: []
            },
            uibDate: {
                birthdate: null,
                format: 'dd/MM/yyyy',
                dateOptions: {
                    maxDate: new Date()
                },
                opened: false,
                defaultBirthdayYear: DateSrv.DEFAULT_BIRTHDAY_YEAR
            }
        },
        CONSTANTS: {
            STORE_APP_CODE: StoreAppCode,
            COUNTRIES: Countries
        },
        specifications: {
            isKycSelfCertificated: false,
            isSelfContractor: false,
            isKycCertificated: false
        }
    };

    $scope.checkValidAllKycDocuments = function () {
        var identity = false;
        var registration = false;
        var articlesOfAssociation = false;

        $scope.dd.view.kycDocuments.forEach(function (kyc) {
            switch (kyc.type) {
                case $scope.dd.view.kycDocumentsType.IDENTITY_PROOF.id:
                    identity = kyc.status === KycDocumentStatus.VALIDATED.id;
                    break;
                case $scope.dd.view.kycDocumentsType.REGISTRATION_PROOF.id:
                    registration = kyc.status === KycDocumentStatus.VALIDATED.id;
                    break;
                case $scope.dd.view.kycDocumentsType.ARTICLES_OF_ASSOCIATION.id:
                    articlesOfAssociation = kyc.status === KycDocumentStatus.VALIDATED.id;
                    break;
            }
        });

        $scope.dd.view.onlinePayment.isValidKycDocuments = identity && registration && articlesOfAssociation;
    };

    $scope.getKycStatus = function () {
        KycStatusSrv.getKycStatus().then(function (res) {
            $scope.dd.view.kycStatus = $scope.dd.kycStatusConstants.getStatusByKey(res.status);
            var kycCertification = new KycSpecifications.KycCertification();
            $scope.dd.specifications.isKycCertificated = kycCertification.isSatisfiedBy($scope.dd.view.kycStatus.key);
        }, function () {
            $scope.dd.view.kycStatus = null;
            $scope.dd.specifications.isKycCertificated = false;
        });
    };

    $scope.onTabCertify = function (currentStep) {
        $scope.dd.view.onlinePayment.certification['s' + currentStep] = true;

        if (currentStep === 2) {
            if ($scope.dd.view.numberOfUploadedDocuments >= $scope.getKycDocumentsNumber()) {
                $scope.dd.view.onlinePayment.certification.s3 = true;
            }
        }
    };

    $scope.resetUboForm = function (form) {
        $scope.dd.view.onlinePayment.editedUboView = new UboView();

        if (form) {
            form.$setPristine();
            form.$setUntouched();
        }
    };

    $scope.hideUboForm = function (form) {
        $scope.dd.view.onlinePayment.isUboForm = false;
        $scope.resetUboForm(form);
    };

    $scope.showUboForm = function (uboView) {
        if (uboView) {
            $scope.dd.view.onlinePayment.editedUboView = uboView;
            if (uboView.birth.day) {
                $scope.dd.view.uibDate.birthdate = DateFormator.dayIdToDate(uboView.birth.day);
            }
        } else {
            $scope.resetUboForm();
            $scope.dd.view.uibDate.birthdate = null;
        }

        $scope.dd.view.onlinePayment.isUboForm = true;
    };

    $scope.onDeleteEditedUbo = function (localId) {
        var newUbosView = $scope.dd.view.onlinePayment.editedUboStatementView.ubosView.filter(function (uboView) {
            return uboView.localId !== localId;
        });
        $scope.dd.view.onlinePayment.editedUboStatementView.ubosView = newUbosView;
        $scope.hideUboForm();
    };

    $scope.closeCalendar = function () {
        $scope.dd.view.uibDate.opened = false;
    };

    $scope.openCalendar = function () {
        if (!$scope.dd.view.uibDate.birthdate) {
            var initDate = new Date($scope.dd.view.uibDate.defaultBirthdayYear, 0, 1);
            $scope.dd.view.uibDate.birthdate = initDate;
        }
        $scope.dd.view.uibDate.opened = true;
    };

    $scope.onSubmitUboForm = function (form) {
        $scope.dd.view.onlinePayment.editedUboView.birth.day = DateFormator.dateToDayId($scope.dd.view.uibDate.birthdate);

        if (!$scope.dd.view.onlinePayment.editedUboView.localId && !$scope.dd.view.onlinePayment.editedUboView.id) {
            $scope.dd.view.onlinePayment.editedUboView.localId = Date.now();
            $scope.dd.view.onlinePayment.editedUboStatementView.ubosView.push($scope.dd.view.onlinePayment.editedUboView);
        } else {
            /* update existing ubo */
            var ubosView = $scope.dd.view.onlinePayment.editedUboStatementView.ubosView.map(function (uboView) {
                if (uboView.localId === $scope.dd.view.onlinePayment.editedUboView.localId) {
                    uboView = $scope.dd.view.onlinePayment.editedUboView;
                }
                return uboView;
            });
            $scope.dd.view.onlinePayment.editedUboStatementView.ubosView = ubosView;
        }

        $scope.hideUboForm(form);
        $scope.openUboFormConfirmDialog();
    };

    $scope.openUboFormConfirmDialog = function () {
        var opts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            dialogClass: "modal modal-sm",
            templateUrl: "/partials/flexyBeauty/dialog/uboFormConfirm.html",
            controller: "DialogCtrl",
            resolve: {
                dialogsModel: function dialogsModel() {
                    var tableModel = {
                        ubosView: $scope.dd.view.onlinePayment.editedUboStatementView.ubosView
                    };
                    return tableModel;
                }
            }
        };

        var d = $dialog.dialog(opts);
        d.open().then(function (result) {
            if (result) {
                if (result.add) {
                    $scope.showUboForm(null);
                } else if (result.send) {
                    $scope.saveUboStatement();
                }
            }
        });
    };

    $scope.onInitCertification = function () {
        if (KycDocumentData.kycDocuments.length === 0) {
            $scope.dd.view.onlinePayment.certification.s1 = false;
            $scope.dd.view.onlinePayment.certification.s2 = false;
            $scope.dd.view.onlinePayment.certification.s3 = false;
        }

        $scope.getUboStatement();
    };

    $scope.getUboStatement = function () {
        $scope.dd.view.onlinePayment.uboLoading = true;
        UboStatementSrv.query().then(function () {
            var uboStatements = UboStatementData.getUboStatements();
            if (uboStatements.length !== 0) {
                var nbUboStatements = uboStatements.length;
                $scope.dd.view.onlinePayment.currentUboStatus = uboStatements[nbUboStatements - 1].status;
                for (var i = 0; i < nbUboStatements; i++) {
                    var uboStatementView = new UboStatementView(uboStatements[i]);

                    if (uboStatementView.status === $scope.dd.view.uboStatus.INCOMPLETE.id) {
                        $scope.dd.view.onlinePayment.editedUboStatementView = uboStatementView;
                    } else {
                        $scope.dd.view.onlinePayment.uboStatementsView.push(uboStatementView);
                    }
                }
            }

            $scope.dd.view.onlinePayment.uboLoading = false;
        }).catch(function () {
            return $scope.dd.view.onlinePayment.uboLoading = false;
        });
    };

    $scope.saveUboStatement = function () {
        if (!$scope.dd.view.onlinePayment.uboStatementSubmitted) {
            $scope.dd.view.onlinePayment.uboStatementSubmitted = true;
            $scope.dd.view.onlinePayment.uboStatementErrorMsg = null;
            $scope.dd.view.onlinePayment.editedUboStatementView.updateModel().then(function () {
                $scope.dd.view.onlinePayment.uboStatementSubmitted = false;
                $scope.getUboStatement();
                $scope.getKycStatus();
            }, function (err) {
                $scope.dd.view.onlinePayment.uboStatementSubmitted = false;

                if (err && err.data) {
                    $scope.dd.view.onlinePayment.uboStatementErrorMsg = err.data.message;
                }
            });
        }
    };

    //Mock for Oui/Non toggle buttons
    $scope.isEnglishLanguage = function () {
        return LanguageManager.isEnglishLanguage();
    };

    $scope.isFrenchLanguage = function () {
        return LanguageManager.isFrenchLanguage();
    };

    $scope.getStoreAppsView = function () {
        return $scope.dd.view.storeAppsView;
    };

    $scope.getStoreAppView = function (storeApp) {
        for (var i = 0; i < $scope.dd.view.storeAppsView.length; i++) {
            if ($scope.dd.view.storeAppsView[i].getModel() === storeApp) {
                return $scope.dd.view.storeAppsView[i];
            }
        }
        return null;
    };

    $scope.$watch('ad.sDm', function (newValue, oldValue) {
        if (newValue === "invoice") {
            $scope.loadBillingManagerIfNeeded();
        }
    });

    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue) {
            if ($scope.ad.loggedUser.company && $scope.ad.loggedUser.company.companyLegal != null) {
                $scope.initializeOnLoading();
            } else {
                $scope.dd.view.paymentUserIsLoading = true;
                UserSrv.loadLoggedUserPayment($scope.ad.loggedUser, function (data) {
                    $scope.dd.view.paymentUserIsLoading = false;
                    $scope.initializeOnLoading();
                }, function () {
                    $scope.dd.view.paymentUserIsLoading = false;
                });
            }
        }
    });

    $scope.initializeOnLoading = function () {
        if ($scope.ad.loggedUser.company.companyLegal) {
            $scope.ad.view.companyView.loadCompanyLegalFrom($scope.ad.loggedUser.company.companyLegal);
            $scope.ad.view.companyView.updateCompanyLegalModel();
        }
        var kycSelfCertification = new KycSpecifications.KycSelfCertification();
        $scope.dd.specifications.isKycSelfCertificated = kycSelfCertification.isSatisfiedBy();

        if ($scope.ad.loggedUser && $scope.ad.loggedUser.company) {
            if (!$scope.ad.managerMode) {
                if ($scope.ad.sDm === "flexyStore" && $scope.ad.ssDomain) {
                    $scope.toggleManagerMode(this);
                }
            }

            $scope.initializeIcalDatas();

            $scope.dd.view.storeAppsView = [];
            var storeApps = StoreAppData.getActiveList();
            for (var i = 0; i < storeApps.length; i++) {
                $scope.dd.view.storeAppsView.push(new StoreAppView(storeApps[i], StoreAppData.getIndexOf(storeApps[i]), $scope));
            }
            $scope.dd.view.storeAppsView = $filter('orderBy')($scope.dd.view.storeAppsView, 'order'); //TODO OPTIMIZE
            $scope.dd.view.companyView = new CompanyView($scope.ad.loggedUser.company, CompanyData.getIndexOf($scope.ad.loggedUser.company), $scope);
            $scope.dd.view.companyView.updateSubscriptions();

            if ($scope.ad.loggedUser.isLoggedToProduction()) {
                mangoPay.cardRegistration.baseURL = "https://api.mangopay.com";
            }

            $scope.getWalletData();

            if ($scope.ad.sDm === "flexyStore" && $scope.ad.ssDomain) {
                $scope.onFlexyStoreOption($scope.ad.ssDomain);
            }

            $scope.dd.view.invoice.currentAnnualInvoiceView = $scope.dd.view.companyView.getLastInvoiceView("annualSubscription", "payed");

            var selfContractor = new KycSpecifications.SelfContractor();
            $scope.dd.specifications.isSelfContractor = selfContractor.isSatisfiedBy($scope.ad.loggedUser);
        }
    };

    $scope.initializeIcalDatas = function () {
        var humanResources = HumanResourceData.getActiveList();
        var hrView = void 0;

        for (var i = 0; i < humanResources.length; i++) {
            hrView = new HumanResourceView(humanResources[i], HumanResourceData.getIndexOf(humanResources[i]), $scope, humanResources[i].order);
            $scope.dd.view.humanResourcesView.push(hrView);
        }

        $scope.dd.view.icalUrl = $location.protocol() + "://" + $location.host();
        if ($location.port() != '' && $location.port() != "443") $scope.dd.view.icalUrl += ":" + $location.port();
        $scope.dd.view.icalUrl += "/ical/" + $scope.ad.companyCode + "/";
    };

    $scope.onFlexyStoreOption = function (storeViewCode) {
        if ($scope.dd.view.companyView) {
            var subscriptionsView = $scope.dd.view.companyView.subscriptionsView;
            if (subscriptionsView) {
                var selectedView = subscriptionsView.find(function (view) {
                    return view.storeAppView.code === storeViewCode;
                });
                if (selectedView !== undefined) {
                    $scope.onConfigureStoreApp(selectedView);
                }
            }
        }
    };

    $scope.proceedInvoicePayment = function (invoiceView) {
        if (!$scope.ad.loggedUser.company.companyPaymentData || !$scope.ad.loggedUser.company.companyPaymentData.isValid) {
            var msgError = gettextCatalog.getString("Vous devez valider votre compte au préalable");
            $scope.dd.view.invoice.errorMessage = msgError + ".";
            return;
        }
        var question = gettextCatalog.getString("Souhaitez vous procéder au paiement de la facture");
        var opts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: '/partials/global/generalConfirm.html',
            controller: 'DialogCtrl',
            resolve: {
                dialogsModel: function dialogsModel() {
                    var tableModel = [];
                    tableModel["question"] = question + " ?";
                    return tableModel;
                } } };

        var d = $dialog.dialog(opts);
        d.open().then(function (result) {
            if (result) {
                $scope.dd.view.invoice.loading = true;
                $scope.dd.view.invoice.errorMessage = null;
                invoiceView.proceedPayment(function (data) {
                    console.log(data);
                    if ($scope.dd.view.companyView.companyPaymentData.type == "DIRECT_DEBIT") {
                        $window.location.reload(true);
                    } else {

                        if (data && data.resultPayIn && data.resultPayIn.status == "CREATED" && data.resultPayIn.secureModeRedirectURL) {
                            //goto 3D secure URL
                            $window.open(data.resultPayIn.secureModeRedirectURL, "_self");
                        } else {
                            var _msgError = gettextCatalog.getString("Validation du paiement refusée. Merci de vérifier vos autorisations de paiement par Internet");
                            $scope.dd.view.invoice.errorMessage = _msgError;
                        }
                    }
                    $scope.dd.view.invoice.loading = false;
                }, function (data) {
                    var msgError = gettextCatalog.getString("Validation du paiement refusée. Merci de vérifier vos autorisations de paiement par Internet");

                    console.log(data);
                    $scope.dd.view.invoice.loading = false;
                    $scope.dd.view.invoice.errorMessage = msgError;
                });
            }
        });
    };

    $scope.updateCompanyWallet = function () {
        if (!$scope.dd.view.companyView.canSaveCompanyLegal() || !$scope.dd.view.wallet.loaded || $scope.dd.view.wallet.walletAmount > 0) {
            return;
        }

        CompanySrv.updateCompanyWallet($scope.dd.view.companyView.getModel(), function () {
            var label = gettextCatalog.getString("La création de votre nouveau porte feuille Mangopay a bien été effectué. L'application a besoin d'être rechargée, cliquer sur 'Oui' pour recharger la page.");

            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/generalConfirmNewLine.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["description"] = label;
                        return tableModel;
                    } } };

            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) {
                    $window.location.reload();
                }
            });
        }, function () {
            var label = gettextCatalog.getString("Impossible de modifier la monnaie associée à votre compte Mangopay.");

            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/errorDialog.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["question"] = label;
                        return tableModel;
                    } } };

            var d = $dialog.dialog(opts);
            d.open().then(function () {});
        });
    };

    $scope.getWalletData = function () {
        $scope.dd.view.wallet.loaded = false;
        $scope.dd.view.wallet.payIns = [];
        $scope.dd.view.wallet.payOuts = [];
        CompanySrv.getWalletData($scope.loadWallet);
    };

    $scope.getWalletPayIns = function (pageNext) {
        if ($scope.dd.view.wallet) {
            $scope.dd.view.wallet.loaded = false;
            $scope.dd.view.wallet.payIns = [];
            $scope.dd.view.wallet.payInsPage += pageNext;
            CompanySrv.getWalletPayIns($scope.dd.view.wallet.payInsPage, $scope.loadWallet);
        }
    };

    $scope.loadWallet = function (wallet) {
        if (wallet) {
            $scope.dd.view.wallet.walletAmount = wallet.walletAmount;
            if (wallet.payIns) for (var i = 0; i < wallet.payIns.length; i++) {
                $scope.dd.view.wallet.payIns.push({
                    id: wallet.payIns[i].id,
                    type: wallet.payIns[i].type,
                    status: wallet.payIns[i].status,
                    nature: wallet.payIns[i].nature,
                    creditedAmount: wallet.payIns[i].creditedAmount,
                    debitedAmount: wallet.payIns[i].debitedAmount,
                    fees: wallet.payIns[i].fees,
                    creationDate: new Date(wallet.payIns[i].creationDate),
                    saleNumber: wallet.payIns[i].saleNumber,
                    advanceNumber: wallet.payIns[i].advanceNumber,
                    canceledSaleNumber: wallet.payIns[i].canceledSaleNumber,
                    customerFullName: wallet.payIns[i].customerFullName,
                    resultMessage: wallet.payIns[i].resultMessage
                });
            }
            if (wallet.payOuts) {
                for (var _i = 0; _i < wallet.payOuts.length; _i++) {
                    $scope.dd.view.wallet.payOuts.push({
                        id: wallet.payOuts[_i].id,
                        type: wallet.payOuts[_i].type,
                        status: wallet.payOuts[_i].status,
                        nature: wallet.payOuts[_i].nature,
                        creditedAmount: wallet.payOuts[_i].creditedAmount,
                        debitedAmount: wallet.payOuts[_i].debitedAmount,
                        creationDate: new Date(wallet.payOuts[_i].creationDate)
                    });
                }
            }
            $scope.dd.view.wallet.loaded = true;
            $scope.dd.view.wallet.currency = wallet.currency;
        }
    };

    $scope.openPayOutDialog = function () {
        //var posView = this;
        if ($scope.dd.view.wallet.walletAmount < 100) $scope.dd.view.onlinePayment.payOutAmount = $scope.dd.view.wallet.walletAmount;else $scope.dd.view.onlinePayment.payOutAmount = 100;
        $scope.dd.view.onlinePayment.payOutAmountInput = $filter('currencyFormatFilter')($scope.dd.view.onlinePayment.payOutAmount);
        var opts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: '/partials/flexyBeauty/dialog/payOutDialog.html',
            controller: 'DialogCtrl',
            resolve: {
                dialogsModel: function dialogsModel() {
                    var tableModel = [];
                    tableModel["view"] = $scope.dd.view;
                    return tableModel;
                }
            }
        };

        var d = $dialog.dialog(opts);
        d.open().then(function (result) {
            if (result) {
                $scope.dd.view.wallet.loaded = false;
                CompanySrv.payOut($scope.dd.view.onlinePayment.payOutAmount, function () {
                    //succeed

                    CompanySrv.getWalletData(function (wallet) {
                        $scope.dd.view.onlinePayment.payOutSuccessMessage = true;
                        $scope.dd.view.wallet.loaded = true;
                        $scope.dd.view.wallet.payIns = [];
                        $scope.dd.view.wallet.payOuts = [];
                        $scope.loadWallet(wallet);
                        $scope.dd.view.onlinePayment.tab = 5;
                    });
                }, function (error) {
                    //Failed

                    console.log(error);
                    var label = null;
                    if (error && error.data && error.data.errorCode == "40903") label = gettextCatalog.getString("Votre demande de retrait a été refusée car un retrait est déjà en cours de traitement.");else label = gettextCatalog.getString("Le retrait n'a pas pu être effectué.");
                    var opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl: '/partials/global/errorDialog.html',
                        controller: 'DialogCtrl',
                        resolve: {
                            dialogsModel: function dialogsModel() {
                                var tableModel = [];
                                tableModel["label"] = label;
                                return tableModel;
                            }
                        }
                    };
                    $scope.dd.view.wallet.loaded = true;
                    $dialog.dialog(opts).open();
                });
            }
        });
    };

    $scope.openLevel3dsDialog = function () {
        var opts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: '/partials/flexyBeauty/dialog/level3dsDialog.html',
            controller: 'DialogLevel3DCtrl',
            resolve: {
                dialogsModel: function dialogsModel() {
                    var tableModel = [];
                    tableModel["companyView"] = $scope.dd.view.companyView;
                    return tableModel;
                }
            }
        };

        var d = $dialog.dialog(opts);
        d.open().then(function (result) {
            if (result) {
                $scope.dd.view.companyView.updateModel();
            }
        });
    };

    $scope.onChangeOnlinePaymentTab = function (event, tabIndex) {
        event.stopPropagation();
        $scope.dd.view.onlinePayment.tab = tabIndex;
        if (tabIndex == 2) {
            alert("Veuillez contacter le support client afin de modifier cette information.\n\nPlease contact customer support to change this information.");
        }

        if (tabIndex === 3) {
            $scope.onInitCertification();
        }
    };

    $scope.getOnlinePaymentLink = function () {
        var link = null;

        if (Countries.map[$scope.dd.view.companyView.country] && Countries.map[$scope.dd.view.companyView.country].onlinePaymentLink) {
            link = Countries.map[$scope.dd.view.companyView.country].onlinePaymentLink;
        } else {
            link = Countries.map[Countries.FRANCE.countryCode].onlinePaymentLink;
        }
        return link;
    };

    $scope.getOnlinePaymentLink = function () {
        var link = null;

        if (Countries.map[$scope.dd.view.companyView.country] && Countries.map[$scope.dd.view.companyView.country].onlinePaymentLink) {
            link = Countries.map[$scope.dd.view.companyView.country].onlinePaymentLink;
        } else {
            link = Countries.map[Countries.FRANCE.countryCode].onlinePaymentLink;
        }
        return link;
    };

    $scope.filterSub = function () {
        return function (subscriptionView) {
            if (subscriptionView.storeAppView === undefined) {
                // prevents eventual subscriptions having a missing store app to be displayed
                return false;
            }
            var displaySubscription = subscriptionView.storeAppView.isVisibleForCustomers && subscriptionView.storeAppView.type !== 'discount' && subscriptionView.isAvailableForBases && subscriptionView.isRelatedToFilter($scope.dd.view.subscriptions.base);
            var storeAppCodeObject = StoreAppCodeFactory.from(subscriptionView.storeAppView.code);
            if (storeAppCodeObject) {
                displaySubscription = displaySubscription && storeAppCodeObject.displaySubscription($scope.dd.view.companyView, subscriptionView) && !$scope.hasAnInactiveMandatoryBasedStoreApp(subscriptionView);
            }
            return displaySubscription;
        };
    };

    $scope.hasAnInactiveMandatoryBasedStoreApp = function (subscriptionView) {
        return $scope.dd.view.companyView.subscriptionsView.find(function (otherSubscriptionView) {
            return otherSubscriptionView.storeAppView && otherSubscriptionView.storeAppView.code === subscriptionView.storeAppView.mandatoryBases && !otherSubscriptionView.isActive;
        });
    };

    $scope.loadSmsReminderSettings = function () {
        if (!$scope.dd.view.smsReminderSettings) {
            $scope.dd.view.isLoadingSmsReminderSettings = true;
            SmsReminderSettingsSrv.get(function (smsReminderSettings) {
                $scope.dd.view.smsReminderSettings = smsReminderSettings;
                $scope.updateStoreAppToUsedSmsReminderFirstName();
                $scope.dd.view.isLoadingSmsReminderSettings = false;
            }, function () {
                $scope.dd.view.isLoadingSmsReminderSettings = false;
                $scope.displayErrorDialog();
            });
        }
    };

    $scope.updateStoreAppToUsedSmsReminderFirstName = function () {
        var app = AppData.getAppByCode(AppCode.SMS_APP);
        if (app) {
            var firstNameAppAttribute = app.getAppAttribute(AppCode.SMS_ATTRIBUTE_FIRST_NAME);
            if (firstNameAppAttribute) {
                $scope.dd.view.cSubscriptionView.storeAppView.smsReminderFirstName = firstNameAppAttribute.value;
            }
        }
    };

    $scope.createSmsReminderSettingsIfNotExist = function () {
        if (!$scope.dd.view.smsReminderSettings || !$scope.dd.view.smsReminderSettings.hourToSend) {
            $scope.dd.view.isLoadingSmsReminderSettings = true;
            SmsReminderSettingsSrv.create(function () {
                $scope.loadSmsReminderSettings();
                $scope.dd.view.isLoadingSmsReminderSettings = false;
            }, function () {
                $scope.loadSmsReminderSettings();
                $scope.dd.view.isLoadingSmsReminderSettings = false;
            });
        }
    };

    $scope.displayErrorDialog = function () {
        var errorMessage = gettextCatalog.getString("Une erreur est survenue. Veuillez réessayer plus tard");

        var opts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: '/partials/global/errorDialog.html',
            controller: 'DialogCtrl',
            resolve: {
                dialogsModel: function dialogsModel() {
                    var tableModel = [];
                    tableModel["label"] = errorMessage;
                    return tableModel;
                }
            }
        };

        $dialog.dialog(opts).open();
    };

    $scope.onSubscriptionChange = function (subscriptionView) {
        var storeAppCodeObject = StoreAppCodeFactory.from(subscriptionView.storeAppView.code);
        if (subscriptionView.isActive && subscriptionView.storeAppView.code === StoreAppCode.OPTION_SMS_REMINDER_APP_CODE) {
            $scope.loadSmsReminderSettingsAndCreateIfNotExist(subscriptionView);
        }
        storeAppCodeObject.onSubscriptionChange(subscriptionView, $scope.ad.view.companyView, $scope.ad.loggedUser).then(function (responseOk) {
            if (responseOk) {
                $scope.updateCompanyViewSubscriptionsAndSave(subscriptionView, function () {
                    storeAppCodeObject.afterSubscriptionChange(subscriptionView);
                }, function () {
                    console.warn("Error during disabling of subscription");
                });
            } else {
                subscriptionView.isActive = !subscriptionView.isActive;
            }
        }, function () {
            subscriptionView.isActive = !subscriptionView.isActive;
        }).catch(function () {
            subscriptionView.isActive = !subscriptionView.isActive;
        });
    };

    $scope.updateCompanyViewSubscriptionsAndSave = function (subscriptionView, successFunction, failureFunction) {
        $scope.dd.view.companyView.updateActiveSubscriptions();
        var toUpdateAndSave = $scope.ad.offerManager.computeMandatoryBased($scope.ad.view.companyView, subscriptionView);
        toUpdateAndSave.unshift(subscriptionView);
        toUpdateAndSave.forEach(function (subscriptionView) {
            return subscriptionView.updateModelAndSave(function (data) {
                $scope.loadSubApp(subscriptionView.storeAppView.code);
                if (successFunction !== undefined) {
                    successFunction(data);
                }
            }, function (data) {
                subscriptionView.isActive = !subscriptionView.isActive;
                $scope.dd.view.companyView.updateActiveSubscriptions();
                subscriptionView.updateModel();
                if (failureFunction !== undefined) {
                    failureFunction(data);
                }
            });
        });
    };

    $scope.goToApplication = function () {
        $scope.goToDomain('planningPos');
    };

    $scope.loadSmsReminderSettingsAndCreateIfNotExist = function () {
        if (!$scope.dd.view.smsReminderSettings) {
            $scope.dd.view.isLoadingSmsReminderSettings = true;
            SmsReminderSettingsSrv.get(function (smsReminderSettings) {
                $scope.dd.view.smsReminderSettings = smsReminderSettings;
                $scope.updateStoreAppToUsedSmsReminderFirstName();
                $scope.dd.view.isLoadingSmsReminderSettings = false;
            }, function () {
                $scope.dd.view.isLoadingSmsReminderSettings = false;
                $scope.createSmsReminderSettingsIfNotExist();
            });
        }
    };

    $scope.onConfigureStoreApp = function (sView) {
        $scope.dd.view.cAppStorePanel = 1;
        $scope.dd.view.cSubscriptionView = sView;
        if (sView.storeAppView && sView.storeAppView.code === StoreAppCode.OPTION_SMS_REMINDER_APP_CODE) {
            if (sView.isActive) {
                $scope.dd.view.cSubscriptionView.storeAppView.smsReminderFirstName = true;
                $scope.loadSmsReminderSettingsAndCreateIfNotExist();
            }
        }
    };

    $scope.saveSmsReminderHour = function (hour) {
        var app = AppData.getAppByCode(AppCode.SMS_APP);
        if (!app) {
            app = new App();
            app.code = AppCode.SMS_APP;
        }

        var lastHour = $scope.dd.view.smsReminderSettings.hourToSend;
        var now = new Date();
        var currentHour = now.getHours();
        var question = "Etes vous sûr de vouloir modifier l'heure d'envoi des rappels de rendez-vous?";
        if (!isNaN(lastHour) && !isNaN(hour)) {
            lastHour = Number(lastHour);
            hour = Number(hour);
        }
        if (lastHour && hour && lastHour > currentHour && currentHour > hour) {
            question = "Attention, l'envoi de rappel de rendez-vous était planifié à " + hour + ". \nEn modifiant l'horaire pour une heure déjà passé, " + "vos SMS ne seront pas envoyés Aujourd'hui. \nEtes vous sûr de vouloir modifier l'heure d'envoi?";
        }
        var opts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: '/partials/global/generalConfirmNewLine.html',
            controller: 'DialogCtrl',
            resolve: {
                dialogsModel: function dialogsModel() {
                    var tableModel = [];
                    tableModel["question"] = question;
                    return tableModel;
                }
            }
        };

        var d = $dialog.dialog(opts);
        d.open().then(function (result) {
            if (result) {
                $scope.dd.view.isLoadingSmsReminderSettings = true;
                var smsReminderSettings = new SmsReminderSettings(hour);
                SmsReminderSettingsSrv.update(smsReminderSettings, function () {
                    $scope.dd.view.smsReminderSettings.hourToSend = hour;
                    $scope.dd.view.isLoadingSmsReminderSettings = false;
                }, function () {
                    $scope.dd.view.isLoadingSmsReminderSettings = false;
                    $scope.displayErrorDialog();
                });
            }
        });
    };

    $scope.saveSmsReminderFirstName = function () {
        var app = AppData.getAppByCode(AppCode.SMS_APP);
        if (!app) {
            app = new App();
            app.code = AppCode.SMS_APP;
        }

        var appAttribute = app.getAppAttribute(AppCode.SMS_ATTRIBUTE_FIRST_NAME);
        if (appAttribute) {
            appAttribute.value = $scope.dd.view.cSubscriptionView.storeAppView.smsReminderFirstName;
        } else {
            var newAppAttribute = new AppAttribute(AppCode.SMS_ATTRIBUTE_FIRST_NAME, $scope.dd.view.cSubscriptionView.storeAppView.smsReminderFirstName, null);
            app.addAppAttribute(newAppAttribute);
        }
        $scope.saveSmsReminderApp(app, "Erreur pendant la modification des rappels de rendez-vous.");
    };

    $scope.saveSmsReminderApp = function (app, errorMessage) {
        AppSrv.save(app, function (data) {}, function (data) {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/infoDialog.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["label"] = errorMessage;
                        return tableModel;
                    }
                }
            };
            $dialog.dialog(opts).open();
        });
    };

    $scope.checkNotAvailableUpdateBankAccount = function () {
        return !$scope.dd.view.bankAccount.ownerName || $scope.dd.view.bankAccount.ownerName == '' || !$scope.dd.view.bankAccount.ownerAddressLine1 || $scope.dd.view.bankAccount.ownerAddressLine1 == '' || !$scope.dd.view.bankAccount.ownerPostalCode || $scope.dd.view.bankAccount.ownerPostalCode == '' || !$scope.dd.view.bankAccount.ownerCity || $scope.dd.view.bankAccount.ownerCity == '' || !$scope.dd.view.bankAccount.ownerCountry || $scope.dd.view.bankAccount.ownerCountry == '' || (!$scope.dd.view.companyView.currency || !$scope.dd.view.companyView.currency.typeBankAccount || $scope.dd.view.companyView.currency.typeBankAccount == $scope.dd.view.bankAccountTypes.iban) && !$scope.dd.view.bankAccount.bankAccountDetails.iban || $scope.dd.view.bankAccount.bankAccountDetails.iban == '' || $scope.dd.view.companyView.currency && $scope.dd.view.companyView.currency.typeBankAccount && $scope.dd.view.companyView.currency.typeBankAccount == $scope.dd.view.bankAccountTypes.gb && (!$scope.dd.view.bankAccount.bankAccountDetails.accountNumber || $scope.dd.view.bankAccount.bankAccountDetails.accountNumber == '' || !$scope.dd.view.bankAccount.bankAccountDetails.sortCode || $scope.dd.view.bankAccount.bankAccountDetails.sortCode == '');
    };

    $scope.updateBankAccount = function () {
        if ($scope.checkNotAvailableUpdateBankAccount()) {
            var msgError = gettextCatalog.getString('Merci de vérifier les champs obligatoires');
            $scope.dd.view.bankAccount.errorMessage = msgError + '.';
            return;
        }
        $scope.dd.view.bankAccount.loading = true;
        $scope.dd.view.bankAccount.errorMessage = null;
        PaymentServiceSrv.updateBankAccount($scope.ad.loggedUser.company, $scope.dd.view.bankAccount, function () {
            $scope.dd.view.bankAccount.loading = false;
        }, function (response) {
            if (response.data.errorCode == '40401') {
                alert("Veuillez contacter le support client afin de modifier cette information.\n\nPlease contact customer support to change this information.");
            }
            var msgError = gettextCatalog.getString('Compte bancaire invalide');
            $scope.dd.view.bankAccount.loading = false;
            $scope.dd.view.bankAccount.errorMessage = msgError;
        });
    };

    $scope.setFlowConfigParam = function (kycDocumentType, $flow, fileExtension) {
        if ($flow) {
            $flow.opts.target = 'rest/kyc/document?kycDocumentType=' + kycDocumentType + '&fileExtension=' + fileExtension;
            $flow.opts.headers.Authorization = $scope.ad.currentUser.token;
            if (Auth.isAdmin()) $flow.opts.headers.Authorization += '&' + $scope.ad.currentUser.companyCode;
        }
    };

    $scope.manageErrorMessageAndDisableUploadButton = function (file, $flow, message, kycDocumentType) {
        if (!$scope.isValidateExtension(file.getExtension())) $scope.dd.view.errors.alertMessage = $scope.dd.view.errors.EXTENSION_ERROR_MESSAGE;else if (!$scope.validateFileSize(file, $flow)) $scope.dd.view.errors.alertMessage = $scope.dd.view.errors.MAX_FILE_SIZE_ERROR_MESSAGE;else if (message !== null && message !== "") {
            $scope.dd.view.errors.alertMessage = $scope.dd.view.errors.OTHER_KYC_ERROR_MESSAGE;
            console.log("KYC upload file error: " + message);
        }

        if ($scope.dd.view.errors.alertMessage !== null && $scope.dd.view.errors.alertMessage !== "") {
            $scope.dd.view.displayErrors = true;
        } else {
            $scope.getKycStatus();
            $scope.setUploadDocumentProperty(kycDocumentType);
        }
    };

    $scope.setUploadDocumentProperty = function (kycDocumentType) {
        switch (kycDocumentType) {
            case $scope.dd.view.kycDocumentsType.IDENTITY_PROOF.id:
                $scope.dd.view.uploadedDocuments.identityProof = true;
                break;
            case $scope.dd.view.kycDocumentsType.REGISTRATION_PROOF.id:
                $scope.dd.view.uploadedDocuments.registrationProof = true;
                break;
            case $scope.dd.view.kycDocumentsType.ARTICLES_OF_ASSOCIATION.id:
                $scope.dd.view.uploadedDocuments.articleOfAssociation = true;
                break;
        }
    };

    $scope.getUploadDocumentProperty = function (kycDocumentType) {
        var uploadedDocument = false;
        switch (kycDocumentType) {
            case $scope.dd.view.kycDocumentsType.IDENTITY_PROOF.id:
                uploadedDocument = $scope.dd.view.uploadedDocuments.identityProof;
                break;
            case $scope.dd.view.kycDocumentsType.REGISTRATION_PROOF.id:
                uploadedDocument = $scope.dd.view.uploadedDocuments.registrationProof;
                break;
            case $scope.dd.view.kycDocumentsType.ARTICLES_OF_ASSOCIATION.id:
                uploadedDocument = $scope.dd.view.uploadedDocuments.articleOfAssociation;
                break;
        }
        return uploadedDocument;
    };

    $scope.getKycDocument = function (type) {
        for (var i = 0; i < $scope.dd.view.kycDocuments.length; i++) {
            var kycDocument = $scope.dd.view.kycDocuments[i];
            if (type === kycDocument.type) {
                return kycDocument;
            }
        }
        return null;
    };

    $scope.getKycDocumentStatus = function (kycDocumentType) {
        var kycDocument = $scope.getKycDocument(kycDocumentType);
        if (kycDocument) return kycDocument.status;
        return null;
    };

    $scope.getKycDocumentRefusedReason = function (kycDocumentType) {
        var kycDocument = $scope.getKycDocument(kycDocumentType);
        if (kycDocument && kycDocument.status === $scope.dd.view.kycDocumentStatus.REFUSED.id) {
            for (var kycRefusedReasonProperty in $scope.dd.view.kycRefusedReason) {
                var kycRefusedReason = $scope.dd.view.kycRefusedReason[kycRefusedReasonProperty];
                if (kycDocument.refusedReasonMessage === kycRefusedReason.id) {
                    return kycRefusedReason.label;
                }
            }
        }
        return "";
    };

    $scope.loadData = function () {
        LoaderKyc.load(function () {
            //success function
            $scope.dd.view.kycDocuments = KycDocumentData.kycDocuments;
            $scope.dd.view.numberOfUploadedDocuments = KycDocumentData.kycDocuments.length;

            if ($scope.dd.view.numberOfUploadedDocuments > 0) {
                $scope.onTabCertify(3);
            }

            $scope.checkValidAllKycDocuments();
            $scope.getKycStatus();
            console.log("success");
        }, function (securityError) {
            //error function
            console.log("Fail to load kycDocuments");
        });
    };

    $scope.loadData();

    $scope.validateFileSize = function (file, $flow) {
        return $flow && file.size <= $scope.dd.kycDocumentsConst.MAX_FILE_SIZE;
    };

    $scope.isValidateExtension = function (fileExtension) {
        return $scope.dd.kycDocumentsConst.EXTENSIONS.includes(fileExtension);
    };

    $scope.submitFile = function (file, $flow, kycDocumentType) {
        $scope.setFlowConfigParam(kycDocumentType, $flow, file.getExtension());
        $flow.upload();
        $scope.dd.view.numberOfUploadedDocuments++;
        $scope.dd.view.errors.alertMessage = "";
        $scope.dd.view.displayErrors = false;

        if ($scope.dd.view.numberOfUploadedDocuments >= $scope.getKycDocumentsNumber()) {
            $scope.onTabCertify(3);
        }
    };

    $scope.disableDocumentUpload = function (docType) {
        return $scope.getKycDocument(docType) && $scope.getKycDocument(docType).status !== KycDocumentStatus.REFUSED.id || $scope.getUploadDocumentProperty(docType) && ($scope.dd.view.kycStatus.key === $scope.dd.kycStatusConstants.VALIDATION_ASKED.key || $scope.dd.view.kycStatus.key === $scope.dd.kycStatusConstants.INCOMPLETE.key);
    };

    $scope.displayWaitingStatusLabel = function (kycDocumentStatus, docType) {
        return kycDocumentStatus === $scope.dd.view.kycDocumentStatus.VALIDATION_ASKED.id || $scope.getUploadDocumentProperty(docType);
    };

    $scope.displayRefusingStatusLabel = function (kycDocumentStatus, docType) {
        return kycDocumentStatus === $scope.dd.view.kycDocumentStatus.REFUSED.id && !$scope.displayWaitingStatusLabel(kycDocumentStatus, docType);
    };

    $scope.displayArticlesOfAssociation = function (type, legalType) {
        return !(type === $scope.dd.view.kycDocumentsType.ARTICLES_OF_ASSOCIATION.id && legalType === $scope.dd.kycDocumentsConst.LEGAL_TYPE.SOLETRADER.id);
    };

    $scope.getKycDocumentsNumber = function () {
        var kycDocumentsTypeNumber = Object.keys($scope.dd.view.kycDocumentsType).length;

        if (!$scope.displayArticlesOfAssociation($scope.dd.view.kycDocumentsType.ARTICLES_OF_ASSOCIATION.id, $scope.ad.loggedUser.company.legalType)) {
            kycDocumentsTypeNumber--;
        }

        return kycDocumentsTypeNumber;
    };

    $scope.canDisplayCertificationSteps = function () {
        if ($scope.ad.loggedUser.company.legalType === $scope.dd.kycDocumentsConst.LEGAL_TYPE.SOLETRADER.id) {
            return $scope.dd.view.companyView.companyLegal.legalRepresentativeEmail ? true : false;
        } else {
            return $scope.dd.view.companyView.companyLegal.legalRepresentativeEmail && $scope.dd.view.companyView.companyLegal.companyNumber;
        }
    };
    $scope.canDisplayFreeWording = function () {
        var subscriptionView = $scope.dd.view.cSubscriptionView;
        var canDisplayFree = true;
        if (subscriptionView) {
            if (subscriptionView.storeAppView && subscriptionView.storeAppView.code === StoreAppCode.OPTION_POS_APP_CODE) {
                var withoutTillStoreAppView = $scope.dd.view.companyView.getSubscriptionViewByStoreAppViewCode(StoreAppCode.OPTION_WITHOUT_TILL_STORE_APP_CODE);
                if (withoutTillStoreAppView && withoutTillStoreAppView.isActive) {
                    canDisplayFree = false;
                }
            } else if (subscriptionView.price !== 0) {
                canDisplayFree = false;
            }
        }
        return canDisplayFree;
    };

    $scope.translateHoursToSend = function () {
        var hoursToSend = Constants.SMS_REMINDER_HOURS_TO_SEND;
        for (var i = 0; i < hoursToSend.length; i++) {
            hoursToSend[i].hour = gettextCatalog.getString(hoursToSend[i].hour);
        }

        return hoursToSend;
    };

    $scope.sendIntercomMessage = function (message) {
        Intercom('showNewMessage', message);
    };

    $scope.openBillingManagerPortal = function () {
        $scope.dd.view.invoice.billingManager.creatingPortalSession = true;
        $scope.createBillingManagerPortalSession().then(function () {
            var chargebeeInstance = Chargebee.getInstance();
            var cbPortal = chargebeeInstance.createChargebeePortal();
            cbPortal.open({
                close: function close() {}
            });
        }, function () {
            $scope.dd.view.invoice.billingManager.errorWithPortalSession = true;
            $scope.dd.view.invoice.billingManager.creatingPortalSession = false;
        });
    };

    $scope.createBillingManagerPortalSession = function () {
        return $scope.initBillingManagerInstanceIfNeeded().then(function () {
            return BillingManagerSrv.createPortalSession().then(function (data) {
                var chargebeeInstance = Chargebee.getInstance();
                if (chargebeeInstance && data.portalSessionAttributes) {
                    $scope.dd.view.invoice.billingManager.errorWithPortalSession = false;
                    chargebeeInstance.setPortalSession(data.portalSessionAttributes);
                } else {
                    $scope.dd.view.invoice.billingManager.errorWithPortalSession = true;
                }
                $scope.dd.view.invoice.billingManager.creatingPortalSession = false;
            }, function () {
                return Promise.reject();
            });
        }, function () {
            return Promise.reject();
        });
    };

    $scope.initBillingManagerInstanceIfNeeded = function () {
        if (!$scope.dd.view.invoice.billingManager.instanceInitialized) {
            return BillingManagerSrv.computeSiteName().then(function (data) {
                Chargebee.init({ site: data.siteName });
                $scope.dd.view.invoice.billingManager.instanceInitialized = true;
            }, function () {
                return Promise.reject();
            });
        } else {
            return Promise.resolve();
        }
    };

    $scope.cancellation = function () {
        window.open('https://form.typeform.com/to/zOVaFV2Z#kiuteid=' + $scope.ad.companyCode, '_blank');
    };

    $scope.dd.view.hoursToSend = $scope.translateHoursToSend();
}]);

/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('ImportCtrl', ["$scope", "$dialog", "$rootScope", "$filter", "$log", "Customer", "CustomerSrv", "CustomerData", "CustomerView", "HumanResourceData", "PhysicalResourceData", "Booking", "CategoryData", "BookingService", "DayData", "Day", "Period", "Transaction", "BookingSrv", "ServerSrv", "Format", "ProductCategoryView", "ProductCategoryData", "ProductView", "SupplierData", "SupplierView", "ImageData", "CompanyImageData", "CategoryView", "ServiceView", "VatData", "VatView", "ProductData", "OptInOutView", "PhoneFormat", "gettextCatalog", "BasicAuthRole", "Constants", "MarketplaceSrv", function ($scope, $dialog, $rootScope, $filter, $log, Customer, CustomerSrv, CustomerData, CustomerView, HumanResourceData, PhysicalResourceData, Booking, CategoryData, BookingService, DayData, Day, Period, Transaction, BookingSrv, ServerSrv, Format, ProductCategoryView, ProductCategoryData, ProductView, SupplierData, SupplierView, ImageData, CompanyImageData, CategoryView, ServiceView, VatData, VatView, ProductData, OptInOutView, PhoneFormat, gettextCatalog, BasicAuthRole, Constants, MarketplaceSrv) {

    $scope.dd = {
        view: {
            vatsView: [],
            customersImportView: [],
            customersDisplayView: [],
            customersSavedView: [],
            bookingsImportView: [],
            bookingsDisplayView: [],
            bookingsSavedView: [],
            waitingForLoading: false,
            productCategoryRootView: null,
            serviceCategoryRootView: null,
            suppliersView: [],
            suppliersImportView: [],
            suppliersSavedView: [],
            cProductCategoryView: null,
            currentServiceCategoryView: null,
            savingNumber: 0,
            saving: false,
            logs: [],
            errors: [],
            tab: 1,
            updateMode: true,
            partnerActivationSettings: [],
            serviceImportReady: false,
            serviceSaveComplete: false,
            tooManyServicesImported: false,
            maxServicesForCompany: Constants.MAX_SERVICES_FOR_COMPANY
        },
        customersImportByCsv: [],
        bookingsImportByCsv: [],
        productsImportByCsv: [],
        servicesImportByCsv: [],
        customersCommentImportByCsv: [],
        displaySubConf: 1,
        basicAuthRole: BasicAuthRole,
        marketplaceData: {
            loaded: false,
            services: []
        },
        settings: [],
        activationByPartnerLabel: {}
    };
    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue) {
            var vats = VatData.getActiveList();
            for (var i = 0; i < vats.length; i++) {
                if (vats[i].isUsable) $scope.addVatView(new VatView(vats[i], VatData.getIndexOf(vats[i])));
            }var suppliers = SupplierData.getActiveList();
            for (var i = 0; i < suppliers.length; i++) {
                $scope.addSupplierView(new SupplierView(suppliers[i], SupplierData.getIndexOf(suppliers[i]), $scope));
            }$scope.dd.view.imagesView = ImageData.getActiveList("");
            $scope.dd.view.companyImagesView = CompanyImageData.companyImages;
            $scope.dd.view.productCategoryRootView = new ProductCategoryView(ProductCategoryData.categoryRoot, ProductCategoryData.getIndexOf(ProductCategoryData.categoryRoot), null, $scope); // categoryRoot index  = 0
            $scope.dd.view.productCategoryRootView.label = "Racine";
            $scope.dd.view.cProductCategoryView = $scope.dd.view.productCategoryRootView;
            $scope.dd.view.serviceCategoryRootView = new CategoryView(CategoryData.categoryRoot, CategoryData.getIndexOf(CategoryData.categoryRoot), null, $scope); // categoryRoot index  = 0
            $scope.dd.view.serviceCategoryRootView.label = "Racine";
            $scope.dd.view.currentServiceCategoryView = $scope.dd.view.serviceCategoryRootView;
            $scope.initializePartnerActivationSettings();
        }
    });

    $scope.initializePartnerActivationSettings = function () {
        $scope.dd.view.partnerActivationSettings.push({
            displayRadio: $scope.ad.addons.sub.optionLeCiseau,
            role: BasicAuthRole.LE_CISEAU_ROLE.role,
            partner: BasicAuthRole.LE_CISEAU_ROLE.label,
            radioLabel: "Activer les nouvelles prestations sur la marketplace " + $scope.ad.brand.marketplace.url.shortWebsite + ", avec promotion",
            activateOnImport: false
        });
    };

    $scope.isPartnerActivationSettingsActive = function (role) {
        if (role) {
            for (var i = 0; i < $scope.dd.view.partnerActivationSettings.length; i++) {
                if ($scope.dd.view.partnerActivationSettings[i].role === role) {
                    return $scope.dd.view.partnerActivationSettings[i].activateOnImport;
                }
            }
        }
        return false;
    };

    $scope.getHasHr = function () {
        return true;
    };
    $scope.getVatView = function (vat) {
        for (var i = 0; i < $scope.dd.view.vatsView.length; i++) {
            if ($scope.dd.view.vatsView[i].getModel() === vat) return $scope.dd.view.vatsView[i];
        } // Not found : instanciate (could be a deleted)
        var vatView = new VatView(vat, VatData.getIndexOf(vat));
        if (!vat.isDeleted) $scope.dd.view.vatsView.push(vatView);
        return vatView;
    };
    $scope.getVatViewByTax = function (tax) {
        for (var i = 0; i < $scope.dd.view.vatsView.length; i++) {
            if ($scope.dd.view.vatsView[i].getModel().tax == tax) return $scope.dd.view.vatsView[i];
        }return null;
    };
    $scope.getDefaultVatView = function () {
        for (var i = 0; i < $scope.dd.view.vatsView.length; i++) {
            if ($scope.dd.view.vatsView[i].isDefault) return $scope.dd.view.vatsView[i];
        }
    };
    $scope.addVatView = function (vatView) {
        var index = $scope.dd.view.vatsView.indexOf(vatView);
        if (index == -1) $scope.dd.view.vatsView.push(vatView);
    };
    $scope.addSupplierView = function (supplierView) {
        var index = $scope.dd.view.suppliersView.indexOf(supplierView);
        if (index == -1) $scope.dd.view.suppliersView.push(supplierView);
    };
    $scope.getSupplierView = function (supplier) {
        //must loop....
        for (var i = 0; i < $scope.dd.view.suppliersView.length; i++) {
            if ($scope.dd.view.suppliersView[i].getModel() === supplier) return $scope.dd.view.suppliersView[i];
        } // Not found : instanciate (could be a deleted customer)
        var supplierView = new SupplierView(supplier, SupplierData.getIndexOf(supplier), $scope);
        if (!supplier.isDeleted) $scope.dd.view.suppliersView.push(supplierView);
        return supplierView;
    };
    $scope.getSupplierViewByLabel = function (supplierLabel) {
        for (var i = 0; i < $scope.dd.view.suppliersView.length; i++) {
            if ($scope.dd.view.suppliersView[i].label == supplierLabel) return $scope.dd.view.suppliersView[i];
        }for (var i = 0; i < $scope.dd.view.suppliersImportView.length; i++) {
            if ($scope.dd.view.suppliersImportView[i].label == supplierLabel) return $scope.dd.view.suppliersImportView[i];
        }var supplierView = new SupplierView(null, -1, $scope);
        supplierView.label = supplierLabel;
        $scope.dd.view.suppliersImportView.push(supplierView);
        return supplierView;
    };
    $scope.getCfgClass = function (confItem, className) {
        if (confItem == $scope.dd.displaySubConf) return className;
        return "";
    };
    $scope.getServiceView = function (service) {
        //Assume view index = model index
        var serviceView = $scope.dd.view.serviceCategoryRootView.getServiceView(service);
        return serviceView;
    };
    $scope.checkPhoneNumberValidity = function (phoneNumber, checkMobile, region) {
        var validPhone = void 0;
        var isMobileNumber = PhoneFormat.isMobileNumber(phoneNumber, region);
        if (PhoneFormat.isValid(phoneNumber, region) && (!checkMobile || checkMobile && isMobileNumber)) {
            validPhone = PhoneFormat.formatNumberWithInternationalFormat(phoneNumber, region);
        } else {
            if (phoneNumber.startsWith("00")) {
                phoneNumber = PhoneFormat.INTERNATIONAL_PREFIX + phoneNumber.substring(2, phoneNumber.length);
            }
            var code = PhoneFormat.getCountryFromNumber(phoneNumber, checkMobile);
            if (code && code !== "" && code !== "unknow" && code !== region) {
                validPhone = $scope.checkPhoneNumberValidity(phoneNumber, checkMobile, code);
            }
        }

        return validPhone;
    };

    $scope.isBlank = function (str) {
        return !str || /^\s*$/.test(str);
    };

    $scope.trimAndUpperFirst = function (str) {
        if (!str) {
            return str;
        }
        return str.trim().toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
            return a.toUpperCase();
        });
    };

    $scope.afterLoadCustomersImportByXlsClicRdv = function (customersImportByXls) {
        var customerView = void 0;
        var birthDate = void 0;
        var existingCustomers = CustomerData.getActiveList();
        var existingCustomersView = [];
        for (var i = 0; i < existingCustomers.length; i++) {
            existingCustomersView.push(new CustomerView(existingCustomers[i], CustomerData.getIndexOf(existingCustomers[i]), $scope));
        }$scope.dd.view.logs = [];
        $scope.dd.view.errors = [];
        for (var _i = 0; _i < customersImportByXls.length; _i++) {
            var lineNb = _i + 2;
            customerView = new CustomerView(null, -1, $scope);

            customerView.lastName = customersImportByXls[_i]["Nom"];
            if ($scope.isBlank(customerView.lastName)) {
                $scope.dd.view.errors.push({
                    message: gettextCatalog.getString("Ligne " + lineNb + " - Nom manquant (Client non importé)")
                });
                continue;
            }
            customerView.firstName = customersImportByXls[_i]["Prénom"];
            if ($scope.isBlank(customerView.firstName)) {
                $scope.dd.view.errors.push({
                    message: gettextCatalog.getString("Ligne " + lineNb + " - Prénom manquant (Client non importé)")
                });
                continue;
            }
            customerView.lastName = $scope.trimAndUpperFirst(customerView.lastName);
            customerView.firstName = $scope.trimAndUpperFirst(customerView.firstName);

            birthDate = customersImportByXls[_i]["Date de Naissance"];
            if (birthDate !== undefined && birthDate && birthDate.length >= 10) {
                var dateFormatted = birthDate.substring(6, 10) + "-" + birthDate.substring(3, 5) + "-" + birthDate.substring(0, 2);
                customerView.birthDate = new Date(dateFormatted);
            }

            var region = PhoneFormat.getLocalCountry();
            customerView.phone = customersImportByXls[_i]["Tél. portable"];
            if (customerView.phone) {
                customerView.phone = $scope.checkPhoneNumberValidity(customerView.phone, true, region);
                if (customerView.phone == null) {
                    $scope.dd.view.errors.push({ message: gettextCatalog.getString("Ligne " + lineNb + " - Numéro de mobile incorrect: " + customersImportByXls[_i]["Tél. portable"] + " (Client " + customerView.lastName + " " + customerView.firstName + " non importé)") });
                    continue;
                }
            }

            customerView.landline = customersImportByXls[_i]["Tél. fixe"];
            if (customerView.landline) {
                customerView.landline = $scope.checkPhoneNumberValidity(customerView.landline, false, region);
                if (customerView.landline == null) {
                    $scope.dd.view.errors.push({ message: gettextCatalog.getString("Ligne " + lineNb + " - Numéro de fixe incorrect: " + customersImportByXls[_i]["Tél. fixe"] + " (Client " + customerView.lastName + " " + customerView.firstName + " non importé)") });
                    continue;
                }
            }

            customerView.email = customersImportByXls[_i]["E-mail"];
            customerView.origin = customersImportByXls[_i]["Origine"];
            customerView.address1 = customersImportByXls[_i]["Adresse"];
            customerView.postCode = customersImportByXls[_i]["Code Postal"];
            customerView.city = customersImportByXls[_i]["Ville"];
            customerView.comment = customersImportByXls[_i]["Commentaire"];

            var foundCustomerView = null;
            for (var j = 0; j < existingCustomersView.length && !foundCustomerView; j++) {
                if (existingCustomersView[j].firstName === customerView.firstName && existingCustomersView[j].lastName === customerView.lastName) {
                    foundCustomerView = existingCustomersView[j];
                }
            }
            if (foundCustomerView) {
                if ($scope.dd.view.updateMode) {
                    foundCustomerView.loadDataFrom(customerView);
                    customerView = foundCustomerView;
                    $scope.dd.view.logs.push({ message: gettextCatalog.getString("Déjà présent dans la base : " + customerView.lastName + " " + customerView.firstName + " " + customerView.phone + " " + customerView.email + " (l'import mettra le client à jour)") });
                } else {
                    $scope.dd.view.logs.push({ message: gettextCatalog.getString("Déjà présent dans la base : " + customerView.lastName + " " + customerView.firstName + " " + customerView.phone + " " + customerView.email + " (l'import crééra un nouveau client)") });
                }
            } else {
                //search on import list
                for (var _j = 0; _j < $scope.dd.view.customersImportView.length && !foundCustomerView; _j++) {
                    if ($scope.dd.view.customersImportView[_j].firstName === customerView.firstName && $scope.dd.view.customersImportView[_j].lastName === customerView.lastName) {
                        foundCustomerView = $scope.dd.view.customersImportView[_j]; //use second data instead
                    }
                }if (foundCustomerView) {
                    $scope.dd.view.logs.push({ message: gettextCatalog.getString("Déjà présent dans l'import  : " + customerView.lastName + " " + customerView.firstName + " " + customerView.phone + " " + customerView.email + " (l'import crééra un nouveau client)") });
                }
            }

            if (customersImportByXls[_i]["Consentement SMS"] != null && customersImportByXls[_i]["Consentement Emails"] != null && customersImportByXls[_i]["Consentement Notif."] != null) {
                customerView.optInOutView = new OptInOutView(null, -1);
                customerView.optInOutView.isSmsCampaignAllowed = customersImportByXls[_i]["Consentement SMS"] === '1' ? true : false;
                customerView.optInOutView.isEmailCampaignAllowed = customersImportByXls[_i]["Consentement Emails"] === '1' ? true : false;
                customerView.optInOutView.isNotificationCampaignAllowed = customersImportByXls[_i]["Consentement Notif."] === '1' ? true : false;
                customerView.optInOutView.isExternalOptInOut = true;
                customerView.optInOutView.origin = customersImportByXls[_i]["Origine consentement"] != null ? customersImportByXls[_i]["Origine consentement"] : '';
                var dateOptInOut = customersImportByXls[_i]["Date de consentement"];
                if (dateOptInOut != undefined && dateOptInOut.length >= 10) {
                    var _dateFormatted = dateOptInOut;
                    if (dateOptInOut.indexOf("/") !== -1) {
                        _dateFormatted = dateOptInOut.substring(6, 10) + "-" + dateOptInOut.substring(3, 5) + "-" + dateOptInOut.substring(0, 2);
                    }
                    customerView.optInOutView.timeModified = $filter('date')(_dateFormatted, 'yyyy-MM-dd');
                } else {
                    customerView.optInOutView.timeModified = $filter('date')(new Date(), 'yyyy-MM-dd');
                }
            } else {
                $scope.dd.view.logs.push({ message: gettextCatalog.getString("Infos RGPD non importées. Colonnes manquantes ... : " + customerView.lastName + " " + customerView.firstName) });
                customerView.optInOutView = null;
            }

            if ($scope.dd.view.customersImportView.indexOf(customerView) === -1) {
                $scope.dd.view.customersImportView.push(customerView);
            }
        }
        console.log($scope.dd.view.customersImportView);
        console.log($scope.dd.view.logs);
        console.log($scope.dd.view.errors);
        $scope.dd.view.customersDisplayView = $scope.dd.view.customersImportView.slice(0, 100);
        $scope.dd.view.waitingForLoading = false;
    };

    $scope.afterLoadCustomersImportByCsvArteBeaute = function (customersImportByCsv) {
        var customerView;
        var existingCustomers = CustomerData.getActiveList();
        var existingCustomersView = [];
        for (var i = 0; i < existingCustomers.length; i++) {
            existingCustomersView.push(new CustomerView(existingCustomers[i], CustomerData.getIndexOf(existingCustomers[i]), $scope));
        }for (var i = 1; i < customersImportByCsv.length; i++) {
            if (customersImportByCsv[i][4] && customersImportByCsv[i][4] != '') {
                var capitalized;
                customerView = new CustomerView(null, -1, $scope);
                customerView.gender = "M";
                if (customersImportByCsv[i][3] != 'Mr.') ;
                customerView.gender = "W";
                customerView.lastName = customersImportByCsv[i][4];
                if (customerView.lastName) {
                    capitalized = customerView.lastName.toLowerCase();
                    customerView.lastName = capitalized.replace(/(?:^|\s)\S/g, function (a) {
                        return a.toUpperCase();
                    });
                }

                customerView.firstName = customersImportByCsv[i][5];
                if (customerView.firstName) {
                    capitalized = customerView.firstName.toLowerCase();
                    customerView.firstName = capitalized.replace(/(?:^|\s)\S/g, function (a) {
                        return a.toUpperCase();
                    });
                }
                customerView.address1 = customersImportByCsv[i][6];
                customerView.postCode = customersImportByCsv[i][7];
                customerView.city = customersImportByCsv[i][8];

                customerView.phone = customersImportByCsv[i][9];
                if (customerView.phone) {
                    customerView.phone = Format.formatNumber(customerView.phone);
                }
                customerView.email = customersImportByCsv[i][10];

                var foundSame = false;
                for (var j = 0; j < existingCustomersView.length && !foundSame; j++) {
                    if (existingCustomersView[j].firstName == customerView.firstName && existingCustomersView[j].lastName == customerView.lastName) foundSame = true;
                }for (var j = 0; j < $scope.dd.view.customersImportView.length && !foundSame; j++) {
                    if ($scope.dd.view.customersImportView[j].firstName == customerView.firstName && $scope.dd.view.customersImportView[j].lastName == customerView.lastName) {
                        foundSame = true; //use second data instead
                        $scope.dd.view.customersImportView[j].loadDataFrom(customerView);
                    }
                }if (!foundSame) $scope.dd.view.customersImportView.push(customerView);else console.log("Already found : " + customerView.lastName + " " + customerView.firstName + " " + customerView.phone + " " + customerView.email + " ");
                //customerView.updateModel();
            }
        }
    };
    $scope.afterLoadProductsImport = function (productsImportByCsv) {
        if (!$scope.dd.view.productCategoryRootView) $scope.dd.view.productCategoryRootView = new ProductCategoryView(ProductCategoryData.categoryRoot, ProductCategoryData.getIndexOf(ProductCategoryData.categoryRoot), null, $scope); // categoryRoot index  = 0
        var categoryView, subCategoryView;
        var categorieLabel, subCategorieLabel, supplierLabel, quantity;
        for (var i = 0; i < productsImportByCsv.length; i++) {
            subCategoryView = null;
            categorieLabel = productsImportByCsv[i]["Catégorie"];
            subCategorieLabel = productsImportByCsv[i]["Sous-Catégorie"];
            if (categorieLabel && categorieLabel != '') {
                categoryView = $scope.dd.view.productCategoryRootView.getCategoryViewByLabel(categorieLabel);
                if (!categoryView) {
                    categoryView = new ProductCategoryView(null, -1, $scope.dd.view.productCategoryRootView, $scope);
                    categoryView.label = categorieLabel;
                    $scope.dd.view.productCategoryRootView.addCategoryView(categoryView);
                }
                if (subCategorieLabel && subCategorieLabel != '') {
                    subCategoryView = categoryView.getCategoryViewByLabel(subCategorieLabel);
                    if (!subCategoryView) {
                        subCategoryView = new ProductCategoryView(null, -1, categoryView, $scope);
                        subCategoryView.label = subCategorieLabel;
                        categoryView.addCategoryView(subCategoryView);
                    }
                }
                var newProductView = new ProductView(null, -1, subCategoryView ? subCategoryView : categoryView, $scope);
                newProductView.label = productsImportByCsv[i]["Libellé produit"];
                newProductView.reference = productsImportByCsv[i]["Référence"];
                //Pa HT	Prix Vente TTC	Stock

                newProductView.buyingPriceInput = productsImportByCsv[i]["Prix d'achat (HT)"];
                newProductView.onBuyingPriceInputChange();
                newProductView.priceInput = productsImportByCsv[i]["Prix de vente TTC"];
                newProductView.onPriceInputChange();

                var vatInput = productsImportByCsv[i]["TVA"];
                var vatView = null;
                if (vatInput) {
                    if (vatInput != null && typeof vatInput === 'string') {
                        var vatStr = vatInput.replace("%", "").replace(",", ".").replace(" ", "");
                        var vat = parseFloat(vatStr);
                        vatView = $scope.getVatViewByTax(vat);
                        if (vatView) newProductView.vatView = vatView;
                    }
                }

                quantity = parseInt(productsImportByCsv[i]["Stock"]);
                if (!isNaN(quantity)) newProductView.quantity = quantity;
                newProductView.code = productsImportByCsv[i]["Code barre"];
                if (newProductView.code && newProductView.code.indexOf('\'') == 0) //remove ' if first
                    newProductView.code = newProductView.code.substr(1);
                newProductView.reference = productsImportByCsv[i]["Référence"];
                newProductView.description = productsImportByCsv[i]["Description"];
                supplierLabel = productsImportByCsv[i]["Fournisseur"];
                var foundProductView = null;

                //var containerCategory = subCategoryView ? subCategoryView : categoryView;

                if ($scope.dd.view.updateMode) {

                    if (newProductView.reference != null && newProductView.reference != "") {

                        var foundProduct = ProductData.getByRef(newProductView.reference); //containerCategory.getProductViewByReference(newProductView.reference);
                        if (foundProduct != null) {
                            foundProductView = $scope.dd.view.productCategoryRootView.getProductView(foundProduct);
                        }
                    }
                    if (foundProductView != null) {
                        if (isNaN(quantity)) newProductView.quantity = foundProductView.quantity;
                        if (!vatInput) {
                            vatView = $scope.getVatViewByTax(foundProductView.vatView.tax);
                        }
                        if (foundProductView.image != null) {
                            newProductView.setImage(foundProductView.image);
                        } else if (foundProductView.companyImage != null) {
                            newProductView.setCompanyImage(foundProductView.companyImage);
                        }
                        if (foundProductView.parentCategoryView != null) {
                            newProductView.parentCategoryView = foundProductView.parentCategoryView;
                        }
                        foundProductView.loadDataFrom(newProductView);

                        newProductView = foundProductView;

                        if (supplierLabel && supplierLabel != '') {
                            newProductView.supplierView = $scope.getSupplierViewByLabel(supplierLabel);
                            newProductView.supplierInputLabel = supplierLabel;
                        }

                        if (vatView && vatView.tax != foundProductView.vatView.tax) {
                            newProductView.vatView = vatView;
                            //newProductView.getModel().vat = vatView.getModel();
                            newProductView.updateTax();
                        }
                        $scope.dd.view.logs.push({ message: "Already found in data : " + newProductView.reference + " (import will update product)" });
                    } else {
                        if (supplierLabel && supplierLabel != '') {
                            newProductView.supplierView = $scope.getSupplierViewByLabel(supplierLabel);
                            newProductView.supplierInputLabel = supplierLabel;
                        }
                        if (subCategoryView) subCategoryView.addProductView(newProductView);else categoryView.addProductView(newProductView);
                        $scope.dd.view.logs.push({ message: "No datas found : " + newProductView.reference + " (import will create product)" });
                    }
                } else {
                    if (subCategoryView) subCategoryView.addProductView(newProductView);else categoryView.addProductView(newProductView);
                    $scope.dd.view.logs.push({ message: "No datas found : " + newProductView.reference + " (import will create product)" });
                }
            }
        }
    };

    $scope.loadMarketplaceDataIfNeeded = function () {
        if (!$scope.dd.marketplaceData.loaded) {
            return MarketplaceSrv.getMarketplaceData().then(function (data) {
                if (data && data.marketplaceCategories) {
                    $scope.dd.marketplaceData.marketplaceCategories = data.marketplaceCategories;
                    $scope.dd.marketplaceData.loaded = true;
                }
            }, function () {
                $scope.dd.marketplaceData.loaded = false;
            });
        }
    };

    $scope.computeMarketplaceCategory = function (marketPlaceCategoryLabel) {
        var marketplaceCategories = $scope.dd.marketplaceData.marketplaceCategories;
        if (marketplaceCategories) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = marketplaceCategories[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var marketplaceCategory = _step.value;

                    if (marketplaceCategory.label && marketplaceCategory.label.localeCompare(marketPlaceCategoryLabel, undefined, { sensitivity: 'base' }) === 0) {
                        return marketplaceCategory;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        return null;
    };

    $scope.computeMarketplaceSubCategory = function (marketplaceSubCategories, marketPlaceSubCategoryLabel) {
        if (marketplaceSubCategories) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = marketplaceSubCategories[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var marketplaceSubCategory = _step2.value;

                    if (marketplaceSubCategory && marketplaceSubCategory.label && marketplaceSubCategory.label.localeCompare(marketPlaceSubCategoryLabel, undefined, { sensitivity: 'base' }) === 0) {
                        return marketplaceSubCategory;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
        return null;
    };

    $scope.computeMarketplaceVariant = function (marketplaceVariants, marketPlaceVariantLabel) {
        if (marketplaceVariants) {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = marketplaceVariants[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var marketplaceVariant = _step3.value;

                    if (marketplaceVariant && marketplaceVariant.label && marketplaceVariant.label.localeCompare(marketPlaceVariantLabel, undefined, { sensitivity: 'base' }) === 0) {
                        return marketplaceVariant;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
        return null;
    };

    $scope.afterLoadServicesImport = function (servicesImportByCsv) {
        $scope.dd.view.serviceSaveComplete = false;
        if (!$scope.dd.view.serviceCategoryRootView) $scope.dd.view.serviceCategoryRootView = new CategoryView(CategoryData.categoryRoot, CategoryData.getIndexOf(CategoryData.categoryRoot), null, $scope); // categoryRoot index  = 0
        var categoryView = void 0,
            subCategoryView = void 0;
        var categorieLabel = void 0,
            subCategorieLabel = void 0,
            duration = void 0;
        $scope.dd.activationByPartnerLabel = {};
        for (var _i2 = 0; _i2 < $scope.dd.view.partnerActivationSettings.length; _i2++) {
            $scope.dd.activationByPartnerLabel[$scope.dd.view.partnerActivationSettings[_i2].role] = $scope.dd.view.partnerActivationSettings[_i2].activateOnImport;
        }
        $scope.dd.view.errors = [];
        for (var i = 0; i < servicesImportByCsv.length; i++) {
            subCategoryView = null;
            categorieLabel = servicesImportByCsv[i]["Catégorie"];
            subCategorieLabel = servicesImportByCsv[i]["Sous-Catégorie"];
            var lineNb = i + 2;
            if (categorieLabel && categorieLabel !== '') {
                categorieLabel = categorieLabel.trim();
                categoryView = $scope.dd.view.serviceCategoryRootView.getCategoryViewByLabel(categorieLabel);
                if (!categoryView) {
                    categoryView = new CategoryView(null, -1, $scope.dd.view.serviceCategoryRootView, $scope);
                    categoryView.label = categorieLabel;
                    $scope.dd.view.serviceCategoryRootView.addCategoryView(categoryView);
                }
                if (subCategorieLabel && subCategorieLabel !== '') {
                    subCategorieLabel = subCategorieLabel.trim();
                    subCategoryView = $scope.dd.view.serviceCategoryRootView.getCategoryViewByLabel(subCategorieLabel);
                    if (!subCategoryView) {
                        subCategoryView = new CategoryView(null, -1, categoryView, $scope);
                        subCategoryView.label = subCategorieLabel;
                        categoryView.addCategoryView(subCategoryView);
                        categoryView.impactedByImport = true;
                    }
                }
                var newServiceView = new ServiceView(null, -1, subCategoryView ? subCategoryView : categoryView, $scope);
                newServiceView.label = servicesImportByCsv[i]["Prestation"];
                if (newServiceView.label) {
                    newServiceView.label = newServiceView.label.trim();
                    newServiceView.labelShort = newServiceView.label;

                    var errorInMarketplaceData = $scope.importMarketplaceDataIfNeeded(servicesImportByCsv[i], categoryView, subCategoryView, newServiceView, lineNb);

                    if (!errorInMarketplaceData) {
                        newServiceView.impactedByImport = true;
                        //Pa HT	Prix Vente TTC	Stock
                        newServiceView.price = servicesImportByCsv[i]["Prix"];
                        newServiceView.onGlobalPriceInputChange();
                        duration = parseInt(servicesImportByCsv[i]["Durée"].replace(" min", "").replace(" mn", ""));
                        if (duration !== "NaN" && duration !== "") newServiceView.duration = duration;
                        if (subCategoryView) {
                            subCategoryView.addServiceView(newServiceView);
                            subCategoryView.impactedByImport = true;
                            $scope.dd.view.serviceImportReady = true;
                        } else {
                            categoryView.addServiceView(newServiceView);
                            categoryView.impactedByImport = true;
                            $scope.dd.view.serviceImportReady = true;
                        }
                    }
                } else {
                    $scope.dd.view.errors.push({ message: gettextCatalog.getString("Ligne " + lineNb + " - Service manquant ou incorrect (Prestation non importée)") });
                }
            } else {
                $scope.dd.view.errors.push({ message: gettextCatalog.getString("Ligne " + lineNb + " - Catégorie manquante ou incorrecte (Prestation non importée)") });
            }
        }
        $scope.dd.view.waitingForLoading = false;
    };

    $scope.importMarketplaceDataIfNeeded = function (importedServiceLine, categoryView, subCategoryView, newServiceView, lineNb) {
        var errorInMarketplaceData = false;
        if ($scope.dd.activationByPartnerLabel[BasicAuthRole.LE_CISEAU_ROLE.role]) {
            var categoryMarketPlaceLabel = importedServiceLine["Catégorie " + $scope.ad.brand.marketplace.url.shortWebsite];
            var subCategoryMarketPlaceLabel = importedServiceLine["Sous-Catégorie " + $scope.ad.brand.marketplace.url.shortWebsite];
            var variantMarketPlaceLabel = importedServiceLine["Variante " + $scope.ad.brand.marketplace.url.shortWebsite];

            var marketplaceCategoryId = void 0,
                marketplaceSubCategoryId = void 0,
                marketplaceVariantId = void 0;

            categoryMarketPlaceLabel = categoryMarketPlaceLabel ? categoryMarketPlaceLabel.trim() : null;
            subCategoryMarketPlaceLabel = subCategoryMarketPlaceLabel ? subCategoryMarketPlaceLabel.trim() : null;
            variantMarketPlaceLabel = variantMarketPlaceLabel ? variantMarketPlaceLabel.trim() : null;

            var marketplaceCategory = $scope.computeMarketplaceCategory(categoryMarketPlaceLabel);
            if (marketplaceCategory) {
                marketplaceCategoryId = marketplaceCategory.id;

                var marketplaceSubCategory = $scope.computeMarketplaceSubCategory(marketplaceCategory.subCategories, subCategoryMarketPlaceLabel);
                if (marketplaceSubCategory) {
                    marketplaceSubCategoryId = marketplaceSubCategory.id;
                } else {
                    $scope.dd.view.errors.push({ message: gettextCatalog.getString("Ligne " + lineNb + " - Sous-Catégorie " + $scope.ad.brand.marketplace.url.shortWebsite + " manquante ou incorrecte (Prestation non importée)") });
                    errorInMarketplaceData = true;
                }

                if (!variantMarketPlaceLabel || marketplaceCategory.variants.length === 0) {
                    marketplaceVariantId = null;
                } else {
                    var marketplaceVariant = $scope.computeMarketplaceVariant(marketplaceCategory.variants, variantMarketPlaceLabel);
                    if (marketplaceVariant) {
                        newServiceView.label = marketplaceVariant.id ? newServiceView.labelShort + " - " + marketplaceVariant.label : newServiceView.labelShort;
                        marketplaceVariantId = marketplaceVariant.id;
                    } else {
                        $scope.dd.view.errors.push({ message: gettextCatalog.getString("Ligne " + lineNb + " - Variante " + $scope.ad.brand.marketplace.url.shortWebsite + " manquante ou incorrecte (Prestation non importée)") });
                        errorInMarketplaceData = true;
                    }
                }
            } else {
                $scope.dd.view.errors.push({ message: gettextCatalog.getString("Ligne " + lineNb + " - Catégorie " + $scope.ad.brand.marketplace.url.shortWebsite + " manquante ou incorrecte (Prestation non importée)") });
                errorInMarketplaceData = true;
            }

            if (!errorInMarketplaceData) {
                var pathService = $scope.computePathService(categoryView, subCategoryView, newServiceView);
                $scope.dd.marketplaceData.services[pathService] = {
                    marketplaceCategoryId: marketplaceCategoryId,
                    marketplaceSubCategoryId: marketplaceSubCategoryId,
                    marketplaceVariantId: marketplaceVariantId
                };
            }
        }
        return errorInMarketplaceData;
    };

    $scope.computePathService = function (categoryView, subCategoryView, serviceView) {
        var pathService = "/";
        if (categoryView && categoryView.label !== "Racine") {
            pathService = pathService + categoryView.label + "/";
        }
        if (subCategoryView) {
            pathService = pathService + subCategoryView.label + "/";
        }
        pathService = pathService + serviceView.label;
        return pathService;
    };

    $scope.afterLoadProductsImportByCsvArteBeaute = function (productsImportByCsv) {

        if (!$scope.dd.view.productCategoryRootView) $scope.dd.view.productCategoryRootView = new ProductCategoryView(ProductCategoryData.categoryRoot, ProductCategoryData.getIndexOf(ProductCategoryData.categoryRoot), null, $scope); // categoryRoot index  = 0
        var categoryView;
        for (var i = 1; i < productsImportByCsv.length; i++) {
            if (productsImportByCsv[i][0] && productsImportByCsv[i][0] != '') {
                categoryView = $scope.dd.view.productCategoryRootView.getCategoryViewByLabel(productsImportByCsv[i][0]);
                if (!categoryView) {
                    categoryView = new ProductCategoryView(null, -1, $scope.dd.view.productCategoryRootView, $scope);
                    categoryView.label = productsImportByCsv[i][0];
                    $scope.dd.view.productCategoryRootView.addCategoryView(categoryView);
                }
                var newProductView = new ProductView(null, -1, categoryView, $scope);
                newProductView.label = productsImportByCsv[i][2];
                //Pa HT	Prix Vente TTC	Stock

                newProductView.buyingPriceInput = productsImportByCsv[i][3];
                newProductView.priceInput = productsImportByCsv[i][4];
                newProductView.quantity = parseInt(productsImportByCsv[i][5]);
                categoryView.addServiceView(newProductView);
            }
        }
    };
    $scope.afterLoadCustomersImportByCsvShortcuts = function (customersImportByCsv) {
        var customerView;
        console.log("afterLoadCustomersImportByCsvShortcuts");
        console.log(customersImportByCsv);
        var existingCustomers = CustomerData.getActiveList();
        var existingCustomersView = [];
        for (var i = 0; i < existingCustomers.length; i++) {
            existingCustomersView.push(new CustomerView(existingCustomers[i], CustomerData.getIndexOf(existingCustomers[i]), $scope));
        }for (var i = 1; i < customersImportByCsv.length; i++) {
            if (customersImportByCsv[i][0] && customersImportByCsv[i][0] != '') {
                var capitalized;
                customerView = new CustomerView(null, -1, $scope);
                customerView.shortcutsId = customersImportByCsv[i][0];
                customerView.lastName = customersImportByCsv[i][1];
                if (customerView.lastName) {
                    capitalized = customerView.lastName.toLowerCase();
                    customerView.lastName = capitalized.replace(/(?:^|\s)\S/g, function (a) {
                        return a.toUpperCase();
                    });
                }

                customerView.firstName = customersImportByCsv[i][2];
                if (customerView.firstName) {
                    capitalized = customerView.firstName.toLowerCase();
                    customerView.firstName = capitalized.replace(/(?:^|\s)\S/g, function (a) {
                        return a.toUpperCase();
                    });
                }
                customerView.address1 = customersImportByCsv[i][3];
                customerView.address2 = customersImportByCsv[i][4];
                customerView.city = customersImportByCsv[i][5];
                customerView.postCode = customersImportByCsv[i][6];
                customerView.landline = customersImportByCsv[i][7];
                if (customerView.landline) {
                    customerView.landline = Format.formatNumber(customerView.landline);
                }
                customerView.phone = customersImportByCsv[i][8];
                if (customerView.phone) {
                    customerView.phone = Format.formatNumber(customerView.phone);
                }
                customerView.email = customersImportByCsv[i][9];
                if (customersImportByCsv[i][10] == "1") //Man
                    customerView.gender = "M";else customerView.gender = "W";
                var foundSame = false;
                for (var j = 0; j < existingCustomersView.length && !foundSame; j++) {
                    if (existingCustomersView[j].phone && existingCustomersView[j].phone != "" && customerView.phone && customerView.phone != "" && existingCustomersView[j].phone == customerView.phone && //no email or sms but same lastname/firstname
                    (!existingCustomersView[j].email || existingCustomersView[j].email == "") && (!customerView.phone || customerView.phone == "") && existingCustomersView[j].firstName == customerView.firstName && existingCustomersView[j].lastName == customerView.lastName) foundSame = true;
                }if (!foundSame) $scope.dd.view.customersImportView.push(customerView);else console.log("Already found : " + customerView.lastName + " " + customerView.firstName + " " + customerView.phone + " " + customerView.email + " ");
                //customerView.updateModel();
            }
        }
    };
    $scope.afterLoadCustomersImportByCsvShortcutsComment = function (customersImportByCsv) {
        console.log("afterLoadCustomersImportByCsvShortcutsComment");
        console.log(customersImportByCsv);
        var found = false;
        var id = null;
        var idInt = null;
        var commentPart;
        var newLine = true;
        for (var i = 1; i < customersImportByCsv.length; i++) {
            commentPart = null;
            if (customersImportByCsv[i][0] && customersImportByCsv[i][0] != '') {

                idInt = parseInt(customersImportByCsv[i][0]);
                if (idInt === NaN) {
                    commentPart = customersImportByCsv[i][0];
                    newLine = false;
                } else {

                    id = customersImportByCsv[i][0];
                    commentPart = customersImportByCsv[i][1];
                    newLine = true;
                }
            }
            if (id && commentPart) {
                found = false;
                for (var j = 0; j < $scope.dd.view.customersImportView.length && !found; j++) {
                    if (id == $scope.dd.view.customersImportView[j].shortcutsId) {
                        found = true;
                        if (!newLine && $scope.dd.view.customersImportView[j].comment) $scope.dd.view.customersImportView[j].comment = $scope.dd.view.customersImportView[j].comment + " " + commentPart;else $scope.dd.view.customersImportView[j].comment = commentPart;
                    }
                }
            }
        }
    };

    $scope.checkBeforeSaveImportedCustomersView = function () {
        if ($scope.dd.view.errors.length != 0) {
            var msgQuestion = gettextCatalog.getString("Des erreurs ont été trouvées pendant l'import, êtes-vous sûr de vouloir sauvegarder");
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/generalConfirm.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["question"] = msgQuestion + " ?";
                        return tableModel;
                    }
                }
            };

            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) {
                    $scope.saveImportedCustomersView();
                }
            });
        } else {
            $scope.saveImportedCustomersView();
        }
    };
    $scope.saveImportedCustomersView = function () {
        console.log("importCustomersView");
        console.log($scope.dd.view.customersImportView);
        $scope.dd.view.saving = true;
        $scope.dd.view.customersSavedView = [];
        for (var i = 0; i < $scope.dd.view.customersImportView.length; i++) {
            $scope.saveImportedCustomerView($scope.dd.view.customersImportView[i]);
        }
    };
    $scope.saveImportedCustomerView = function (customerView) {
        customerView.updateModel(true, function () {
            if (customerView.optInOutView != null && customerView.optInOutView.timeModified != null && customerView.getModel() != null) {
                customerView.optInOutView.updateModel(null, null, customerView.getModel().getId());
            }
            $scope.dd.view.customersSavedView.push(customerView);
            if ($scope.dd.view.customersSavedView.length == $scope.dd.view.customersImportView.length) {
                $scope.dd.view.customersImportView = [];
                $scope.dd.view.customersDisplayView = [];
                $scope.dd.view.saving = false;
            }
        });
    };
    $scope.saveImportedProductsView = function () {
        var supplierView;
        console.log("importSuppliersView");
        console.log($scope.dd.view.suppliersImportView);
        $scope.dd.view.suppliersSavedView = [];
        if ($scope.dd.view.suppliersImportView.length > 0) for (var i = 0; i < $scope.dd.view.suppliersImportView.length; i++) {
            $scope.saveImportedSupplierView($scope.dd.view.suppliersImportView[i]);
        } else $scope.saveImportedProductsTreeView();
    };
    $scope.saveImportedSupplierView = function (supplierView) {
        console.log("save supplierView " + supplierView.label);
        supplierView.updateModel(true, function () {
            $scope.dd.view.suppliersSavedView.push(supplierView);
            if ($scope.dd.view.suppliersSavedView.length == $scope.dd.view.suppliersImportView.length) {
                $scope.saveImportedProductsTreeView();
            }
        });
    };
    $scope.saveImportedProductsTreeView = function () {

        for (var j = 0; j < $scope.dd.view.productCategoryRootView.categoriesView.length; j++) {
            $scope.dd.view.productCategoryRootView.categoriesView[j].updateModelTree();
        }
    };

    $scope.saveImportedServicesTreeView = function () {
        $scope.dd.view.saving = true;

        var globalImportData = {
            categoryViewsToUpdate: [],
            serviceCount: 0
        };
        for (var j = 0; j < $scope.dd.view.serviceCategoryRootView.categoriesView.length; j++) {
            var categoryTreeImportData = $scope.dd.view.serviceCategoryRootView.categoriesView[j].computeViewsImpactedByImportAndCountServices();
            globalImportData.categoryViewsToUpdate = globalImportData.categoryViewsToUpdate.concat(categoryTreeImportData.categoryViewsToUpdate);
            globalImportData.serviceCount = globalImportData.serviceCount + categoryTreeImportData.serviceCount;
        }
        if (globalImportData.categoryViewsToUpdate.length > 0 && globalImportData.serviceCount < Constants.MAX_SERVICES_FOR_COMPANY) {
            $scope.saveCategoryViewsToUpdate(globalImportData.categoryViewsToUpdate, 0, $scope.dd.activationByPartnerLabel);
        } else {
            $scope.dd.view.saving = false;
            $scope.dd.view.tooManyServicesImported = true;
        }
    };

    $scope.saveCategoryViewsToUpdate = function (categoryViewsToUpdate, index, activationByPartnerLabel) {
        var categoryViewToUpdate = categoryViewsToUpdate[index];
        categoryViewToUpdate.updateModel(function () {
            categoryViewToUpdate.impactedByImport = false;
            if (categoryViewToUpdate.servicesView && categoryViewToUpdate.servicesView.length > 0) {
                $scope.saveServiceViewsToUpdate(categoryViewsToUpdate, index, 0, activationByPartnerLabel);
            } else {
                $scope.saveNextCategoryToImportOrFinish(categoryViewsToUpdate, index, activationByPartnerLabel);
            }
        }, function () {
            $scope.dd.view.saving = false;
        });
    };

    $scope.saveNextCategoryToImportOrFinish = function (categoryViewsToUpdate, index, activationByPartnerLabel) {
        if (index !== categoryViewsToUpdate.length - 1) {
            $scope.saveCategoryViewsToUpdate(categoryViewsToUpdate, index + 1, activationByPartnerLabel);
        } else {
            $scope.dd.view.serviceImportReady = false;
            $scope.dd.view.saving = false;
            $scope.dd.view.serviceSaveComplete = true;
        }
    };

    $scope.saveServiceViewsToUpdate = function (categoryViewsToUpdate, indexCategories, indexServices, activationByPartnerLabel) {
        var categoryViewToUpdate = categoryViewsToUpdate[indexCategories];
        var serviceViewToUpdate = categoryViewToUpdate.servicesView[indexServices];
        if (serviceViewToUpdate.impactedByImport) {
            serviceViewToUpdate.impactedByImport = false;
            var settingsByPartnerLabel = {};
            var pathService = $scope.computePathService(categoryViewToUpdate.parentCategoryView, categoryViewToUpdate, serviceViewToUpdate);
            settingsByPartnerLabel[BasicAuthRole.LE_CISEAU_ROLE.role] = $scope.dd.marketplaceData.services[pathService];
            serviceViewToUpdate.updateModelAndCreateWithPartnerServiceSettings(activationByPartnerLabel, settingsByPartnerLabel, function () {
                $scope.saveNextServiceToImportOrFinish(categoryViewsToUpdate, indexCategories, serviceViewToUpdate, indexServices, activationByPartnerLabel);
            }, function () {
                $scope.dd.view.saving = false;
            });
        } else {
            $scope.saveNextServiceToImportOrFinish(categoryViewsToUpdate, indexCategories, serviceViewToUpdate, indexServices, activationByPartnerLabel);
        }
    };

    $scope.saveNextServiceToImportOrFinish = function (categoryViewsToUpdate, indexCategories, serviceViewToUpdate, indexServices, activationByPartnerLabel) {
        serviceViewToUpdate.impactedByImport = false;
        if (indexServices !== categoryViewsToUpdate[indexCategories].servicesView.length - 1) {
            $scope.saveServiceViewsToUpdate(categoryViewsToUpdate, indexCategories, indexServices + 1, activationByPartnerLabel);
        } else {
            $scope.saveNextCategoryToImportOrFinish(categoryViewsToUpdate, indexCategories, activationByPartnerLabel);
        }
    };

    $scope.resetServiceTreeImport = function () {
        $scope.dd.view.waitingForLoading = false;
        $scope.dd.view.serviceImportReady = false;
        $scope.dd.view.saving = false;
        $scope.dd.view.serviceSaveComplete = false;
        $scope.dd.view.tooManyServicesImported = false;
        $scope.dd.view.serviceCategoryRootView = new CategoryView(CategoryData.categoryRoot, CategoryData.getIndexOf(CategoryData.categoryRoot), null, $scope); // categoryRoot index  = 0
        $scope.dd.view.serviceCategoryRootView.label = "Racine";
        $scope.dd.view.currentServiceCategoryView = $scope.dd.view.serviceCategoryRootView;
    };

    $scope.afterLoadBookingsImportByXlsClicRdv = function (bookingsImportByXls) {
        var cCustomerView;
        var existingCustomers = CustomerData.getActiveList();
        var existingCustomersView = [];
        for (var i = 0; i < existingCustomers.length; i++) {
            existingCustomersView.push(new CustomerView(existingCustomers[i], CustomerData.getIndexOf(existingCustomers[i]), $scope));
        }var existingHrs = HumanResourceData.getActiveList();
        var existingPrs = PhysicalResourceData.getActiveList();
        $scope.dd.view.logs = [];
        for (var i = 0; i < bookingsImportByXls.length; i++) {
            //if (bookingsImportByXls[i][0] && bookingsImportByXls[i][0]!='')
            {
                var capitalized;
                cCustomerView = new CustomerView(null, -1, $scope);
                cCustomerView.lastName = bookingsImportByXls[i]["Nom"];
                if (cCustomerView.lastName) {
                    capitalized = cCustomerView.lastName.toLowerCase();
                    cCustomerView.lastName = capitalized.replace(/(?:^|\s)\S/g, function (a) {
                        return a.toUpperCase();
                    });
                }

                cCustomerView.firstName = bookingsImportByXls[i]["Prénom"];
                if (cCustomerView.firstName) {
                    capitalized = cCustomerView.firstName.toLowerCase();
                    cCustomerView.firstName = capitalized.replace(/(?:^|\s)\S/g, function (a) {
                        return a.toUpperCase();
                    });
                }
                cCustomerView.email = bookingsImportByXls[i]["E-mail"];
                cCustomerView.phone = bookingsImportByXls[i]["Tél. portable"];
                if (cCustomerView.phone) {
                    cCustomerView.phone = Format.formatNumber(cCustomerView.phone);
                }

                var existingCustomerView = null;
                //try to find with  firstName && lastName (email || phone)
                if (cCustomerView.email && cCustomerView.email != '' || cCustomerView.phone && cCustomerView.phone != '') for (var j = 0; j < existingCustomersView.length && !existingCustomerView; j++) {
                    if (existingCustomersView[j].firstName == cCustomerView.firstName && existingCustomersView[j].lastName == cCustomerView.lastName && (cCustomerView.email && cCustomerView.email != '' && existingCustomersView[j].email == cCustomerView.email || cCustomerView.phone && cCustomerView.phone != '' && existingCustomersView[j].phone == cCustomerView.phone)) {
                        existingCustomerView = existingCustomersView[j];
                        cCustomerView.cIndex = j;
                    }
                }
                if (!existingCustomerView) //try with only firstName && lastName
                    for (var j = 0; j < existingCustomersView.length && !existingCustomerView; j++) {
                        if (existingCustomersView[j].firstName == cCustomerView.firstName && existingCustomersView[j].lastName == cCustomerView.lastName) {
                            existingCustomerView = existingCustomersView[j];
                            cCustomerView.cIndex = j;
                        }
                    }
                if (existingCustomerView) {
                    var hr = null;
                    var pr = null;
                    var prNumber = 0;
                    var prLabel;
                    for (var k = 0; k < existingHrs.length && !hr; k++) {
                        if (existingHrs[k].label.replace(/\s/g, '') == bookingsImportByXls[i]["Agenda"].replace(/\s/g, '')) hr = existingHrs[k];
                    }
                    for (var k = 0; k < existingPrs.length && !pr; k++) {
                        for (prNumber = 1; prNumber <= existingPrs[k].number && !pr; prNumber++) {
                            prLabel = existingPrs[k].label;
                            if (existingPrs[k].number > 1) prLabel = prLabel + " " + prNumber;
                            if (prLabel.replace(/\s/g, '') == bookingsImportByXls[i]["Agenda"].replace(/\s/g, '')) pr = existingPrs[k];
                        }
                    }
                    if (hr || pr) {
                        var service = CategoryData.categoryRoot.getServiceByLabel(bookingsImportByXls[i]["Rdv proposé"].replace(/\s+$/, '').toLowerCase()); //remove last space
                        if (service) {
                            //getDay
                            var year = bookingsImportByXls[i]["Date et heure de début"].substr(6, 4);
                            var month = bookingsImportByXls[i]["Date et heure de début"].substr(3, 2);
                            var dayOfM = bookingsImportByXls[i]["Date et heure de début"].substr(0, 2);

                            if (year.indexOf("-") != -1) {
                                year = bookingsImportByXls[i]["Date et heure de début"].substr(0, 4);
                                month = bookingsImportByXls[i]["Date et heure de début"].substr(5, 2);
                                dayOfM = bookingsImportByXls[i]["Date et heure de début"].substr(8, 2);
                            }
                            var startHour = bookingsImportByXls[i]["Date et heure de début"].substr(11, 2);
                            var startMinute = bookingsImportByXls[i]["Date et heure de début"].substr(14, 2);
                            var endHour = bookingsImportByXls[i]["Date et heure de fin"].substr(11, 2);
                            var endMinute = bookingsImportByXls[i]["Date et heure de fin"].substr(14, 2);
                            var dayId = year + month + dayOfM;
                            if (dayId.length == 8) {
                                var day = DayData.getById(parseInt(dayId));
                                if (!day) {
                                    day = new Day();
                                    day.id = parseInt(dayId);
                                    DayData.insert(day);
                                }
                                var dayR = null;
                                if (hr) {
                                    dayR = day.getDayHrByHrId(hr.id);
                                    if (!dayR) dayR = day.createAndAddDayHr(hr.id);
                                    dayR.humanResourceLabel = hr.label; //TODO OPTIMIZE;
                                }
                                if (pr) {
                                    dayR = day.getDayPrByPrId(pr.id, prNumber);
                                    if (!dayR) dayR = day.createAndAddDayPr(pr.id, prNumber);
                                    dayR.physicalResourceLabel = pr.label;
                                    if (pr.number > 1) dayR.physicalResourceLabel = dayR.physicalResourceLabel + " " + prNumber;
                                }
                                var booking = day.getBookingByCustomerId(existingCustomerView.getModel().id);
                                if (!booking) {
                                    booking = new Booking();

                                    booking.status = "planned";
                                    booking.customer = existingCustomerView.getModel();
                                    day.addBooking(booking);
                                    if (bookingsImportByXls[i]["Pris par internet"] == "1") booking.isCreatedByCustomer = true;
                                    if (bookingsImportByXls[i]["Venu / pas venu"] == "Pas Venu") booking.status = "notCame";
                                    if (bookingsImportByXls[i]["Venu / pas venu"] == "Venu") booking.status = "came";
                                    $scope.dd.view.bookingsImportView.push(booking);
                                }
                                var bookingService = new BookingService();
                                bookingService.service = service;
                                bookingService.price = parseInt(bookingsImportByXls[i]["Prix"]);
                                bookingService.label = service.label;

                                bookingService.period = new Period();
                                bookingService.period.setStartHour(parseInt(startHour));
                                bookingService.period.setStartMinute(parseInt(startMinute));
                                bookingService.period.setEndHour(parseInt(endHour));
                                bookingService.period.setEndMinute(parseInt(endMinute));
                                dayR.addActivity(bookingService);
                                booking.addBookingService(bookingService);
                                if (bookingsImportByXls[i]["Commentaires"] != "" && bookingsImportByXls[i]["Commentaires"] != booking.comment) if (booking.comment) booking.comment += " " + bookingsImportByXls[i]["Commentaires"];else booking.comment = bookingsImportByXls[i]["Commentaires"];
                                booking.price += bookingService.price;
                                if (booking.period && booking.bookingServices.length > 0) {
                                    booking.globalDuration = 0;
                                    booking.price = 0;
                                    var start = booking.bookingServices[0].period.start;
                                    var end = booking.bookingServices[0].period.end;
                                    booking.globalDuration += booking.bookingServices[0].period.duration;
                                    booking.price += booking.bookingServices[0].price;
                                    for (var l = 1; l < booking.bookingServices.length; l++) {
                                        if (booking.bookingServices[l].period.start.getTime() < start.getTime()) start = booking.bookingServices[l].period.start;
                                        if (booking.bookingServices[l].period.end.getTime() > end.getTime()) end = booking.bookingServices[l].period.end;
                                        booking.globalDuration += booking.bookingServices[l].period.duration;
                                        booking.price += booking.bookingServices[l].price;
                                    }
                                    booking.period.setStart(start);
                                    booking.period.setEnd(end);
                                } else {
                                    booking.period = new Period(bookingService.period);
                                    this.globalDuration = booking.period.duration;
                                }
                            } else $scope.dd.view.logs.push({ message: "Day incorrect or not found line n°" + i + " " + bookingsImportByXls[i]["Date et heure de début"] });
                        } else $scope.dd.view.logs.push({ message: "Service not found  line n°" + i + " '" + bookingsImportByXls[i]["Rdv proposé"] + "'" });
                    } else $scope.dd.view.logs.push({ message: "HumanResource not found  line n°" + i + " '" + bookingsImportByXls[i]["Agenda"] + "'" });
                } else $scope.dd.view.logs.push({ message: "Customer not found  on line n°" + i + " '" + cCustomerView.lastName + "' '" + cCustomerView.firstName + "' '" + cCustomerView.phone + "' '" + cCustomerView.email + "'" });
            }
        }
        $scope.dd.view.bookingsDisplayView = $scope.dd.view.bookingsImportView.slice(0, 50);
        $scope.dd.view.waitingForLoading = false;
    };

    $scope.saveImportedBookingsView = function () {
        var transaction = new Transaction();
        var compteur = 0;
        $scope.dd.view.saving = true;
        $scope.dd.view.savingNumber = $scope.dd.view.bookingsImportView.length;
        for (var i = 0; i < $scope.dd.view.bookingsImportView.length; i++) {
            transaction.addObject($scope.dd.view.bookingsImportView[i]);
            compteur++;
            if (compteur == 30) {
                BookingSrv.executeTransaction(transaction, function () {
                    $scope.dd.view.bookingsSavedView = $scope.dd.view.bookingsSavedView.concat(transaction.objects);
                    if (ServerSrv.nextSavesStack.length == 1) {
                        $scope.dd.view.saving = false;
                    }
                });
                transaction = new Transaction();
                compteur = 0;
            }
        }
        BookingSrv.executeTransaction(transaction, function () {
            $scope.dd.view.bookingsSavedView = $scope.dd.view.bookingsSavedView.concat(transaction.objects);
            if (ServerSrv.nextSavesStack.length == 1) {
                $scope.dd.view.saving = false;
            }
        });
        $scope.dd.view.bookingsImportView = [];
        $scope.dd.view.bookingsDisplayView = [];
    };
}]);

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('LoyaltyCardCtrl', ["$scope", "$dialog", "$timeout", "LoyaltyCardCategorySrv", "LoyaltyCardCategoryData", "LoyaltyCardCategory", "LoyaltyCardSrv", "LoyaltyCardData", "LoyaltyCard", "ImageData", "LoyaltyCardView", "LoyaltyCardCategoryView", "StyleData", "CategoryView", "CategoryData", "CustomerData", "$filter", "gettextCatalog", function ($scope, $dialog, $timeout, LoyaltyCardCategorySrv, LoyaltyCardCategoryData, LoyaltyCardCategory, LoyaltyCardSrv, LoyaltyCardData, LoyaltyCard, ImageData, LoyaltyCardView, LoyaltyCardCategoryView, StyleData, CategoryView, CategoryData, CustomerData, $filter, gettextCatalog) {
    $scope.dd = {
        view: {
            categoryRootView: null,
            loyaltyCardsViewIndex: [], //Keep index
            deletedCategoriesView: [],
            deletedLoyaltyCardsView: [],
            imagesView: [],
            imagesViewFiltered: [],
            styles: StyleData.styles,
            displaySubConf: 1,
            tab: 1,
            subTab: 1,
            displayError: false, //Used  to display error message when user click on save,
            selected: {
                categoryView: null,
                loyaltyCardView: null
            },
            edited: {
                categoryView: null,
                loyaltyCardView: null,
                loading: false,
                editable: true
            }
        },
        flowConfig: {
            target: '/rest/companyImageUpload',
            method: 'octet',
            query: { companyCode: $scope.ad.companyCode, type: 'loyaltyCard' },
            maxChunkRetries: 1,
            chunkRetryInterval: 5000,
            simultaneousUploads: 4,
            singleFile: true,
            testChunks: false,
            headers: { Authorization: $scope.ad.currentUser.token }
        }
    };

    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue) {
            if (!$scope.ad.managerMode) {
                $scope.goToDomain("planningPos", "dashboard");
            }
            $scope.dd.view.imagesView = ImageData.getActiveList("");
            $scope.dd.view.imagesViewFiltered = ImageData.getFilteredImages();
            $scope.dd.view.categoryRootView = new LoyaltyCardCategoryView(LoyaltyCardCategoryData.categoryRoot, LoyaltyCardCategoryData.getIndexOf(LoyaltyCardCategoryData.categoryRoot), null, $scope); // categoryRoot index  = 0
            $scope.dd.view.categoryRootView.label = "Racine";
            $scope.dd.view.selected.categoryView = $scope.dd.view.categoryRootView;

            var categories = LoyaltyCardCategoryData.getDeletedList();
            var parentCatView;
            for (var i = 0; i < categories.length; i++) {
                if (categories[i].parentCategory) parentCatView = $scope.getCategoryView(categories[i].parentCategory);else parentCatView = null;
                $scope.dd.view.deletedCategoriesView.push(new LoyaltyCardCategoryView(categories[i], LoyaltyCardCategoryData.getIndexOf(categories[i]), parentCatView, $scope));
            }
            var loyaltyCards = LoyaltyCardData.getDeletedList();
            for (var i = 0; i < loyaltyCards.length; i++) {
                if (loyaltyCards[i].parentCategory) parentCatView = $scope.getCategoryView(loyaltyCards[i].parentCategory);else parentCatView = null;
                $scope.dd.view.deletedLoyaltyCardsView.push(new LoyaltyCardView(loyaltyCards[i], LoyaltyCardData.getIndexOf(loyaltyCards[i]), parentCatView, $scope));
            }
        }
    });

    $scope.addLoyaltyCardViewIndex = function (loyaltyCardView) {
        $scope.dd.view.loyaltyCardsViewIndex.push(loyaltyCardView);
    };

    $scope.getCfgClass = function (confItem, className) {
        if (confItem == $scope.dd.view.displaySubConf) return className;
        return "";
    };

    $scope.getServiceView = function (service) {
        return $scope.dd.view.serviceCategoryRootView.getServiceView(service);
    };
    //CATEGORY


    $scope.getCategoryView = function (category) {
        //Assume view index = model index
        var categoryView = $scope.dd.view.categoryRootView.getCategoryView(category);
        if (!categoryView) //must be deleted then instanciate it
            {
                var parentCategoryView = null;
                if (category.parentCategory) parentCategoryView = this.getCategoryView(category.parentCategory);
                categoryView = new LoyaltyCardCategoryView(category, LoyaltyCardCategoryData.getIndexOf(category), parentCategoryView, this);
            }
        return categoryView;
    };
    $scope.createCategory = function (parentCategoryView) {
        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }
        if ($scope.dd.view.edited.loyaltyCardView) if ($scope.dd.view.edited.loyaltyCardView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        } else {
            $scope.dd.view.edited.loyaltyCardView = null;
        }

        var categoryView = new LoyaltyCardCategoryView(null, -1, parentCategoryView, $scope);
        if (parentCategoryView) {
            if (parentCategoryView.image) categoryView.setImage(parentCategoryView.image);

            $scope.dd.view.edited.categoryView = categoryView;
            parentCategoryView.addCategoryView(categoryView);
        }
    };
    $scope.setCurrentCategory = function (category) {
        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }
        if ($scope.dd.view.edited.loyaltyCardView) if ($scope.dd.view.edited.loyaltyCardView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        } else {
            $scope.dd.view.edited.loyaltyCardView.hrSkillsView = null;
            $scope.dd.view.edited.loyaltyCardView.prSkillsView = null;
            $scope.dd.view.edited.loyaltyCardView = null;
        }

        if ($scope.dd.view.edited.categoryView) $scope.dd.view.edited.categoryView = null;

        $scope.dd.view.selected.categoryView = category;
    };
    $scope.setEditedCategory = function (categoryView) {
        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }
        if ($scope.dd.view.edited.loyaltyCardView) if ($scope.dd.view.edited.loyaltyCardView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        } else {
            $scope.dd.view.edited.loyaltyCardView = null;
        }

        $scope.dd.view.edited.categoryView = categoryView;

        if ($scope.dd.view.tab > 2) $scope.dd.view.tab = 1;
    };
    $scope.saveEditedCategory = function () {
        if ($scope.dd.view.edited.categoryView) $scope.dd.view.edited.categoryView.updateModel();
        $scope.dd.view.edited.categoryView = null;
        $scope.displayChangeMsg = false;
    };
    $scope.cancelEditedCategory = function () {
        $scope.dd.view.edited.categoryView.reloadModel();
        $scope.dd.view.displayError = false;
        $scope.dd.view.edited.categoryView = null;
        $scope.displayChangeMsg = false;
    };
    $scope.afterRemoveCategory = function (category) {
        if (!category.parentCategory) //Remove from $scope
            {
                var index = $scope.categoryRoot.categories.indexOf(category);
                if (index != -1) $scope.categoryRoot.categories.splice(index, 1);
                $scope.currentCategory = null;
            }
    };
    $scope.openDeletedCategoryViewConfirmDialog = function () {
        if ($scope.dd.view.edited.categoryView) {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/removeConfirm.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["label"] = $scope.dd.view.edited.categoryView.label;
                        return tableModel;
                    } } };

            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) $scope.removeEditedCategory();
            });
        }
    };
    $scope.removeEditedCategory = function () {
        if ($scope.dd.view.edited.categoryView) {
            $scope.dd.view.edited.categoryView.removeModel();
            var parentCategoryView = $scope.dd.view.edited.categoryView.parentCategoryView;
            if (parentCategoryView) parentCategoryView.removeCategoryView($scope.dd.view.edited.categoryView);
            $scope.dd.view.deletedCategoriesView.push($scope.dd.view.edited.categoryView);
            $scope.dd.view.edited.categoryView = null;
            $scope.displayChangeMsg = false;
        }
    };
    $scope.getClassForActiveCategory = function (category, className) {
        ////console.log("getClassForActive" + loyaltyCard.id);
        if (category === $scope.dd.view.edited.categoryView) return className;
        return "";
    };
    $scope.restoreCategory = function (categoryView) {
        if (categoryView) {
            if (categoryView.catIndex != -1) // retrieve old value from server
                categoryView.restoreModel();
            var index = $scope.dd.view.deletedCategoriesView.indexOf(categoryView);
            if (index != -1) {
                $scope.dd.view.deletedCategoriesView.splice(index, 1);
                if (categoryView.parentCategoryView) categoryView.parentCategoryView.addCategoryView(categoryView);
            }
        }
    };

    // LoyaltyCard


    $scope.getClassForActiveLoyaltyCard = function (loyaltyCard, className) {
        ////console.log("getClassForActive" + loyaltyCard.id);
        if (loyaltyCard === $scope.dd.view.edited.loyaltyCardView) return className;
        return "";
    };
    $scope.createLoyaltyCard = function () {
        $scope.dd.view.edited.editable = true;
        if ($scope.dd.view.edited.categoryView) if ($scope.dd.view.edited.categoryView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        } else $scope.dd.view.edited.categoryView = null;

        if ($scope.dd.view.edited.loyaltyCardView && $scope.dd.view.edited.loyaltyCardView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }
        var categoryView = $scope.dd.view.selected.categoryView;
        if (categoryView.catIndex == -1) {
            var msg = gettextCatalog.getString("Vous devez sauver une première fois la catégorie pour pouvoir lui ajouter des cartes.");
            alert(msg + ".");
            return;
        }
        var newLoyaltyCardView = new LoyaltyCardView(null, -1, categoryView, $scope);
        categoryView.addLoyaltyCardView(newLoyaltyCardView);

        if (categoryView.image && categoryView.image !== null) newLoyaltyCardView.setImage(categoryView.image);

        $scope.setEditedLoyaltyCard(newLoyaltyCardView);
    };

    $scope.loyaltyCardClicked = function (loyaltyCardView) {
        var loyaltyCard = loyaltyCardView.getModel();
        var loyaltyCardId = loyaltyCard ? loyaltyCard.id : null;
        if (loyaltyCardId) {
            $scope.dd.view.edited.loading = true;
            LoyaltyCardSrv.editable(loyaltyCard.id).then(function () {
                $scope.dd.view.edited.editable = true;
                $scope.setEditedLoyaltyCard(loyaltyCardView);
            }, function () {
                $scope.dd.view.edited.editable = false;
                $scope.setEditedLoyaltyCard(loyaltyCardView);
            });
        } else {
            $scope.setEditedLoyaltyCard(loyaltyCardView);
        }
    };

    $scope.updateSmsList = function (loyaltyCardView) {
        var loyaltyCardsLoading = gettextCatalog.getString("Chargement en cours...");
        $('#table-smsSent').replaceWith('<div id=\"table-smsSent\"><i class=\"fal fa-spinner fa-spin\"></i>' + loyaltyCardsLoading + '</div>');
        LoyaltyCardSrv.getSms(loyaltyCardView.getModel(), function (smsList) {
            if (smsList && smsList.length > 0) {
                smsList = $filter('orderBy')(smsList, 'sentDate');
                loyaltyCardView.nbSmsSent = smsList.length;
                smsList = $filter('orderBy')(smsList, 'sentDate');
                var table = "<div id=\"table-smsSent\"><table class=\"table table-bordered fxb-table\" style=\"width: 100%\"><tr><th>Nb : " + smsList.length + "</th>" + "<th>Date</th><th>Client</th><th>Mobile</th></tr>";
                for (var i = 0; i < smsList.length; i++) {
                    var customerLabel = "";
                    if (smsList[i].customerId) {
                        var customer = CustomerData.getById(smsList[i].customerId);
                        if (customer) customerLabel = customer.firstName + ' ' + customer.lastName;
                    }
                    table += "<tr><td>" + (i + 1) + "</td><td>" + $filter('date')(smsList[i].sentDate, 'short') + "</td><td>" + customerLabel + "</td><td>" + smsList[i].sentTo + "</td></tr>";
                }
                table += "</table></div>";
                $('#table-smsSent').replaceWith(table);
            } else {
                var noSmsSend = gettextCatalog.getString("Aucun sms envoyé.");
                $('#table-smsSent').replaceWith("<div id=\"table-smsSent\">" + noSmsSend);
            }
        });
    };
    $scope.setEditedLoyaltyCard = function (loyaltyCardView) {
        $scope.dd.view.edited.loading = false;
        if ($scope.dd.view.edited.categoryView) {
            if ($scope.dd.view.edited.categoryView.isChanged()) {
                $scope.displayChangeMsg = true;
                return;
            } else {
                $scope.dd.view.edited.categoryView = null;
            }
        }
        if ($scope.dd.view.edited.loyaltyCardView && $scope.dd.view.edited.loyaltyCardView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }
        $scope.dd.view.edited.loyaltyCardView = loyaltyCardView;
        if ($scope.dd.view.tab == 6) {
            $scope.updateSmsList(loyaltyCardView);
        }
    };

    $scope.saveEditedLoyaltyCard = function () {
        if ($scope.dd.view.edited.loyaltyCardView) {
            $scope.dd.view.edited.loyaltyCardView.updateModel();
            $scope.dd.view.displayError = false;
            $scope.dd.view.edited.loyaltyCardView.hrSkillsView = null;
            $scope.dd.view.edited.loyaltyCardView.prSkillsView = null;
            $scope.dd.view.edited.loyaltyCardView = null;
            $scope.displayChangeMsg = false;
        }
    };
    $scope.cancelEditedLoyaltyCard = function () {
        $scope.dd.view.edited.loyaltyCardView.reloadModel();
        $scope.dd.view.displayError = false;
        $scope.dd.view.edited.loyaltyCardView = null;
        $scope.displayChangeMsg = false;
    };
    $scope.openDeletedLoyaltyCardViewConfirmDialog = function () {
        if ($scope.dd.view.edited.loyaltyCardView) {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/removeConfirm.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["label"] = $scope.dd.view.edited.loyaltyCardView.label;
                        return tableModel;
                    } } };

            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) $scope.removeEditedLoyaltyCard();
            });
        }
    };
    $scope.removeEditedLoyaltyCard = function () {
        if ($scope.dd.view.edited.loyaltyCardView) {
            $scope.dd.view.edited.loyaltyCardView.removeModel();
            var parentCategoryView = $scope.dd.view.edited.loyaltyCardView.parentCategoryView;
            if (parentCategoryView) parentCategoryView.removeLoyaltyCardView($scope.dd.view.edited.loyaltyCardView);
            $scope.dd.view.deletedLoyaltyCardsView.push($scope.dd.view.edited.loyaltyCardView);
            $scope.dd.view.edited.loyaltyCardView.hrSkillsView = null;
            $scope.dd.view.edited.loyaltyCardView.prSkillsView = null;
            $scope.dd.view.edited.loyaltyCardView = null;

            $scope.displayChangeMsg = false;
        }
    };
    $scope.restoreLoyaltyCard = function (loyaltyCardView) {
        if (loyaltyCardView) {
            if (loyaltyCardView.servIndex != -1) // retrieve old value from server
                loyaltyCardView.restoreModel();
            var index = $scope.dd.view.deletedLoyaltyCardsView.indexOf(loyaltyCardView);
            if (index != -1) {
                $scope.dd.view.deletedLoyaltyCardsView.splice(index, 1);
                if (loyaltyCardView.parentCategoryView) loyaltyCardView.parentCategoryView.addLoyaltyCardView(loyaltyCardView);
            }
        }
    };

    //Assign image


    $scope.imageIsSelected = function (image) {
        if ($scope.dd.view.edited.loyaltyCardView) {
            if (!$scope.dd.view.edited.loyaltyCardView.companyImage && $scope.dd.view.edited.loyaltyCardView.image === image) return true;
        } else if (!$scope.dd.view.edited.categoryView.companyImage && $scope.dd.view.edited.categoryView.image === image) return true;

        return false;
    };

    $scope.companyImageIsSelected = function (companyImage) {
        if ($scope.dd.view.edited.loyaltyCardView && $scope.dd.view.edited.loyaltyCardView.companyImage === companyImage) return true;
        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.companyImage === companyImage) return true;
        return false;
    };
    $scope.setImage = function (image) {
        if ($scope.dd.view.edited.loyaltyCardView) {
            if (image === $scope.dd.view.edited.loyaltyCardView.image) {
                if ($scope.dd.view.edited.loyaltyCardView.image != null) {
                    $scope.dd.view.edited.loyaltyCardView.setImage(null);
                } else {
                    $scope.dd.view.edited.loyaltyCardView.setImage($scope.dd.view.edited.loyaltyCardView.parentCategoryView.image);
                }
            } else if (image != null) {
                $scope.dd.view.edited.loyaltyCardView.setImage(image);
            } else {
                $scope.dd.view.edited.loyaltyCardView.setImage($scope.dd.view.edited.loyaltyCardView.parentCategoryView.image);
            }
        }

        if ($scope.dd.view.edited.categoryView) {
            if (image === $scope.dd.view.edited.categoryView.image) {
                if ($scope.dd.view.edited.categoryView.image != null) {
                    $scope.dd.view.edited.categoryView.setImage(null);
                } else {
                    $scope.dd.view.edited.categoryView.setImage($scope.dd.view.edited.categoryView.parentCategoryView.image);
                }
            } else if (image != null) {
                $scope.dd.view.edited.categoryView.setImage(image);
            } else {
                $scope.dd.view.edited.categoryView.setImage($scope.dd.view.edited.categoryView.parentCategoryView.image);
            }
        }
    };
    $scope.setCompanyImage = function (companyImage) {
        if ($scope.dd.view.edited.loyaltyCardView) {
            if (companyImage === $scope.dd.view.edited.loyaltyCardView.companyImage) {
                if ($scope.dd.view.edited.loyaltyCardView.companyImage != null) {
                    $scope.dd.view.edited.loyaltyCardView.setCompanyImage(null);
                } else {
                    $scope.dd.view.edited.loyaltyCardView.setCompanyImage($scope.dd.view.edited.loyaltyCardView.parentCategoryView.companyImage);
                }
            } else if (companyImage != null) {
                $scope.dd.view.edited.loyaltyCardView.setCompanyImage(companyImage);
            } else {
                $scope.dd.view.edited.loyaltyCardView.setCompanyImage($scope.dd.view.edited.loyaltyCardView.parentCategoryView.companyImage);
            }
        }

        if ($scope.dd.view.edited.categoryView) {
            if (companyImage === $scope.dd.view.edited.categoryView.companyImage) {
                if ($scope.dd.view.edited.categoryView.companyImage != null) {
                    $scope.dd.view.edited.categoryView.setCompanyImage(null);
                } else {
                    $scope.dd.view.edited.categoryView.setCompanyImage($scope.dd.view.edited.categoryView.parentCategoryView.companyImage);
                }
            } else if (companyImage != null) {
                $scope.dd.view.edited.categoryView.setCompanyImage(companyImage);
            } else {
                $scope.dd.view.edited.categoryView.setCompanyImage($scope.dd.view.edited.categoryView.parentCategoryView.companyImage);
            }
        }
    };

    $scope.getEditedItem = function () {
        return $scope.dd.view.edited.categoryView ? $scope.dd.view.edited.categoryView : $scope.dd.view.edited.loyaltyCardView ? $scope.dd.view.edited.loyaltyCardView : null;
    };
}]);

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.controllers').controller('MarketplaceCtrl', ["$scope", "$sce", "UserSrv", "Brand", function ($scope, $sce, UserSrv, Brand) {
    $scope.dd = {
        marketplaceUrl: null
    };

    $scope.init = function () {
        $scope.getMarketplaceUrl();
    };

    $scope.getMarketplaceUrl = function () {
        if ($scope.dd.marketplaceUrl === null && $scope.ad.addons.sub.optionLeCiseau && $scope.checkMarketplaceComplianceIfNeeded()) {
            return UserSrv.ssoConnexion(function (urlResponse) {
                $scope.dd.marketplaceUrl = $sce.trustAsResourceUrl(urlResponse.url);
            }, function (defaultUrl) {
                $scope.dd.marketplaceUrl = $sce.trustAsResourceUrl(defaultUrl);
            });
        } else {
            $scope.dd.marketplaceUrl = $sce.trustAsResourceUrl(Brand.url.landingPage);
        }
    };

    $scope.init();
}]);

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.controllers').controller('PatchCtrl', ["$scope", "$sce", "CategorySrv", "ProductCategorySrv", "PatchSrv", "$http", function ($scope, $sce, CategorySrv, ProductCategorySrv, PatchSrv, $http) {
  $scope.dd = {
    view: {
      isLoading: false,
      response: '',
      currentPatchId: null,
      currentPatch: null,
      currentPatchString: '',
      patchSendingBodyObject: null,
      patchList: {
        SERVICE_CATEGORY_LOST_CHILDREN: {
          id: 1,
          label: "Catégorie de service a perdu son enfant",
          parentId: '',
          childId: ''
        },
        PRODUCT_CATEGORY_LOST_CHILDREN: {
          id: 2,
          label: "Catégorie de produit a perdu son enfant"
        },
        ACTIVITY_DELETE: {
          id: 3,
          label: "Supprimer une indisponibilité"
        }
      },
      patchListTwo: null
    }
  };

  $scope.init = function () {
    $scope.dd.view.isLoading = true;
    PatchSrv.list().then(function (response) {
      $scope.dd.view.isLoading = false;
      $scope.dd.view.patchListTwo = response.patches;
    });
  };

  $scope.changePatch = function () {
    $scope.dd.view.currentPatch = JSON.parse($scope.dd.view.currentPatchString);
  };

  $scope.init();

  $scope.stopLoadingChangeResponse = function (response) {
    $scope.dd.view.response = response;
    $scope.dd.view.isLoading = false;
  };

  $scope.lostChildren = function () {
    if ($scope.dd.view.currentPatchId === $scope.dd.view.patchList.SERVICE_CATEGORY_LOST_CHILDREN.id) {
      $scope.serviceCategoryLostChildren();
    } else if ($scope.dd.view.currentPatchId === $scope.dd.view.patchList.PRODUCT_CATEGORY_LOST_CHILDREN.id) {
      $scope.productCategoryLostChildren();
    }
  };

  $scope.serviceCategoryLostChildren = function () {
    CategorySrv.patchParentLostChild($scope.ad.companyCode, $scope.dd.view.patchList.SERVICE_CATEGORY_LOST_CHILDREN.parentId, $scope.dd.view.patchList.SERVICE_CATEGORY_LOST_CHILDREN.childId, $scope.stopLoadingChangeResponse, $scope.stopLoadingChangeResponse);
  };

  $scope.productCategoryLostChildren = function () {
    ProductCategorySrv.patchParentLostChild($scope.ad.companyCode, $scope.dd.view.patchList.SERVICE_CATEGORY_LOST_CHILDREN.parentId, $scope.dd.view.patchList.SERVICE_CATEGORY_LOST_CHILDREN.childId, $scope.stopLoadingChangeResponse, $scope.stopLoadingChangeResponse);
  };

  $scope.clearPatch = function () {
    $scope.dd.view.patchSendingBodyObject = null;
  };

  $scope.updateObject = function (fieldLabel, value) {
    $scope.dd.view.patchSendingBodyObject = $scope.dd.view.patchSendingBodyObject === null ? {} : $scope.dd.view.patchSendingBodyObject;
    if ($scope.dd.view.patchSendingBodyObject != null && $scope.dd.view.patchSendingBodyObject.fieldLabel === undefined) {
      $scope.dd.view.patchSendingBodyObject[fieldLabel] = value;
    }
  };

  $scope.doPatch = function () {
    var body = $scope.dd.view.patchSendingBodyObject;
    var method = $scope.dd.view.currentPatch.method;
    if (method === "POST") {
      $scope.dd.view.isLoading = true;
      $http.post($scope.dd.view.currentPatch.url, body).then(function (response) {
        $scope.dd.view.response = response;
        $scope.dd.view.isLoading = false;
      }).catch(function (error) {
        $scope.dd.view.response = error;
        $scope.dd.view.isLoading = false;
      });
    }
    if (method === "PATCH") {
      $scope.dd.view.isLoading = true;
      $http.patch($scope.dd.view.currentPatch.url, body).then(function (response) {
        $scope.dd.view.response = response;
        $scope.dd.view.isLoading = false;
      }).catch(function (error) {
        $scope.dd.view.response = error;
        $scope.dd.view.isLoading = false;
      });
    }
  };

  $scope.deleteActivity = function () {};

  $scope.patch = function () {};
}]);

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('CureCtrl', ["$scope", "$dialog", "$timeout", "CureCategorySrv", "CureCategoryData", "CureCategory", "CureSrv", "CureData", "Cure", "ImageData", "CureView", "CureCategoryView", "StyleData", "CompanyImageData", "CategoryView", "CategoryData", "CompanyImageSrv", "LanguageManager", function ($scope, $dialog, $timeout, CureCategorySrv, CureCategoryData, CureCategory, CureSrv, CureData, Cure, ImageData, CureView, CureCategoryView, StyleData, CompanyImageData, CategoryView, CategoryData, CompanyImageSrv, LanguageManager) {
    $scope.dd = {
        view: {
            categoryRootView: null,
            curesViewIndex: [], //Keep index
            deletedCategoriesView: [],
            serviceCategoryRootView: null,
            cServiceCategoryView: null,
            deletedCuresView: [],
            imagesView: [],
            imagesViewFiltered: [],
            styles: StyleData.styles,
            displaySubConf: 1,
            tab: 1,
            subTab: 1,
            displayError: false, //Used  to display error message when user click on save,
            selected: {
                categoryView: null,
                cureView: null
            },
            edited: {
                categoryView: null,
                cureView: null
            }
        },
        flowConfig: {
            target: '/rest/companyImageUpload',
            method: 'octet',
            query: { companyCode: $scope.ad.companyCode, type: 'cure' },
            maxChunkRetries: 1,
            chunkRetryInterval: 5000,
            simultaneousUploads: 4,
            singleFile: true,
            testChunks: false,
            headers: { Authorization: $scope.ad.currentUser.token }
        }
    };

    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue) {
            if (!$scope.ad.managerMode) {
                $scope.goToDomain("planningPos", "dashboard");
            }
            $scope.dd.view.serviceCategoryRootView = new CategoryView(CategoryData.categoryRoot, CategoryData.getIndexOf(CategoryData.categoryRoot), null, $scope); // categoryRoot index  = 0
            $scope.dd.view.cServiceCategoryView = $scope.dd.view.serviceCategoryRootView;
            $scope.dd.view.imagesView = ImageData.getActiveList("");
            $scope.dd.view.imagesViewFiltered = ImageData.getFilteredImages();
            $scope.dd.view.categoryRootView = new CureCategoryView(CureCategoryData.categoryRoot, CureCategoryData.getIndexOf(CureCategoryData.categoryRoot), null, $scope); // categoryRoot index  = 0
            $scope.dd.view.categoryRootView.label = "Racine";
            $scope.dd.view.selected.categoryView = $scope.dd.view.categoryRootView;

            var categories = CureCategoryData.getDeletedList();
            var parentCatView;
            for (var i = 0; i < categories.length; i++) {
                if (categories[i].parentCategory) parentCatView = $scope.getCategoryView(categories[i].parentCategory);else parentCatView = null;
                $scope.dd.view.deletedCategoriesView.push(new CureCategoryView(categories[i], CureCategoryData.getIndexOf(categories[i]), parentCatView, $scope));
            }
            var cures = CureData.getDeletedList();
            for (var i = 0; i < cures.length; i++) {
                if (cures[i].parentCategory) parentCatView = $scope.getCategoryView(cures[i].parentCategory);else parentCatView = null;
                $scope.dd.view.deletedCuresView.push(new CureView(cures[i], CureData.getIndexOf(cures[i]), parentCatView, $scope));
            }
        }
    });

    $scope.addCureViewIndex = function (cureView) {
        $scope.dd.view.curesViewIndex.push(cureView);
    };

    $scope.getCfgClass = function (confItem, className) {
        if (confItem == $scope.dd.view.displaySubConf) return className;
        return "";
    };

    $scope.getServiceView = function (service) {
        return $scope.dd.view.serviceCategoryRootView.getServiceView(service);
    };
    //CATEGORY


    $scope.getCategoryView = function (category) {
        //Assume view index = model index
        var categoryView = $scope.dd.view.categoryRootView.getCategoryView(category);
        if (!categoryView) //must be deleted then instanciate it
            {
                var parentCategoryView = null;
                if (category.parentCategory) parentCategoryView = this.getCategoryView(category.parentCategory);
                categoryView = new CureCategoryView(category, CureCategoryData.getIndexOf(category), parentCategoryView, this);
            }
        return categoryView;
    };
    $scope.createCategory = function (parentCategoryView) {
        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }
        if ($scope.dd.view.edited.cureView) if ($scope.dd.view.edited.cureView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        } else {
            $scope.dd.view.edited.cureView.hrSkillsView = null;
            $scope.dd.view.edited.cureView.prSkillsView = null;
            $scope.dd.view.edited.cureView = null;
        }

        var categoryView = new CureCategoryView(null, -1, parentCategoryView, $scope);
        if (parentCategoryView) {
            if (parentCategoryView.image) categoryView.setImage(parentCategoryView.image);

            $scope.dd.view.edited.categoryView = categoryView;
            parentCategoryView.addCategoryView(categoryView);
        }
    };
    $scope.setCurrentCategory = function (category) {
        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }
        if ($scope.dd.view.edited.cureView) if ($scope.dd.view.edited.cureView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        } else {
            $scope.dd.view.edited.cureView.hrSkillsView = null;
            $scope.dd.view.edited.cureView.prSkillsView = null;
            $scope.dd.view.edited.cureView = null;
        }

        if ($scope.dd.view.edited.categoryView) $scope.dd.view.edited.categoryView = null;

        $scope.dd.view.selected.categoryView = category;
    };
    $scope.setEditedCategory = function (categoryView) {
        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }
        if ($scope.dd.view.edited.cureView) if ($scope.dd.view.edited.cureView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        } else {
            $scope.dd.view.edited.cureView.hrSkillsView = null;
            $scope.dd.view.edited.cureView.prSkillsView = null;
            $scope.dd.view.edited.cureView = null;
        }

        $scope.dd.view.edited.categoryView = categoryView;

        if ($scope.dd.view.tab > 2) $scope.dd.view.tab = 1;
    };
    $scope.saveEditedCategory = function () {
        if ($scope.dd.view.edited.categoryView) $scope.dd.view.edited.categoryView.updateModel();
        $scope.dd.view.edited.categoryView = null;
        $scope.displayChangeMsg = false;
    };
    $scope.cancelEditedCategory = function () {
        $scope.dd.view.edited.categoryView.reloadModel();
        $scope.dd.view.displayError = false;
        $scope.dd.view.edited.categoryView = null;
        $scope.displayChangeMsg = false;
    };
    $scope.afterRemoveCategory = function (category) {
        if (!category.parentCategory) //Remove from $scope
            {
                var index = $scope.categoryRoot.categories.indexOf(category);
                if (index != -1) $scope.categoryRoot.categories.splice(index, 1);
                $scope.currentCategory = null;
            }
    };
    $scope.openDeletedCategoryViewConfirmDialog = function () {
        if ($scope.dd.view.edited.categoryView) {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/removeConfirm.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["label"] = $scope.dd.view.edited.categoryView.label;
                        return tableModel;
                    } } };

            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) $scope.removeEditedCategory();
            });
        }
    };
    $scope.removeEditedCategory = function () {
        if ($scope.dd.view.edited.categoryView) {
            $scope.dd.view.edited.categoryView.removeModel();
            var parentCategoryView = $scope.dd.view.edited.categoryView.parentCategoryView;
            if (parentCategoryView) parentCategoryView.removeCategoryView($scope.dd.view.edited.categoryView);
            $scope.dd.view.deletedCategoriesView.push($scope.dd.view.edited.categoryView);
            $scope.dd.view.edited.categoryView = null;
            $scope.displayChangeMsg = false;
        }
    };
    $scope.getClassForActiveCategory = function (category, className) {
        ////console.log("getClassForActive" + cure.id);
        if (category === $scope.dd.view.edited.categoryView) return className;
        return "";
    };
    $scope.restoreCategory = function (categoryView) {
        if (categoryView) {
            if (categoryView.catIndex != -1) // retrieve old value from server
                categoryView.restoreModel();
            var index = $scope.dd.view.deletedCategoriesView.indexOf(categoryView);
            if (index != -1) {
                $scope.dd.view.deletedCategoriesView.splice(index, 1);
                if (categoryView.parentCategoryView) categoryView.parentCategoryView.addCategoryView(categoryView);
            }
        }
    };

    // Cure


    $scope.getClassForActiveCure = function (cure, className) {
        ////console.log("getClassForActive" + cure.id);
        if (cure === $scope.dd.view.edited.cureView) return className;
        return "";
    };
    $scope.createCure = function () {
        if ($scope.dd.view.edited.categoryView) if ($scope.dd.view.edited.categoryView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        } else $scope.dd.view.edited.categoryView = null;

        if ($scope.dd.view.edited.cureView && $scope.dd.view.edited.cureView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }
        var categoryView = $scope.dd.view.selected.categoryView;
        if (categoryView.catIndex == -1) {
            alert("Vous devez sauver une première fois la catégorie pour pouvoir lui ajouter des cures.");
            return;
        }
        var newCureView = new CureView(null, -1, categoryView, $scope);
        categoryView.addCureView(newCureView);

        if (categoryView.image && categoryView.image !== null) newCureView.setImage(categoryView.image);

        $scope.setEditedCure(newCureView);
    };
    $scope.cureClicked = function (cureView) //Function linked to curesSelector.html
    {
        $scope.setEditedCure(cureView);
    };
    $scope.setEditedCure = function (cureView) {
        if ($scope.dd.view.edited.categoryView) if ($scope.dd.view.edited.categoryView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        } else $scope.dd.view.edited.categoryView = null;
        if ($scope.dd.view.edited.cureView && $scope.dd.view.edited.cureView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }
        $scope.dd.view.edited.cureView = cureView;
    };

    $scope.saveEditedCure = function () {
        if ($scope.dd.view.edited.cureView) {
            $scope.dd.view.edited.cureView.updateModel();
            $scope.dd.view.displayError = false;
            $scope.dd.view.edited.cureView.hrSkillsView = null;
            $scope.dd.view.edited.cureView.prSkillsView = null;
            $scope.dd.view.edited.cureView = null;
            $scope.displayChangeMsg = false;
        }
    };
    $scope.cancelEditedCure = function () {
        $scope.dd.view.edited.cureView.reloadModel();
        $scope.dd.view.displayError = false;
        $scope.dd.view.edited.cureView.hrSkillsView = null;
        $scope.dd.view.edited.cureView.prSkillsView = null;
        $scope.dd.view.edited.cureView = null;
        $scope.displayChangeMsg = false;
    };
    $scope.openDeletedCureViewConfirmDialog = function () {
        if ($scope.dd.view.edited.cureView) {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/removeConfirm.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["label"] = $scope.dd.view.edited.cureView.label;
                        return tableModel;
                    } } };

            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) $scope.removeEditedCure();
            });
        }
    };
    $scope.removeEditedCure = function () {
        if ($scope.dd.view.edited.cureView) {
            $scope.dd.view.edited.cureView.removeModel();
            var parentCategoryView = $scope.dd.view.edited.cureView.parentCategoryView;
            if (parentCategoryView) parentCategoryView.removeCureView($scope.dd.view.edited.cureView);
            $scope.dd.view.deletedCuresView.push($scope.dd.view.edited.cureView);
            $scope.dd.view.edited.cureView.hrSkillsView = null;
            $scope.dd.view.edited.cureView.prSkillsView = null;
            $scope.dd.view.edited.cureView = null;

            $scope.displayChangeMsg = false;
        }
    };
    $scope.restoreCure = function (cureView) {
        if (cureView) {
            if (cureView.servIndex != -1) // retrieve old value from server
                cureView.restoreModel();
            var index = $scope.dd.view.deletedCuresView.indexOf(cureView);
            if (index != -1) {
                $scope.dd.view.deletedCuresView.splice(index, 1);
                if (cureView.parentCategoryView) cureView.parentCategoryView.addCureView(cureView);
            }
        }
    };

    //Assign image


    $scope.imageIsSelected = function (image) {
        if ($scope.dd.view.edited.cureView) {
            if (!$scope.dd.view.edited.cureView.companyImage && $scope.dd.view.edited.cureView.image === image) return true;
        } else if (!$scope.dd.view.edited.categoryView.companyImage && $scope.dd.view.edited.categoryView.image === image) return true;

        return false;
    };

    $scope.companyImageIsSelected = function (companyImage) {
        if ($scope.dd.view.edited.cureView && $scope.dd.view.edited.cureView.companyImage === companyImage) return true;
        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.companyImage === companyImage) return true;
        return false;
    };
    $scope.setImage = function (image) {
        if ($scope.dd.view.edited.cureView) {
            if (image === $scope.dd.view.edited.cureView.image) {
                if ($scope.dd.view.edited.cureView.image != null) {
                    $scope.dd.view.edited.cureView.setImage(null);
                } else {
                    $scope.dd.view.edited.cureView.setImage($scope.dd.view.edited.cureView.parentCategoryView.image);
                }
            } else if (image != null) {
                $scope.dd.view.edited.cureView.setImage(image);
            } else {
                $scope.dd.view.edited.cureView.setImage($scope.dd.view.edited.cureView.parentCategoryView.image);
            }
        }

        if ($scope.dd.view.edited.categoryView) {
            if (image === $scope.dd.view.edited.categoryView.image) {
                if ($scope.dd.view.edited.categoryView.image != null) {
                    $scope.dd.view.edited.categoryView.setImage(null);
                } else {
                    $scope.dd.view.edited.categoryView.setImage($scope.dd.view.edited.categoryView.parentCategoryView.image);
                }
            } else if (image != null) {
                $scope.dd.view.edited.categoryView.setImage(image);
            } else {
                $scope.dd.view.edited.categoryView.setImage($scope.dd.view.edited.categoryView.parentCategoryView.image);
            }
        }
    };
    $scope.setCompanyImage = function (companyImage) {
        if ($scope.dd.view.edited.cureView) {
            if (companyImage === $scope.dd.view.edited.cureView.companyImage) {
                if ($scope.dd.view.edited.cureView.companyImage != null) {
                    $scope.dd.view.edited.cureView.setCompanyImage(null);
                } else {
                    $scope.dd.view.edited.cureView.setCompanyImage($scope.dd.view.edited.cureView.parentCategoryView.companyImage);
                }
            } else if (companyImage != null) {
                $scope.dd.view.edited.cureView.setCompanyImage(companyImage);
            } else {
                $scope.dd.view.edited.cureView.setCompanyImage($scope.dd.view.edited.cureView.parentCategoryView.companyImage);
            }
        }

        if ($scope.dd.view.edited.categoryView) {
            if (companyImage === $scope.dd.view.edited.categoryView.companyImage) {
                if ($scope.dd.view.edited.categoryView.companyImage != null) {
                    $scope.dd.view.edited.categoryView.setCompanyImage(null);
                } else {
                    $scope.dd.view.edited.categoryView.setCompanyImage($scope.dd.view.edited.categoryView.parentCategoryView.companyImage);
                }
            } else if (companyImage != null) {
                $scope.dd.view.edited.categoryView.setCompanyImage(companyImage);
            } else {
                $scope.dd.view.edited.categoryView.setCompanyImage($scope.dd.view.edited.categoryView.parentCategoryView.companyImage);
            }
        }
    };

    $scope.getEditedItem = function () {
        return $scope.dd.view.edited.categoryView ? $scope.dd.view.edited.categoryView : $scope.dd.view.edited.cureView ? $scope.dd.view.edited.cureView : null;
    };
}]);

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('hrPlanningCtrl', ["$log", "$scope", "SiteData", "$timeout", "PlanningTableView", function ($log, $scope, SiteData, $timeout, PlanningTableView) {
    $scope.$watch('ad.sDm', function (newValue, oldValue) {
        if (newValue == 'planning') {
            // INIT VIEW
            $scope.loadPTView();
        }
    });

    var doit;
    window.onresize = function () {
        clearTimeout(doit);
        doit = setTimeout($scope.onWindowResizeEnd, 500);
    };
    $scope.onWindowResizeEnd = function () {
        if ($scope.dd.view && $scope.dd.view.pTView) {
            $scope.dd.view.pTView.updateSize($scope.getPlanningLeft(), $scope.getPlanningTop(), $scope.getPlanningWidth(), $scope.getPlanningHeight());
            $scope.$apply();
        }
    };

    $scope.loadPTView = function () {
        $timeout(function () // Assychron load to display waiting spinner
        {
            console.log($scope.dd.view.humanResourcesView);
            $scope.dd.view.humanResourcesView = [];
            var nbHrMax = $scope.dd.view.humanResourcesActiveView.length;
            if ($scope.ad.addons.sub.solo) nbHrMax = 1;
            var nbHr = 0;
            for (var i = 0; i < $scope.dd.view.humanResourcesActiveView.length && nbHr < nbHrMax; i++) {
                if ($scope.dd.view.humanResourcesActiveView[i].hasPlanning) {
                    $scope.dd.view.humanResourcesView.push($scope.dd.view.humanResourcesActiveView[i]); // planning actived
                    nbHr++;
                }
            }
            $scope.dd.view.scope = $scope;
            $scope.dd.view.getHrView = function (hr) {
                for (var i = 0; i < this.humanResourcesActiveView.length; i++) {
                    if (this.humanResourcesActiveView[i].getModel() === hr) return this.humanResourcesActiveView[i];
                }for (i = 0; i < this.humanResourcesDeletedView.length; i++) {
                    if (this.humanResourcesDeletedView[i].getModel() === hr) return this.humanResourcesDeletedView[i];
                }return null;
            };
            $scope.dd.view.getNbVisibleHr = function () {
                return $scope.dd.view.humanResourcesView.length;
            };
            $scope.dd.view.getHumanResourcesView = function () {
                return $scope.dd.view.humanResourcesView;
            };

            $scope.dd.view.pTView = new PlanningTableView(true, true, $scope.getPlanningLeft(), $scope.getPlanningTop(), $scope.getPlanningWidth(), $scope.getPlanningHeight(), null, $scope.dd.view, false);

            $scope.dd.loading = false;
        }, 100);
    };
    $scope.$watch('dd.view.pTView.dim.nbDays', function (newValue, oldValue) {
        if ($scope.dd.view && $scope.dd.view.pTView && $scope.dd.view.pTView instanceof PlanningTableView && oldValue !== undefined && !$scope.dd.view.pTView.loading) {
            $scope.dd.view.pTView.initPlgDaysViewOnStandardWeek();
        }
    });
    $scope.getPlanningLeft = function () {
        var planningStart = 0;

        var cfgMenuWidth = angular.element('#cfg-menu').css('width');
        var posMenuWidth = angular.element('#pos-menu').css('width');
        var menuWidthStr = '';

        if (cfgMenuWidth) {
            menuWidthStr = cfgMenuWidth;
        } else if (posMenuWidth) {
            menuWidthStr = posMenuWidth;
        }

        if (menuWidthStr) {
            menuWidthStr = menuWidthStr.replace("px");
            planningStart = parseInt(menuWidthStr);
        }

        return planningStart;
    };
    $scope.getPlanningTop = function () {
        return 136; //menu + table titles
    };
    $scope.getPlanningWidth = function () {
        var bodyWidth = $scope.getDomainWidth();

        if ($scope.dd.isStandardWeek) {
            var menuLeft = $scope.getPlanningLeft();
            if (menuLeft) {
                bodyWidth -= menuLeft;
            }
        }

        return bodyWidth;
    };
    $scope.getPlanningHeight = function () {
        var planningHeightStr = angular.element('body').css('height');
        if (planningHeightStr == null) return 0;
        var planningHeight = parseInt(planningHeightStr.replace("px"));
        planningHeight -= $scope.getPlanningTop(); //menu + action barre + table titles
        return planningHeight;
    };

    $scope.getDomainWidth = function () {
        var bodyWidthStr = angular.element('body').css('width');
        bodyWidthStr = bodyWidthStr.replace("px");
        return parseInt(bodyWidthStr);
    };
}]);

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('HrSkillCtrl', ["$scope", "$rootScope", "$dialog", "$timeout", "DateSrv", "HumanResourceSrv", "HumanResourceData", "CategoryData", "CategoryView", "gettextCatalog", function ($scope, $rootScope, $dialog, $timeout, DateSrv, HumanResourceSrv, HumanResourceData, CategoryData, CategoryView, gettextCatalog) {

    $scope.$watch('ad.sDm', function (newValue, oldValue) {
        if (newValue == 'skill') {
            $scope.loadSkillView();
        }
    });

    $scope.loadSkillView = function () {
        var allCategories = gettextCatalog.getString("Toutes les prestations");
        var categoryRootView = new CategoryView(CategoryData.categoryRoot, CategoryData.getIndexOf(CategoryData.categoryRoot), null, $scope); // categoryRoot index  = 0
        $scope.dd.skillRoot = {
            type: "Category",
            label: allCategories,
            show: true,
            open: true,
            element: categoryRootView,
            subElement: [],
            level: 0,
            shift: 0,
            humanResourceValues: []
        };
        $scope.dd.skills = [];
        $scope.dd.skills.push($scope.dd.skillRoot);
        $scope.dd.view.humanResourcesView = [];
        for (var i = 0; i < $scope.dd.view.humanResourcesActiveView.length; i++) {
            if ($scope.dd.view.humanResourcesActiveView[i].hasPlanning) $scope.dd.view.humanResourcesView.push($scope.dd.view.humanResourcesActiveView[i]); // planning actived
        }
        $scope.fillSkills($scope.dd.skillRoot);
        $scope.dd.loading = false;
    };
    $scope.fillSkills = function (skillCategory) {
        var hrViews = $scope.dd.view.humanResourcesView;

        for (var i = 0; i < hrViews.length; i++) {
            skillCategory.humanResourceValues.push("on");
        }var hrOneSonTrueValues = [];
        for (i = 0; i < hrViews.length; i++) {
            hrOneSonTrueValues.push(false);
        }for (i = 0; i < skillCategory.element.categoriesView.length; i++) {
            var newSkillCategory = {
                type: "Category",
                label: skillCategory.element.categoriesView[i].label,
                show: skillCategory.open,
                open: false,
                element: skillCategory.element.categoriesView[i],
                subElement: [],
                level: skillCategory.level + 1,
                shift: 0,
                humanResourceValues: []
            };
            skillCategory.subElement.push(newSkillCategory);
            $scope.dd.skills.push(newSkillCategory);
            var humanResourceValuesCat = $scope.fillSkills(newSkillCategory);
            for (var k = 0; k < hrViews.length; k++) {
                if (humanResourceValuesCat[k] == "on") hrOneSonTrueValues[k] = true;else if (skillCategory.humanResourceValues[k] == "on") //if partial set dont change it
                    skillCategory.humanResourceValues[k] = humanResourceValuesCat[k];
            }
        }
        for (i = 0; i < skillCategory.element.servicesView.length; i++) {
            var newSkillService = {
                type: "Service",
                label: skillCategory.element.servicesView[i].label,
                show: skillCategory.open,
                element: skillCategory.element.servicesView[i],
                level: skillCategory.level + 1,
                shift: 1,
                humanResourceValues: []
            };

            for (var j = 0; j < hrViews.length; j++) {
                if (hrViews[j].getModel() && hrViews[j].getModel().hasService(skillCategory.element.servicesView[i].getModel())) {
                    newSkillService.humanResourceValues.push("on");
                    hrOneSonTrueValues[j] = true;
                } else {
                    newSkillService.humanResourceValues.push("off");
                    skillCategory.humanResourceValues[j] = "off";
                }
            }skillCategory.subElement.push(newSkillService);
            $scope.dd.skills.push(newSkillService);
        }
        for (i = 0; i < hrViews.length; i++) {
            if (skillCategory.humanResourceValues[i] == "off" && hrOneSonTrueValues[i]) skillCategory.humanResourceValues[i] = "partial";
        }

        return skillCategory.humanResourceValues;
    };
    $scope.skillClick = function (skill, hrIndex) {
        //se
        var changed = false;
        if (skill.humanResourceValues[hrIndex] == "on") changed = $scope.updateSubElementHrValues(skill, hrIndex, "off");else changed = $scope.updateSubElementHrValues(skill, hrIndex, "on");
        $scope.updateCategoryHrValues($scope.dd.skillRoot, hrIndex);

        if (changed) HumanResourceSrv.save($scope.dd.view.humanResourcesView[hrIndex].getModel());
    };
    $scope.updateSubElementHrValues = function (skill, hrIndex, value) {
        var changed = false;
        if (skill.humanResourceValues[hrIndex] != value) {
            skill.humanResourceValues[hrIndex] = value;
            if (skill.type == "Service") //Save it
                {
                    if (skill.humanResourceValues[hrIndex] == "on") $scope.dd.view.humanResourcesView[hrIndex].getModel().addService(skill.element.getModel());else $scope.dd.view.humanResourcesView[hrIndex].getModel().removeService(skill.element.getModel());

                    changed = true;
                }
        }

        if (skill.subElement) for (var j = 0; j < skill.subElement.length; j++) {
            changed = $scope.updateSubElementHrValues(skill.subElement[j], hrIndex, value) || changed;
        }return changed;
    };
    $scope.updateCategoryHrValues = function (skillCategory, hrIndex) {
        var hrValue = "on";
        var chrValue = "on";
        var hrOneSonTrueValue = false;
        for (var j = 0; j < skillCategory.subElement.length; j++) {
            if (skillCategory.subElement[j].type == "Category") {
                chrValue = $scope.updateCategoryHrValues(skillCategory.subElement[j], hrIndex);
                if (chrValue == "on") hrOneSonTrueValue = true;else ////chrValue = partial or off
                    if (hrValue == "on") //if partial set dont change it
                        hrValue = chrValue;
            } else {
                if (skillCategory.subElement[j].humanResourceValues[hrIndex] == "off") hrValue = "off";else hrOneSonTrueValue = true;
            }
        }
        if (hrValue == "off" && hrOneSonTrueValue) hrValue = "partial";
        skillCategory.humanResourceValues[hrIndex] = hrValue;
        return hrValue;
    };
    $scope.openSkillCategory = function (skillCategory) {
        skillCategory.open = true;
        if (skillCategory.subElement) for (var j = 0; j < skillCategory.subElement.length; j++) {
            $scope.propagateShowStatus(skillCategory.subElement[j], true);
        }
    };
    $scope.closeSkillCategory = function (skillCategory) {
        skillCategory.open = false;
        if (skillCategory.subElement) for (var j = 0; j < skillCategory.subElement.length; j++) {
            $scope.propagateShowStatus(skillCategory.subElement[j], false);
        }
    };
    $scope.propagateShowStatus = function (skillCategory, showStatus) {
        skillCategory.show = showStatus;
        if (skillCategory.open && skillCategory.subElement) for (var j = 0; j < skillCategory.subElement.length; j++) {
            $scope.propagateShowStatus(skillCategory.subElement[j], showStatus);
        }
    };
}]);

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('HrTeamCtrl', ["$rootScope", "$scope", "$dialog", "$filter", "HumanResource", "HumanResourceView", "HumanResourceData", "LanguageManager", "$timeout", "Auth", "Genders", "SiteData", function ($rootScope, $scope, $dialog, $filter, HumanResource, HumanResourceView, HumanResourceData, LanguageManager, $timeout, Auth, Genders, SiteData) {
    $scope.displayModificationMessage = false;
    $scope.displayError = false;
    $scope.dd.loading = false;
    $scope.hrIsLoading = false;
    $scope.dd.flowConfig = {
        target: '/rest/companyImageUpload',
        method: 'octet',
        query: { companyCode: Auth.getCompanyCode(), type: 'humanResource' },
        maxChunkRetries: 1,
        chunkRetryInterval: 5000,
        simultaneousUploads: 1,
        chunkSize: 1024 * 1024 * 5,
        singleFile: true,
        testChunks: false,
        headers: { Authorization: $scope.ad.currentUser.token }
    };
    $scope.dd.view.tab = 0;
    $scope.dd.view.imageUploadRunning = false;
    $scope.dd.view.genders = Genders;

    $scope.changeOrderDown = function (hrView) {
        var index = $scope.dd.view.humanResourcesActiveView.indexOf(hrView);
        // put a human resource up in the order
        if (index > 0 && index != -1) $scope.dd.view.humanResourcesActiveView[index - 1].order++;
        hrView.order--;

        $scope.sortHrActiveViewArray();
    };
    $scope.changeOrderUp = function (hrView) {
        // put a human resource down in the order
        var index = $scope.dd.view.humanResourcesActiveView.indexOf(hrView);
        // put a human resource up in the order
        if (index < $scope.dd.view.humanResourcesActiveView.length - 1 && index != -1) $scope.dd.view.humanResourcesActiveView[index + 1].order--;
        hrView.order++;

        $scope.sortHrActiveViewArray();
    };

    $scope.openDeletedHrViewConfirmDialog = function () {
        if ($scope.dd.edited.hrView) {
            if ($scope.dd.edited.hrView.id === SiteData.defaultSite.ownerId) {
                var opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials/global/infoDialog.html',
                    controller: 'DialogCtrl',
                    resolve: {
                        dialogsModel: function dialogsModel() {
                            var tableModel = [];
                            tableModel["label"] = "Impossible de supprimer ce personnel car il est gestionnaire du site.";
                            return tableModel;
                        }
                    }
                };
                $dialog.dialog(opts).open();
            } else {
                var opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials/global/removeConfirm.html',
                    controller: 'DialogCtrl',
                    resolve: {
                        dialogsModel: function dialogsModel() {
                            var tableModel = [];
                            tableModel["label"] = $scope.dd.edited.hrView.label;
                            return tableModel;
                        } } };

                var d = $dialog.dialog(opts);
                d.open().then(function (result) {
                    if (result) $scope.removeEditedHrView();
                });
            }
        }
    };
    $scope.setEditedHrView = function (hrView) {
        if ($scope.dd.edited.hrView && $scope.dd.edited.hrView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }

        $scope.dd.edited.hrView = hrView;
    };
    $scope.createHumanResource = function () {
        if ($scope.dd.view.humanResourcesActiveView) {
            if ($scope.dd.edited.hrView && $scope.dd.edited.hrView.isChanged()) {
                $scope.displayChangeMsg = true;
                return;
            }
            var order = $scope.dd.view.humanResourcesActiveView.length;

            var newHrView = new HumanResourceView(null, -1, $scope, order);
            $scope.dd.view.humanResourcesActiveView.push(newHrView);
            $scope.dd.view.humanResourcesView.push(newHrView);
            $scope.dd.edited.hrView = newHrView;
        }
    };
    $scope.cancelEditedHrView = function () {
        /*if ($scope.dd.edited.hrView.getModel() != null)// retrieve old value from server
        {
            $scope.dd.edited.hrView.reloadModel();
        }
        else*/
        if ($scope.dd.edited.hrView.getModel() == null) {
            var index = $scope.dd.view.humanResourcesActiveView.indexOf($scope.dd.edited.hrView);
            if (index >= 0) $scope.dd.view.humanResourcesActiveView.splice(index, 1);
        }

        if ($scope.isHrArrayOrdered()) {
            // if order value defined good, we can reload model
            for (var i = 0; i < $scope.dd.view.humanResourcesActiveView.length; i++) {
                $scope.dd.view.humanResourcesActiveView[i].reloadModel();
            }
        } else {
            // if order value defined badly, there is no model to reload : redefine order value
            var humanResources = HumanResourceData.getActiveList();
            $scope.dd.view.humanResourcesActiveView = [];
            for (i = 0; i < humanResources.length; i++) {
                // init order with i
                $scope.dd.view.humanResourcesActiveView.push(new HumanResourceView(humanResources[i], HumanResourceData.getIndexOf(humanResources[i]), $scope, i));
            }
        }

        $scope.sortHrActiveViewArray();

        $scope.dd.edited.hrView = null;
        $scope.displayError = false;
        $scope.displayChangeMsg = false;
    };

    $scope.saveEditedHrView = function () {
        $scope.hrIsLoading = true;
        var humanResourcesActiveView = $scope.dd.view.humanResourcesActiveView;
        var promises = [];
        for (var i = 0; i < humanResourcesActiveView.length; i++) {
            promises.push(humanResourcesActiveView[i].updateModelWithPromise());
        }
        Promise.all(promises).finally(function () {
            $timeout(function () {
                $scope.hrIsLoading = false;
            });
        });

        $scope.sortHrActiveViewArray();

        $scope.dd.edited.hrView = null;
        $scope.displayError = false;
        $scope.displayChangeMsg = false;
    };

    $scope.removeEditedHrView = function () {
        if ($scope.dd.edited.hrView) {
            if ($scope.dd.edited.hrView.hrIndex != -1) // retrieve old value from server
                $scope.dd.edited.hrView.removeModel();
            var index = $scope.dd.view.humanResourcesActiveView.indexOf($scope.dd.edited.hrView);
            if (index != -1) {
                $scope.dd.view.humanResourcesActiveView.splice(index, 1);
                if ($scope.dd.view.humanResourcesDeletedView) $scope.dd.view.humanResourcesDeletedView.push($scope.dd.edited.hrView);
            }

            var indexStartDelete = index;
            for (var i = indexStartDelete; i < $scope.dd.view.humanResourcesActiveView.length; i++) {
                $scope.dd.view.humanResourcesActiveView[i].order--;
                $scope.dd.view.humanResourcesActiveView[i].updateModel();
            }

            $scope.dd.edited.hrView = null;
            $scope.displayError = false;
            $scope.displayChangeMsg = false;
        }
    };
}]);

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('HrTrashCtrl', ["$rootScope", "$scope", "HumanResourceData", "HumanResourceView", function ($rootScope, $scope, HumanResourceData, HumanResourceView) {
    $scope.dd.loading = false;

    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue && !$scope.dd.initTrashView) {
            $scope.initView();
        }
    });

    $scope.initView = function () {
        $scope.dd.view.humanResourcesDeletedView = [];
        var humanResourcesDeleted = HumanResourceData.getDeletedList();
        for (var i = 0; i < humanResourcesDeleted.length; i++) {
            $scope.dd.view.humanResourcesDeletedView.push(new HumanResourceView(humanResourcesDeleted[i], HumanResourceData.getIndexOf(humanResourcesDeleted[i]), $scope));
        }$scope.dd.loading = false;
        $scope.dd.initTrashView = true;
    };
    $scope.restore = function (hrView) {
        if (hrView) {
            if (hrView != -1) {
                // retrieve old value from server
                //hrView.restoreModelAndUpdateOrder(HumanResourceData.getActiveList().length);
                hrView.restoreModel();
                hrView.order = HumanResourceData.getActiveList().length - 1;
                hrView.updateModel();
            }
            var index = $scope.dd.view.humanResourcesDeletedView.indexOf(hrView);
            if (index != -1) {
                $scope.dd.view.humanResourcesDeletedView.splice(index, 1);
                $scope.dd.view.humanResourcesActiveView.push(hrView);
                if (hrView.hasPlanning) $scope.dd.view.humanResourcesView.push(hrView);
            }
        }
    };
}]);

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('HumanResourceCtrl', ["$scope", "$filter", "HumanResourceData", "HumanResourceView", "LanguageManager", function ($scope, $filter, HumanResourceData, HumanResourceView, LanguageManager) {

    //HumanResource functions
    $scope.dd = {
        view: {
            humanResourcesView: [], //for planning TODO RENAME
            humanResourcesActiveView: [], //Active hr
            humanResourcesDeletedView: [],
            pTView: null
        },
        edited: { hrView: null },
        skillRoot: null, //used by hrSkillCtrl
        skills: [], //used by hrSkillCtrl
        siteView: {},
        displaySubConf: 1,
        display: {
            startDay: 0,
            nbDays: 6
        },
        loading: true,
        initTeamView: false,
        initTrashView: false
    };

    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue && !$scope.dd.initTeamView) {
            if (!$scope.ad.managerMode) {
                $scope.goToDomain("planningPos", "dashboard");
            }
            $scope.initView();
        }
    });
    $scope.sortHrActiveViewArray = function () {
        $scope.dd.view.humanResourcesActiveView = $filter('orderBy')($scope.dd.view.humanResourcesActiveView, 'order');
    };
    $scope.isHrArrayOrdered = function () {
        var humanResources = HumanResourceData.getActiveList();

        humanResources = $filter('orderBy')(humanResources, 'order');

        var orderedValues = true;
        for (var i = 0; i < humanResources.length; i++) {
            if (humanResources[i].order == null || humanResources[i].order != i) orderedValues = false;
        }
        return orderedValues;
    };
    $scope.initView = function () {
        var humanResources = HumanResourceData.getActiveList();
        var hrView;

        for (var i = 0; i < humanResources.length; i++) {
            hrView = new HumanResourceView(humanResources[i], HumanResourceData.getIndexOf(humanResources[i]), $scope, humanResources[i].order);
            $scope.dd.view.humanResourcesActiveView.push(hrView);
        }

        // Sort humanResourcesActiveView by order value
        if ($scope.dd.view.humanResourcesActiveView.length > 1) $scope.sortHrActiveViewArray();

        $scope.dd.loading = false;
        $scope.dd.initTeamView = true;
    };
}]);

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.controllers').controller('CompanyImageCtrl', ["$scope", "$dialog", "$timeout", "CompanyImageData", "CompanyImageSrv", function ($scope, $dialog, $timeout, CompanyImageData, CompanyImageSrv) {
    var MAX_IMAGES_DISPLAYED_ON_SCROLL = 100;
    $scope.dd.view.companyImagesView = [];
    $scope.dd.view.companyImagesViewDisplayed = [];
    $scope.dd.view.imageUploadRunning = false;

    $scope.$watch('ad.dataLoaded', function (newValue) {
        if (newValue) {
            $scope.dd.view.companyImagesView = CompanyImageData.companyImages;
            $scope.addMoreCompanyImage();
        }
    });

    $scope.addCompanyImagesViewDisplayed = function (companyImageView) {
        if (companyImageView && $scope.dd.view.companyImagesViewDisplayed.indexOf(companyImageView) === -1) {
            $scope.dd.view.companyImagesViewDisplayed.push(companyImageView);
        }
    };

    $scope.addMoreCompanyImage = function () {
        if ($scope.dd.view.companyImagesViewDisplayed && $scope.dd.view.companyImagesView) {
            var initialSize = $scope.dd.view.companyImagesViewDisplayed.length;
            var numberOfImagesToDisplay = initialSize + MAX_IMAGES_DISPLAYED_ON_SCROLL;
            for (var i = initialSize; i < $scope.dd.view.companyImagesView.length && i < numberOfImagesToDisplay; i++) {
                $scope.addCompanyImagesViewDisplayed($scope.dd.view.companyImagesView[i]);
            }
        }
    };

    $scope.removeImageViewFromEditedItem = function (editedItemView, companyImage) {
        if (editedItemView) {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/removeConfirm.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["label"] = companyImage.label;
                        return tableModel;
                    }
                }
            };
            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) {
                    var index = $scope.dd.view.companyImagesViewDisplayed.indexOf(companyImage);
                    if (index !== -1) {
                        $scope.dd.view.companyImagesViewDisplayed.splice(index, 1);
                    }
                    var indexDisplay = $scope.dd.view.companyImagesView.indexOf(companyImage);
                    if (indexDisplay !== -1) {
                        $scope.dd.view.companyImagesView.splice(index, 1);
                        CompanyImageSrv.remove(companyImage);
                    }
                }
            });
        }
    };

    $scope.onUploadCompanyImageSuccess = function (editedItemView, message) {
        try {
            var companyImage = JSON.parse(message);
            $scope.dd.view.imageUploadRunning = false;
            if (editedItemView && editedItemView.setCompanyImage) editedItemView.setCompanyImage(companyImage);
            if (companyImage) {
                CompanyImageData.add(companyImage);
                $scope.dd.view.companyImagesViewDisplayed.push(companyImage);
            }
        } catch (e) {
            console.log('onUploadCompanyImageSuccess JSON.parse error', e);
        }
    };

    $scope.onStartUploadImage = function () {
        $scope.dd.view.imageUploadRunning = true;
    };
}]);

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('PhysicalResourceCtrl', ["$scope", "$rootScope", "$dialog", "$timeout", "$filter", "DateSrv", "PhysicalResourceSrv", "PhysicalResourceData", "PhysicalResource", "SiteData", "PhysicalResourceView", "LanguageManager", function ($scope, $rootScope, $dialog, $timeout, $filter, DateSrv, PhysicalResourceSrv, PhysicalResourceData, PhysicalResource, SiteData, PhysicalResourceView, LanguageManager) {

    //PhysicalResource functions
    $scope.dd = {
        view: {
            physicalResourcesView: [], //for planning TODO RENAME
            physicalResourcesActiveView: [], //Active pr
            physicalResourcesDeletedView: [],
            physicalResourcesUnitView: [] //visible on planning
        },
        edited: { prView: null },
        displaySubConf: 1,
        display: {
            startDay: 0,
            nbDays: 6
        }
    };

    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue) {
            if (!$scope.ad.managerMode) {
                $scope.goToDomain("planningPos", "dashboard");
            }
            var physicalResources = PhysicalResourceData.getActiveList();
            var prView;
            for (var i = 0; i < physicalResources.length; i++) {
                prView = new PhysicalResourceView(physicalResources[i], PhysicalResourceData.getIndexOf(physicalResources[i]), $scope, physicalResources[i].order);
                $scope.dd.view.physicalResourcesActiveView.push(prView);
                $scope.dd.view.physicalResourcesView.push(prView);
                for (var k = 1; k <= prView.number; k++) {
                    $scope.dd.view.physicalResourcesUnitView.push({
                        prView: prView,
                        prUnitId: k,
                        label: prView.label + (prView.number > 1 ? ' ' + k : '')
                    });
                }
            }

            // Sort physicalResourcesActiveView by order value
            if ($scope.dd.view.physicalResourcesActiveView.length > 1) $scope.sortPrActiveViewArray();
            var physicalResourcesDeleted = PhysicalResourceData.getDeletedList();
            for (var i = 0; i < physicalResourcesDeleted.length; i++) {
                $scope.dd.view.physicalResourcesDeletedView.push(new PhysicalResourceView(physicalResourcesDeleted[i], PhysicalResourceData.getIndexOf(physicalResourcesDeleted[i]), $scope));
            }
        }
    });
    $scope.isPrArrayOrdered = function () {
        var physicalResources = PhysicalResourceData.getActiveList();

        physicalResources = $filter('orderBy')(physicalResources, 'order');

        var orderedValues = true;
        for (var i = 0; i < physicalResources.length; i++) {
            if (physicalResources[i].order == null || physicalResources[i].order != i) orderedValues = false;
        }
        return orderedValues;
    };
    $scope.sortPrActiveViewArray = function () {
        $scope.dd.view.physicalResourcesActiveView = $filter('orderBy')($scope.dd.view.physicalResourcesActiveView, 'order');
    };
    $scope.changeOrderDown = function (prView) {
        var index = $scope.dd.view.physicalResourcesActiveView.indexOf(prView);
        // put a physical resource up in the order
        if (index > 0 && index != -1) $scope.dd.view.physicalResourcesActiveView[index - 1].order++;
        prView.order--;

        $scope.sortPrActiveViewArray();
    };
    $scope.changeOrderUp = function (prView) {
        // put a physical resource down in the order
        var index = $scope.dd.view.physicalResourcesActiveView.indexOf(prView);
        // put a physical resource up in the order
        if (index < $scope.dd.view.physicalResourcesActiveView.length - 1 && index != -1) $scope.dd.view.physicalResourcesActiveView[index + 1].order--;
        prView.order++;

        $scope.sortPrActiveViewArray();
    };
    $scope.getPhysicalResourcesView = function () {
        return $scope.dd.view.physicalResourcesView;
    };

    $scope.getPrView = function (hr) {
        for (var i = 0; i < this.physicalResourcesActiveView.length; i++) {
            if (this.physicalResourcesActiveView[i].getModel() === hr) return this.physicalResourcesActiveView[i];
        }for (var i = 0; i < this.physicalResourcesDeletedView.length; i++) {
            if (this.physicalResourcesDeletedView[i].getModel() === hr) return this.physicalResourcesDeletedView[i];
        }return null;
    };

    $scope.getCfgClass = function (confItem, className) {
        if (confItem == $scope.dd.displaySubConf) return className;
        return "";
    };
}]);

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('PrDataCtrl', ["$rootScope", "$scope", "$dialog", "PhysicalResource", "PhysicalResourceView", "PhysicalResourceData", "$timeout", function ($rootScope, $scope, $dialog, PhysicalResource, PhysicalResourceView, PhysicalResourceData, $timeout) {
    $scope.displayModificationMessage = false;
    $scope.displayError = false;
    $scope.prIsLoading = false;

    $scope.openDeletedPrViewConfirmDialog = function () {
        if ($scope.dd.edited.prView) {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/removeConfirm.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["label"] = $scope.dd.edited.prView.label;
                        return tableModel;
                    } } };

            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) $scope.removeEditedPrView();
            });
        }
    };
    $scope.setEditedPrView = function (prView) {
        if ($scope.dd.edited.prView && $scope.dd.edited.prView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }

        $scope.dd.edited.prView = prView;
    };
    $scope.createPhysicalResource = function () {
        if ($scope.dd.edited.prView && $scope.dd.edited.prView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }
        var newPrView = new PhysicalResourceView(null, -1, $scope, $scope.dd.view.physicalResourcesActiveView.length);
        $scope.dd.view.physicalResourcesActiveView.push(newPrView);
        $scope.dd.view.physicalResourcesView.push(newPrView);
        $scope.dd.edited.prView = newPrView;
    };
    $scope.cancelEditedPrView = function () {
        if ($scope.dd.edited.prView.prIndex != -1) // retrieve old value from server
            {
                $scope.dd.edited.prView.reloadModel();
            } else {
            var index = $scope.dd.view.physicalResourcesView.indexOf($scope.dd.edited.prView);
            if (index >= 0) $scope.dd.view.physicalResourcesView.splice(index, 1);
            index = $scope.dd.view.physicalResourcesActiveView.indexOf($scope.dd.edited.prView);
            if (index >= 0) $scope.dd.view.physicalResourcesActiveView.splice(index, 1);
        }
        $scope.dd.edited.prView = null;
        $scope.displayError = false;
        $scope.displayChangeMsg = false;
    };

    $scope.saveEditedPrView = function () {
        if ($scope.dd.edited.prView) {
            $scope.prIsLoading = true;
            var promises = [];
            for (var i = 0; i < $scope.dd.view.physicalResourcesActiveView.length; i++) {
                promises.push($scope.dd.view.physicalResourcesActiveView[i].updateModelWithPromise());
            }

            Promise.all(promises).finally(function () {
                $timeout(function () {
                    $scope.prIsLoading = false;
                });
            });

            $scope.sortPrActiveViewArray();
        }
        $scope.dd.edited.prView = null;
        $scope.displayError = false;
        $scope.displayChangeMsg = false;
    };

    $scope.removeEditedPrView = function () {

        if ($scope.dd.edited.prView) {
            if ($scope.dd.edited.prView.prIndex != -1) // retrieve old value from server
                $scope.dd.edited.prView.removeModel();
            var index = $scope.dd.view.physicalResourcesActiveView.indexOf($scope.dd.edited.prView);
            if (index != -1) {
                $scope.dd.view.physicalResourcesActiveView.splice(index, 1);
                if ($scope.dd.view.physicalResourcesDeletedView) $scope.dd.view.physicalResourcesDeletedView.push($scope.dd.edited.prView);
                index = $scope.dd.view.physicalResourcesView.indexOf($scope.dd.edited.prView);
                if (index != -1) $scope.dd.view.physicalResourcesView.splice(index, 1);

                var indexStartDelete = index;
                for (var i = indexStartDelete; i < $scope.dd.view.physicalResourcesActiveView.length; i++) {
                    $scope.dd.view.physicalResourcesActiveView[i].order--;
                    $scope.dd.view.physicalResourcesActiveView[i].updateModel();
                }
            }
            $scope.dd.edited.prView = null;
            $scope.displayError = false;
            $scope.displayChangeMsg = false;
        }
    };
}]);

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('prPlanningCtrl', ["$scope", "SiteData", "$timeout", "PlanningTableView", function ($scope, SiteData, $timeout, PlanningTableView) {
    $scope.$watch('dd.displaySubConf', function (newValue, oldValue) {
        if (newValue == 3) {
            // INIT VIEW
            $scope.loadPTView();
        }
    });

    var doit;
    window.onresize = function () {
        clearTimeout(doit);
        doit = setTimeout($scope.onWindowResizeEnd, 500);
    };
    $scope.onWindowResizeEnd = function () {
        if ($scope.dd.view && $scope.dd.view.pTView) {
            $scope.dd.view.pTView.updateSize($scope.getPlanningLeft(), $scope.getPlanningTop(), $scope.getPlanningWidth(), $scope.getPlanningHeight());
            $scope.$apply();
        }
    };

    $scope.loadPTView = function () {
        $timeout(function () // Assycpron load to display waiting spinner
        {
            $scope.dd.view.physicalResourcesView = [];
            for (var i = 0; i < $scope.dd.view.physicalResourcesActiveView.length; i++) {
                if ($scope.dd.view.physicalResourcesActiveView[i].hasPlanning) $scope.dd.view.physicalResourcesView.push($scope.dd.view.physicalResourcesActiveView[i]); // planning actived
            }
            $scope.dd.view.scope = $scope;
            $scope.dd.view.getHrView = function (pr) {
                for (var i = 0; i < this.physicalResourcesActiveView.length; i++) {
                    if (this.physicalResourcesActiveView[i].getModel() === pr) return this.physicalResourcesActiveView[i];
                }for (i = 0; i < this.physicalResourcesDeletedView.length; i++) {
                    if (this.physicalResourcesDeletedView[i].getModel() === pr) return this.physicalResourcesDeletedView[i];
                }return null;
            };
            $scope.dd.view.getNbVisibleHr = function () {
                return $scope.dd.view.physicalResourcesView.length;
            };
            $scope.dd.view.getPhysicalResourcesView = function () {
                return $scope.dd.view.physicalResourcesView;
            };

            $scope.dd.view.pTView = new PlanningTableView(false, true, $scope.getPlanningLeft(), $scope.getPlanningTop(), $scope.getPlanningWidth(), $scope.getPlanningHeight(), null, $scope.dd.view, true);

            $scope.dd.loading = false;
        }, 100);
    };
    $scope.$watch('dd.view.pTView.dim.nbDays', function (newValue, oldValue) {
        if ($scope.dd.view && $scope.dd.view.pTView && $scope.dd.view.pTView instanceof PlanningTableView && oldValue !== undefined && !$scope.dd.view.pTView.loading) {
            $scope.dd.view.pTView.initPlgDaysViewOnStandardWeek();
        }
    });
    $scope.getPlanningLeft = function () {
        var planningStart = 0;
        var cfgMenuWidth = angular.element('#cfg-menu').css('width');
        var posMenuWidth = angular.element('#pos-menu').css('width');
        var menuWidthStr = '';

        if (cfgMenuWidth) {
            menuWidthStr = cfgMenuWidth;
        } else if (posMenuWidth) {
            menuWidthStr = posMenuWidth;
        }

        if (menuWidthStr) {
            menuWidthStr = menuWidthStr.replace("px");
            planningStart = parseInt(menuWidthStr);
        }
        return planningStart;
    };
    $scope.getPlanningTop = function () {
        return 136; //menu + table titles
    };
    $scope.getPlanningWidth = function () {
        var bodyWidth = $scope.getDomainWidth();

        if ($scope.dd.isStandardWeek) {
            var menuLeft = $scope.getPlanningLeft();
            if (menuLeft) {
                bodyWidth -= menuLeft;
            }
        }

        return bodyWidth;
    };
    $scope.getPlanningHeight = function () {
        var planningHeightStr = angular.element('body').css('height');
        if (planningHeightStr == null) return 0;
        var planningHeight = parseInt(planningHeightStr.replace("px"));
        planningHeight -= $scope.getPlanningTop(); //menu + action barre + table titles
        return planningHeight;
    };

    $scope.getDomainWidth = function () {
        var bodyWidthStr = angular.element('body').css('width');
        bodyWidthStr = bodyWidthStr.replace("px");
        return parseInt(bodyWidthStr);
    };
}]);

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('PrSkillCtrl', ["$scope", "$rootScope", "$dialog", "$timeout", "DateSrv", "PhysicalResourceSrv", "PhysicalResourceData", "CategoryData", "CategoryView", "gettextCatalog", function ($scope, $rootScope, $dialog, $timeout, DateSrv, PhysicalResourceSrv, PhysicalResourceData, CategoryData, CategoryView, gettextCatalog) {

    $scope.$watch('dd.displaySubConf', function (newValue, oldValue) {
        if (newValue == 2) {
            //INIT VIEW
            $scope.loadSkillView();
        }
    });

    $scope.loadSkillView = function () {
        //$timeout(function () {//In order to reduce wa
        var categoryRootView = new CategoryView(CategoryData.categoryRoot, CategoryData.getIndexOf(CategoryData.categoryRoot), null, $scope); // categoryRoot index  = 0
        $scope.dd.skillRoot = {
            type: "Category",
            label: gettextCatalog.getString("Toutes les prestations"),
            show: true,
            open: true,
            element: categoryRootView,
            subElement: [],
            level: 0,
            shift: 0,
            physicalResourceValues: []
        };
        $scope.dd.skills = [];
        $scope.dd.skills.push($scope.dd.skillRoot);
        $scope.dd.view.physicalResourcesView = [];
        for (var i = 0; i < $scope.dd.view.physicalResourcesActiveView.length; i++) {
            if ($scope.dd.view.physicalResourcesActiveView[i].hasPlanning) $scope.dd.view.physicalResourcesView.push($scope.dd.view.physicalResourcesActiveView[i]); // planning actived
        }
        $scope.fillSkills($scope.dd.skillRoot);
        $scope.dd.loading = false;
        //},50);
    };
    $scope.fillSkills = function (skillCategory) {
        var prViews = $scope.dd.view.physicalResourcesView;

        for (var i = 0; i < prViews.length; i++) {
            skillCategory.physicalResourceValues.push("on");
        }var prOneSonTrueValues = [];
        for (i = 0; i < prViews.length; i++) {
            prOneSonTrueValues.push(false);
        }for (i = 0; i < skillCategory.element.categoriesView.length; i++) {
            var newSkillCategory = {
                type: "Category",
                label: skillCategory.element.categoriesView[i].label,
                show: skillCategory.open,
                open: false,
                element: skillCategory.element.categoriesView[i],
                subElement: [],
                level: skillCategory.level + 1,
                shift: 0,
                physicalResourceValues: []
            };
            skillCategory.subElement.push(newSkillCategory);
            $scope.dd.skills.push(newSkillCategory);
            var physicalResourceValuesCat = $scope.fillSkills(newSkillCategory);
            for (var k = 0; k < prViews.length; k++) {
                if (physicalResourceValuesCat[k] == "on") prOneSonTrueValues[k] = true;else if (skillCategory.physicalResourceValues[k] == "on") //if partial set dont change it
                    skillCategory.physicalResourceValues[k] = physicalResourceValuesCat[k];
            }
        }
        for (i = 0; i < skillCategory.element.servicesView.length; i++) {
            var newSkillService = {
                type: "Service",
                label: skillCategory.element.servicesView[i].label,
                show: skillCategory.open,
                element: skillCategory.element.servicesView[i],
                level: skillCategory.level + 1,
                shift: 1,
                physicalResourceValues: []
            };

            for (var j = 0; j < prViews.length; j++) {
                if (prViews[j].getModel() && prViews[j].getModel().hasService(skillCategory.element.servicesView[i].getModel())) {
                    newSkillService.physicalResourceValues.push("on");
                    prOneSonTrueValues[j] = true;
                } else {
                    newSkillService.physicalResourceValues.push("off");
                    skillCategory.physicalResourceValues[j] = "off";
                }
            }skillCategory.subElement.push(newSkillService);
            $scope.dd.skills.push(newSkillService);
        }
        for (i = 0; i < prViews.length; i++) {
            if (skillCategory.physicalResourceValues[i] == "off" && prOneSonTrueValues[i]) skillCategory.physicalResourceValues[i] = "partial";
        }

        return skillCategory.physicalResourceValues;
    };
    $scope.skillClick = function (skill, prIndex) {
        //se
        var changed = false;
        if (skill.physicalResourceValues[prIndex] == "on") changed = $scope.updateSubElementPrValues(skill, prIndex, "off");else changed = $scope.updateSubElementPrValues(skill, prIndex, "on");
        $scope.updateCategoryPrValues($scope.dd.skillRoot, prIndex);

        if (changed) PhysicalResourceSrv.save($scope.dd.view.physicalResourcesView[prIndex].getModel());
    };
    $scope.updateSubElementPrValues = function (skill, prIndex, value) {
        var changed = false;
        if (skill.physicalResourceValues[prIndex] != value) {
            skill.physicalResourceValues[prIndex] = value;
            if (skill.type == "Service") //Save it
                {
                    if (skill.physicalResourceValues[prIndex] == "on") $scope.dd.view.physicalResourcesView[prIndex].getModel().addService(skill.element.getModel());else $scope.dd.view.physicalResourcesView[prIndex].getModel().removeService(skill.element.getModel());

                    changed = true;
                }
        }

        if (skill.subElement) for (var j = 0; j < skill.subElement.length; j++) {
            changed = $scope.updateSubElementPrValues(skill.subElement[j], prIndex, value) || changed;
        }return changed;
    };
    $scope.updateCategoryPrValues = function (skillCategory, prIndex) {
        var prValue = "on";
        var cprValue = "on";
        var prOneSonTrueValue = false;
        for (var j = 0; j < skillCategory.subElement.length; j++) {
            if (skillCategory.subElement[j].type == "Category") {
                cprValue = $scope.updateCategoryPrValues(skillCategory.subElement[j], prIndex);
                if (cprValue == "on") prOneSonTrueValue = true;else ////cprValue = partial or off
                    if (prValue == "on") //if partial set dont change it
                        prValue = cprValue;
            } else {
                if (skillCategory.subElement[j].physicalResourceValues[prIndex] == "off") prValue = "off";else prOneSonTrueValue = true;
            }
        }
        if (prValue == "off" && prOneSonTrueValue) prValue = "partial";
        skillCategory.physicalResourceValues[prIndex] = prValue;
        return prValue;
    };
    $scope.openSkillCategory = function (skillCategory) {
        skillCategory.open = true;
        for (var j = 0; j < skillCategory.subElement.length; j++) {
            $scope.propagateShowStatus(skillCategory.subElement[j], true);
        }
    };
    $scope.closeSkillCategory = function (skillCategory) {
        skillCategory.open = false;
        for (var j = 0; j < skillCategory.subElement.length; j++) {
            $scope.propagateShowStatus(skillCategory.subElement[j], false);
        }
    };
    $scope.propagateShowStatus = function (skillCategory, showStatus) {
        skillCategory.show = showStatus;
        if (skillCategory.open && skillCategory.subElement) for (var j = 0; j < skillCategory.subElement.length; j++) {
            $scope.propagateShowStatus(skillCategory.subElement[j], showStatus);
        }
    };
}]);

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('PrTrashCtrl', ["$rootScope", "$scope", function ($rootScope, $scope) {

    $scope.restore = function (prView) {
        if (prView) {
            if (prView != -1) // retrieve old value from server
                prView.restoreModel();
            var index = $scope.dd.view.physicalResourcesDeletedView.indexOf(prView);
            if (index != -1) {
                $scope.dd.view.physicalResourcesDeletedView.splice(index, 1);
                $scope.dd.view.physicalResourcesActiveView.push(prView);
                if (prView.hasPlanning) $scope.dd.view.physicalResourcesView.push(prView);
            }
        }
    };
}]);

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('ProductCtrl', ["$scope", "$dialog", "$timeout", "ProductCategorySrv", "ProductCategoryData", "ProductCategory", "ProductSrv", "ProductData", "Product", "ImageData", "ProductView", "ProductCategoryView", "StyleData", "HumanResourceData", "HumanResourceView", "PhysicalResourceData", "PhysicalResourceView", "SupplierView", "SupplierData", "VatData", "VatView", "LanguageManager", "gettextCatalog", function ($scope, $dialog, $timeout, ProductCategorySrv, ProductCategoryData, ProductCategory, ProductSrv, ProductData, Product, ImageData, ProductView, ProductCategoryView, StyleData, HumanResourceData, HumanResourceView, PhysicalResourceData, PhysicalResourceView, SupplierView, SupplierData, VatData, VatView, LanguageManager, gettextCatalog) {
    $scope.dd = {
        view: {
            vatsView: [],
            categoryRootView: null,
            productsViewIndex: [], //Keep index
            deletedCategoriesView: [],
            deletedProductsView: [],
            imagesView: [],
            imagesViewFiltered: [],
            humanResourcesView: [],
            suppliersView: [],
            supplierFilter: "", //filer on search
            styles: StyleData.styles,
            displaySubConf: 1,
            tab: 1,
            subTab: 1,
            displayError: false, //Used  to display error message when user click on save,
            filter: "",
            filterProductsView: null,
            filterTimeOut: null,
            selected: {
                categoryView: null,
                productView: null,
                supplierView: null
            },
            edited: {
                categoryView: null,
                productView: null,
                supplierView: null
            }
        },
        flowConfig: {
            target: '/rest/companyImageUpload',
            method: 'octet',
            query: { companyCode: $scope.ad.companyCode, type: 'product' },
            maxChunkRetries: 1,
            chunkSize: 5 * 1024 * 1024,
            simultaneousUploads: 4,
            singleFile: true,
            testChunks: false,
            headers: { Authorization: $scope.ad.currentUser.token }
        }
    };

    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue) {
            if (!$scope.ad.managerMode) {
                $scope.goToDomain("planningPos", "dashboard");
            }
            var vats = VatData.getActiveList();
            for (var i = 0; i < vats.length; i++) {
                if (vats[i].isUsable) $scope.addVatView(new VatView(vats[i], VatData.getIndexOf(vats[i])));
            }var suppliers = SupplierData.getActiveList();
            for (var i = 0; i < suppliers.length; i++) {
                $scope.addSupplierView(new SupplierView(suppliers[i], SupplierData.getIndexOf(suppliers[i]), $scope));
            }$scope.dd.view.imagesView = ImageData.getActiveList("");
            $scope.dd.view.imagesViewFiltered = ImageData.getFilteredImages();
            $scope.dd.view.categoryRootView = new ProductCategoryView(ProductCategoryData.categoryRoot, ProductCategoryData.getIndexOf(ProductCategoryData.categoryRoot), null, $scope); // categoryRoot index  = 0
            $scope.dd.view.categoryRootView.label = "Racine";
            $scope.dd.view.selected.categoryView = $scope.dd.view.categoryRootView;

            var categories = ProductCategoryData.getDeletedList();
            var parentCatView;
            for (var i = 0; i < categories.length; i++) {
                if (categories[i].parentCategory) parentCatView = $scope.getCategoryView(categories[i].parentCategory);else parentCatView = null;
                $scope.dd.view.deletedCategoriesView.push(new ProductCategoryView(categories[i], ProductCategoryData.getIndexOf(categories[i]), parentCatView, $scope));
            }
            var products = ProductData.getDeletedList();
            for (var i = 0; i < products.length; i++) {
                if (products[i].parentCategory) parentCatView = $scope.getCategoryView(products[i].parentCategory);else parentCatView = null;
                $scope.dd.view.deletedProductsView.push(new ProductView(products[i], ProductData.getIndexOf(products[i]), parentCatView, $scope));
            }
        }
    });

    $scope.addProductViewIndex = function (productView) {
        $scope.dd.view.productsViewIndex.push(productView);
    };
    $scope.getVatView = function (vat) {
        for (var i = 0; i < $scope.dd.view.vatsView.length; i++) {
            if ($scope.dd.view.vatsView[i].getModel() === vat) return $scope.dd.view.vatsView[i];
        } // Not found : instanciate (could be a deleted)
        var vatView = new VatView(vat, VatData.getIndexOf(vat));
        if (!vat.isDeleted) $scope.dd.view.vatsView.push(vatView);
        return vatView;
    };
    $scope.getDefaultVatView = function () {
        for (var i = 0; i < $scope.dd.view.vatsView.length; i++) {
            if ($scope.dd.view.vatsView[i].isDefault) return $scope.dd.view.vatsView[i];
        }
    };
    $scope.getSupplierView = function (supplier) {
        //must loop....
        for (var i = 0; i < $scope.dd.view.suppliersView.length; i++) {
            if ($scope.dd.view.suppliersView[i].getModel() === supplier) return $scope.dd.view.suppliersView[i];
        } // Not found : instanciate (could be a deleted customer)
        var supplierView = new SupplierView(supplier, SupplierData.getIndexOf(supplier), $scope);
        if (!supplier.isDeleted) $scope.dd.view.suppliersView.push(supplierView);
        return supplierView;
    };
    $scope.addSupplierView = function (supplierView) {
        var index = $scope.dd.view.suppliersView.indexOf(supplierView);
        if (index == -1) $scope.dd.view.suppliersView.push(supplierView);
    };
    $scope.addVatView = function (vatView) {
        var index = $scope.dd.view.vatsView.indexOf(vatView);
        if (index == -1) $scope.dd.view.vatsView.push(vatView);
    };
    $scope.onSupplierInputKeyDown = function (event) {
        var keyCode = event.which;
        //if key delete detected : clear supplier
        if (keyCode == 8 || keyCode == 46) {
            if ($scope.dd.view.edited && $scope.dd.view.edited.productView) $scope.dd.view.edited.productView.supplierView = null;
        }
    };
    $scope.onEnterKeyDown = function (event) {
        var ENTER_KEY_CODE = 13;
        var keyCode = event.which;

        if (keyCode === ENTER_KEY_CODE) {
            event.preventDefault();
            return false;
        }
    };
    $scope.getCfgClass = function (confItem, className) {
        if (confItem == $scope.dd.view.displaySubConf) return className;
        return "";
    };

    //CATEGORY


    $scope.getCategoryView = function (category) {
        //Assume view index = model index
        var categoryView = $scope.dd.view.categoryRootView.getCategoryView(category);
        if (!categoryView) //must be deleted then instanciate it
            {
                var parentCategoryView = null;
                if (category.parentCategory) parentCategoryView = $scope.getCategoryView(category.parentCategory);
                categoryView = new ProductCategoryView(category, ProductCategoryData.getIndexOf(category), parentCategoryView, $scope);
            }
        return categoryView;
    };
    $scope.onSearchProductInputKeyDown = function () {

        if ($scope.dd.view.categoryRootView) {
            $scope.dd.view.filterProductsView = null;
            if ($scope.dd.view.filterTimeOut) $timeout.cancel($scope.dd.view.filterTimeOut);
            $scope.dd.view.filterTimeOut = $timeout(function () {
                //useTimeOut in order to search only when use finish typing (or barcode scanner stop)
                if ($scope.dd.view.filter && $scope.dd.view.filter.length > 2) $scope.dd.view.filterProductsView = $scope.dd.view.categoryRootView.getProductViewByCodeOrLabel($scope.dd.view.filter.toLowerCase());
            }, 250);
        }
    };
    $scope.createCategory = function (parentCategoryView) {
        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }
        if ($scope.dd.view.edited.productView) if ($scope.dd.view.edited.productView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        } else {
            $scope.dd.view.edited.productView.hrSkillsView = null;
            $scope.dd.view.edited.productView.prSkillsView = null;
            $scope.dd.view.edited.productView = null;
        }

        var categoryView = new ProductCategoryView(null, -1, parentCategoryView, $scope);
        if (parentCategoryView) {
            if (parentCategoryView.image) categoryView.setImage(parentCategoryView.image);

            $scope.dd.view.edited.categoryView = categoryView;
            parentCategoryView.addCategoryView(categoryView);
        }
    };
    $scope.setCurrentCategory = function (category) {
        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }
        if ($scope.dd.view.edited.productView) if ($scope.dd.view.edited.productView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        } else {
            $scope.dd.view.edited.productView.hrSkillsView = null;
            $scope.dd.view.edited.productView.prSkillsView = null;
            $scope.dd.view.edited.productView = null;
        }

        if ($scope.dd.view.edited.categoryView) $scope.dd.view.edited.categoryView = null;

        $scope.dd.view.selected.categoryView = category;
    };
    $scope.setEditedCategory = function (categoryView) {
        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }
        if ($scope.dd.view.edited.productView) if ($scope.dd.view.edited.productView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        } else {
            $scope.dd.view.edited.productView.hrSkillsView = null;
            $scope.dd.view.edited.productView.prSkillsView = null;
            $scope.dd.view.edited.productView = null;
        }

        $scope.dd.view.edited.categoryView = categoryView;

        if ($scope.dd.view.tab > 2) $scope.dd.view.tab = 1;
    };
    $scope.saveEditedCategory = function () {
        if ($scope.dd.view.edited.categoryView) $scope.dd.view.edited.categoryView.updateModel();
        $scope.dd.view.edited.categoryView = null;
        $scope.displayChangeMsg = false;
    };
    $scope.cancelEditedCategory = function () {
        $scope.dd.view.edited.categoryView.reloadModel();
        $scope.dd.view.displayError = false;
        $scope.dd.view.edited.categoryView = null;
        $scope.displayChangeMsg = false;
    };
    $scope.afterRemoveCategory = function (category) {
        if (!category.parentCategory) //Remove from $scope
            {
                var index = $scope.categoryRoot.categories.indexOf(category);
                if (index != -1) $scope.categoryRoot.categories.splice(index, 1);
                $scope.currentCategory = null;
            }
    };
    $scope.openDeletedCategoryViewConfirmDialog = function () {
        if ($scope.dd.view.edited.categoryView) {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/removeConfirm.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["label"] = $scope.dd.view.edited.categoryView.label;
                        return tableModel;
                    } } };

            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) $scope.removeEditedCategory();
            });
        }
    };
    $scope.removeEditedCategory = function () {
        if ($scope.dd.view.edited.categoryView) {
            $scope.dd.view.edited.categoryView.removeModel();
            var parentCategoryView = $scope.dd.view.edited.categoryView.parentCategoryView;
            if (parentCategoryView) parentCategoryView.removeCategoryView($scope.dd.view.edited.categoryView);
            $scope.dd.view.deletedCategoriesView.push($scope.dd.view.edited.categoryView);
            $scope.dd.view.edited.categoryView = null;
            $scope.displayChangeMsg = false;
        }
    };
    $scope.getClassForActiveCategory = function (category, className) {
        ////console.log("getClassForActive" + product.id);
        if (category === $scope.dd.view.edited.categoryView) return className;
        return "";
    };
    $scope.restoreCategory = function (categoryView) {
        if (categoryView) {
            if (categoryView.catIndex != -1) // retrieve old value from server
                categoryView.restoreModel();
            var index = $scope.dd.view.deletedCategoriesView.indexOf(categoryView);
            if (index != -1) {
                $scope.dd.view.deletedCategoriesView.splice(index, 1);
                if (categoryView.parentCategoryView) categoryView.parentCategoryView.addCategoryView(categoryView);
            }
        }
    };

    // PRODUCT
    $scope.getClassForActiveProduct = function (product, className) {
        ////console.log("getClassForActive" + product.id);
        if (product === $scope.dd.view.edited.productView) return className;
        return "";
    };
    $scope.createProduct = function () {
        if ($scope.dd.view.edited.categoryView) if ($scope.dd.view.edited.categoryView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        } else $scope.dd.view.edited.categoryView = null;

        if ($scope.dd.view.edited.productView && $scope.dd.view.edited.productView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }
        var categoryView = $scope.dd.view.selected.categoryView;
        if (categoryView.catIndex == -1) {
            alert("Vous devez sauver une première fois la catégorie pour pouvoir lui ajouter des prestations.");
            return;
        }
        var newProductView = new ProductView(null, -1, categoryView, $scope);
        categoryView.addProductView(newProductView);

        if (categoryView.image && categoryView.image !== null) newProductView.setImage(categoryView.image);

        $scope.setEditedProduct(newProductView);
    };
    $scope.productClicked = function (productView) //Function linked to productsSelector.html
    {
        $scope.setEditedProduct(productView);
    };
    $scope.setEditedProduct = function (productView) {
        if ($scope.dd.view.edited.categoryView) if ($scope.dd.view.edited.categoryView.isChanged()) {
            $scope.displayChangeMsg = true;
            return false;
        } else $scope.dd.view.edited.categoryView = null;
        if ($scope.dd.view.edited.productView && $scope.dd.view.edited.productView.isChanged()) {
            $scope.displayChangeMsg = true;
            return false;
        }
        $scope.dd.view.edited.productView = productView;
        productView.getQuantityHistory();
        return true;
    };

    $scope.duplicateProduct = function (productView) {
        if ($scope.dd.view.edited.productView) {
            if ($scope.dd.view.edited.productView.isChanged()) {
                $scope.displayChangeMsg = true;
                return;
            }
            $scope.dd.view.edited.productView = null;
        }
        if ($scope.dd.view.edited.productView && $scope.dd.view.edited.productView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }
        $scope.dd.view.edited.productView = productView.getClone();
        if ($scope.dd.view.edited.productView.label && $scope.dd.view.edited.productView.label != '') {
            $scope.dd.view.edited.productView.label = "Copie de " + $scope.dd.view.edited.productView.label;
        }
        if (productView.parentCategoryView) {
            productView.parentCategoryView.addProductView($scope.dd.view.edited.productView);
            if (productView.parentCategoryView.image) {
                $scope.dd.view.edited.productView.setImage(productView.parentCategoryView.image);
            }
        }
    };

    $scope.saveEditedProduct = function () {
        if ($scope.dd.view.edited.productView) {
            $scope.dd.view.edited.productView.updateModel();
            $scope.dd.view.displayError = false;
            $scope.dd.view.edited.productView.hrSkillsView = null;
            $scope.dd.view.edited.productView.prSkillsView = null;
            $scope.dd.view.edited.productView = null;
            $scope.displayChangeMsg = false;
            $scope.dd.view.filterProductsView = null;
            $scope.dd.view.filter = "";
        }
    };
    $scope.cancelEditedProduct = function () {
        $scope.dd.view.edited.productView.reloadModel();
        $scope.dd.view.displayError = false;
        $scope.dd.view.edited.productView.hrSkillsView = null;
        $scope.dd.view.edited.productView.prSkillsView = null;
        $scope.dd.view.edited.productView = null;
        $scope.dd.view.filterProductsView = null;
        $scope.dd.view.filter = "";
        $scope.displayChangeMsg = false;
    };
    $scope.openDeletedProductViewConfirmDialog = function () {
        if ($scope.dd.view.edited.productView) {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/removeConfirm.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["label"] = $scope.dd.view.edited.productView.label;
                        return tableModel;
                    } } };

            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) $scope.removeEditedProduct();
            });
        }
    };
    $scope.removeEditedProduct = function () {
        if ($scope.dd.view.edited.productView) {
            $scope.dd.view.edited.productView.removeModel();
            var parentCategoryView = $scope.dd.view.edited.productView.parentCategoryView;
            if (parentCategoryView) parentCategoryView.removeProductView($scope.dd.view.edited.productView);
            $scope.dd.view.deletedProductsView.push($scope.dd.view.edited.productView);
            $scope.dd.view.edited.productView.hrSkillsView = null;
            $scope.dd.view.edited.productView.prSkillsView = null;
            $scope.dd.view.edited.productView = null;
            $scope.dd.view.filterProductsView = null;
            $scope.dd.view.filter = "";
            $scope.displayChangeMsg = false;
        }
    };

    $scope.emptyTrash = function () {
        var opts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: '/partials/global/generalConfirm.html',
            controller: 'DialogCtrl',
            resolve: {
                dialogsModel: function dialogsModel() {
                    var tableModel = [];
                    tableModel["question"] = gettextCatalog.getString("Voulez-vous vraiment vider la corbeille?");
                    tableModel["description"] = gettextCatalog.getString("Tous les produits de la corbeille vont être supprimés, l'action ne pourra pas être annulée après validation.");
                    return tableModel;
                } } };

        var d = $dialog.dialog(opts);
        d.open().then(function (result) {
            if (result) {
                ProductSrv.emptyTrash();
                opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials/global/infoDialog.html',
                    controller: 'DialogCtrl',
                    resolve: {
                        dialogsModel: function dialogsModel() {
                            var tableModel = [];
                            tableModel["label"] = "La fonction de purge s'exécute sur le serveur et peut prendre jusqu'à 10 minutes. Il faudra ensuite actualiser pour constater le résultat.";
                            return tableModel;
                        } } };

                $dialog.dialog(opts).open();
            }
        });
    };

    $scope.restoreProduct = function (productView) {
        if (productView) {
            if (productView.servIndex != -1) // retrieve old value from server
                productView.restoreModel();
            var index = $scope.dd.view.deletedProductsView.indexOf(productView);
            if (index != -1) {
                $scope.dd.view.deletedProductsView.splice(index, 1);
                if (productView.parentCategoryView) productView.parentCategoryView.addProductView(productView);
            }
        }
    };

    //Assign image


    $scope.imageIsSelected = function (image) {
        if ($scope.dd.view.edited.productView) {
            if (!$scope.dd.view.edited.productView.companyImage && $scope.dd.view.edited.productView.image === image) return true;
        } else if (!$scope.dd.view.edited.categoryView.companyImage && $scope.dd.view.edited.categoryView.image === image) return true;

        return false;
    };

    $scope.companyImageIsSelected = function (companyImage) {
        if ($scope.dd.view.edited.productView && $scope.dd.view.edited.productView.companyImage === companyImage) return true;
        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.companyImage === companyImage) return true;
        return false;
    };
    $scope.setImage = function (image) {
        if ($scope.dd.view.edited.productView) {
            if (image === $scope.dd.view.edited.productView.image) {
                if ($scope.dd.view.edited.productView.image != null) {
                    $scope.dd.view.edited.productView.setImage(null);
                } else {
                    $scope.dd.view.edited.productView.setImage($scope.dd.view.edited.productView.parentCategoryView.image);
                }
            } else if (image != null) {
                $scope.dd.view.edited.productView.setImage(image);
            } else {
                $scope.dd.view.edited.productView.setImage($scope.dd.view.edited.productView.parentCategoryView.image);
            }
        }

        if ($scope.dd.view.edited.categoryView) {
            if (image === $scope.dd.view.edited.categoryView.image) {
                if ($scope.dd.view.edited.categoryView.image != null) {
                    $scope.dd.view.edited.categoryView.setImage(null);
                } else {
                    $scope.dd.view.edited.categoryView.setImage($scope.dd.view.edited.categoryView.parentCategoryView.image);
                }
            } else if (image != null) {
                $scope.dd.view.edited.categoryView.setImage(image);
            } else {
                $scope.dd.view.edited.categoryView.setImage($scope.dd.view.edited.categoryView.parentCategoryView.image);
            }
        }
    };
    $scope.setCompanyImage = function (companyImage) {
        if ($scope.dd.view.edited.productView) {
            if (companyImage === $scope.dd.view.edited.productView.companyImage) {
                if ($scope.dd.view.edited.productView.companyImage != null) {
                    $scope.dd.view.edited.productView.setCompanyImage(null);
                } else {
                    $scope.dd.view.edited.productView.setCompanyImage($scope.dd.view.edited.productView.parentCategoryView.companyImage);
                }
            } else if (companyImage != null) {
                $scope.dd.view.edited.productView.setCompanyImage(companyImage);
            } else {
                $scope.dd.view.edited.productView.setCompanyImage($scope.dd.view.edited.productView.parentCategoryView.companyImage);
            }
        }

        if ($scope.dd.view.edited.categoryView) {
            if (companyImage === $scope.dd.view.edited.categoryView.companyImage) {
                if ($scope.dd.view.edited.categoryView.companyImage != null) {
                    $scope.dd.view.edited.categoryView.setCompanyImage(null);
                } else {
                    $scope.dd.view.edited.categoryView.setCompanyImage($scope.dd.view.edited.categoryView.parentCategoryView.companyImage);
                }
            } else if (companyImage != null) {
                $scope.dd.view.edited.categoryView.setCompanyImage(companyImage);
            } else {
                $scope.dd.view.edited.categoryView.setCompanyImage($scope.dd.view.edited.categoryView.parentCategoryView.companyImage);
            }
        }
    };

    // Suppliers
    $scope.setEditedSupplierView = function (supplierView) {
        if ($scope.dd.view.edited.supplierView && $scope.dd.view.edited.supplierView !== supplierView) $scope.dd.view.edited.supplierView.reloadModel();
        $scope.dd.view.edited.supplierView = supplierView;
    };
    $scope.createSupplier = function () {
        if ($scope.dd.view.edited.supplierView && $scope.dd.view.edited.supplierView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }
        var newSupplierView = new SupplierView(null, -1, $scope);
        $scope.dd.view.suppliersView.push(newSupplierView);
        $scope.dd.view.edited.supplierView = newSupplierView;
    };
    $scope.cancelEditedSupplierView = function () {
        if ($scope.dd.view.edited.supplierView.sIndex != -1) // retrieve old value from server
            {
                $scope.dd.view.edited.supplierView.reloadModel();
            } else {
            var index = $scope.dd.view.suppliersView.indexOf($scope.dd.view.edited.supplierView);
            if (index >= 0) $scope.dd.view.suppliersView.splice(index, 1);
        }
        $scope.dd.view.edited.supplierView = null;
        $scope.displayError = false;
        $scope.displayChangeMsg = false;
    };
    $scope.saveEditedSupplierView = function () {
        if ($scope.dd.view.edited.supplierView) $scope.dd.view.edited.supplierView.updateModel();

        $scope.dd.view.edited.supplierView = null;
        $scope.displayError = false;
        $scope.displayChangeMsg = false;
    };
    $scope.removeEditedSupplierView = function () {

        if ($scope.dd.view.edited.supplierView) {
            if ($scope.dd.view.edited.supplierView.sIndex != -1) // retrieve old value from server
                $scope.dd.view.edited.supplierView.removeModel();
            var index = $scope.dd.view.suppliersView.indexOf($scope.dd.view.edited.supplierView);
            if (index != -1) {
                $scope.dd.view.suppliersView.splice(index, 1);
            }
            $scope.dd.view.edited.supplierView = null;
            $scope.displayError = false;
            $scope.displayChangeMsg = false;
        }
    };
    $scope.displaySupplierError = function () {
        $scope.dd.displayError = true;
        if ($scope.dd.view.edited.supplierView) $scope.dd.displayPhoneError = false;else $scope.dd.displayPhoneError = true;
        if ($scope.dd.view.edited.supplierView) $scope.dd.displayLandlineError = false;else $scope.dd.displayLandlineError = true;
    };
    $scope.openDeletedSupplierViewConfirmDialog = function () {
        if ($scope.dd.view.edited.supplierView) {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/removeConfirm.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["label"] = $scope.dd.view.edited.supplierView.label;
                        return tableModel;
                    } } };

            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) $scope.removeEditedSupplierView();
            });
        }
    };
    $scope.getEditedItem = function () {
        return $scope.dd.view.edited.categoryView ? $scope.dd.view.edited.categoryView : $scope.dd.view.edited.productView ? $scope.dd.view.edited.productView : null;
    };
}]);

/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('ServiceCtrl', ["$scope", "$dialog", "$timeout", "CategorySrv", "CategoryData", "Category", "ServiceSrv", "ServiceData", "Service", "ImageData", "ServiceView", "CategoryView", "StyleData", "HumanResourceData", "HumanResourceView", "PhysicalResourceData", "PhysicalResourceView", "ProductCategoryView", "ProductCategoryData", "LanguageManager", "CureSrv", "gettextCatalog", "ServiceSettingsReserveWithGoogleSrv", "ServiceSettingsReserveWithGoogleView", "ServiceSettingsLeCiseauSrv", "ServiceSettingsLeCiseauView", "ServiceSettingsLeCiseauData", "BasicAuthRole", "LaunchDarklyFeatureFlagList", "LaunchDarklyFeatureFlagData", "MarketplaceSrv", function ($scope, $dialog, $timeout, CategorySrv, CategoryData, Category, ServiceSrv, ServiceData, Service, ImageData, ServiceView, CategoryView, StyleData, HumanResourceData, HumanResourceView, PhysicalResourceData, PhysicalResourceView, ProductCategoryView, ProductCategoryData, LanguageManager, CureSrv, gettextCatalog, ServiceSettingsReserveWithGoogleSrv, ServiceSettingsReserveWithGoogleView, ServiceSettingsLeCiseauSrv, ServiceSettingsLeCiseauView, ServiceSettingsLeCiseauData, BasicAuthRole, LaunchDarklyFeatureFlagList, LaunchDarklyFeatureFlagData, MarketplaceSrv) {
    $scope.dd = {
        view: {
            categoryRootView: null,
            cCategoryView: null,
            servicesViewIndex: [], //Keep index
            deletedCategoriesView: [],
            deletedServicesView: [],
            imagesView: [],
            imagesViewFiltered: [],
            humanResourcesView: [],
            hsHr: true,
            physicalResourcesView: [],
            hsPr: true,
            styles: StyleData.styles,
            displaySubConf: 1,
            tab: 1,
            subTab: 1,
            displayError: false, //Used  to display error message when user click on save,
            filterServicesView: null,
            filterTimeOut: null,
            filterTypeService: "",
            filterTypeServiceList: {
                allServices: "all",
                website: "website",
                reserveWithGoogle: "reserveWithGoogle"
            },
            filter: "",
            selected: {
                categoryView: null,
                serviceView: null
            },
            edited: {
                categoryView: null,
                serviceView: null
            },
            serviceLoading: false,
            categoriesLoading: false,
            marketplaceData: {
                marketplaceCategories: [],
                marketplaceSubCategories: [],
                marketplaceVariants: [],
                defaultData: {
                    marketplaceDefaultPromoEnabled: true,
                    marketplaceDefaultCategory: { id: null },
                    marketplaceDefaultSubCategory: { id: null },
                    marketplaceDefaultVariant: { id: null }
                },
                loaded: false
            }
        },
        flowConfig: {
            target: '/rest/companyImageUpload',
            method: 'octet',
            query: { companyCode: $scope.ad.companyCode, type: 'service' },
            maxChunkRetries: 1,
            chunkRetryInterval: 5000,
            simultaneousUploads: 1,
            chunkSize: 1024 * 1024 * 5,
            singleFile: true,
            testChunks: false,
            headers: { Authorization: $scope.ad.currentUser.token }
        },
        isDuplicatingCategory: false
    };

    $scope.basicAuthRole = BasicAuthRole;

    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue) {
            if (!$scope.ad.managerMode) {
                $scope.goToDomain("planningPos", "dashboard");
            }
            $scope.dd.view.imagesView = ImageData.getActiveList("");
            $scope.dd.view.imagesViewFiltered = ImageData.getFilteredImages();
            $scope.dd.view.categoryRootView = new CategoryView(CategoryData.categoryRoot, CategoryData.getIndexOf(CategoryData.categoryRoot), null, $scope); // categoryRoot index  = 0
            $scope.dd.view.productCategoryRootView = new ProductCategoryView(ProductCategoryData.categoryRoot, ProductCategoryData.getIndexOf(ProductCategoryData.categoryRoot), null, $scope); // categoryRoot index  = 0
            $scope.dd.view.categoryRootView.loadProductsView();
            $scope.dd.view.cCategoryView = $scope.dd.view.categoryRootView;
            $scope.dd.view.cProductCategoryView = $scope.dd.view.productCategoryRootView;
            $scope.dd.view.selected.categoryView = $scope.dd.view.categoryRootView;
            $scope.dd.view.humanResourcesView = [];
            $scope.dd.view.physicalResourcesView = [];
            var humanResources = HumanResourceData.getActiveList();
            var hrView;
            for (var i = 0; i < humanResources.length; i++) {
                hrView = new HumanResourceView(humanResources[i], HumanResourceData.getIndexOf(humanResources[i]), $scope);
                $scope.dd.view.humanResourcesView.push(hrView);
            }
            $scope.dd.view.hsHr = $scope.dd.view.humanResourcesView.length > 0;
            var physicalResources = PhysicalResourceData.getActiveList();
            var prView;
            for (var i = 0; i < physicalResources.length; i++) {
                prView = new PhysicalResourceView(physicalResources[i], PhysicalResourceData.getIndexOf(physicalResources[i]), $scope);
                $scope.dd.view.physicalResourcesView.push(prView);
            }
            $scope.dd.view.hsPr = $scope.dd.view.physicalResourcesView.length > 0;
            var categories = CategoryData.getDeletedList();
            var parentCatView;
            for (var i = 0; i < categories.length; i++) {
                if (categories[i].parentCategory) parentCatView = $scope.getCategoryView(categories[i].parentCategory);else parentCatView = null;
                $scope.dd.view.deletedCategoriesView.push(new CategoryView(categories[i], CategoryData.getIndexOf(categories[i]), parentCatView, $scope));
            }
            var services = ServiceData.getDeletedList();
            for (var i = 0; i < services.length; i++) {
                if (services[i].parentCategory) parentCatView = $scope.getCategoryView(services[i].parentCategory);else parentCatView = null;
                $scope.dd.view.deletedServicesView.push(new ServiceView(services[i], ServiceData.getIndexOf(services[i]), parentCatView, $scope));
            }

            $scope.dd.view.filterTypeService = $scope.dd.view.filterTypeServiceList.allServices;

            BasicAuthRole.GOOGLE_ROLE.loadingMethod = $scope.loadServiceSettingsReserveWithGoogleView;
            BasicAuthRole.LE_CISEAU_ROLE.loadingMethod = $scope.loadServiceSettingsLeCiseauView;
        }
    });

    $scope.addServiceViewIndex = function (serviceView) {
        $scope.dd.view.servicesViewIndex.push(serviceView);
    };
    $scope.getServiceView = function (service) {
        return $scope.dd.view.categoryRootView.getServiceView(service);
    };
    $scope.getProductView = function (product) {
        return $scope.dd.view.productCategoryRootView.getProductView(product);
    };
    $scope.getCfgClass = function (confItem, className) {
        if (confItem == $scope.dd.view.displaySubConf) return className;
        return "";
    };
    $scope.getHumanResourcesView = function () {
        return $scope.dd.view.humanResourcesView;
    };
    $scope.getPhysicalResourcesView = function () {
        return $scope.dd.view.physicalResourcesView;
    };
    $scope.getHasHr = function () {
        return $scope.dd.view.humanResourcesView && $scope.dd.view.humanResourcesView.length != 0;
    };

    //CATEGORY


    $scope.getCategoryView = function (category) {
        //Assume view index = model index
        var categoryView = $scope.dd.view.categoryRootView.getCategoryView(category);
        if (!categoryView) //must be deleted then instanciate it
            {
                var parentCategoryView = null;
                if (category.parentCategory) parentCategoryView = this.getCategoryView(category.parentCategory);
                categoryView = new CategoryView(category, CategoryData.getIndexOf(category), parentCategoryView, this);
            }
        return categoryView;
    };
    $scope.createCategory = function (parentCategoryView) {
        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }
        if ($scope.dd.view.edited.serviceView) if ($scope.dd.view.edited.serviceView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        } else {
            $scope.dd.view.edited.serviceView = null;
        }

        var categoryView = new CategoryView(null, -1, parentCategoryView, $scope);
        if (parentCategoryView) {
            if (parentCategoryView.image) categoryView.setImage(parentCategoryView.image);

            $scope.dd.view.edited.categoryView = categoryView;
            parentCategoryView.addCategoryView(categoryView);
        }
    };

    $scope.setCurrentCategory = function (category) {
        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }
        if ($scope.dd.view.edited.serviceView) if ($scope.dd.view.edited.serviceView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        } else {
            $scope.dd.view.edited.serviceView = null;
        }

        if ($scope.dd.view.edited.categoryView) $scope.dd.view.edited.categoryView = null;

        $scope.dd.view.selected.categoryView = category;

        if (!$scope.dd.view.filter || $scope.dd.view.filter.length < 2) {
            $scope.updateVisibilityCategoriesAndServices();
        }
    };
    $scope.setEditedCategory = function (categoryView) {
        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }
        if ($scope.dd.view.edited.serviceView) if ($scope.dd.view.edited.serviceView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        } else {
            $scope.dd.view.edited.serviceView = null;
        }

        $scope.dd.view.edited.categoryView = categoryView;

        if ($scope.dd.view.tab > 2) $scope.dd.view.tab = 1;
    };

    $scope.saveEditedCategory = function () {
        if ($scope.dd.view.edited.categoryView) {
            $scope.dd.view.categorySaving = true;
            $scope.dd.view.edited.categoryView.updateModel($scope.closeCategoryView, $scope.closeCategoryView);
        }
    };

    $scope.closeCategoryView = function () {
        $scope.dd.view.categorySaving = false;
        $scope.dd.view.edited.categoryView = null;
        $scope.displayChangeMsg = false;
    };

    $scope.cancelEditedCategory = function () {
        $scope.dd.view.edited.categoryView.reloadModel();
        $scope.dd.view.displayError = false;
        $scope.dd.view.edited.categoryView = null;
        $scope.displayChangeMsg = false;
    };
    $scope.afterRemoveCategory = function (category) {
        if (!category.parentCategory) //Remove from $scope
            {
                var index = $scope.categoryRoot.categories.indexOf(category);
                if (index != -1) $scope.categoryRoot.categories.splice(index, 1);
                $scope.currentCategory = null;
            }
    };
    $scope.openDeletedCategoryViewConfirmDialog = function () {
        if ($scope.dd.view.edited.categoryView) {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/removeConfirm.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["label"] = $scope.dd.view.edited.categoryView.label;
                        return tableModel;
                    } } };

            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) $scope.removeEditedCategory();
            });
        }
    };
    $scope.removeEditedCategory = function () {
        if ($scope.dd.view.edited.categoryView) {
            $scope.dd.view.edited.categoryView.removeModel();
            var parentCategoryView = $scope.dd.view.edited.categoryView.parentCategoryView;
            if (parentCategoryView) parentCategoryView.removeCategoryView($scope.dd.view.edited.categoryView);
            $scope.dd.view.deletedCategoriesView.push($scope.dd.view.edited.categoryView);
            $scope.dd.view.edited.categoryView = null;
            $scope.displayChangeMsg = false;
        }
    };
    $scope.openDuplicateCategoryViewConfirmDialog = function () {
        if ($scope.dd.view.edited.categoryView) {
            var label = gettextCatalog.getString("Voulez vous dupliquer la catégorie \"" + $scope.dd.view.edited.categoryView.label + "\"?");
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/generalConfirm.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["question"] = label;
                        return tableModel;
                    } } };

            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) {
                    $scope.dd.view.isDuplicatingCategory = true;
                    $scope.dd.view.edited.categoryView.countCurrentServices(function () {
                        $scope.duplicateCategory();
                    }, function (data, maxServices) {
                        if (data && data.numberOfCurrentServices && data.numberOfCurrentServices > maxServices) {
                            $scope.openErrorDialog(gettextCatalog.getString("Duplication impossible, le compte a plus de 1000 prestations."));
                        } else {
                            $scope.openErrorDialog(gettextCatalog.getString("Une erreur s'est produite, impossible de dupliquer la catégorie."));
                        }
                        $scope.dd.view.isDuplicatingCategory = false;
                    });
                }
            });
        }
    };
    $scope.duplicateCategory = function () {
        $scope.dd.view.edited.categoryView.duplicateCategory(function () {
            $scope.confirmDialogAndReload(gettextCatalog.getString("La copie est terminée. Veuillez recharger la page."));
            $scope.dd.view.isDuplicatingCategory = false;
        }, function () {
            $scope.openErrorDialog(gettextCatalog.getString("La copie a échoué. Veuillez recharger la page."));
            $scope.dd.view.isDuplicatingCategory = false;
        });
    };

    $scope.confirmDialogAndReload = function (message) {
        var label = gettextCatalog.getString(message),
            opts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: '/partials/global/refreshDialog.html',
            controller: 'DialogCtrl',
            resolve: {
                dialogsModel: function dialogsModel() {
                    var tableModel = [];
                    tableModel["label"] = label;
                    return tableModel;
                }
            }
        },
            d = $dialog.dialog(opts);
        d.open().then(function (result) {
            if (result) {
                document.location.reload();
            }
        });
    };

    $scope.openErrorDialog = function (errorMessage) {
        var label = gettextCatalog.getString(errorMessage),
            opts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: '/partials/global/errorDialog.html',
            controller: 'DialogCtrl',
            resolve: {
                dialogsModel: function dialogsModel() {
                    var tableModel = [];
                    tableModel["label"] = label;
                    return tableModel;
                }
            }
        },
            d = $dialog.dialog(opts);
        d.open();
    };

    $scope.getClassForActiveCategory = function (category, className) {
        ////console.log("getClassForActive" + service.id);
        if (category === $scope.dd.view.edited.categoryView) return className;
        return "";
    };

    $scope.restoreCategory = function (categoryView) {
        if (categoryView) {
            if (categoryView.catIndex != -1) // retrieve old value from server
                categoryView.restoreModel();
            var index = $scope.dd.view.deletedCategoriesView.indexOf(categoryView);
            if (index != -1) {
                $scope.dd.view.deletedCategoriesView.splice(index, 1);
                if (categoryView.parentCategoryView) categoryView.parentCategoryView.addCategoryView(categoryView);
            }
        }
    };

    $scope.getClassForActiveService = function (service, className) {
        ////console.log("getClassForActive" + service.id);
        if (service === $scope.dd.view.edited.serviceView) return className;
        return "";
    };

    $scope.createService = function (isPackage) {
        if ($scope.dd.view.edited.categoryView) if ($scope.dd.view.edited.categoryView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        } else $scope.dd.view.edited.categoryView = null;

        if ($scope.dd.view.edited.serviceView && $scope.dd.view.edited.serviceView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }
        var categoryView = $scope.dd.view.selected.categoryView;
        if (categoryView.catIndex == -1) {
            alert("Vous devez sauver une première fois la catégorie pour pouvoir lui ajouter des prestations.");
            return;
        }
        var newServiceView = new ServiceView(null, -1, categoryView, $scope);
        newServiceView.isPackage = isPackage;
        categoryView.addServiceView(newServiceView);

        if (categoryView.image && categoryView.image !== null) newServiceView.setImage(categoryView.image);

        $scope.setEditedService(newServiceView);
    };

    $scope.serviceClicked = function (serviceView) //Function linked to servicesSelector.html
    {
        $scope.setEditedService(serviceView);
    };
    $scope.setEditedService = function (serviceView) {
        if ($scope.dd.view.edited.categoryView) if ($scope.dd.view.edited.categoryView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        } else $scope.dd.view.edited.categoryView = null;
        if ($scope.dd.view.edited.serviceView && $scope.dd.view.edited.serviceView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }

        $scope.dd.view.edited.serviceView = serviceView;

        for (var basicAuthRole in BasicAuthRole) {
            if (BasicAuthRole.hasOwnProperty(basicAuthRole)) {
                if ($scope.ad.addons.sub[BasicAuthRole[basicAuthRole].storeAppCode] && BasicAuthRole[basicAuthRole].loadingMethod !== undefined) {
                    BasicAuthRole[basicAuthRole].loadingMethod();
                }
            }
        }

        $scope.dd.view.tab = 1;

        if (serviceView) {
            serviceView.initSkills($scope.dd.view.humanResourcesView, $scope.dd.view.physicalResourcesView);
        }
    };
    $scope.duplicateService = function (serviceView) {
        if ($scope.dd.view.edited.categoryView) if ($scope.dd.view.edited.categoryView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        } else $scope.dd.view.edited.categoryView = null;
        if ($scope.dd.view.edited.serviceView && $scope.dd.view.edited.serviceView.isChanged()) {
            $scope.displayChangeMsg = true;
            return;
        }

        $scope.dd.view.edited.serviceView = serviceView.getClone();
        if ($scope.dd.view.edited.serviceView.label) {
            $scope.dd.view.edited.serviceView.label = "Copie de " + $scope.dd.view.edited.serviceView.label;
        }
        if ($scope.dd.view.edited.serviceView.labelShort) {
            $scope.dd.view.edited.serviceView.labelShort = "Copie de " + $scope.dd.view.edited.serviceView.labelShort;
        }
        if (serviceView.parentCategoryView) {
            serviceView.parentCategoryView.addServiceView($scope.dd.view.edited.serviceView);
            if (serviceView.parentCategoryView.image && serviceView.parentCategoryView.image !== null) $scope.dd.view.edited.serviceView.setImage(serviceView.parentCategoryView.image);
        }
    };

    $scope.saveEditedService = function () {
        if ($scope.dd.view.edited.serviceView) {
            $scope.dd.view.serviceSaving = true;
            $scope.dd.view.edited.serviceView.updateModel(function (serviceResponse) {
                var service = ServiceData.getById(serviceResponse.id);
                $scope.dd.view.edited.serviceView.serviceId = serviceResponse.id;
                if (service) {
                    for (var basicAuthRole in BasicAuthRole) {
                        if (BasicAuthRole.hasOwnProperty(basicAuthRole)) {
                            var role = BasicAuthRole[basicAuthRole].role;
                            if ($scope.dd.view.edited.serviceView.serviceSettings.hasOwnProperty(role)) {
                                var subscription = BasicAuthRole[basicAuthRole].storeAppCode;
                                var serviceSettings = $scope.dd.view.edited.serviceView.serviceSettings[role];
                                if ($scope.ad.addons.sub[subscription] && serviceSettings.view) {
                                    if (serviceSettings.id) {
                                        serviceSettings.view.updateModel(service.id);
                                    } else if (serviceSettings.view.isVisibleOnPartner) {
                                        serviceSettings.view.createModel(service);
                                    }
                                    serviceSettings.view = null;
                                }
                            }
                        }
                    }
                }
                $scope.closeServiceView();
            }, $scope.closeServiceView);
        } else {
            $scope.dd.view.edited.serviceView.updateModel($scope.closeServiceView);
        }
    };

    $scope.closeServiceView = function () {
        $scope.dd.view.displayError = false;
        $scope.dd.view.edited.serviceView = null;
        $scope.displayChangeMsg = false;
        $scope.dd.view.serviceSaving = false;
    };

    $scope.cancelEditedService = function () {
        var previousLabelShort = $scope.dd.view.edited.serviceView.labelShort;
        $scope.dd.view.edited.serviceView.reloadModel();
        $scope.updateLinkedServicesLabels(previousLabelShort);
        for (var serviceSettings in $scope.dd.view.edited.serviceView.serviceSettings) {
            if ($scope.dd.view.edited.serviceView.serviceSettings.hasOwnProperty(serviceSettings) && $scope.dd.view.edited.serviceView.serviceSettings[serviceSettings].view) {
                $scope.dd.view.edited.serviceView.serviceSettings[serviceSettings].view.reloadModel();
                $scope.dd.view.edited.serviceView.serviceSettings[serviceSettings].view = null;
            }
        }
        $scope.dd.view.displayError = false;
        $scope.dd.view.edited.serviceView = null;
        $scope.displayChangeMsg = false;
    };

    $scope.openDeletedServiceViewConfirmDialog = function () {
        var message = "";
        var cureId = "";
        if ($scope.dd.view.edited.serviceView) {
            var service = ServiceData.getById($scope.dd.view.edited.serviceView.serviceId);

            if ($scope.dd.view.edited.serviceView.serviceId == "" || $scope.dd.view.edited.serviceView.serviceId == null) {
                message = message = "Etes-vous sûr de vouloir supprimer " + $scope.dd.view.edited.serviceView.label + "?";
            } else {
                if (service.cures.length != 0) {
                    for (var i = 0; i < service.cures.length; i++) {
                        if (service.cures[i].serviceTab.length == 1) {
                            message = "Cette prestation est l'unique prestation d'une cure, si vous la supprimez la cure sera inutilisable et ne sera plus affichée sur votre site internet. Souhaitez-vous la supprimer? ";
                            cureId = service.cures[i].id;
                            break;
                        } else {
                            message = "Cette prestation est liée à une cure, si vous la supprimez la cure sera inutilisable. Souhaitez-vous la supprimer? ";
                        }
                    }
                } else {
                    message = "Etes-vous sûr de vouloir supprimer " + service.label + "?";
                }
            }
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/removeConfirmTraitement.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["label"] = message;
                        return tableModel;
                    }
                }
            };

            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) $scope.removeEditedService(cureId, service);
            });
        }
    };

    $scope.removeEditedService = function (cureId, service) {
        if ($scope.dd.view.edited.serviceView) {
            $scope.dd.view.edited.serviceView.removeModel();

            if (service && service.cures) {
                for (var i = 0; i < service.cures.length; i++) {
                    if (service.cures[i] && service.cures[i].id === cureId) {
                        service.cures[i].isVisibleOnWebSite = false;

                        if (service.cures[i].serviceTab) {
                            for (var j = 0; j < service.cures[i].serviceTab.length; j++) {
                                if (service.cures[i].serviceTab[j].id === $scope.dd.view.edited.serviceView.serviceId) {
                                    service.cures[i].serviceTab.splice(j, 1);
                                }
                                CureSrv.save(service.cures[i]);
                            }
                        }
                    }
                }
            }

            var parentCategoryView = $scope.dd.view.edited.serviceView.parentCategoryView;
            if (parentCategoryView) {
                parentCategoryView.removeServiceView($scope.dd.view.edited.serviceView);
            }

            $scope.dd.view.deletedServicesView.push($scope.dd.view.edited.serviceView);
            $scope.dd.view.edited.serviceView = null;
            $scope.displayChangeMsg = false;
        }
    };

    $scope.restoreService = function (serviceView) {
        if (serviceView) {
            if (serviceView.servIndex != -1) // retrieve old value from server
                serviceView.restoreModel();
            var index = $scope.dd.view.deletedServicesView.indexOf(serviceView);
            if (index != -1) {
                $scope.dd.view.deletedServicesView.splice(index, 1);
                if (serviceView.parentCategoryView) serviceView.parentCategoryView.addServiceView(serviceView);
            }
        }
    };

    //Assign image


    $scope.imageIsSelected = function (image) {
        if ($scope.dd.view.edited.serviceView) {
            if (!$scope.dd.view.edited.serviceView.companyImage && $scope.dd.view.edited.serviceView.image === image) return true;
        } else if (!$scope.dd.view.edited.categoryView.companyImage && $scope.dd.view.edited.categoryView.image === image) return true;

        return false;
    };

    $scope.companyImageIsSelected = function (companyImage) {
        if ($scope.dd.view.edited.serviceView && $scope.dd.view.edited.serviceView.companyImage === companyImage) return true;
        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.companyImage === companyImage) return true;
        return false;
    };
    $scope.setImage = function (image) {
        if ($scope.dd.view.edited.serviceView) {
            if (image === $scope.dd.view.edited.serviceView.image) {
                if ($scope.dd.view.edited.serviceView.image != null) {
                    $scope.dd.view.edited.serviceView.setImage(null);
                } else {
                    $scope.dd.view.edited.serviceView.setImage($scope.dd.view.edited.serviceView.parentCategoryView.image);
                }
            } else if (image != null) {
                $scope.dd.view.edited.serviceView.setImage(image);
            } else {
                $scope.dd.view.edited.serviceView.setImage($scope.dd.view.edited.serviceView.parentCategoryView.image);
            }
        }

        if ($scope.dd.view.edited.categoryView) {
            if (image === $scope.dd.view.edited.categoryView.image) {
                if ($scope.dd.view.edited.categoryView.image != null) {
                    $scope.dd.view.edited.categoryView.setImage(null);
                } else {
                    $scope.dd.view.edited.categoryView.setImage($scope.dd.view.edited.categoryView.parentCategoryView.image);
                }
            } else if (image != null) {
                $scope.dd.view.edited.categoryView.setImage(image);
            } else {
                $scope.dd.view.edited.categoryView.setImage($scope.dd.view.edited.categoryView.parentCategoryView.image);
            }
        }
    };
    $scope.setCompanyImage = function (companyImage) {
        if ($scope.dd.view.edited.serviceView) {
            if (companyImage === $scope.dd.view.edited.serviceView.companyImage) {
                if ($scope.dd.view.edited.serviceView.companyImage != null) {
                    $scope.dd.view.edited.serviceView.setCompanyImage(null);
                } else {
                    $scope.dd.view.edited.serviceView.setCompanyImage($scope.dd.view.edited.serviceView.parentCategoryView.companyImage);
                }
            } else if (companyImage != null) {
                $scope.dd.view.edited.serviceView.setCompanyImage(companyImage);
            } else {
                $scope.dd.view.edited.serviceView.setCompanyImage($scope.dd.view.edited.serviceView.parentCategoryView.companyImage);
            }
        }

        if ($scope.dd.view.edited.categoryView) {
            if (companyImage === $scope.dd.view.edited.categoryView.companyImage) {
                if ($scope.dd.view.edited.categoryView.companyImage != null) {
                    $scope.dd.view.edited.categoryView.setCompanyImage(null);
                } else {
                    $scope.dd.view.edited.categoryView.setCompanyImage($scope.dd.view.edited.categoryView.parentCategoryView.companyImage);
                }
            } else if (companyImage != null) {
                $scope.dd.view.edited.categoryView.setCompanyImage(companyImage);
            } else {
                $scope.dd.view.edited.categoryView.setCompanyImage($scope.dd.view.edited.categoryView.parentCategoryView.companyImage);
            }
        }
    };

    $scope.getEditedItem = function () {
        return $scope.dd.view.edited.categoryView ? $scope.dd.view.edited.categoryView : $scope.dd.view.edited.serviceView ? $scope.dd.view.edited.serviceView : null;
    };

    $scope.onSearchServiceInputKeyDown = function () {
        if ($scope.dd.view.categoryRootView) {
            $scope.dd.view.filterServicesView = null;
            if ($scope.dd.view.filterTimeOut) $timeout.cancel($scope.dd.view.filterTimeOut);
            $scope.dd.view.filterTimeOut = $timeout(function () {
                //useTimeOut in order to search only when use finish typing (or barcode scanner stop)
                if ($scope.dd.view.filter && $scope.dd.view.filter.length > 2) $scope.dd.view.filterServicesView = $scope.dd.view.categoryRootView.getServicesViewByLabel($scope.dd.view.filter.toLowerCase());
            }, 250);
        }
    };

    $scope.addServiceViewDisplayed = function (serviceView) {
        if (serviceView && $scope.dd.view.filterServicesView && $scope.dd.view.filterServicesView.indexOf(serviceView) === -1) {
            $scope.dd.view.filterServicesView.push(serviceView);
        }
    };

    $scope.loadEnabledServiceSettingsReserveWithGoogleViews = function () {
        $scope.dd.view.categoriesLoading = true;
        var filterLabel = $scope.dd.view.filter.toLowerCase();
        ServiceSrv.loadEnabledServiceSettingsReserveWithGoogleViews(function (data) {
            $scope.dd.view.filterServicesView = [];
            if (data && $scope.dd.view.categoryRootView) {
                for (var i = 0; i < data.length; i++) {
                    var serviceView = $scope.dd.view.categoryRootView.getServiceViewById(data[i].id);
                    if (serviceView) {
                        if (filterLabel && serviceView.label.toLowerCase().indexOf(filterLabel) !== -1 || !filterLabel) {
                            $scope.addServiceViewDisplayed(serviceView);
                        }
                    }
                }
            }
            $scope.dd.view.categoriesLoading = false;
        }, function () {
            $scope.dd.view.categoriesLoading = false;
        });
    };

    $scope.updateVisibilityCategoriesAndServicesForRwg = function () {
        $scope.dd.view.categoriesLoading = true;
        ServiceSrv.loadEnabledServiceSettingsReserveWithGoogleViews(function (data) {
            if (data) {
                $scope.updateRecursivelyVisibilityCategoriesAndServicesForRwg($scope.dd.view.selected.categoryView, data);
            }
            $scope.dd.view.categoriesLoading = false;
        }, function () {
            $scope.dd.view.categoriesLoading = false;
        });
    };

    $scope.updateRecursivelyVisibilityCategoriesAndServicesForRwg = function (categoryParentView, data) {
        var isVisibleCategory = false;
        for (var i = 0; i < categoryParentView.servicesView.length; i++) {
            var serviceView = categoryParentView.servicesView[i];
            var isVisibleService = false;
            for (var k = 0; k < data.length; k++) {
                if (data[k].id == serviceView.serviceId) {
                    isVisibleCategory = true;
                    isVisibleService = true;
                    break;
                }
            }
            serviceView.isVisible = isVisibleService;
        }
        for (var j = 0; j < categoryParentView.categoriesView.length; j++) {
            isVisibleCategory = $scope.updateRecursivelyVisibilityCategoriesAndServicesForRwg(categoryParentView.categoriesView[j], data) || isVisibleCategory;
        }
        categoryParentView.isVisible = isVisibleCategory;
        return isVisibleCategory;
    };

    $scope.updateVisibilityCategoriesAndServicesForWebSite = function (categoryParentView) {
        var isVisibleCategory = false;
        for (var i = 0; i < categoryParentView.servicesView.length; i++) {
            var serviceView = categoryParentView.servicesView[i];
            if (serviceView && serviceView.isVisibleOnWebSite && serviceView.isBookableOnWebSite) {
                isVisibleCategory = true;
                serviceView.isVisible = true;
            } else {
                serviceView.isVisible = false;
            }
        }
        for (var j = 0; j < categoryParentView.categoriesView.length; j++) {
            isVisibleCategory = $scope.updateVisibilityCategoriesAndServicesForWebSite(categoryParentView.categoriesView[j]) || isVisibleCategory;
        }
        categoryParentView.isVisible = isVisibleCategory;
        return isVisibleCategory;
    };

    $scope.updateVisibilityCategoriesAndServices = function () {
        if ($scope.dd.view.filterTypeService === $scope.dd.view.filterTypeServiceList.reserveWithGoogle) {
            $scope.updateVisibilityCategoriesAndServicesForRwg();
        } else if ($scope.dd.view.filterTypeService === $scope.dd.view.filterTypeServiceList.website) {
            $scope.updateVisibilityCategoriesAndServicesForWebSite($scope.dd.view.selected.categoryView);
        }
    };

    $scope.resetVisibilityCategoriesAndServices = function (categoryParentView) {
        for (var i = 0; i < categoryParentView.servicesView.length; i++) {
            categoryParentView.servicesView[i].isVisible = true;
        }
        for (var j = 0; j < categoryParentView.categoriesView.length; j++) {
            $scope.resetVisibilityCategoriesAndServices(categoryParentView.categoriesView[j]);
        }
        categoryParentView.isVisible = true;
    };

    $scope.onSearchService = function () {
        if (!$scope.ad.offerManager.hasCompanyAccessToOnlineReservation($scope.ad.loggedUser.company)) {
            $scope.onSearchServiceInputKeyDown();
        } else {
            if (!$scope.dd.view.filter || $scope.dd.view.filter.length < 2) {
                if ($scope.dd.view.filterTypeService === $scope.dd.view.filterTypeServiceList.allServices) {
                    $scope.resetVisibilityCategoriesAndServices($scope.dd.view.selected.categoryView);
                } else {
                    $scope.updateVisibilityCategoriesAndServices();
                }
            } else {
                if ($scope.dd.view.filterTimeOut) $timeout.cancel($scope.dd.view.filterTimeOut);
                $scope.dd.view.filterTimeOut = $timeout(function () {
                    //useTimeOut in order to search only when use finish typing (or barcode scanner stop)
                    if ($scope.dd.view.filterTypeService === $scope.dd.view.filterTypeServiceList.reserveWithGoogle) {
                        $scope.loadEnabledServiceSettingsReserveWithGoogleViews();
                    } else {
                        $scope.dd.view.filterServicesView = [];
                        var servicesViewByLabel = $scope.dd.view.categoryRootView.getServicesViewByLabel($scope.dd.view.filter.toLowerCase());
                        for (var i = 0; i < servicesViewByLabel.length; i++) {
                            var serviceViewByLabel = servicesViewByLabel[i];
                            if ($scope.dd.view.filterTypeService === "" || $scope.dd.view.filterTypeService === $scope.dd.view.filterTypeServiceList.allServices || $scope.dd.view.filterTypeService === $scope.dd.view.filterTypeServiceList.website && serviceViewByLabel.isVisibleOnWebSite && serviceViewByLabel.isBookableOnWebSite) {
                                $scope.addServiceViewDisplayed(serviceViewByLabel);
                            }
                        }
                    }
                }, 250);
            }
        }
    };

    $scope.loadServiceSettingsReserveWithGoogleView = function () {
        if ($scope.dd.view.edited.serviceView) {
            var service = $scope.dd.view.edited.serviceView.getModel();
            var serviceSettings = $scope.dd.view.edited.serviceView.serviceSettings[BasicAuthRole.GOOGLE_ROLE.role];
            if (service && service.serviceSettingsReserveWithGoogleId) {
                if (serviceSettings.view) {
                    $scope.dd.view.edited.serviceView.onVisibleOnPartnerChange(BasicAuthRole.GOOGLE_ROLE.role);
                } else {
                    $scope.dd.view.serviceLoading = true;
                    ServiceSettingsReserveWithGoogleSrv.get(service.serviceSettingsReserveWithGoogleId, function (serviceSettingsReserveWithGoogle) {
                        if ($scope.dd.view.edited.serviceView) {
                            serviceSettings.view = new ServiceSettingsReserveWithGoogleView(serviceSettingsReserveWithGoogle);
                            serviceSettings.id = service.serviceSettingsReserveWithGoogleId;
                            $scope.dd.view.serviceLoading = false;
                            $scope.dd.view.edited.serviceView.onVisibleOnPartnerChange(BasicAuthRole.GOOGLE_ROLE.role);
                            $scope.maybeInitAlertMessagePaymentOnline();
                        }
                    }, function () {
                        serviceSettings.view = new ServiceSettingsReserveWithGoogleView(null, $scope.dd.view.edited.serviceView.price);
                        $scope.dd.view.serviceLoading = false;
                    });
                }
            } else {
                if (!serviceSettings.view) {
                    serviceSettings.view = new ServiceSettingsReserveWithGoogleView(null, $scope.dd.view.edited.serviceView.price);
                }
                $scope.maybeInitAlertMessagePaymentOnline();
            }
        }
    };

    $scope.displayLeCiseauTab = function () {
        var launchDarklyFeatureFlag = LaunchDarklyFeatureFlagData.getByFlagName(LaunchDarklyFeatureFlagList.FLEX_3534_FEATURE_FLAG_LE_CISEAU_SERVICE_SETTINGS.flagName);
        return (!launchDarklyFeatureFlag || !launchDarklyFeatureFlag.isActive) && $scope.ad.addons.sub.optionLeCiseau;
    };

    $scope.loadServiceSettingsLeCiseauView = function () {
        if ($scope.dd.view.edited.serviceView) {
            $scope.dd.view.serviceLoading = true;
            if (!$scope.dd.view.marketplaceData.loaded) {
                $scope.initMarketplaceData().then($scope.loadServiceSettingsLeCiseauViewAfterMarketplaceLoad);
            } else {
                $scope.loadServiceSettingsLeCiseauViewAfterMarketplaceLoad();
            }
        }
    };

    $scope.loadServiceSettingsLeCiseauViewAfterMarketplaceLoad = function () {
        var service = $scope.dd.view.edited.serviceView.getModel();
        var serviceSettings = $scope.dd.view.edited.serviceView.serviceSettings[BasicAuthRole.LE_CISEAU_ROLE.role];
        if (service) {
            ServiceSettingsLeCiseauSrv.get(service.id, function (serviceSettingsLeCiseau) {
                if ($scope.dd.view.edited.serviceView) {
                    serviceSettings.view = new ServiceSettingsLeCiseauView(serviceSettingsLeCiseau, service.id, $scope.dd.view.marketplaceData.defaultData);
                    serviceSettings.id = service.id;
                    $scope.dd.view.edited.serviceView.onVisibleOnPartnerChange(BasicAuthRole.LE_CISEAU_ROLE.role);
                    $scope.computeMarketplaceSubCategoriesAndVariantsFromCategory(serviceSettings.view.marketplaceCategoryId);
                    $scope.dd.view.serviceLoading = false;
                }
            }, function () {
                serviceSettings.view = new ServiceSettingsLeCiseauView(null, service.id, $scope.dd.view.marketplaceData.defaultData);
                $scope.computeMarketplaceSubCategoriesAndVariantsFromCategory(serviceSettings.view.marketplaceCategoryId);
                $scope.dd.view.serviceLoading = false;
            });
        } else if (!serviceSettings.view) {
            serviceSettings.view = new ServiceSettingsLeCiseauView(null, null, $scope.dd.view.marketplaceData.defaultData);
            $scope.computeMarketplaceSubCategoriesAndVariantsFromCategory(serviceSettings.view.marketplaceCategoryId);
            $scope.dd.view.serviceLoading = false;
        }
    };

    $scope.maybeInitAlertMessagePaymentOnline = function () {
        if ($scope.ad.addons.sub.websitePaymentAccess) {
            $scope.dd.view.edited.serviceView.initAlertMessagePaymentOnline();
        }
    };

    $scope.initMarketplaceData = function () {
        return MarketplaceSrv.getMarketplaceData().then(function (data) {
            if (data && data.marketplaceCategories) {
                $scope.dd.view.marketplaceData.marketplaceCategories = data.marketplaceCategories;
                $scope.dd.view.marketplaceData.defaultData.marketplaceDefaultCategory = data.marketplaceCategories[0];
                $scope.dd.view.marketplaceData.defaultData.marketplaceDefaultSubCategory = data.marketplaceCategories[0].subCategories[0];
                $scope.dd.view.marketplaceData.defaultData.marketplaceDefaultVariant = data.marketplaceCategories[0].variants[0];
                $scope.dd.view.marketplaceData.loaded = true;
            }
        }, function () {
            $scope.dd.view.marketplaceData.loaded = false;
        });
    };

    $scope.onMarketplaceCategoryChange = function (serviceSettings) {
        if (serviceSettings.view) {
            $scope.computeMarketplaceSubCategoriesAndVariantsFromCategory(serviceSettings.view.marketplaceCategoryId);
            if ($scope.dd.view.marketplaceData.marketplaceSubCategories && $scope.dd.view.marketplaceData.marketplaceSubCategories.length > 0) {
                serviceSettings.view.marketplaceSubCategoryId = $scope.dd.view.marketplaceData.marketplaceSubCategories[0].id;
            } else {
                serviceSettings.view.marketplaceSubCategory = null;
            }

            if ($scope.dd.view.marketplaceData.marketplaceVariants && $scope.dd.view.marketplaceData.marketplaceVariants.length > 0) {
                serviceSettings.view.marketplaceVariantId = $scope.dd.view.marketplaceData.marketplaceVariants[0].id;
            } else {
                serviceSettings.view.marketplaceVariant = null;
            }
        }
    };

    $scope.computeMarketplaceSubCategoriesAndVariantsFromCategory = function (marketplaceCategoryId) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = $scope.dd.view.marketplaceData.marketplaceCategories[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var marketplaceCategory = _step.value;

                if (marketplaceCategoryId === marketplaceCategory.id) {
                    $scope.dd.view.marketplaceData.marketplaceSubCategories = marketplaceCategory.subCategories;
                    $scope.dd.view.marketplaceData.marketplaceVariants = marketplaceCategory.variants;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };

    $scope.computeVariantLabelById = function (variantId) {
        var label = "";
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = $scope.dd.view.marketplaceData.marketplaceVariants[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var variant = _step2.value;

                if (variant.id === variantId) {
                    label = variant.label;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        return label;
    };

    $scope.updateLabelAndLinkedServices = function () {
        $scope.updateLabelFromLabelShort($scope.dd.view.edited.serviceView, $scope.dd.view.edited.serviceView.previousLabelShort);
        $scope.updateLinkedServicesLabels($scope.dd.view.edited.serviceView.previousLabelShort);
        $scope.dd.view.edited.serviceView.previousLabelShort = $scope.dd.view.edited.serviceView.labelShort ? $scope.dd.view.edited.serviceView.labelShort : "";
    };

    $scope.updateLinkedServicesLabels = function (previousLabelShort) {
        var serviceSettings = $scope.dd.view.edited.serviceView.serviceSettings[BasicAuthRole.LE_CISEAU_ROLE.role];
        if (serviceSettings && serviceSettings.view && serviceSettings.view.hasLinkedServiceIds()) {
            serviceSettings.view.linkedServiceIds.forEach(function (linkedServiceId) {
                var service = ServiceData.getById(linkedServiceId);
                if (service) {
                    service.labelShort = $scope.dd.view.edited.serviceView.labelShort;
                    $scope.updateLabelFromLabelShort(service, previousLabelShort);
                    var serviceView = $scope.dd.view.selected.categoryView.getServiceView(service);
                    if (serviceView) {
                        serviceView.labelShort = $scope.dd.view.edited.serviceView.labelShort;
                        $scope.updateLabelFromLabelShort(serviceView, previousLabelShort);
                    }
                }
            });
        }
    };

    $scope.updateLabelFromLabelShort = function (service, previousLabelShort) {
        previousLabelShort = previousLabelShort ? previousLabelShort : "";
        if (service.labelShort) {
            service.label = service.label.replace(previousLabelShort, service.labelShort);
        } else {
            service.label = service.label.replace(previousLabelShort, "");
        }
    };

    $scope.clearVariants = function (service) {
        service.label = service.labelShort ? service.labelShort : "";
    };
}]);

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 02/12/2013
 * Time: 12:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('SiteCtrl', ["$scope", "$rootScope", "$locale", "DateSrv", "SiteData", "SiteView", "SiteSrv", "WorkingPeriod", "WorkingPeriodSrv", "WorkingPeriodView", "Site", "Auth", "HumanResourceData", "Constants", "HumanResourceView", function ($scope, $rootScope, $locale, DateSrv, SiteData, SiteView, SiteSrv, WorkingPeriod, WorkingPeriodSrv, WorkingPeriodView, Site, Auth, HumanResourceData, Constants, HumanResourceView) {
    //Start-Init
    $scope.daysOfWeekLabel = DateSrv.daysOfWeekLabel;
    $scope.dd = {
        siteView: null,
        companyView: null,
        hours: [],
        hourQuarters: [],
        edited: { siteView: null }, //edited site
        displayError: false,
        displayPhoneError: false,
        displayWPError: false,
        displayWPIntersectError: false,
        displayWPPeriodError: false,
        displayWPMinDaysError: false,
        displayDesc: 1,
        workingPeriodDayViewsToClose: [],
        humanResources: HumanResourceData.getActiveList(),
        ownerHumanResourceView: null,
        isAddressDifferentFromHeadOffice: null,
        countries: Constants.SITE_COUNTRIES,
        phoneCountry: null,
        isLoading: false
    };

    $scope.checkAddressDifferentHeadOffice = function () {
        return $scope.dd.siteView.address !== $scope.dd.siteView.legalAddress || $scope.dd.siteView.city !== $scope.dd.siteView.legalCity || $scope.dd.siteView.country !== $scope.dd.siteView.legalCountry || $scope.dd.siteView.postalCode !== $scope.dd.siteView.legalZip;
    };

    $scope.updateIsAddressDifferentFromHeadOffice = function () {
        $scope.isAddressDifferentFromHeadOffice = !$scope.isAddressDifferentFromHeadOffice;
        $scope.updateLegalAddressSameAddress();
    };

    $scope.updateLegalAddressSameAddress = function () {
        if (!$scope.dd.isAddressDifferentFromHeadOffice) {
            $scope.dd.siteView.legalAddress = $scope.dd.siteView.address;
            $scope.dd.siteView.legalCity = $scope.dd.siteView.city;
            $scope.dd.siteView.legalCountry = $scope.dd.siteView.country;
            $scope.dd.siteView.legalZip = $scope.dd.siteView.postalCode;
        }
    };

    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue) {
            if (!$scope.ad.managerMode) {
                $scope.goToDomain("planningPos", "dashboard");
            }
            $scope.dd.siteView = new SiteView(SiteData.defaultSite);
            if (!$scope.dd.siteView.ownerId) {
                var humanResource = HumanResourceData.getFirstActive();
                $scope.dd.siteView.ownerId = humanResource ? humanResource.id : null;
            }
            $scope.dd.phoneCountry = $scope.dd.siteView.country.toLowerCase();
            $scope.updateOwner();
            $scope.dd.isAddressDifferentFromHeadOffice = $scope.checkAddressDifferentHeadOffice();
            $scope.dd.edited.siteView = $scope.dd.siteView;
        }
    });

    //Implement userActionCanceler
    var userActionCancelFn = $rootScope.$on('userActionCancel', function (_, actionCanceledType, object) {
        if (object instanceof Site) {
            $scope.dd.siteView.loadDataFrom(object);
        }
    });
    $scope.newWorkingHour = function () {
        $scope.dd.displayWPError = false;
        $scope.currentWpView = new WorkingPeriodView();
        $scope.newWorkingHourMode = true;
    };

    $scope.removeWorkingPeriod = function (wpView) {
        $scope.dd.siteView.removeWorkingPeriodView(wpView);
    };

    $scope.toggleOpenDay = function (wpDayView, newOpenDayValue) {
        if (wpDayView.openDay && !newOpenDayValue) {
            $scope.dd.workingPeriodDayViewsToClose.push(wpDayView);
        } else if (!wpDayView.openDay && newOpenDayValue) {
            var wpIndex = $scope.dd.workingPeriodDayViewsToClose.indexOf(wpDayView);
            if (wpIndex != -1) {
                $scope.dd.workingPeriodDayViewsToClose.splice(wpIndex, 1);
            }
        }
        wpDayView.openDay = newOpenDayValue;
    };

    $scope.saveSite = function () {
        if ($scope.dd.siteView.canSave($scope.ad.addons.sub.websiteAccess) && $scope.canSaveHumanResource() && !$scope.dd.displayPhoneError && !$scope.currentWpView && !$scope.isReadOnly()) {
            $scope.dd.isLoading = true;
            $scope.dd.siteView.updateModel($scope.dd.workingPeriodDayViewsToClose, $scope.finishSave, $scope.finishSave);
        }
    };

    $scope.finishSave = function () {
        $scope.dd.isLoading = false;
        $scope.dd.edited.siteView = null;
    };

    $scope.canSave = function (wpView) {
        if (wpView && wpView.period.end.dateTime && wpView.period.start.dateTime) {
            return true;
        }
        return false;
    };

    $scope.canSaveHumanResource = function () {
        return $scope.dd.ownerHumanResourceView && $scope.dd.ownerHumanResourceView.email && $scope.dd.ownerHumanResourceView.email !== '' && $scope.dd.ownerHumanResourceView.phone !== '' && $scope.dd.ownerHumanResourceView.phone;
    };

    $scope.checkIsAdminNotGroup = function () {
        return Auth.isAdminNotGroup();
    };

    $scope.saveWorkingPeriod = function (wpView) {
        if (wpView) {
            if (wpView.nbOpenDays() == 0) {
                $scope.dd.displayWPMinDaysError = true;
                return;
            }
            if (wpView.period.start.getTime() >= wpView.period.end.getTime()) {
                $scope.dd.displayWPPeriodError = true;
                return;
            }
            if ($scope.dd.siteView.intersectWorkingPeriodsView(wpView)) {
                $scope.dd.displayWPIntersectError = true;
                return;
            }
            $scope.dd.displayWPMinDaysError = false;
            $scope.dd.displayWPIntersectError = false;
            $scope.dd.displayWPPeriodError = false;
            if (wpView.modelIndex == -1) // new item
                $scope.dd.siteView.addWorkingPeriodView(wpView);

            //Update view
            wpView.edit = false;
            $scope.currentWpView = null;
            $scope.newWorkingHourMode = false;
            wpView.update();
        }
    };
    $scope.setCurrentWorkingPeriod = function (wpView) {
        $scope.currentWpView = wpView;
        wpView.edit = true;
    };

    $scope.cancelWorkingPeriod = function () {
        if ($scope.currentWpView) {
            $scope.currentWpView.edit = false;
        }
        $scope.currentWpView = null;
        $scope.currentWp = null;

        $scope.dd.displayWPMinDaysError = false;
        $scope.dd.displayWPIntersectError = false;
        $scope.dd.displayWPPeriodError = false;
    };

    $scope.displayError = function () {
        if (!$scope.dd.siteView.name || $scope.dd.siteView.name == '') $scope.dd.displayError = true;else $scope.dd.displayError = false;

        if ($scope.dd.siteView.workingPeriodsView.length < 1) $scope.dd.displayWPError = true;else $scope.dd.displayWPError = false;

        if ($scope.dd.edited.siteView && $scope.dd.edited.siteView.hasValidWorkPhone()) $scope.dd.displayPhoneError = false;else $scope.dd.displayPhoneError = true;
    };

    $scope.$on('$destroy', function () {
        userActionCancelFn();
    });

    $scope.updateOwner = function () {
        if ($scope.dd.siteView && $scope.dd.siteView.ownerId) {
            var humanResource = HumanResourceData.getById($scope.dd.siteView.ownerId);
            $scope.dd.ownerHumanResourceView = new HumanResourceView(humanResource, HumanResourceData.getIndexOf(humanResource));
        }
    };

    $scope.updateTimezone = function () {
        var country = $scope.dd.countries.find(function (country) {
            return country.code == $scope.dd.siteView.country;
        });
        $scope.dd.siteView.timeZone = country.timezone;
    };
}]);

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: vanessaSoc
 * Date: 26/04/19
 * Time: 09:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('DialogLevel3DCtrl', ["$scope", "$rootScope", "dialog", "dialogsModel", function ($scope, $rootScope, dialog, dialogsModel) {
    var key = void 0;
    // hook the passed data to the popin scope
    for (key in dialogsModel) {
        $scope[key] = dialogsModel[key];
    }
    $scope.dd = {
        level: "" + $scope.companyView.level3ds + ""
    };
    $scope.dialog = dialog;
    $scope.cancel = function () {
        $scope.onCloseWindow();
        dialog.close(false);
    };
    $scope.action = function () {
        $scope.onCloseWindow();
        dialog.close(true);
    };
    $scope.onCloseWindow = function () {
        if (!isNaN($scope.dd.level)) $scope.companyView.level3ds = parseInt($scope.dd.level);
    };
}]);

/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.controllers').controller('BookingFormCtrl', ["$scope", "$timeout", "OfferManager", "StoreAppCode", "Images", "BookingCreator", function ($scope, $timeout, OfferManager, StoreAppCode, Images, BookingCreator) {
    $scope.bookingStatusImage = Images.saleStatus;
    $scope.startHourSel = false;
    $scope.startMinuteSel = false;
    $scope.datePicker = {
        opened: false,
        date: null
    };
    $scope.bookingDate = null; // edited booking date by date picker
    $scope.bookingView = null; // Direct access to bookingView Edited
    $scope.tailleTest = -1;
    $scope.serviceFilter = {
        text: null,
        timeOut: null,
        servicesView: null,
        customerServicesView: null
    };
    $scope.datePickerTimer = null;
    $scope.bookingCreator = BookingCreator;

    //Put in scope edited booking
    $scope.$watch('dd.view.pTView.edited.bookingView', function (bookingView) {
        if (bookingView && $scope.bookingView !== bookingView) {
            $scope.displayServiceSelector = true; //display selector has period selected and bookingServices == 0
            $scope.displayCustomerForm = false;
            $scope.serviceFilter.text = null;
            $scope.serviceFilter.servicesView = null;
        }
        $scope.bookingView = bookingView;
        if (bookingView && bookingView.plgDayView && bookingView.plgDayView.date) {
            $scope.bookingDate = bookingView.plgDayView.date;
        }
        if ($scope.dd.view.pTView && $scope.dd.view.pTView.updateDisplaySelector) {
            $scope.dd.view.pTView.updateDisplaySelector();
        }
    });

    $scope.onCustomerInputKeyDown = function (event) {
        var keyCode = event.which;
        //if key delete detected : clear customer
        if (keyCode == 8 || keyCode == 46) {
            $scope.bookingView.removeCustomerView();
        }
    };
    $scope.setCurrentCategory = function (categoryView) {
        $scope.dd.view.cCategoryView = categoryView;
    };
    $scope.setCurrentProductCategory = function (categoryView) {
        $scope.dd.view.cProductCategoryView = categoryView;
    };
    $scope.displayDatePickerF = function () {
        if ($scope.datePickerTimer) {
            $timeout.cancel($scope.datePickerTimer);
        }

        if (!$scope.bookingView.isReadOnly && $scope.bookingView.plgDayView) $scope.datePickerTimer = $timeout(function () {
            $scope.datePicker.date = new Date($scope.bookingView.plgDayView.date);
            $scope.datePicker.opened = true;
        });
    };

    $scope.onSearchServiceInputKeyDown = function () {

        if ($scope.dd.view.categoryRootView) {

            if ($scope.serviceFilter.timeOut) $timeout.cancel($scope.serviceFilter.timeOut);
            $scope.serviceFilter.timeOut = $timeout(function () {
                //useTimeOut in order to search only when use finish typing (or barcode scanner stop)

                if ($scope.serviceFilter.text && $scope.serviceFilter.text.length >= 2) {
                    var lowerText = $scope.serviceFilter.text.toLowerCase();
                    $scope.serviceFilter.customerServicesView = [];
                    $scope.serviceFilter.servicesView = $scope.dd.view.categoryRootView.getServicesViewByLabel(lowerText);
                    if ($scope.dd.view.pTView && $scope.dd.view.pTView.edited.bookingView && $scope.dd.view.pTView.edited.bookingView.customerView && $scope.dd.view.pTView.edited.bookingView.customerView.proposedServices) for (var i = 0; i < $scope.dd.view.pTView.edited.bookingView.customerView.proposedServices.length; i++) {
                        if ($scope.dd.view.pTView.edited.bookingView.customerView.proposedServices[i].bsView && $scope.dd.view.pTView.edited.bookingView.customerView.proposedServices[i].bsView.label && $scope.dd.view.pTView.edited.bookingView.customerView.proposedServices[i].bsView.label.toLowerCase().indexOf(lowerText) !== -1) $scope.serviceFilter.customerServicesView.push($scope.dd.view.pTView.edited.bookingView.customerView.proposedServices[i]);
                    }
                } else {
                    $scope.serviceFilter.servicesView = null;
                    $scope.serviceFilter.customerServicesView = null;
                }
            }, 250);
        }
    };
}]);

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 2.5.6 - 2017-10-14
 * License: MIT
 */angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.collapse","ui.bootstrap.tabindex","ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.dateparser","ui.bootstrap.isClass","ui.bootstrap.datepicker","ui.bootstrap.position","ui.bootstrap.datepickerPopup","ui.bootstrap.debounce","ui.bootstrap.multiMap","ui.bootstrap.dropdown","ui.bootstrap.stackedMap","ui.bootstrap.modal","ui.bootstrap.paging","ui.bootstrap.pager","ui.bootstrap.pagination","ui.bootstrap.tooltip","ui.bootstrap.popover","ui.bootstrap.progressbar","ui.bootstrap.rating","ui.bootstrap.tabs","ui.bootstrap.timepicker","ui.bootstrap.typeahead"]);
angular.module("ui.bootstrap.tpls", ["uib/template/accordion/accordion-group.html","uib/template/accordion/accordion.html","uib/template/alert/alert.html","uib/template/carousel/carousel.html","uib/template/carousel/slide.html","uib/template/datepicker/datepicker.html","uib/template/datepicker/day.html","uib/template/datepicker/month.html","uib/template/datepicker/year.html","uib/template/datepickerPopup/popup.html","uib/template/modal/window.html","uib/template/pager/pager.html","uib/template/pagination/pagination.html","uib/template/tooltip/tooltip-html-popup.html","uib/template/tooltip/tooltip-popup.html","uib/template/tooltip/tooltip-template-popup.html","uib/template/popover/popover-html.html","uib/template/popover/popover-template.html","uib/template/popover/popover.html","uib/template/progressbar/bar.html","uib/template/progressbar/progress.html","uib/template/progressbar/progressbar.html","uib/template/rating/rating.html","uib/template/tabs/tab.html","uib/template/tabs/tabset.html","uib/template/timepicker/timepicker.html","uib/template/typeahead/typeahead-match.html","uib/template/typeahead/typeahead-popup.html"]);
angular.module('ui.bootstrap.collapse', [])

  .directive('uibCollapse', ['$animate', '$q', '$parse', '$injector', function($animate, $q, $parse, $injector) {
    var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
    return {
      link: function(scope, element, attrs) {
        var expandingExpr = $parse(attrs.expanding),
          expandedExpr = $parse(attrs.expanded),
          collapsingExpr = $parse(attrs.collapsing),
          collapsedExpr = $parse(attrs.collapsed),
          horizontal = false,
          css = {},
          cssTo = {};

        init();

        function init() {
          horizontal = !!('horizontal' in attrs);
          if (horizontal) {
            css = {
              width: ''
            };
            cssTo = {width: '0'};
          } else {
            css = {
              height: ''
            };
            cssTo = {height: '0'};
          }
          if (!scope.$eval(attrs.uibCollapse)) {
            element.addClass('in')
              .addClass('collapse')
              .attr('aria-expanded', true)
              .attr('aria-hidden', false)
              .css(css);
          }
        }

        function getScrollFromElement(element) {
          if (horizontal) {
            return {width: element.scrollWidth + 'px'};
          }
          return {height: element.scrollHeight + 'px'};
        }

        function expand() {
          if (element.hasClass('collapse') && element.hasClass('in')) {
            return;
          }

          $q.resolve(expandingExpr(scope))
            .then(function() {
              element.removeClass('collapse')
                .addClass('collapsing')
                .attr('aria-expanded', true)
                .attr('aria-hidden', false);

              if ($animateCss) {
                $animateCss(element, {
                  addClass: 'in',
                  easing: 'ease',
                  css: {
                    overflow: 'hidden'
                  },
                  to: getScrollFromElement(element[0])
                }).start()['finally'](expandDone);
              } else {
                $animate.addClass(element, 'in', {
                  css: {
                    overflow: 'hidden'
                  },
                  to: getScrollFromElement(element[0])
                }).then(expandDone);
              }
            }, angular.noop);
        }

        function expandDone() {
          element.removeClass('collapsing')
            .addClass('collapse')
            .css(css);
          expandedExpr(scope);
        }

        function collapse() {
          if (!element.hasClass('collapse') && !element.hasClass('in')) {
            return collapseDone();
          }

          $q.resolve(collapsingExpr(scope))
            .then(function() {
              element
              // IMPORTANT: The width must be set before adding "collapsing" class.
              // Otherwise, the browser attempts to animate from width 0 (in
              // collapsing class) to the given width here.
                .css(getScrollFromElement(element[0]))
                // initially all panel collapse have the collapse class, this removal
                // prevents the animation from jumping to collapsed state
                .removeClass('collapse')
                .addClass('collapsing')
                .attr('aria-expanded', false)
                .attr('aria-hidden', true);

              if ($animateCss) {
                $animateCss(element, {
                  removeClass: 'in',
                  to: cssTo
                }).start()['finally'](collapseDone);
              } else {
                $animate.removeClass(element, 'in', {
                  to: cssTo
                }).then(collapseDone);
              }
            }, angular.noop);
        }

        function collapseDone() {
          element.css(cssTo); // Required so that collapse works when animation is disabled
          element.removeClass('collapsing')
            .addClass('collapse');
          collapsedExpr(scope);
        }

        scope.$watch(attrs.uibCollapse, function(shouldCollapse) {
          if (shouldCollapse) {
            collapse();
          } else {
            expand();
          }
        });
      }
    };
  }]);

angular.module('ui.bootstrap.tabindex', [])

.directive('uibTabindexToggle', function() {
  return {
    restrict: 'A',
    link: function(scope, elem, attrs) {
      attrs.$observe('disabled', function(disabled) {
        attrs.$set('tabindex', disabled ? -1 : null);
      });
    }
  };
});

angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse', 'ui.bootstrap.tabindex'])

.constant('uibAccordionConfig', {
  closeOthers: true
})

.controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function($scope, $attrs, accordionConfig) {
  // This array keeps track of the accordion groups
  this.groups = [];

  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
  this.closeOthers = function(openGroup) {
    var closeOthers = angular.isDefined($attrs.closeOthers) ?
      $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
    if (closeOthers) {
      angular.forEach(this.groups, function(group) {
        if (group !== openGroup) {
          group.isOpen = false;
        }
      });
    }
  };

  // This is called from the accordion-group directive to add itself to the accordion
  this.addGroup = function(groupScope) {
    var that = this;
    this.groups.push(groupScope);

    groupScope.$on('$destroy', function(event) {
      that.removeGroup(groupScope);
    });
  };

  // This is called from the accordion-group directive when to remove itself
  this.removeGroup = function(group) {
    var index = this.groups.indexOf(group);
    if (index !== -1) {
      this.groups.splice(index, 1);
    }
  };
}])

// The accordion directive simply sets up the directive controller
// and adds an accordion CSS class to itself element.
.directive('uibAccordion', function() {
  return {
    controller: 'UibAccordionController',
    controllerAs: 'accordion',
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/accordion/accordion.html';
    }
  };
})

// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
.directive('uibAccordionGroup', function() {
  return {
    require: '^uibAccordion',         // We need this directive to be inside an accordion
    transclude: true,              // It transcludes the contents of the directive into the template
    restrict: 'A',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/accordion/accordion-group.html';
    },
    scope: {
      heading: '@',               // Interpolate the heading attribute onto this scope
      panelClass: '@?',           // Ditto with panelClass
      isOpen: '=?',
      isDisabled: '=?'
    },
    controller: function() {
      this.setHeading = function(element) {
        this.heading = element;
      };
    },
    link: function(scope, element, attrs, accordionCtrl) {
      element.addClass('panel');
      accordionCtrl.addGroup(scope);

      scope.openClass = attrs.openClass || 'panel-open';
      scope.panelClass = attrs.panelClass || 'panel-default';
      scope.$watch('isOpen', function(value) {
        element.toggleClass(scope.openClass, !!value);
        if (value) {
          accordionCtrl.closeOthers(scope);
        }
      });

      scope.toggleOpen = function($event) {
        if (!scope.isDisabled) {
          if (!$event || $event.which === 32) {
            scope.isOpen = !scope.isOpen;
          }
        }
      };

      var id = 'accordiongroup-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
      scope.headingId = id + '-tab';
      scope.panelId = id + '-panel';
    }
  };
})

// Use accordion-heading below an accordion-group to provide a heading containing HTML
.directive('uibAccordionHeading', function() {
  return {
    transclude: true,   // Grab the contents to be used as the heading
    template: '',       // In effect remove this element!
    replace: true,
    require: '^uibAccordionGroup',
    link: function(scope, element, attrs, accordionGroupCtrl, transclude) {
      // Pass the heading to the accordion-group controller
      // so that it can be transcluded into the right place in the template
      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
      accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
    }
  };
})

// Use in the accordion-group template to indicate where you want the heading to be transcluded
// You must provide the property on the accordion-group controller that will hold the transcluded element
.directive('uibAccordionTransclude', function() {
  return {
    require: '^uibAccordionGroup',
    link: function(scope, element, attrs, controller) {
      scope.$watch(function() { return controller[attrs.uibAccordionTransclude]; }, function(heading) {
        if (heading) {
          var elem = angular.element(element[0].querySelector(getHeaderSelectors()));
          elem.html('');
          elem.append(heading);
        }
      });
    }
  };

  function getHeaderSelectors() {
      return 'uib-accordion-header,' +
          'data-uib-accordion-header,' +
          'x-uib-accordion-header,' +
          'uib\\:accordion-header,' +
          '[uib-accordion-header],' +
          '[data-uib-accordion-header],' +
          '[x-uib-accordion-header]';
  }
});

angular.module('ui.bootstrap.alert', [])

.controller('UibAlertController', ['$scope', '$element', '$attrs', '$interpolate', '$timeout', function($scope, $element, $attrs, $interpolate, $timeout) {
  $scope.closeable = !!$attrs.close;
  $element.addClass('alert');
  $attrs.$set('role', 'alert');
  if ($scope.closeable) {
    $element.addClass('alert-dismissible');
  }

  var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ?
    $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;

  if (dismissOnTimeout) {
    $timeout(function() {
      $scope.close();
    }, parseInt(dismissOnTimeout, 10));
  }
}])

.directive('uibAlert', function() {
  return {
    controller: 'UibAlertController',
    controllerAs: 'alert',
    restrict: 'A',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/alert/alert.html';
    },
    transclude: true,
    scope: {
      close: '&'
    }
  };
});

angular.module('ui.bootstrap.buttons', [])

.constant('uibButtonConfig', {
  activeClass: 'active',
  toggleEvent: 'click'
})

.controller('UibButtonsController', ['uibButtonConfig', function(buttonConfig) {
  this.activeClass = buttonConfig.activeClass || 'active';
  this.toggleEvent = buttonConfig.toggleEvent || 'click';
}])

.directive('uibBtnRadio', ['$parse', function($parse) {
  return {
    require: ['uibBtnRadio', 'ngModel'],
    controller: 'UibButtonsController',
    controllerAs: 'buttons',
    link: function(scope, element, attrs, ctrls) {
      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
      var uncheckableExpr = $parse(attrs.uibUncheckable);

      element.find('input').css({display: 'none'});

      //model -> UI
      ngModelCtrl.$render = function() {
        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
      };

      //ui->model
      element.on(buttonsCtrl.toggleEvent, function() {
        if (attrs.disabled) {
          return;
        }

        var isActive = element.hasClass(buttonsCtrl.activeClass);

        if (!isActive || angular.isDefined(attrs.uncheckable)) {
          scope.$apply(function() {
            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
            ngModelCtrl.$render();
          });
        }
      });

      if (attrs.uibUncheckable) {
        scope.$watch(uncheckableExpr, function(uncheckable) {
          attrs.$set('uncheckable', uncheckable ? '' : undefined);
        });
      }
    }
  };
}])

.directive('uibBtnCheckbox', function() {
  return {
    require: ['uibBtnCheckbox', 'ngModel'],
    controller: 'UibButtonsController',
    controllerAs: 'button',
    link: function(scope, element, attrs, ctrls) {
      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      element.find('input').css({display: 'none'});

      function getTrueValue() {
        return getCheckboxValue(attrs.btnCheckboxTrue, true);
      }

      function getFalseValue() {
        return getCheckboxValue(attrs.btnCheckboxFalse, false);
      }

      function getCheckboxValue(attribute, defaultValue) {
        return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
      }

      //model -> UI
      ngModelCtrl.$render = function() {
        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
      };

      //ui->model
      element.on(buttonsCtrl.toggleEvent, function() {
        if (attrs.disabled) {
          return;
        }

        scope.$apply(function() {
          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
          ngModelCtrl.$render();
        });
      });
    }
  };
});

angular.module('ui.bootstrap.carousel', [])

.controller('UibCarouselController', ['$scope', '$element', '$interval', '$timeout', '$animate', function($scope, $element, $interval, $timeout, $animate) {
  var self = this,
    slides = self.slides = $scope.slides = [],
    SLIDE_DIRECTION = 'uib-slideDirection',
    currentIndex = $scope.active,
    currentInterval, isPlaying;

  var destroyed = false;
  $element.addClass('carousel');

  self.addSlide = function(slide, element) {
    slides.push({
      slide: slide,
      element: element
    });
    slides.sort(function(a, b) {
      return +a.slide.index - +b.slide.index;
    });
    //if this is the first slide or the slide is set to active, select it
    if (slide.index === $scope.active || slides.length === 1 && !angular.isNumber($scope.active)) {
      if ($scope.$currentTransition) {
        $scope.$currentTransition = null;
      }

      currentIndex = slide.index;
      $scope.active = slide.index;
      setActive(currentIndex);
      self.select(slides[findSlideIndex(slide)]);
      if (slides.length === 1) {
        $scope.play();
      }
    }
  };

  self.getCurrentIndex = function() {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].slide.index === currentIndex) {
        return i;
      }
    }
  };

  self.next = $scope.next = function() {
    var newIndex = (self.getCurrentIndex() + 1) % slides.length;

    if (newIndex === 0 && $scope.noWrap()) {
      $scope.pause();
      return;
    }

    return self.select(slides[newIndex], 'next');
  };

  self.prev = $scope.prev = function() {
    var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;

    if ($scope.noWrap() && newIndex === slides.length - 1) {
      $scope.pause();
      return;
    }

    return self.select(slides[newIndex], 'prev');
  };

  self.removeSlide = function(slide) {
    var index = findSlideIndex(slide);

    //get the index of the slide inside the carousel
    slides.splice(index, 1);
    if (slides.length > 0 && currentIndex === index) {
      if (index >= slides.length) {
        currentIndex = slides.length - 1;
        $scope.active = currentIndex;
        setActive(currentIndex);
        self.select(slides[slides.length - 1]);
      } else {
        currentIndex = index;
        $scope.active = currentIndex;
        setActive(currentIndex);
        self.select(slides[index]);
      }
    } else if (currentIndex > index) {
      currentIndex--;
      $scope.active = currentIndex;
    }

    //clean the active value when no more slide
    if (slides.length === 0) {
      currentIndex = null;
      $scope.active = null;
    }
  };

  /* direction: "prev" or "next" */
  self.select = $scope.select = function(nextSlide, direction) {
    var nextIndex = findSlideIndex(nextSlide.slide);
    //Decide direction if it's not given
    if (direction === undefined) {
      direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
    }
    //Prevent this user-triggered transition from occurring if there is already one in progress
    if (nextSlide.slide.index !== currentIndex &&
      !$scope.$currentTransition) {
      goNext(nextSlide.slide, nextIndex, direction);
    }
  };

  /* Allow outside people to call indexOf on slides array */
  $scope.indexOfSlide = function(slide) {
    return +slide.slide.index;
  };

  $scope.isActive = function(slide) {
    return $scope.active === slide.slide.index;
  };

  $scope.isPrevDisabled = function() {
    return $scope.active === 0 && $scope.noWrap();
  };

  $scope.isNextDisabled = function() {
    return $scope.active === slides.length - 1 && $scope.noWrap();
  };

  $scope.pause = function() {
    if (!$scope.noPause) {
      isPlaying = false;
      resetTimer();
    }
  };

  $scope.play = function() {
    if (!isPlaying) {
      isPlaying = true;
      restartTimer();
    }
  };

  $element.on('mouseenter', $scope.pause);
  $element.on('mouseleave', $scope.play);

  $scope.$on('$destroy', function() {
    destroyed = true;
    resetTimer();
  });

  $scope.$watch('noTransition', function(noTransition) {
    $animate.enabled($element, !noTransition);
  });

  $scope.$watch('interval', restartTimer);

  $scope.$watchCollection('slides', resetTransition);

  $scope.$watch('active', function(index) {
    if (angular.isNumber(index) && currentIndex !== index) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].slide.index === index) {
          index = i;
          break;
        }
      }

      var slide = slides[index];
      if (slide) {
        setActive(index);
        self.select(slides[index]);
        currentIndex = index;
      }
    }
  });

  function getSlideByIndex(index) {
    for (var i = 0, l = slides.length; i < l; ++i) {
      if (slides[i].index === index) {
        return slides[i];
      }
    }
  }

  function setActive(index) {
    for (var i = 0; i < slides.length; i++) {
      slides[i].slide.active = i === index;
    }
  }

  function goNext(slide, index, direction) {
    if (destroyed) {
      return;
    }

    angular.extend(slide, {direction: direction});
    angular.extend(slides[currentIndex].slide || {}, {direction: direction});
    if ($animate.enabled($element) && !$scope.$currentTransition &&
      slides[index].element && self.slides.length > 1) {
      slides[index].element.data(SLIDE_DIRECTION, slide.direction);
      var currentIdx = self.getCurrentIndex();

      if (angular.isNumber(currentIdx) && slides[currentIdx].element) {
        slides[currentIdx].element.data(SLIDE_DIRECTION, slide.direction);
      }

      $scope.$currentTransition = true;
      $animate.on('addClass', slides[index].element, function(element, phase) {
        if (phase === 'close') {
          $scope.$currentTransition = null;
          $animate.off('addClass', element);
        }
      });
    }

    $scope.active = slide.index;
    currentIndex = slide.index;
    setActive(index);

    //every time you change slides, reset the timer
    restartTimer();
  }

  function findSlideIndex(slide) {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].slide === slide) {
        return i;
      }
    }
  }

  function resetTimer() {
    if (currentInterval) {
      $interval.cancel(currentInterval);
      currentInterval = null;
    }
  }

  function resetTransition(slides) {
    if (!slides.length) {
      $scope.$currentTransition = null;
    }
  }

  function restartTimer() {
    resetTimer();
    var interval = +$scope.interval;
    if (!isNaN(interval) && interval > 0) {
      currentInterval = $interval(timerFn, interval);
    }
  }

  function timerFn() {
    var interval = +$scope.interval;
    if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
      $scope.next();
    } else {
      $scope.pause();
    }
  }
}])

.directive('uibCarousel', function() {
  return {
    transclude: true,
    controller: 'UibCarouselController',
    controllerAs: 'carousel',
    restrict: 'A',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/carousel/carousel.html';
    },
    scope: {
      active: '=',
      interval: '=',
      noTransition: '=',
      noPause: '=',
      noWrap: '&'
    }
  };
})

.directive('uibSlide', ['$animate', function($animate) {
  return {
    require: '^uibCarousel',
    restrict: 'A',
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/carousel/slide.html';
    },
    scope: {
      actual: '=?',
      index: '=?'
    },
    link: function (scope, element, attrs, carouselCtrl) {
      element.addClass('item');
      carouselCtrl.addSlide(scope, element);
      //when the scope is destroyed then remove the slide from the current slides array
      scope.$on('$destroy', function() {
        carouselCtrl.removeSlide(scope);
      });

      scope.$watch('active', function(active) {
        $animate[active ? 'addClass' : 'removeClass'](element, 'active');
      });
    }
  };
}])

.animation('.item', ['$animateCss',
function($animateCss) {
  var SLIDE_DIRECTION = 'uib-slideDirection';

  function removeClass(element, className, callback) {
    element.removeClass(className);
    if (callback) {
      callback();
    }
  }

  return {
    beforeAddClass: function(element, className, done) {
      if (className === 'active') {
        var stopped = false;
        var direction = element.data(SLIDE_DIRECTION);
        var directionClass = direction === 'next' ? 'left' : 'right';
        var removeClassFn = removeClass.bind(this, element,
          directionClass + ' ' + direction, done);
        element.addClass(direction);

        $animateCss(element, {addClass: directionClass})
          .start()
          .done(removeClassFn);

        return function() {
          stopped = true;
        };
      }
      done();
    },
    beforeRemoveClass: function (element, className, done) {
      if (className === 'active') {
        var stopped = false;
        var direction = element.data(SLIDE_DIRECTION);
        var directionClass = direction === 'next' ? 'left' : 'right';
        var removeClassFn = removeClass.bind(this, element, directionClass, done);

        $animateCss(element, {addClass: directionClass})
          .start()
          .done(removeClassFn);

        return function() {
          stopped = true;
        };
      }
      done();
    }
  };
}]);

angular.module('ui.bootstrap.dateparser', [])

.service('uibDateParser', ['$log', '$locale', 'dateFilter', 'orderByFilter', 'filterFilter', function($log, $locale, dateFilter, orderByFilter, filterFilter) {
  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

  var localeId;
  var formatCodeToRegex;

  this.init = function() {
    localeId = $locale.id;

    this.parsers = {};
    this.formatters = {};

    formatCodeToRegex = [
      {
        key: 'yyyy',
        regex: '\\d{4}',
        apply: function(value) { this.year = +value; },
        formatter: function(date) {
          var _date = new Date();
          _date.setFullYear(Math.abs(date.getFullYear()));
          return dateFilter(_date, 'yyyy');
        }
      },
      {
        key: 'yy',
        regex: '\\d{2}',
        apply: function(value) { value = +value; this.year = value < 69 ? value + 2000 : value + 1900; },
        formatter: function(date) {
          var _date = new Date();
          _date.setFullYear(Math.abs(date.getFullYear()));
          return dateFilter(_date, 'yy');
        }
      },
      {
        key: 'y',
        regex: '\\d{1,4}',
        apply: function(value) { this.year = +value; },
        formatter: function(date) {
          var _date = new Date();
          _date.setFullYear(Math.abs(date.getFullYear()));
          return dateFilter(_date, 'y');
        }
      },
      {
        key: 'M!',
        regex: '0?[1-9]|1[0-2]',
        apply: function(value) { this.month = value - 1; },
        formatter: function(date) {
          var value = date.getMonth();
          if (/^[0-9]$/.test(value)) {
            return dateFilter(date, 'MM');
          }

          return dateFilter(date, 'M');
        }
      },
      {
        key: 'MMMM',
        regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
        apply: function(value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); },
        formatter: function(date) { return dateFilter(date, 'MMMM'); }
      },
      {
        key: 'MMM',
        regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
        apply: function(value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); },
        formatter: function(date) { return dateFilter(date, 'MMM'); }
      },
      {
        key: 'MM',
        regex: '0[1-9]|1[0-2]',
        apply: function(value) { this.month = value - 1; },
        formatter: function(date) { return dateFilter(date, 'MM'); }
      },
      {
        key: 'M',
        regex: '[1-9]|1[0-2]',
        apply: function(value) { this.month = value - 1; },
        formatter: function(date) { return dateFilter(date, 'M'); }
      },
      {
        key: 'd!',
        regex: '[0-2]?[0-9]{1}|3[0-1]{1}',
        apply: function(value) { this.date = +value; },
        formatter: function(date) {
          var value = date.getDate();
          if (/^[1-9]$/.test(value)) {
            return dateFilter(date, 'dd');
          }

          return dateFilter(date, 'd');
        }
      },
      {
        key: 'dd',
        regex: '[0-2][0-9]{1}|3[0-1]{1}',
        apply: function(value) { this.date = +value; },
        formatter: function(date) { return dateFilter(date, 'dd'); }
      },
      {
        key: 'd',
        regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
        apply: function(value) { this.date = +value; },
        formatter: function(date) { return dateFilter(date, 'd'); }
      },
      {
        key: 'EEEE',
        regex: $locale.DATETIME_FORMATS.DAY.join('|'),
        formatter: function(date) { return dateFilter(date, 'EEEE'); }
      },
      {
        key: 'EEE',
        regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
        formatter: function(date) { return dateFilter(date, 'EEE'); }
      },
      {
        key: 'HH',
        regex: '(?:0|1)[0-9]|2[0-3]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'HH'); }
      },
      {
        key: 'hh',
        regex: '0[0-9]|1[0-2]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'hh'); }
      },
      {
        key: 'H',
        regex: '1?[0-9]|2[0-3]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'H'); }
      },
      {
        key: 'h',
        regex: '[0-9]|1[0-2]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'h'); }
      },
      {
        key: 'mm',
        regex: '[0-5][0-9]',
        apply: function(value) { this.minutes = +value; },
        formatter: function(date) { return dateFilter(date, 'mm'); }
      },
      {
        key: 'm',
        regex: '[0-9]|[1-5][0-9]',
        apply: function(value) { this.minutes = +value; },
        formatter: function(date) { return dateFilter(date, 'm'); }
      },
      {
        key: 'sss',
        regex: '[0-9][0-9][0-9]',
        apply: function(value) { this.milliseconds = +value; },
        formatter: function(date) { return dateFilter(date, 'sss'); }
      },
      {
        key: 'ss',
        regex: '[0-5][0-9]',
        apply: function(value) { this.seconds = +value; },
        formatter: function(date) { return dateFilter(date, 'ss'); }
      },
      {
        key: 's',
        regex: '[0-9]|[1-5][0-9]',
        apply: function(value) { this.seconds = +value; },
        formatter: function(date) { return dateFilter(date, 's'); }
      },
      {
        key: 'a',
        regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
        apply: function(value) {
          if (this.hours === 12) {
            this.hours = 0;
          }

          if (value === 'PM') {
            this.hours += 12;
          }
        },
        formatter: function(date) { return dateFilter(date, 'a'); }
      },
      {
        key: 'Z',
        regex: '[+-]\\d{4}',
        apply: function(value) {
          var matches = value.match(/([+-])(\d{2})(\d{2})/),
            sign = matches[1],
            hours = matches[2],
            minutes = matches[3];
          this.hours += toInt(sign + hours);
          this.minutes += toInt(sign + minutes);
        },
        formatter: function(date) {
          return dateFilter(date, 'Z');
        }
      },
      {
        key: 'ww',
        regex: '[0-4][0-9]|5[0-3]',
        formatter: function(date) { return dateFilter(date, 'ww'); }
      },
      {
        key: 'w',
        regex: '[0-9]|[1-4][0-9]|5[0-3]',
        formatter: function(date) { return dateFilter(date, 'w'); }
      },
      {
        key: 'GGGG',
        regex: $locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\s/g, '\\s'),
        formatter: function(date) { return dateFilter(date, 'GGGG'); }
      },
      {
        key: 'GGG',
        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
        formatter: function(date) { return dateFilter(date, 'GGG'); }
      },
      {
        key: 'GG',
        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
        formatter: function(date) { return dateFilter(date, 'GG'); }
      },
      {
        key: 'G',
        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
        formatter: function(date) { return dateFilter(date, 'G'); }
      }
    ];

    if (angular.version.major >= 1 && angular.version.minor > 4) {
      formatCodeToRegex.push({
        key: 'LLLL',
        regex: $locale.DATETIME_FORMATS.STANDALONEMONTH.join('|'),
        apply: function(value) { this.month = $locale.DATETIME_FORMATS.STANDALONEMONTH.indexOf(value); },
        formatter: function(date) { return dateFilter(date, 'LLLL'); }
      });
    }
  };

  this.init();

  function getFormatCodeToRegex(key) {
    return filterFilter(formatCodeToRegex, {key: key}, true)[0];
  }

  this.getParser = function (key) {
    var f = getFormatCodeToRegex(key);
    return f && f.apply || null;
  };

  this.overrideParser = function (key, parser) {
    var f = getFormatCodeToRegex(key);
    if (f && angular.isFunction(parser)) {
      this.parsers = {};
      f.apply = parser;
    }
  }.bind(this);

  function createParser(format) {
    var map = [], regex = format.split('');

    // check for literal values
    var quoteIndex = format.indexOf('\'');
    if (quoteIndex > -1) {
      var inLiteral = false;
      format = format.split('');
      for (var i = quoteIndex; i < format.length; i++) {
        if (inLiteral) {
          if (format[i] === '\'') {
            if (i + 1 < format.length && format[i+1] === '\'') { // escaped single quote
              format[i+1] = '$';
              regex[i+1] = '';
            } else { // end of literal
              regex[i] = '';
              inLiteral = false;
            }
          }
          format[i] = '$';
        } else {
          if (format[i] === '\'') { // start of literal
            format[i] = '$';
            regex[i] = '';
            inLiteral = true;
          }
        }
      }

      format = format.join('');
    }

    angular.forEach(formatCodeToRegex, function(data) {
      var index = format.indexOf(data.key);

      if (index > -1) {
        format = format.split('');

        regex[index] = '(' + data.regex + ')';
        format[index] = '$'; // Custom symbol to define consumed part of format
        for (var i = index + 1, n = index + data.key.length; i < n; i++) {
          regex[i] = '';
          format[i] = '$';
        }
        format = format.join('');

        map.push({
          index: index,
          key: data.key,
          apply: data.apply,
          matcher: data.regex
        });
      }
    });

    return {
      regex: new RegExp('^' + regex.join('') + '$'),
      map: orderByFilter(map, 'index')
    };
  }

  function createFormatter(format) {
    var formatters = [];
    var i = 0;
    var formatter, literalIdx;
    while (i < format.length) {
      if (angular.isNumber(literalIdx)) {
        if (format.charAt(i) === '\'') {
          if (i + 1 >= format.length || format.charAt(i + 1) !== '\'') {
            formatters.push(constructLiteralFormatter(format, literalIdx, i));
            literalIdx = null;
          }
        } else if (i === format.length) {
          while (literalIdx < format.length) {
            formatter = constructFormatterFromIdx(format, literalIdx);
            formatters.push(formatter);
            literalIdx = formatter.endIdx;
          }
        }

        i++;
        continue;
      }

      if (format.charAt(i) === '\'') {
        literalIdx = i;
        i++;
        continue;
      }

      formatter = constructFormatterFromIdx(format, i);

      formatters.push(formatter.parser);
      i = formatter.endIdx;
    }

    return formatters;
  }

  function constructLiteralFormatter(format, literalIdx, endIdx) {
    return function() {
      return format.substr(literalIdx + 1, endIdx - literalIdx - 1);
    };
  }

  function constructFormatterFromIdx(format, i) {
    var currentPosStr = format.substr(i);
    for (var j = 0; j < formatCodeToRegex.length; j++) {
      if (new RegExp('^' + formatCodeToRegex[j].key).test(currentPosStr)) {
        var data = formatCodeToRegex[j];
        return {
          endIdx: i + data.key.length,
          parser: data.formatter
        };
      }
    }

    return {
      endIdx: i + 1,
      parser: function() {
        return currentPosStr.charAt(0);
      }
    };
  }

  this.filter = function(date, format) {
    if (!angular.isDate(date) || isNaN(date) || !format) {
      return '';
    }

    format = $locale.DATETIME_FORMATS[format] || format;

    if ($locale.id !== localeId) {
      this.init();
    }

    if (!this.formatters[format]) {
      this.formatters[format] = createFormatter(format);
    }

    var formatters = this.formatters[format];

    return formatters.reduce(function(str, formatter) {
      return str + formatter(date);
    }, '');
  };

  this.parse = function(input, format, baseDate) {
    if (!angular.isString(input) || !format) {
      return input;
    }

    format = $locale.DATETIME_FORMATS[format] || format;
    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');

    if ($locale.id !== localeId) {
      this.init();
    }

    if (!this.parsers[format]) {
      this.parsers[format] = createParser(format, 'apply');
    }

    var parser = this.parsers[format],
        regex = parser.regex,
        map = parser.map,
        results = input.match(regex),
        tzOffset = false;
    if (results && results.length) {
      var fields, dt;
      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
        fields = {
          year: baseDate.getFullYear(),
          month: baseDate.getMonth(),
          date: baseDate.getDate(),
          hours: baseDate.getHours(),
          minutes: baseDate.getMinutes(),
          seconds: baseDate.getSeconds(),
          milliseconds: baseDate.getMilliseconds()
        };
      } else {
        if (baseDate) {
          $log.warn('dateparser:', 'baseDate is not a valid date');
        }
        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
      }

      for (var i = 1, n = results.length; i < n; i++) {
        var mapper = map[i - 1];
        if (mapper.matcher === 'Z') {
          tzOffset = true;
        }

        if (mapper.apply) {
          mapper.apply.call(fields, results[i]);
        }
      }

      var datesetter = tzOffset ? Date.prototype.setUTCFullYear :
        Date.prototype.setFullYear;
      var timesetter = tzOffset ? Date.prototype.setUTCHours :
        Date.prototype.setHours;

      if (isValid(fields.year, fields.month, fields.date)) {
        if (angular.isDate(baseDate) && !isNaN(baseDate.getTime()) && !tzOffset) {
          dt = new Date(baseDate);
          datesetter.call(dt, fields.year, fields.month, fields.date);
          timesetter.call(dt, fields.hours, fields.minutes,
            fields.seconds, fields.milliseconds);
        } else {
          dt = new Date(0);
          datesetter.call(dt, fields.year, fields.month, fields.date);
          timesetter.call(dt, fields.hours || 0, fields.minutes || 0,
            fields.seconds || 0, fields.milliseconds || 0);
        }
      }

      return dt;
    }
  };

  // Check if date is valid for specific month (and year for February).
  // Month: 0 = Jan, 1 = Feb, etc
  function isValid(year, month, date) {
    if (date < 1) {
      return false;
    }

    if (month === 1 && date > 28) {
      return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
    }

    if (month === 3 || month === 5 || month === 8 || month === 10) {
      return date < 31;
    }

    return true;
  }

  function toInt(str) {
    return parseInt(str, 10);
  }

  this.toTimezone = toTimezone;
  this.fromTimezone = fromTimezone;
  this.timezoneToOffset = timezoneToOffset;
  this.addDateMinutes = addDateMinutes;
  this.convertTimezoneToLocal = convertTimezoneToLocal;

  function toTimezone(date, timezone) {
    return date && timezone ? convertTimezoneToLocal(date, timezone) : date;
  }

  function fromTimezone(date, timezone) {
    return date && timezone ? convertTimezoneToLocal(date, timezone, true) : date;
  }

  //https://github.com/angular/angular.js/blob/622c42169699ec07fc6daaa19fe6d224e5d2f70e/src/Angular.js#L1207
  function timezoneToOffset(timezone, fallback) {
    timezone = timezone.replace(/:/g, '');
    var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
    return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
  }

  function addDateMinutes(date, minutes) {
    date = new Date(date.getTime());
    date.setMinutes(date.getMinutes() + minutes);
    return date;
  }

  function convertTimezoneToLocal(date, timezone, reverse) {
    reverse = reverse ? -1 : 1;
    var dateTimezoneOffset = date.getTimezoneOffset();
    var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
    return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
  }
}]);

// Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to
// at most one element.
angular.module('ui.bootstrap.isClass', [])
.directive('uibIsClass', [
         '$animate',
function ($animate) {
  //                    11111111          22222222
  var ON_REGEXP = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/;
  //                    11111111           22222222
  var IS_REGEXP = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;

  var dataPerTracked = {};

  return {
    restrict: 'A',
    compile: function(tElement, tAttrs) {
      var linkedScopes = [];
      var instances = [];
      var expToData = {};
      var lastActivated = null;
      var onExpMatches = tAttrs.uibIsClass.match(ON_REGEXP);
      var onExp = onExpMatches[2];
      var expsStr = onExpMatches[1];
      var exps = expsStr.split(',');

      return linkFn;

      function linkFn(scope, element, attrs) {
        linkedScopes.push(scope);
        instances.push({
          scope: scope,
          element: element
        });

        exps.forEach(function(exp, k) {
          addForExp(exp, scope);
        });

        scope.$on('$destroy', removeScope);
      }

      function addForExp(exp, scope) {
        var matches = exp.match(IS_REGEXP);
        var clazz = scope.$eval(matches[1]);
        var compareWithExp = matches[2];
        var data = expToData[exp];
        if (!data) {
          var watchFn = function(compareWithVal) {
            var newActivated = null;
            instances.some(function(instance) {
              var thisVal = instance.scope.$eval(onExp);
              if (thisVal === compareWithVal) {
                newActivated = instance;
                return true;
              }
            });
            if (data.lastActivated !== newActivated) {
              if (data.lastActivated) {
                $animate.removeClass(data.lastActivated.element, clazz);
              }
              if (newActivated) {
                $animate.addClass(newActivated.element, clazz);
              }
              data.lastActivated = newActivated;
            }
          };
          expToData[exp] = data = {
            lastActivated: null,
            scope: scope,
            watchFn: watchFn,
            compareWithExp: compareWithExp,
            watcher: scope.$watch(compareWithExp, watchFn)
          };
        }
        data.watchFn(scope.$eval(compareWithExp));
      }

      function removeScope(e) {
        var removedScope = e.targetScope;
        var index = linkedScopes.indexOf(removedScope);
        linkedScopes.splice(index, 1);
        instances.splice(index, 1);
        if (linkedScopes.length) {
          var newWatchScope = linkedScopes[0];
          angular.forEach(expToData, function(data) {
            if (data.scope === removedScope) {
              data.watcher = newWatchScope.$watch(data.compareWithExp, data.watchFn);
              data.scope = newWatchScope;
            }
          });
        } else {
          expToData = {};
        }
      }
    }
  };
}]);
angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.isClass'])

.value('$datepickerSuppressError', false)

.value('$datepickerLiteralWarning', true)

.constant('uibDatepickerConfig', {
  datepickerMode: 'day',
  formatDay: 'dd',
  formatMonth: 'MMMM',
  formatYear: 'yyyy',
  formatDayHeader: 'EEE',
  formatDayTitle: 'MMMM yyyy',
  formatMonthTitle: 'yyyy',
  maxDate: null,
  maxMode: 'year',
  minDate: null,
  minMode: 'day',
  monthColumns: 3,
  ngModelOptions: {},
  shortcutPropagation: false,
  showWeeks: true,
  yearColumns: 5,
  yearRows: 4
})

.controller('UibDatepickerController', ['$scope', '$element', '$attrs', '$parse', '$interpolate', '$locale', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerLiteralWarning', '$datepickerSuppressError', 'uibDateParser',
  function($scope, $element, $attrs, $parse, $interpolate, $locale, $log, dateFilter, datepickerConfig, $datepickerLiteralWarning, $datepickerSuppressError, dateParser) {
  var self = this,
      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl;
      ngModelOptions = {},
      watchListeners = [];

  $element.addClass('uib-datepicker');
  $attrs.$set('role', 'application');

  if (!$scope.datepickerOptions) {
    $scope.datepickerOptions = {};
  }

  // Modes chain
  this.modes = ['day', 'month', 'year'];

  [
    'customClass',
    'dateDisabled',
    'datepickerMode',
    'formatDay',
    'formatDayHeader',
    'formatDayTitle',
    'formatMonth',
    'formatMonthTitle',
    'formatYear',
    'maxDate',
    'maxMode',
    'minDate',
    'minMode',
    'monthColumns',
    'showWeeks',
    'shortcutPropagation',
    'startingDay',
    'yearColumns',
    'yearRows'
  ].forEach(function(key) {
    switch (key) {
      case 'customClass':
      case 'dateDisabled':
        $scope[key] = $scope.datepickerOptions[key] || angular.noop;
        break;
      case 'datepickerMode':
        $scope.datepickerMode = angular.isDefined($scope.datepickerOptions.datepickerMode) ?
          $scope.datepickerOptions.datepickerMode : datepickerConfig.datepickerMode;
        break;
      case 'formatDay':
      case 'formatDayHeader':
      case 'formatDayTitle':
      case 'formatMonth':
      case 'formatMonthTitle':
      case 'formatYear':
        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
          $interpolate($scope.datepickerOptions[key])($scope.$parent) :
          datepickerConfig[key];
        break;
      case 'monthColumns':
      case 'showWeeks':
      case 'shortcutPropagation':
      case 'yearColumns':
      case 'yearRows':
        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
          $scope.datepickerOptions[key] : datepickerConfig[key];
        break;
      case 'startingDay':
        if (angular.isDefined($scope.datepickerOptions.startingDay)) {
          self.startingDay = $scope.datepickerOptions.startingDay;
        } else if (angular.isNumber(datepickerConfig.startingDay)) {
          self.startingDay = datepickerConfig.startingDay;
        } else {
          self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
        }

        break;
      case 'maxDate':
      case 'minDate':
        $scope.$watch('datepickerOptions.' + key, function(value) {
          if (value) {
            if (angular.isDate(value)) {
              self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.getOption('timezone'));
            } else {
              if ($datepickerLiteralWarning) {
                $log.warn('Literal date support has been deprecated, please switch to date object usage');
              }

              self[key] = new Date(dateFilter(value, 'medium'));
            }
          } else {
            self[key] = datepickerConfig[key] ?
              dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.getOption('timezone')) :
              null;
          }

          self.refreshView();
        });

        break;
      case 'maxMode':
      case 'minMode':
        if ($scope.datepickerOptions[key]) {
          $scope.$watch(function() { return $scope.datepickerOptions[key]; }, function(value) {
            self[key] = $scope[key] = angular.isDefined(value) ? value : $scope.datepickerOptions[key];
            if (key === 'minMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) < self.modes.indexOf(self[key]) ||
              key === 'maxMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) > self.modes.indexOf(self[key])) {
              $scope.datepickerMode = self[key];
              $scope.datepickerOptions.datepickerMode = self[key];
            }
          });
        } else {
          self[key] = $scope[key] = datepickerConfig[key] || null;
        }

        break;
    }
  });

  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);

  $scope.disabled = angular.isDefined($attrs.disabled) || false;
  if (angular.isDefined($attrs.ngDisabled)) {
    watchListeners.push($scope.$parent.$watch($attrs.ngDisabled, function(disabled) {
      $scope.disabled = disabled;
      self.refreshView();
    }));
  }

  $scope.isActive = function(dateObject) {
    if (self.compare(dateObject.date, self.activeDate) === 0) {
      $scope.activeDateId = dateObject.uid;
      return true;
    }
    return false;
  };

  this.init = function(ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;
    ngModelOptions = extractOptions(ngModelCtrl);

    if ($scope.datepickerOptions.initDate) {
      self.activeDate = dateParser.fromTimezone($scope.datepickerOptions.initDate, ngModelOptions.getOption('timezone')) || new Date();
      $scope.$watch('datepickerOptions.initDate', function(initDate) {
        if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
          self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.getOption('timezone'));
          self.refreshView();
        }
      });
    } else {
      self.activeDate = new Date();
    }

    var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : new Date();
    this.activeDate = !isNaN(date) ?
      dateParser.fromTimezone(date, ngModelOptions.getOption('timezone')) :
      dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));

    ngModelCtrl.$render = function() {
      self.render();
    };
  };

  this.render = function() {
    if (ngModelCtrl.$viewValue) {
      var date = new Date(ngModelCtrl.$viewValue),
          isValid = !isNaN(date);

      if (isValid) {
        this.activeDate = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
      } else if (!$datepickerSuppressError) {
        $log.error('Datepicker directive: "ng-model" value must be a Date object');
      }
    }
    this.refreshView();
  };

  this.refreshView = function() {
    if (this.element) {
      $scope.selectedDt = null;
      this._refreshView();
      if ($scope.activeDt) {
        $scope.activeDateId = $scope.activeDt.uid;
      }

      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
      date = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
      ngModelCtrl.$setValidity('dateDisabled', !date ||
        this.element && !this.isDisabled(date));
    }
  };

  this.createDateObject = function(date, format) {
    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
    model = dateParser.fromTimezone(model, ngModelOptions.getOption('timezone'));
    var today = new Date();
    today = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
    var time = this.compare(date, today);
    var dt = {
      date: date,
      label: dateParser.filter(date, format),
      selected: model && this.compare(date, model) === 0,
      disabled: this.isDisabled(date),
      past: time < 0,
      current: time === 0,
      future: time > 0,
      customClass: this.customClass(date) || null
    };

    if (model && this.compare(date, model) === 0) {
      $scope.selectedDt = dt;
    }

    if (self.activeDate && this.compare(dt.date, self.activeDate) === 0) {
      $scope.activeDt = dt;
    }

    return dt;
  };

  this.isDisabled = function(date) {
    return $scope.disabled ||
      this.minDate && this.compare(date, this.minDate) < 0 ||
      this.maxDate && this.compare(date, this.maxDate) > 0 ||
      $scope.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode});
  };

  this.customClass = function(date) {
    return $scope.customClass({date: date, mode: $scope.datepickerMode});
  };

  // Split array into smaller arrays
  this.split = function(arr, size) {
    var arrays = [];
    while (arr.length > 0) {
      arrays.push(arr.splice(0, size));
    }
    return arrays;
  };

  $scope.select = function(date) {
    if ($scope.datepickerMode === self.minMode) {
      var dt = ngModelCtrl.$viewValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue), ngModelOptions.getOption('timezone')) : new Date(0, 0, 0, 0, 0, 0, 0);
      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
      dt = dateParser.toTimezone(dt, ngModelOptions.getOption('timezone'));
      ngModelCtrl.$setViewValue(dt);
      ngModelCtrl.$render();
    } else {
      self.activeDate = date;
      setMode(self.modes[self.modes.indexOf($scope.datepickerMode) - 1]);

      $scope.$emit('uib:datepicker.mode');
    }

    $scope.$broadcast('uib:datepicker.focus');
  };

  $scope.move = function(direction) {
    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
    self.activeDate.setFullYear(year, month, 1);
    self.refreshView();
  };

  $scope.toggleMode = function(direction) {
    direction = direction || 1;

    if ($scope.datepickerMode === self.maxMode && direction === 1 ||
      $scope.datepickerMode === self.minMode && direction === -1) {
      return;
    }

    setMode(self.modes[self.modes.indexOf($scope.datepickerMode) + direction]);

    $scope.$emit('uib:datepicker.mode');
  };

  // Key event mapper
  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };

  var focusElement = function() {
    self.element[0].focus();
  };

  // Listen for focus requests from popup directive
  $scope.$on('uib:datepicker.focus', focusElement);

  $scope.keydown = function(evt) {
    var key = $scope.keys[evt.which];

    if (!key || evt.shiftKey || evt.altKey || $scope.disabled) {
      return;
    }

    evt.preventDefault();
    if (!self.shortcutPropagation) {
      evt.stopPropagation();
    }

    if (key === 'enter' || key === 'space') {
      if (self.isDisabled(self.activeDate)) {
        return; // do nothing
      }
      $scope.select(self.activeDate);
    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
      $scope.toggleMode(key === 'up' ? 1 : -1);
    } else {
      self.handleKeyDown(key, evt);
      self.refreshView();
    }
  };

  $element.on('keydown', function(evt) {
    $scope.$apply(function() {
      $scope.keydown(evt);
    });
  });

  $scope.$on('$destroy', function() {
    //Clear all watch listeners on destroy
    while (watchListeners.length) {
      watchListeners.shift()();
    }
  });

  function setMode(mode) {
    $scope.datepickerMode = mode;
    $scope.datepickerOptions.datepickerMode = mode;
  }

  function extractOptions(ngModelCtrl) {
    var ngModelOptions;

    if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
      // guarantee a value
      ngModelOptions = ngModelCtrl.$options ||
        $scope.datepickerOptions.ngModelOptions ||
        datepickerConfig.ngModelOptions ||
        {};

      // mimic 1.6+ api
      ngModelOptions.getOption = function (key) {
        return ngModelOptions[key];
      };
    } else { // in angular >=1.6 $options is always present
      // ng-model-options defaults timezone to null; don't let its precedence squash a non-null value
      var timezone = ngModelCtrl.$options.getOption('timezone') ||
        ($scope.datepickerOptions.ngModelOptions ? $scope.datepickerOptions.ngModelOptions.timezone : null) ||
        (datepickerConfig.ngModelOptions ? datepickerConfig.ngModelOptions.timezone : null);

      // values passed to createChild override existing values
      ngModelOptions = ngModelCtrl.$options // start with a ModelOptions instance
        .createChild(datepickerConfig.ngModelOptions) // lowest precedence
        .createChild($scope.datepickerOptions.ngModelOptions)
        .createChild(ngModelCtrl.$options) // highest precedence
        .createChild({timezone: timezone}); // to keep from squashing a non-null value
    }

    return ngModelOptions;
  }
}])

.controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
  var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  this.step = { months: 1 };
  this.element = $element;
  function getDaysInMonth(year, month) {
    return month === 1 && year % 4 === 0 &&
      (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
  }

  this.init = function(ctrl) {
    angular.extend(ctrl, this);
    scope.showWeeks = ctrl.showWeeks;
    ctrl.refreshView();
  };

  this.getDates = function(startDate, n) {
    var dates = new Array(n), current = new Date(startDate), i = 0, date;
    while (i < n) {
      date = new Date(current);
      dates[i++] = date;
      current.setDate(current.getDate() + 1);
    }
    return dates;
  };

  this._refreshView = function() {
    var year = this.activeDate.getFullYear(),
      month = this.activeDate.getMonth(),
      firstDayOfMonth = new Date(this.activeDate);

    firstDayOfMonth.setFullYear(year, month, 1);

    var difference = this.startingDay - firstDayOfMonth.getDay(),
      numDisplayedFromPreviousMonth = difference > 0 ?
        7 - difference : - difference,
      firstDate = new Date(firstDayOfMonth);

    if (numDisplayedFromPreviousMonth > 0) {
      firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
    }

    // 42 is the number of days on a six-week calendar
    var days = this.getDates(firstDate, 42);
    for (var i = 0; i < 42; i ++) {
      days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
        secondary: days[i].getMonth() !== month,
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.labels = new Array(7);
    for (var j = 0; j < 7; j++) {
      scope.labels[j] = {
        abbr: dateFilter(days[j].date, this.formatDayHeader),
        full: dateFilter(days[j].date, 'EEEE')
      };
    }

    scope.title = dateFilter(this.activeDate, this.formatDayTitle);
    scope.rows = this.split(days, 7);

    if (scope.showWeeks) {
      scope.weekNumbers = [];
      var thursdayIndex = (4 + 7 - this.startingDay) % 7,
          numWeeks = scope.rows.length;
      for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
        scope.weekNumbers.push(
          getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
      }
    }
  };

  this.compare = function(date1, date2) {
    var _date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    var _date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
    _date1.setFullYear(date1.getFullYear());
    _date2.setFullYear(date2.getFullYear());
    return _date1 - _date2;
  };

  function getISO8601WeekNumber(date) {
    var checkDate = new Date(date);
    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
    var time = checkDate.getTime();
    checkDate.setMonth(0); // Compare with Jan 1
    checkDate.setDate(1);
    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
  }

  this.handleKeyDown = function(key, evt) {
    var date = this.activeDate.getDate();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - 7;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + 7;
    } else if (key === 'pageup' || key === 'pagedown') {
      var month = this.activeDate.getMonth() + (key === 'pageup' ? - 1 : 1);
      this.activeDate.setMonth(month, 1);
      date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
    } else if (key === 'home') {
      date = 1;
    } else if (key === 'end') {
      date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
    }
    this.activeDate.setDate(date);
  };
}])

.controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
  this.step = { years: 1 };
  this.element = $element;

  this.init = function(ctrl) {
    angular.extend(ctrl, this);
    ctrl.refreshView();
  };

  this._refreshView = function() {
    var months = new Array(12),
        year = this.activeDate.getFullYear(),
        date;

    for (var i = 0; i < 12; i++) {
      date = new Date(this.activeDate);
      date.setFullYear(year, i, 1);
      months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
    scope.rows = this.split(months, this.monthColumns);
    scope.yearHeaderColspan = this.monthColumns > 3 ? this.monthColumns - 2 : 1;
  };

  this.compare = function(date1, date2) {
    var _date1 = new Date(date1.getFullYear(), date1.getMonth());
    var _date2 = new Date(date2.getFullYear(), date2.getMonth());
    _date1.setFullYear(date1.getFullYear());
    _date2.setFullYear(date2.getFullYear());
    return _date1 - _date2;
  };

  this.handleKeyDown = function(key, evt) {
    var date = this.activeDate.getMonth();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - this.monthColumns;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + this.monthColumns;
    } else if (key === 'pageup' || key === 'pagedown') {
      var year = this.activeDate.getFullYear() + (key === 'pageup' ? - 1 : 1);
      this.activeDate.setFullYear(year);
    } else if (key === 'home') {
      date = 0;
    } else if (key === 'end') {
      date = 11;
    }
    this.activeDate.setMonth(date);
  };
}])

.controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
  var columns, range;
  this.element = $element;

  function getStartingYear(year) {
    return parseInt((year - 1) / range, 10) * range + 1;
  }

  this.yearpickerInit = function() {
    columns = this.yearColumns;
    range = this.yearRows * columns;
    this.step = { years: range };
  };

  this._refreshView = function() {
    var years = new Array(range), date;

    for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
      date = new Date(this.activeDate);
      date.setFullYear(start + i, 0, 1);
      years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.title = [years[0].label, years[range - 1].label].join(' - ');
    scope.rows = this.split(years, columns);
    scope.columns = columns;
  };

  this.compare = function(date1, date2) {
    return date1.getFullYear() - date2.getFullYear();
  };

  this.handleKeyDown = function(key, evt) {
    var date = this.activeDate.getFullYear();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - columns;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + columns;
    } else if (key === 'pageup' || key === 'pagedown') {
      date += (key === 'pageup' ? - 1 : 1) * range;
    } else if (key === 'home') {
      date = getStartingYear(this.activeDate.getFullYear());
    } else if (key === 'end') {
      date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
    }
    this.activeDate.setFullYear(date);
  };
}])

.directive('uibDatepicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/datepicker.html';
    },
    scope: {
      datepickerOptions: '=?'
    },
    require: ['uibDatepicker', '^ngModel'],
    restrict: 'A',
    controller: 'UibDatepickerController',
    controllerAs: 'datepicker',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      datepickerCtrl.init(ngModelCtrl);
    }
  };
})

.directive('uibDaypicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/day.html';
    },
    require: ['^uibDatepicker', 'uibDaypicker'],
    restrict: 'A',
    controller: 'UibDaypickerController',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0],
        daypickerCtrl = ctrls[1];

      daypickerCtrl.init(datepickerCtrl);
    }
  };
})

.directive('uibMonthpicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/month.html';
    },
    require: ['^uibDatepicker', 'uibMonthpicker'],
    restrict: 'A',
    controller: 'UibMonthpickerController',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0],
        monthpickerCtrl = ctrls[1];

      monthpickerCtrl.init(datepickerCtrl);
    }
  };
})

.directive('uibYearpicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/year.html';
    },
    require: ['^uibDatepicker', 'uibYearpicker'],
    restrict: 'A',
    controller: 'UibYearpickerController',
    link: function(scope, element, attrs, ctrls) {
      var ctrl = ctrls[0];
      angular.extend(ctrl, ctrls[1]);
      ctrl.yearpickerInit();

      ctrl.refreshView();
    }
  };
});

angular.module('ui.bootstrap.position', [])

/**
 * A set of utility methods for working with the DOM.
 * It is meant to be used where we need to absolute-position elements in
 * relation to another element (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */
  .factory('$uibPosition', ['$document', '$window', function($document, $window) {
    /**
     * Used by scrollbarWidth() function to cache scrollbar's width.
     * Do not access this variable directly, use scrollbarWidth() instead.
     */
    var SCROLLBAR_WIDTH;
    /**
     * scrollbar on body and html element in IE and Edge overlay
     * content and should be considered 0 width.
     */
    var BODY_SCROLLBAR_WIDTH;
    var OVERFLOW_REGEX = {
      normal: /(auto|scroll)/,
      hidden: /(auto|scroll|hidden)/
    };
    var PLACEMENT_REGEX = {
      auto: /\s?auto?\s?/i,
      primary: /^(top|bottom|left|right)$/,
      secondary: /^(top|bottom|left|right|center)$/,
      vertical: /^(top|bottom)$/
    };
    var BODY_REGEX = /(HTML|BODY)/;

    return {

      /**
       * Provides a raw DOM element from a jQuery/jQLite element.
       *
       * @param {element} elem - The element to convert.
       *
       * @returns {element} A HTML element.
       */
      getRawNode: function(elem) {
        return elem.nodeName ? elem : elem[0] || elem;
      },

      /**
       * Provides a parsed number for a style property.  Strips
       * units and casts invalid numbers to 0.
       *
       * @param {string} value - The style value to parse.
       *
       * @returns {number} A valid number.
       */
      parseStyle: function(value) {
        value = parseFloat(value);
        return isFinite(value) ? value : 0;
      },

      /**
       * Provides the closest positioned ancestor.
       *
       * @param {element} element - The element to get the offest parent for.
       *
       * @returns {element} The closest positioned ancestor.
       */
      offsetParent: function(elem) {
        elem = this.getRawNode(elem);

        var offsetParent = elem.offsetParent || $document[0].documentElement;

        function isStaticPositioned(el) {
          return ($window.getComputedStyle(el).position || 'static') === 'static';
        }

        while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
          offsetParent = offsetParent.offsetParent;
        }

        return offsetParent || $document[0].documentElement;
      },

      /**
       * Provides the scrollbar width, concept from TWBS measureScrollbar()
       * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
       * In IE and Edge, scollbar on body and html element overlay and should
       * return a width of 0.
       *
       * @returns {number} The width of the browser scollbar.
       */
      scrollbarWidth: function(isBody) {
        if (isBody) {
          if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
            var bodyElem = $document.find('body');
            bodyElem.addClass('uib-position-body-scrollbar-measure');
            BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
            BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
            bodyElem.removeClass('uib-position-body-scrollbar-measure');
          }
          return BODY_SCROLLBAR_WIDTH;
        }

        if (angular.isUndefined(SCROLLBAR_WIDTH)) {
          var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
          $document.find('body').append(scrollElem);
          SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
          SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
          scrollElem.remove();
        }

        return SCROLLBAR_WIDTH;
      },

      /**
       * Provides the padding required on an element to replace the scrollbar.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**scrollbarWidth**: the width of the scrollbar</li>
       *     <li>**widthOverflow**: whether the the width is overflowing</li>
       *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
       *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
       *     <li>**heightOverflow**: whether the the height is overflowing</li>
       *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
       *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
       *   </ul>
       */
      scrollbarPadding: function(elem) {
        elem = this.getRawNode(elem);

        var elemStyle = $window.getComputedStyle(elem);
        var paddingRight = this.parseStyle(elemStyle.paddingRight);
        var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
        var scrollParent = this.scrollParent(elem, false, true);
        var scrollbarWidth = this.scrollbarWidth(BODY_REGEX.test(scrollParent.tagName));

        return {
          scrollbarWidth: scrollbarWidth,
          widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
          right: paddingRight + scrollbarWidth,
          originalRight: paddingRight,
          heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
          bottom: paddingBottom + scrollbarWidth,
          originalBottom: paddingBottom
         };
      },

      /**
       * Checks to see if the element is scrollable.
       *
       * @param {element} elem - The element to check.
       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
       *   default is false.
       *
       * @returns {boolean} Whether the element is scrollable.
       */
      isScrollable: function(elem, includeHidden) {
        elem = this.getRawNode(elem);

        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
        var elemStyle = $window.getComputedStyle(elem);
        return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
      },

      /**
       * Provides the closest scrollable ancestor.
       * A port of the jQuery UI scrollParent method:
       * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
       *
       * @param {element} elem - The element to find the scroll parent of.
       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
       *   default is false.
       * @param {boolean=} [includeSelf=false] - Should the element being passed be
       * included in the scrollable llokup.
       *
       * @returns {element} A HTML element.
       */
      scrollParent: function(elem, includeHidden, includeSelf) {
        elem = this.getRawNode(elem);

        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
        var documentEl = $document[0].documentElement;
        var elemStyle = $window.getComputedStyle(elem);
        if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
          return elem;
        }
        var excludeStatic = elemStyle.position === 'absolute';
        var scrollParent = elem.parentElement || documentEl;

        if (scrollParent === documentEl || elemStyle.position === 'fixed') {
          return documentEl;
        }

        while (scrollParent.parentElement && scrollParent !== documentEl) {
          var spStyle = $window.getComputedStyle(scrollParent);
          if (excludeStatic && spStyle.position !== 'static') {
            excludeStatic = false;
          }

          if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
            break;
          }
          scrollParent = scrollParent.parentElement;
        }

        return scrollParent;
      },

      /**
       * Provides read-only equivalent of jQuery's position function:
       * http://api.jquery.com/position/ - distance to closest positioned
       * ancestor.  Does not account for margins by default like jQuery position.
       *
       * @param {element} elem - The element to caclulate the position on.
       * @param {boolean=} [includeMargins=false] - Should margins be accounted
       * for, default is false.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**width**: the width of the element</li>
       *     <li>**height**: the height of the element</li>
       *     <li>**top**: distance to top edge of offset parent</li>
       *     <li>**left**: distance to left edge of offset parent</li>
       *   </ul>
       */
      position: function(elem, includeMagins) {
        elem = this.getRawNode(elem);

        var elemOffset = this.offset(elem);
        if (includeMagins) {
          var elemStyle = $window.getComputedStyle(elem);
          elemOffset.top -= this.parseStyle(elemStyle.marginTop);
          elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
        }
        var parent = this.offsetParent(elem);
        var parentOffset = {top: 0, left: 0};

        if (parent !== $document[0].documentElement) {
          parentOffset = this.offset(parent);
          parentOffset.top += parent.clientTop - parent.scrollTop;
          parentOffset.left += parent.clientLeft - parent.scrollLeft;
        }

        return {
          width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
          height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
          top: Math.round(elemOffset.top - parentOffset.top),
          left: Math.round(elemOffset.left - parentOffset.left)
        };
      },

      /**
       * Provides read-only equivalent of jQuery's offset function:
       * http://api.jquery.com/offset/ - distance to viewport.  Does
       * not account for borders, margins, or padding on the body
       * element.
       *
       * @param {element} elem - The element to calculate the offset on.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**width**: the width of the element</li>
       *     <li>**height**: the height of the element</li>
       *     <li>**top**: distance to top edge of viewport</li>
       *     <li>**right**: distance to bottom edge of viewport</li>
       *   </ul>
       */
      offset: function(elem) {
        elem = this.getRawNode(elem);

        var elemBCR = elem.getBoundingClientRect();
        return {
          width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
          height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
          top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
          left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
        };
      },

      /**
       * Provides offset distance to the closest scrollable ancestor
       * or viewport.  Accounts for border and scrollbar width.
       *
       * Right and bottom dimensions represent the distance to the
       * respective edge of the viewport element.  If the element
       * edge extends beyond the viewport, a negative value will be
       * reported.
       *
       * @param {element} elem - The element to get the viewport offset for.
       * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
       * of the first scrollable element, default is false.
       * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
       * be accounted for, default is true.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**top**: distance to the top content edge of viewport element</li>
       *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
       *     <li>**left**: distance to the left content edge of viewport element</li>
       *     <li>**right**: distance to the right content edge of viewport element</li>
       *   </ul>
       */
      viewportOffset: function(elem, useDocument, includePadding) {
        elem = this.getRawNode(elem);
        includePadding = includePadding !== false ? true : false;

        var elemBCR = elem.getBoundingClientRect();
        var offsetBCR = {top: 0, left: 0, bottom: 0, right: 0};

        var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
        var offsetParentBCR = offsetParent.getBoundingClientRect();

        offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
        offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
        if (offsetParent === $document[0].documentElement) {
          offsetBCR.top += $window.pageYOffset;
          offsetBCR.left += $window.pageXOffset;
        }
        offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
        offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;

        if (includePadding) {
          var offsetParentStyle = $window.getComputedStyle(offsetParent);
          offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
          offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
          offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
          offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
        }

        return {
          top: Math.round(elemBCR.top - offsetBCR.top),
          bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
          left: Math.round(elemBCR.left - offsetBCR.left),
          right: Math.round(offsetBCR.right - elemBCR.right)
        };
      },

      /**
       * Provides an array of placement values parsed from a placement string.
       * Along with the 'auto' indicator, supported placement strings are:
       *   <ul>
       *     <li>top: element on top, horizontally centered on host element.</li>
       *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
       *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
       *     <li>bottom: element on bottom, horizontally centered on host element.</li>
       *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
       *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
       *     <li>left: element on left, vertically centered on host element.</li>
       *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
       *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
       *     <li>right: element on right, vertically centered on host element.</li>
       *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
       *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
       *   </ul>
       * A placement string with an 'auto' indicator is expected to be
       * space separated from the placement, i.e: 'auto bottom-left'  If
       * the primary and secondary placement values do not match 'top,
       * bottom, left, right' then 'top' will be the primary placement and
       * 'center' will be the secondary placement.  If 'auto' is passed, true
       * will be returned as the 3rd value of the array.
       *
       * @param {string} placement - The placement string to parse.
       *
       * @returns {array} An array with the following values
       * <ul>
       *   <li>**[0]**: The primary placement.</li>
       *   <li>**[1]**: The secondary placement.</li>
       *   <li>**[2]**: If auto is passed: true, else undefined.</li>
       * </ul>
       */
      parsePlacement: function(placement) {
        var autoPlace = PLACEMENT_REGEX.auto.test(placement);
        if (autoPlace) {
          placement = placement.replace(PLACEMENT_REGEX.auto, '');
        }

        placement = placement.split('-');

        placement[0] = placement[0] || 'top';
        if (!PLACEMENT_REGEX.primary.test(placement[0])) {
          placement[0] = 'top';
        }

        placement[1] = placement[1] || 'center';
        if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
          placement[1] = 'center';
        }

        if (autoPlace) {
          placement[2] = true;
        } else {
          placement[2] = false;
        }

        return placement;
      },

      /**
       * Provides coordinates for an element to be positioned relative to
       * another element.  Passing 'auto' as part of the placement parameter
       * will enable smart placement - where the element fits. i.e:
       * 'auto left-top' will check to see if there is enough space to the left
       * of the hostElem to fit the targetElem, if not place right (same for secondary
       * top placement).  Available space is calculated using the viewportOffset
       * function.
       *
       * @param {element} hostElem - The element to position against.
       * @param {element} targetElem - The element to position.
       * @param {string=} [placement=top] - The placement for the targetElem,
       *   default is 'top'. 'center' is assumed as secondary placement for
       *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
       *   <ul>
       *     <li>top</li>
       *     <li>top-right</li>
       *     <li>top-left</li>
       *     <li>bottom</li>
       *     <li>bottom-left</li>
       *     <li>bottom-right</li>
       *     <li>left</li>
       *     <li>left-top</li>
       *     <li>left-bottom</li>
       *     <li>right</li>
       *     <li>right-top</li>
       *     <li>right-bottom</li>
       *   </ul>
       * @param {boolean=} [appendToBody=false] - Should the top and left values returned
       *   be calculated from the body element, default is false.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**top**: Value for targetElem top.</li>
       *     <li>**left**: Value for targetElem left.</li>
       *     <li>**placement**: The resolved placement.</li>
       *   </ul>
       */
      positionElements: function(hostElem, targetElem, placement, appendToBody) {
        hostElem = this.getRawNode(hostElem);
        targetElem = this.getRawNode(targetElem);

        // need to read from prop to support tests.
        var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
        var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');

        placement = this.parsePlacement(placement);

        var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
        var targetElemPos = {top: 0, left: 0, placement: ''};

        if (placement[2]) {
          var viewportOffset = this.viewportOffset(hostElem, appendToBody);

          var targetElemStyle = $window.getComputedStyle(targetElem);
          var adjustedSize = {
            width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
            height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
          };

          placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' :
                         placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' :
                         placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' :
                         placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' :
                         placement[0];

          placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' :
                         placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' :
                         placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' :
                         placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' :
                         placement[1];

          if (placement[1] === 'center') {
            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
              var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
              if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
                placement[1] = 'left';
              } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
                placement[1] = 'right';
              }
            } else {
              var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
              if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
                placement[1] = 'top';
              } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
                placement[1] = 'bottom';
              }
            }
          }
        }

        switch (placement[0]) {
          case 'top':
            targetElemPos.top = hostElemPos.top - targetHeight;
            break;
          case 'bottom':
            targetElemPos.top = hostElemPos.top + hostElemPos.height;
            break;
          case 'left':
            targetElemPos.left = hostElemPos.left - targetWidth;
            break;
          case 'right':
            targetElemPos.left = hostElemPos.left + hostElemPos.width;
            break;
        }

        switch (placement[1]) {
          case 'top':
            targetElemPos.top = hostElemPos.top;
            break;
          case 'bottom':
            targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
            break;
          case 'left':
            targetElemPos.left = hostElemPos.left;
            break;
          case 'right':
            targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
            break;
          case 'center':
            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
              targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
            } else {
              targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
            }
            break;
        }

        targetElemPos.top = Math.round(targetElemPos.top);
        targetElemPos.left = Math.round(targetElemPos.left);
        targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];

        return targetElemPos;
      },

      /**
       * Provides a way to adjust the top positioning after first
       * render to correctly align element to top after content
       * rendering causes resized element height
       *
       * @param {array} placementClasses - The array of strings of classes
       * element should have.
       * @param {object} containerPosition - The object with container
       * position information
       * @param {number} initialHeight - The initial height for the elem.
       * @param {number} currentHeight - The current height for the elem.
       */
      adjustTop: function(placementClasses, containerPosition, initialHeight, currentHeight) {
        if (placementClasses.indexOf('top') !== -1 && initialHeight !== currentHeight) {
          return {
            top: containerPosition.top - currentHeight + 'px'
          };
        }
      },

      /**
       * Provides a way for positioning tooltip & dropdown
       * arrows when using placement options beyond the standard
       * left, right, top, or bottom.
       *
       * @param {element} elem - The tooltip/dropdown element.
       * @param {string} placement - The placement for the elem.
       */
      positionArrow: function(elem, placement) {
        elem = this.getRawNode(elem);

        var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
        if (!innerElem) {
          return;
        }

        var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');

        var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
        if (!arrowElem) {
          return;
        }

        var arrowCss = {
          top: '',
          bottom: '',
          left: '',
          right: ''
        };

        placement = this.parsePlacement(placement);
        if (placement[1] === 'center') {
          // no adjustment necessary - just reset styles
          angular.element(arrowElem).css(arrowCss);
          return;
        }

        var borderProp = 'border-' + placement[0] + '-width';
        var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];

        var borderRadiusProp = 'border-';
        if (PLACEMENT_REGEX.vertical.test(placement[0])) {
          borderRadiusProp += placement[0] + '-' + placement[1];
        } else {
          borderRadiusProp += placement[1] + '-' + placement[0];
        }
        borderRadiusProp += '-radius';
        var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];

        switch (placement[0]) {
          case 'top':
            arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'bottom':
            arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'left':
            arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'right':
            arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
            break;
        }

        arrowCss[placement[1]] = borderRadius;

        angular.element(arrowElem).css(arrowCss);
      }
    };
  }]);

angular.module('ui.bootstrap.datepickerPopup', ['ui.bootstrap.datepicker', 'ui.bootstrap.position'])

.value('$datepickerPopupLiteralWarning', true)

.constant('uibDatepickerPopupConfig', {
  altInputFormats: [],
  appendToBody: false,
  clearText: 'Clear',
  closeOnDateSelection: true,
  closeText: 'Done',
  currentText: 'Today',
  datepickerPopup: 'yyyy-MM-dd',
  datepickerPopupTemplateUrl: 'uib/template/datepickerPopup/popup.html',
  datepickerTemplateUrl: 'uib/template/datepicker/datepicker.html',
  html5Types: {
    date: 'yyyy-MM-dd',
    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
    'month': 'yyyy-MM'
  },
  onOpenFocus: true,
  showButtonBar: true,
  placement: 'auto bottom-left'
})

.controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$log', '$parse', '$window', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout', 'uibDatepickerConfig', '$datepickerPopupLiteralWarning',
function($scope, $element, $attrs, $compile, $log, $parse, $window, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout, datepickerConfig, $datepickerPopupLiteralWarning) {
  var cache = {},
    isHtml5DateInput = false;
  var dateFormat, closeOnDateSelection, appendToBody, onOpenFocus,
    datepickerPopupTemplateUrl, datepickerTemplateUrl, popupEl, datepickerEl, scrollParentEl,
    ngModel, ngModelOptions, $popup, altInputFormats, watchListeners = [];

  this.init = function(_ngModel_) {
    ngModel = _ngModel_;
    ngModelOptions = extractOptions(ngModel);
    closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ?
      $scope.$parent.$eval($attrs.closeOnDateSelection) :
      datepickerPopupConfig.closeOnDateSelection;
    appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ?
      $scope.$parent.$eval($attrs.datepickerAppendToBody) :
      datepickerPopupConfig.appendToBody;
    onOpenFocus = angular.isDefined($attrs.onOpenFocus) ?
      $scope.$parent.$eval($attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
    datepickerPopupTemplateUrl = angular.isDefined($attrs.datepickerPopupTemplateUrl) ?
      $attrs.datepickerPopupTemplateUrl :
      datepickerPopupConfig.datepickerPopupTemplateUrl;
    datepickerTemplateUrl = angular.isDefined($attrs.datepickerTemplateUrl) ?
      $attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
    altInputFormats = angular.isDefined($attrs.altInputFormats) ?
      $scope.$parent.$eval($attrs.altInputFormats) :
      datepickerPopupConfig.altInputFormats;

    $scope.showButtonBar = angular.isDefined($attrs.showButtonBar) ?
      $scope.$parent.$eval($attrs.showButtonBar) :
      datepickerPopupConfig.showButtonBar;

    if (datepickerPopupConfig.html5Types[$attrs.type]) {
      dateFormat = datepickerPopupConfig.html5Types[$attrs.type];
      isHtml5DateInput = true;
    } else {
      dateFormat = $attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
      $attrs.$observe('uibDatepickerPopup', function(value, oldValue) {
        var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
        // Invalidate the $modelValue to ensure that formatters re-run
        // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
        if (newDateFormat !== dateFormat) {
          dateFormat = newDateFormat;
          ngModel.$modelValue = null;

          if (!dateFormat) {
            throw new Error('uibDatepickerPopup must have a date format specified.');
          }
        }
      });
    }

    if (!dateFormat) {
      throw new Error('uibDatepickerPopup must have a date format specified.');
    }

    if (isHtml5DateInput && $attrs.uibDatepickerPopup) {
      throw new Error('HTML5 date input types do not support custom formats.');
    }

    // popup element used to display calendar
    popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');

    popupEl.attr({
      'ng-model': 'date',
      'ng-change': 'dateSelection(date)',
      'template-url': datepickerPopupTemplateUrl
    });

    // datepicker element
    datepickerEl = angular.element(popupEl.children()[0]);
    datepickerEl.attr('template-url', datepickerTemplateUrl);

    if (!$scope.datepickerOptions) {
      $scope.datepickerOptions = {};
    }

    if (isHtml5DateInput) {
      if ($attrs.type === 'month') {
        $scope.datepickerOptions.datepickerMode = 'month';
        $scope.datepickerOptions.minMode = 'month';
      }
    }

    datepickerEl.attr('datepicker-options', 'datepickerOptions');

    if (!isHtml5DateInput) {
      // Internal API to maintain the correct ng-invalid-[key] class
      ngModel.$$parserName = 'date';
      ngModel.$validators.date = validator;
      ngModel.$parsers.unshift(parseDate);
      ngModel.$formatters.push(function(value) {
        if (ngModel.$isEmpty(value)) {
          $scope.date = value;
          return value;
        }

        if (angular.isNumber(value)) {
          value = new Date(value);
        }

        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));

        return dateParser.filter($scope.date, dateFormat);
      });
    } else {
      ngModel.$formatters.push(function(value) {
        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));
        return value;
      });
    }

    // Detect changes in the view from the text box
    ngModel.$viewChangeListeners.push(function() {
      $scope.date = parseDateString(ngModel.$viewValue);
    });

    $element.on('keydown', inputKeydownBind);

    $popup = $compile(popupEl)($scope);
    // Prevent jQuery cache memory leak (template is now redundant after linking)
    popupEl.remove();

    if (appendToBody) {
      $document.find('body').append($popup);
    } else {
      $element.after($popup);
    }

    $scope.$on('$destroy', function() {
      if ($scope.isOpen === true) {
        if (!$rootScope.$$phase) {
          $scope.$apply(function() {
            $scope.isOpen = false;
          });
        }
      }

      $popup.remove();
      $element.off('keydown', inputKeydownBind);
      $document.off('click', documentClickBind);
      if (scrollParentEl) {
        scrollParentEl.off('scroll', positionPopup);
      }
      angular.element($window).off('resize', positionPopup);

      //Clear all watch listeners on destroy
      while (watchListeners.length) {
        watchListeners.shift()();
      }
    });
  };

  $scope.getText = function(key) {
    return $scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
  };

  $scope.isDisabled = function(date) {
    if (date === 'today') {
      date = dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));
    }

    var dates = {};
    angular.forEach(['minDate', 'maxDate'], function(key) {
      if (!$scope.datepickerOptions[key]) {
        dates[key] = null;
      } else if (angular.isDate($scope.datepickerOptions[key])) {
        dates[key] = new Date($scope.datepickerOptions[key]);
      } else {
        if ($datepickerPopupLiteralWarning) {
          $log.warn('Literal date support has been deprecated, please switch to date object usage');
        }

        dates[key] = new Date(dateFilter($scope.datepickerOptions[key], 'medium'));
      }
    });

    return $scope.datepickerOptions &&
      dates.minDate && $scope.compare(date, dates.minDate) < 0 ||
      dates.maxDate && $scope.compare(date, dates.maxDate) > 0;
  };

  $scope.compare = function(date1, date2) {
    return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
  };

  // Inner change
  $scope.dateSelection = function(dt) {
    $scope.date = dt;
    var date = $scope.date ? dateParser.filter($scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
    $element.val(date);
    ngModel.$setViewValue(date);

    if (closeOnDateSelection) {
      $scope.isOpen = false;
      $element[0].focus();
    }
  };

  $scope.keydown = function(evt) {
    if (evt.which === 27) {
      evt.stopPropagation();
      $scope.isOpen = false;
      $element[0].focus();
    }
  };

  $scope.select = function(date, evt) {
    evt.stopPropagation();

    if (date === 'today') {
      var today = new Date();
      if (angular.isDate($scope.date)) {
        date = new Date($scope.date);
        date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
      } else {
        date = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
        date.setHours(0, 0, 0, 0);
      }
    }
    $scope.dateSelection(date);
  };

  $scope.close = function(evt) {
    evt.stopPropagation();

    $scope.isOpen = false;
    $element[0].focus();
  };

  $scope.disabled = angular.isDefined($attrs.disabled) || false;
  if ($attrs.ngDisabled) {
    watchListeners.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(disabled) {
      $scope.disabled = disabled;
    }));
  }

  $scope.$watch('isOpen', function(value) {
    if (value) {
      if (!$scope.disabled) {
        $timeout(function() {
          positionPopup();

          if (onOpenFocus) {
            $scope.$broadcast('uib:datepicker.focus');
          }

          $document.on('click', documentClickBind);

          var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
          if (appendToBody || $position.parsePlacement(placement)[2]) {
            scrollParentEl = scrollParentEl || angular.element($position.scrollParent($element));
            if (scrollParentEl) {
              scrollParentEl.on('scroll', positionPopup);
            }
          } else {
            scrollParentEl = null;
          }

          angular.element($window).on('resize', positionPopup);
        }, 0, false);
      } else {
        $scope.isOpen = false;
      }
    } else {
      $document.off('click', documentClickBind);
      if (scrollParentEl) {
        scrollParentEl.off('scroll', positionPopup);
      }
      angular.element($window).off('resize', positionPopup);
    }
  });

  function cameltoDash(string) {
    return string.replace(/([A-Z])/g, function($1) { return '-' + $1.toLowerCase(); });
  }

  function parseDateString(viewValue) {
    var date = dateParser.parse(viewValue, dateFormat, $scope.date);
    if (isNaN(date)) {
      for (var i = 0; i < altInputFormats.length; i++) {
        date = dateParser.parse(viewValue, altInputFormats[i], $scope.date);
        if (!isNaN(date)) {
          return date;
        }
      }
    }
    return date;
  }

  function parseDate(viewValue) {
    if (angular.isNumber(viewValue)) {
      // presumably timestamp to date object
      viewValue = new Date(viewValue);
    }

    if (!viewValue) {
      return null;
    }

    if (angular.isDate(viewValue) && !isNaN(viewValue)) {
      return viewValue;
    }

    if (angular.isString(viewValue)) {
      var date = parseDateString(viewValue);
      if (!isNaN(date)) {
        return dateParser.toTimezone(date, ngModelOptions.getOption('timezone'));
      }
    }

    return ngModelOptions.getOption('allowInvalid') ? viewValue : undefined;
  }

  function validator(modelValue, viewValue) {
    var value = modelValue || viewValue;

    if (!$attrs.ngRequired && !value) {
      return true;
    }

    if (angular.isNumber(value)) {
      value = new Date(value);
    }

    if (!value) {
      return true;
    }

    if (angular.isDate(value) && !isNaN(value)) {
      return true;
    }

    if (angular.isString(value)) {
      return !isNaN(parseDateString(value));
    }

    return false;
  }

  function documentClickBind(event) {
    if (!$scope.isOpen && $scope.disabled) {
      return;
    }

    var popup = $popup[0];
    var dpContainsTarget = $element[0].contains(event.target);
    // The popup node may not be an element node
    // In some browsers (IE) only element nodes have the 'contains' function
    var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
    if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
      $scope.$apply(function() {
        $scope.isOpen = false;
      });
    }
  }

  function inputKeydownBind(evt) {
    if (evt.which === 27 && $scope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.$apply(function() {
        $scope.isOpen = false;
      });
      $element[0].focus();
    } else if (evt.which === 40 && !$scope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.$apply(function() {
        $scope.isOpen = true;
      });
    }
  }

  function positionPopup() {
    if ($scope.isOpen) {
      var dpElement = angular.element($popup[0].querySelector('.uib-datepicker-popup'));
      var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
      var position = $position.positionElements($element, dpElement, placement, appendToBody);
      dpElement.css({top: position.top + 'px', left: position.left + 'px'});
      if (dpElement.hasClass('uib-position-measure')) {
        dpElement.removeClass('uib-position-measure');
      }
    }
  }

  function extractOptions(ngModelCtrl) {
    var ngModelOptions;

    if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
      // guarantee a value
      ngModelOptions = angular.isObject(ngModelCtrl.$options) ?
        ngModelCtrl.$options :
        {
          timezone: null
        };

      // mimic 1.6+ api
      ngModelOptions.getOption = function (key) {
        return ngModelOptions[key];
      };
    } else { // in angular >=1.6 $options is always present
      ngModelOptions = ngModelCtrl.$options;
    }

    return ngModelOptions;
  }

  $scope.$on('uib:datepicker.mode', function() {
    $timeout(positionPopup, 0, false);
  });
}])

.directive('uibDatepickerPopup', function() {
  return {
    require: ['ngModel', 'uibDatepickerPopup'],
    controller: 'UibDatepickerPopupController',
    scope: {
      datepickerOptions: '=?',
      isOpen: '=?',
      currentText: '@',
      clearText: '@',
      closeText: '@'
    },
    link: function(scope, element, attrs, ctrls) {
      var ngModel = ctrls[0],
        ctrl = ctrls[1];

      ctrl.init(ngModel);
    }
  };
})

.directive('uibDatepickerPopupWrap', function() {
  return {
    restrict: 'A',
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepickerPopup/popup.html';
    }
  };
});

angular.module('ui.bootstrap.debounce', [])
/**
 * A helper, internal service that debounces a function
 */
  .factory('$$debounce', ['$timeout', function($timeout) {
    return function(callback, debounceTime) {
      var timeoutPromise;

      return function() {
        var self = this;
        var args = Array.prototype.slice.call(arguments);
        if (timeoutPromise) {
          $timeout.cancel(timeoutPromise);
        }

        timeoutPromise = $timeout(function() {
          callback.apply(self, args);
        }, debounceTime);
      };
    };
  }]);

angular.module('ui.bootstrap.multiMap', [])
/**
 * A helper, internal data structure that stores all references attached to key
 */
  .factory('$$multiMap', function() {
    return {
      createNew: function() {
        var map = {};

        return {
          entries: function() {
            return Object.keys(map).map(function(key) {
              return {
                key: key,
                value: map[key]
              };
            });
          },
          get: function(key) {
            return map[key];
          },
          hasKey: function(key) {
            return !!map[key];
          },
          keys: function() {
            return Object.keys(map);
          },
          put: function(key, value) {
            if (!map[key]) {
              map[key] = [];
            }

            map[key].push(value);
          },
          remove: function(key, value) {
            var values = map[key];

            if (!values) {
              return;
            }

            var idx = values.indexOf(value);

            if (idx !== -1) {
              values.splice(idx, 1);
            }

            if (!values.length) {
              delete map[key];
            }
          }
        };
      }
    };
  });

angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.multiMap', 'ui.bootstrap.position'])

.constant('uibDropdownConfig', {
  appendToOpenClass: 'uib-dropdown-open',
  openClass: 'open'
})

.service('uibDropdownService', ['$document', '$rootScope', '$$multiMap', function($document, $rootScope, $$multiMap) {
  var openScope = null;
  var openedContainers = $$multiMap.createNew();

  this.isOnlyOpen = function(dropdownScope, appendTo) {
    var openedDropdowns = openedContainers.get(appendTo);
    if (openedDropdowns) {
      var openDropdown = openedDropdowns.reduce(function(toClose, dropdown) {
        if (dropdown.scope === dropdownScope) {
          return dropdown;
        }

        return toClose;
      }, {});
      if (openDropdown) {
        return openedDropdowns.length === 1;
      }
    }

    return false;
  };

  this.open = function(dropdownScope, element, appendTo) {
    if (!openScope) {
      $document.on('click', closeDropdown);
    }

    if (openScope && openScope !== dropdownScope) {
      openScope.isOpen = false;
    }

    openScope = dropdownScope;

    if (!appendTo) {
      return;
    }

    var openedDropdowns = openedContainers.get(appendTo);
    if (openedDropdowns) {
      var openedScopes = openedDropdowns.map(function(dropdown) {
        return dropdown.scope;
      });
      if (openedScopes.indexOf(dropdownScope) === -1) {
        openedContainers.put(appendTo, {
          scope: dropdownScope
        });
      }
    } else {
      openedContainers.put(appendTo, {
        scope: dropdownScope
      });
    }
  };

  this.close = function(dropdownScope, element, appendTo) {
    if (openScope === dropdownScope) {
      $document.off('click', closeDropdown);
      $document.off('keydown', this.keybindFilter);
      openScope = null;
    }

    if (!appendTo) {
      return;
    }

    var openedDropdowns = openedContainers.get(appendTo);
    if (openedDropdowns) {
      var dropdownToClose = openedDropdowns.reduce(function(toClose, dropdown) {
        if (dropdown.scope === dropdownScope) {
          return dropdown;
        }

        return toClose;
      }, {});
      if (dropdownToClose) {
        openedContainers.remove(appendTo, dropdownToClose);
      }
    }
  };

  var closeDropdown = function(evt) {
    // This method may still be called during the same mouse event that
    // unbound this event handler. So check openScope before proceeding.
    if (!openScope || !openScope.isOpen) { return; }

    if (evt && openScope.getAutoClose() === 'disabled') { return; }

    if (evt && evt.which === 3) { return; }

    var toggleElement = openScope.getToggleElement();
    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
      return;
    }

    var dropdownElement = openScope.getDropdownElement();
    if (evt && openScope.getAutoClose() === 'outsideClick' &&
      dropdownElement && dropdownElement[0].contains(evt.target)) {
      return;
    }

    openScope.focusToggleElement();
    openScope.isOpen = false;

    if (!$rootScope.$$phase) {
      openScope.$apply();
    }
  };

  this.keybindFilter = function(evt) {
    if (!openScope) {
      // see this.close as ESC could have been pressed which kills the scope so we can not proceed
      return;
    }

    var dropdownElement = openScope.getDropdownElement();
    var toggleElement = openScope.getToggleElement();
    var dropdownElementTargeted = dropdownElement && dropdownElement[0].contains(evt.target);
    var toggleElementTargeted = toggleElement && toggleElement[0].contains(evt.target);
    if (evt.which === 27) {
      evt.stopPropagation();
      openScope.focusToggleElement();
      closeDropdown();
    } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen && (dropdownElementTargeted || toggleElementTargeted)) {
      evt.preventDefault();
      evt.stopPropagation();
      openScope.focusDropdownEntry(evt.which);
    }
  };
}])

.controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
  var self = this,
    scope = $scope.$new(), // create a child scope so we are not polluting original one
    templateScope,
    appendToOpenClass = dropdownConfig.appendToOpenClass,
    openClass = dropdownConfig.openClass,
    getIsOpen,
    setIsOpen = angular.noop,
    toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
    keynavEnabled = false,
    selectedOption = null,
    body = $document.find('body');

  $element.addClass('dropdown');

  this.init = function() {
    if ($attrs.isOpen) {
      getIsOpen = $parse($attrs.isOpen);
      setIsOpen = getIsOpen.assign;

      $scope.$watch(getIsOpen, function(value) {
        scope.isOpen = !!value;
      });
    }

    keynavEnabled = angular.isDefined($attrs.keyboardNav);
  };

  this.toggle = function(open) {
    scope.isOpen = arguments.length ? !!open : !scope.isOpen;
    if (angular.isFunction(setIsOpen)) {
      setIsOpen(scope, scope.isOpen);
    }

    return scope.isOpen;
  };

  // Allow other directives to watch status
  this.isOpen = function() {
    return scope.isOpen;
  };

  scope.getToggleElement = function() {
    return self.toggleElement;
  };

  scope.getAutoClose = function() {
    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
  };

  scope.getElement = function() {
    return $element;
  };

  scope.isKeynavEnabled = function() {
    return keynavEnabled;
  };

  scope.focusDropdownEntry = function(keyCode) {
    var elems = self.dropdownMenu ? //If append to body is used.
      angular.element(self.dropdownMenu).find('a') :
      $element.find('ul').eq(0).find('a');

    switch (keyCode) {
      case 40: {
        if (!angular.isNumber(self.selectedOption)) {
          self.selectedOption = 0;
        } else {
          self.selectedOption = self.selectedOption === elems.length - 1 ?
            self.selectedOption :
            self.selectedOption + 1;
        }
        break;
      }
      case 38: {
        if (!angular.isNumber(self.selectedOption)) {
          self.selectedOption = elems.length - 1;
        } else {
          self.selectedOption = self.selectedOption === 0 ?
            0 : self.selectedOption - 1;
        }
        break;
      }
    }
    elems[self.selectedOption].focus();
  };

  scope.getDropdownElement = function() {
    return self.dropdownMenu;
  };

  scope.focusToggleElement = function() {
    if (self.toggleElement) {
      self.toggleElement[0].focus();
    }
  };

  function removeDropdownMenu() {
    $element.append(self.dropdownMenu);
  }

  scope.$watch('isOpen', function(isOpen, wasOpen) {
    var appendTo = null,
      appendToBody = false;

    if (angular.isDefined($attrs.dropdownAppendTo)) {
      var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
      if (appendToEl) {
        appendTo = angular.element(appendToEl);
      }
    }

    if (angular.isDefined($attrs.dropdownAppendToBody)) {
      var appendToBodyValue = $parse($attrs.dropdownAppendToBody)(scope);
      if (appendToBodyValue !== false) {
        appendToBody = true;
      }
    }

    if (appendToBody && !appendTo) {
      appendTo = body;
    }

    if (appendTo && self.dropdownMenu) {
      if (isOpen) {
        appendTo.append(self.dropdownMenu);
        $element.on('$destroy', removeDropdownMenu);
      } else {
        $element.off('$destroy', removeDropdownMenu);
        removeDropdownMenu();
      }
    }

    if (appendTo && self.dropdownMenu) {
      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
        css,
        rightalign,
        scrollbarPadding,
        scrollbarWidth = 0;

      css = {
        top: pos.top + 'px',
        display: isOpen ? 'block' : 'none'
      };

      rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
      if (!rightalign) {
        css.left = pos.left + 'px';
        css.right = 'auto';
      } else {
        css.left = 'auto';
        scrollbarPadding = $position.scrollbarPadding(appendTo);

        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
          scrollbarWidth = scrollbarPadding.scrollbarWidth;
        }

        css.right = window.innerWidth - scrollbarWidth -
          (pos.left + $element.prop('offsetWidth')) + 'px';
      }

      // Need to adjust our positioning to be relative to the appendTo container
      // if it's not the body element
      if (!appendToBody) {
        var appendOffset = $position.offset(appendTo);

        css.top = pos.top - appendOffset.top + 'px';

        if (!rightalign) {
          css.left = pos.left - appendOffset.left + 'px';
        } else {
          css.right = window.innerWidth -
            (pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';
        }
      }

      self.dropdownMenu.css(css);
    }

    var openContainer = appendTo ? appendTo : $element;
    var dropdownOpenClass = appendTo ? appendToOpenClass : openClass;
    var hasOpenClass = openContainer.hasClass(dropdownOpenClass);
    var isOnlyOpen = uibDropdownService.isOnlyOpen($scope, appendTo);

    if (hasOpenClass === !isOpen) {
      var toggleClass;
      if (appendTo) {
        toggleClass = !isOnlyOpen ? 'addClass' : 'removeClass';
      } else {
        toggleClass = isOpen ? 'addClass' : 'removeClass';
      }
      $animate[toggleClass](openContainer, dropdownOpenClass).then(function() {
        if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
          toggleInvoker($scope, { open: !!isOpen });
        }
      });
    }

    if (isOpen) {
      if (self.dropdownMenuTemplateUrl) {
        $templateRequest(self.dropdownMenuTemplateUrl).then(function(tplContent) {
          templateScope = scope.$new();
          $compile(tplContent.trim())(templateScope, function(dropdownElement) {
            var newEl = dropdownElement;
            self.dropdownMenu.replaceWith(newEl);
            self.dropdownMenu = newEl;
            $document.on('keydown', uibDropdownService.keybindFilter);
          });
        });
      } else {
        $document.on('keydown', uibDropdownService.keybindFilter);
      }

      scope.focusToggleElement();
      uibDropdownService.open(scope, $element, appendTo);
    } else {
      uibDropdownService.close(scope, $element, appendTo);
      if (self.dropdownMenuTemplateUrl) {
        if (templateScope) {
          templateScope.$destroy();
        }
        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
        self.dropdownMenu.replaceWith(newEl);
        self.dropdownMenu = newEl;
      }

      self.selectedOption = null;
    }

    if (angular.isFunction(setIsOpen)) {
      setIsOpen($scope, isOpen);
    }
  });
}])

.directive('uibDropdown', function() {
  return {
    controller: 'UibDropdownController',
    link: function(scope, element, attrs, dropdownCtrl) {
      dropdownCtrl.init();
    }
  };
})

.directive('uibDropdownMenu', function() {
  return {
    restrict: 'A',
    require: '?^uibDropdown',
    link: function(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
        return;
      }

      element.addClass('dropdown-menu');

      var tplUrl = attrs.templateUrl;
      if (tplUrl) {
        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
      }

      if (!dropdownCtrl.dropdownMenu) {
        dropdownCtrl.dropdownMenu = element;
      }
    }
  };
})

.directive('uibDropdownToggle', function() {
  return {
    require: '?^uibDropdown',
    link: function(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl) {
        return;
      }

      element.addClass('dropdown-toggle');

      dropdownCtrl.toggleElement = element;

      var toggleDropdown = function(event) {
        event.preventDefault();

        if (!element.hasClass('disabled') && !attrs.disabled) {
          scope.$apply(function() {
            dropdownCtrl.toggle();
          });
        }
      };

      element.on('click', toggleDropdown);

      // WAI-ARIA
      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
      scope.$watch(dropdownCtrl.isOpen, function(isOpen) {
        element.attr('aria-expanded', !!isOpen);
      });

      scope.$on('$destroy', function() {
        element.off('click', toggleDropdown);
      });
    }
  };
});

angular.module('ui.bootstrap.stackedMap', [])
/**
 * A helper, internal data structure that acts as a map but also allows getting / removing
 * elements in the LIFO order
 */
  .factory('$$stackedMap', function() {
    return {
      createNew: function() {
        var stack = [];

        return {
          add: function(key, value) {
            stack.push({
              key: key,
              value: value
            });
          },
          get: function(key) {
            for (var i = 0; i < stack.length; i++) {
              if (key === stack[i].key) {
                return stack[i];
              }
            }
          },
          keys: function() {
            var keys = [];
            for (var i = 0; i < stack.length; i++) {
              keys.push(stack[i].key);
            }
            return keys;
          },
          top: function() {
            return stack[stack.length - 1];
          },
          remove: function(key) {
            var idx = -1;
            for (var i = 0; i < stack.length; i++) {
              if (key === stack[i].key) {
                idx = i;
                break;
              }
            }
            return stack.splice(idx, 1)[0];
          },
          removeTop: function() {
            return stack.pop();
          },
          length: function() {
            return stack.length;
          }
        };
      }
    };
  });
angular.module('ui.bootstrap.modal', ['ui.bootstrap.multiMap', 'ui.bootstrap.stackedMap', 'ui.bootstrap.position'])
/**
 * Pluggable resolve mechanism for the modal resolve resolution
 * Supports UI Router's $resolve service
 */
  .provider('$uibResolve', function() {
    var resolve = this;
    this.resolver = null;

    this.setResolver = function(resolver) {
      this.resolver = resolver;
    };

    this.$get = ['$injector', '$q', function($injector, $q) {
      var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
      return {
        resolve: function(invocables, locals, parent, self) {
          if (resolver) {
            return resolver.resolve(invocables, locals, parent, self);
          }

          var promises = [];

          angular.forEach(invocables, function(value) {
            if (angular.isFunction(value) || angular.isArray(value)) {
              promises.push($q.resolve($injector.invoke(value)));
            } else if (angular.isString(value)) {
              promises.push($q.resolve($injector.get(value)));
            } else {
              promises.push($q.resolve(value));
            }
          });

          return $q.all(promises).then(function(resolves) {
            var resolveObj = {};
            var resolveIter = 0;
            angular.forEach(invocables, function(value, key) {
              resolveObj[key] = resolves[resolveIter++];
            });

            return resolveObj;
          });
        }
      };
    }];
  })

/**
 * A helper directive for the $modal service. It creates a backdrop element.
 */
  .directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack',
  function($animate, $injector, $modalStack) {
    return {
      restrict: 'A',
      compile: function(tElement, tAttrs) {
        tElement.addClass(tAttrs.backdropClass);
        return linkFn;
      }
    };

    function linkFn(scope, element, attrs) {
      if (attrs.modalInClass) {
        $animate.addClass(element, attrs.modalInClass);

        scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
          var done = setIsAsync();
          if (scope.modalOptions.animation) {
            $animate.removeClass(element, attrs.modalInClass).then(done);
          } else {
            done();
          }
        });
      }
    }
  }])

  .directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document',
  function($modalStack, $q, $animateCss, $document) {
    return {
      scope: {
        index: '@'
      },
      restrict: 'A',
      transclude: true,
      templateUrl: function(tElement, tAttrs) {
        return tAttrs.templateUrl || 'uib/template/modal/window.html';
      },
      link: function(scope, element, attrs) {
        element.addClass(attrs.windowTopClass || '');
        scope.size = attrs.size;

        scope.close = function(evt) {
          var modal = $modalStack.getTop();
          if (modal && modal.value.backdrop &&
            modal.value.backdrop !== 'static' &&
            evt.target === evt.currentTarget) {
            evt.preventDefault();
            evt.stopPropagation();
            $modalStack.dismiss(modal.key, 'backdrop click');
          }
        };

        // moved from template to fix issue #2280
        element.on('click', scope.close);

        // This property is only added to the scope for the purpose of detecting when this directive is rendered.
        // We can detect that by using this property in the template associated with this directive and then use
        // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
        scope.$isRendered = true;

        // Deferred object that will be resolved when this modal is rendered.
        var modalRenderDeferObj = $q.defer();
        // Resolve render promise post-digest
        scope.$$postDigest(function() {
          modalRenderDeferObj.resolve();
        });

        modalRenderDeferObj.promise.then(function() {
          var animationPromise = null;

          if (attrs.modalInClass) {
            animationPromise = $animateCss(element, {
              addClass: attrs.modalInClass
            }).start();

            scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
              var done = setIsAsync();
              $animateCss(element, {
                removeClass: attrs.modalInClass
              }).start().then(done);
            });
          }


          $q.when(animationPromise).then(function() {
            // Notify {@link $modalStack} that modal is rendered.
            var modal = $modalStack.getTop();
            if (modal) {
              $modalStack.modalRendered(modal.key);
            }

            /**
             * If something within the freshly-opened modal already has focus (perhaps via a
             * directive that causes focus) then there's no need to try to focus anything.
             */
            if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
              var inputWithAutofocus = element[0].querySelector('[autofocus]');
              /**
               * Auto-focusing of a freshly-opened modal element causes any child elements
               * with the autofocus attribute to lose focus. This is an issue on touch
               * based devices which will show and then hide the onscreen keyboard.
               * Attempts to refocus the autofocus element via JavaScript will not reopen
               * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
               * the modal element if the modal does not contain an autofocus element.
               */
              if (inputWithAutofocus) {
                inputWithAutofocus.focus();
              } else {
                element[0].focus();
              }
            }
          });
        });
      }
    };
  }])

  .directive('uibModalAnimationClass', function() {
    return {
      compile: function(tElement, tAttrs) {
        if (tAttrs.modalAnimation) {
          tElement.addClass(tAttrs.uibModalAnimationClass);
        }
      }
    };
  })

  .directive('uibModalTransclude', ['$animate', function($animate) {
    return {
      link: function(scope, element, attrs, controller, transclude) {
        transclude(scope.$parent, function(clone) {
          element.empty();
          $animate.enter(clone, element);
        });
      }
    };
  }])

  .factory('$uibModalStack', ['$animate', '$animateCss', '$document',
    '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition',
    function($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {
      var OPENED_MODAL_CLASS = 'modal-open';

      var backdropDomEl, backdropScope;
      var openedWindows = $$stackedMap.createNew();
      var openedClasses = $$multiMap.createNew();
      var $modalStack = {
        NOW_CLOSING_EVENT: 'modal.stack.now-closing'
      };
      var topModalIndex = 0;
      var previousTopOpenedModal = null;
      var ARIA_HIDDEN_ATTRIBUTE_NAME = 'data-bootstrap-modal-aria-hidden-count';

      //Modal focus behavior
      var tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' +
        'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' +
        'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';
      var scrollbarPadding;
      var SNAKE_CASE_REGEXP = /[A-Z]/g;

      // TODO: extract into common dependency with tooltip
      function snake_case(name) {
        var separator = '-';
        return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
          return (pos ? separator : '') + letter.toLowerCase();
        });
      }

      function isVisible(element) {
        return !!(element.offsetWidth ||
          element.offsetHeight ||
          element.getClientRects().length);
      }

      function backdropIndex() {
        var topBackdropIndex = -1;
        var opened = openedWindows.keys();
        for (var i = 0; i < opened.length; i++) {
          if (openedWindows.get(opened[i]).value.backdrop) {
            topBackdropIndex = i;
          }
        }

        // If any backdrop exist, ensure that it's index is always
        // right below the top modal
        if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {
          topBackdropIndex = topModalIndex;
        }
        return topBackdropIndex;
      }

      $rootScope.$watch(backdropIndex, function(newBackdropIndex) {
        if (backdropScope) {
          backdropScope.index = newBackdropIndex;
        }
      });

      function removeModalWindow(modalInstance, elementToReceiveFocus) {
        var modalWindow = openedWindows.get(modalInstance).value;
        var appendToElement = modalWindow.appendTo;

        //clean up the stack
        openedWindows.remove(modalInstance);
        previousTopOpenedModal = openedWindows.top();
        if (previousTopOpenedModal) {
          topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);
        }

        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function() {
          var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
          openedClasses.remove(modalBodyClass, modalInstance);
          var areAnyOpen = openedClasses.hasKey(modalBodyClass);
          appendToElement.toggleClass(modalBodyClass, areAnyOpen);
          if (!areAnyOpen && scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
            if (scrollbarPadding.originalRight) {
              appendToElement.css({paddingRight: scrollbarPadding.originalRight + 'px'});
            } else {
              appendToElement.css({paddingRight: ''});
            }
            scrollbarPadding = null;
          }
          toggleTopWindowClass(true);
        }, modalWindow.closedDeferred);
        checkRemoveBackdrop();

        //move focus to specified element if available, or else to body
        if (elementToReceiveFocus && elementToReceiveFocus.focus) {
          elementToReceiveFocus.focus();
        } else if (appendToElement.focus) {
          appendToElement.focus();
        }
      }

      // Add or remove "windowTopClass" from the top window in the stack
      function toggleTopWindowClass(toggleSwitch) {
        var modalWindow;

        if (openedWindows.length() > 0) {
          modalWindow = openedWindows.top().value;
          modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
        }
      }

      function checkRemoveBackdrop() {
        //remove backdrop if no longer needed
        if (backdropDomEl && backdropIndex() === -1) {
          var backdropScopeRef = backdropScope;
          removeAfterAnimate(backdropDomEl, backdropScope, function() {
            backdropScopeRef = null;
          });
          backdropDomEl = undefined;
          backdropScope = undefined;
        }
      }

      function removeAfterAnimate(domEl, scope, done, closedDeferred) {
        var asyncDeferred;
        var asyncPromise = null;
        var setIsAsync = function() {
          if (!asyncDeferred) {
            asyncDeferred = $q.defer();
            asyncPromise = asyncDeferred.promise;
          }

          return function asyncDone() {
            asyncDeferred.resolve();
          };
        };
        scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);

        // Note that it's intentional that asyncPromise might be null.
        // That's when setIsAsync has not been called during the
        // NOW_CLOSING_EVENT broadcast.
        return $q.when(asyncPromise).then(afterAnimating);

        function afterAnimating() {
          if (afterAnimating.done) {
            return;
          }
          afterAnimating.done = true;

          $animate.leave(domEl).then(function() {
            if (done) {
              done();
            }

            domEl.remove();
            if (closedDeferred) {
              closedDeferred.resolve();
            }
          });

          scope.$destroy();
        }
      }

      $document.on('keydown', keydownListener);

      $rootScope.$on('$destroy', function() {
        $document.off('keydown', keydownListener);
      });

      function keydownListener(evt) {
        if (evt.isDefaultPrevented()) {
          return evt;
        }

        var modal = openedWindows.top();
        if (modal) {
          switch (evt.which) {
            case 27: {
              if (modal.value.keyboard) {
                evt.preventDefault();
                $rootScope.$apply(function() {
                  $modalStack.dismiss(modal.key, 'escape key press');
                });
              }
              break;
            }
            case 9: {
              var list = $modalStack.loadFocusElementList(modal);
              var focusChanged = false;
              if (evt.shiftKey) {
                if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
                  focusChanged = $modalStack.focusLastFocusableElement(list);
                }
              } else {
                if ($modalStack.isFocusInLastItem(evt, list)) {
                  focusChanged = $modalStack.focusFirstFocusableElement(list);
                }
              }

              if (focusChanged) {
                evt.preventDefault();
                evt.stopPropagation();
              }

              break;
            }
          }
        }
      }

      $modalStack.open = function(modalInstance, modal) {
        var modalOpener = $document[0].activeElement,
          modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;

        toggleTopWindowClass(false);

        // Store the current top first, to determine what index we ought to use
        // for the current top modal
        previousTopOpenedModal = openedWindows.top();

        openedWindows.add(modalInstance, {
          deferred: modal.deferred,
          renderDeferred: modal.renderDeferred,
          closedDeferred: modal.closedDeferred,
          modalScope: modal.scope,
          backdrop: modal.backdrop,
          keyboard: modal.keyboard,
          openedClass: modal.openedClass,
          windowTopClass: modal.windowTopClass,
          animation: modal.animation,
          appendTo: modal.appendTo
        });

        openedClasses.put(modalBodyClass, modalInstance);

        var appendToElement = modal.appendTo,
            currBackdropIndex = backdropIndex();

        if (currBackdropIndex >= 0 && !backdropDomEl) {
          backdropScope = $rootScope.$new(true);
          backdropScope.modalOptions = modal;
          backdropScope.index = currBackdropIndex;
          backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
          backdropDomEl.attr({
            'class': 'modal-backdrop',
            'ng-style': '{\'z-index\': 1040 + (index && 1 || 0) + index*10}',
            'uib-modal-animation-class': 'fade',
            'modal-in-class': 'in'
          });
          if (modal.backdropClass) {
            backdropDomEl.addClass(modal.backdropClass);
          }

          if (modal.animation) {
            backdropDomEl.attr('modal-animation', 'true');
          }
          $compile(backdropDomEl)(backdropScope);
          $animate.enter(backdropDomEl, appendToElement);
          if ($uibPosition.isScrollable(appendToElement)) {
            scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);
            if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
              appendToElement.css({paddingRight: scrollbarPadding.right + 'px'});
            }
          }
        }

        var content;
        if (modal.component) {
          content = document.createElement(snake_case(modal.component.name));
          content = angular.element(content);
          content.attr({
            resolve: '$resolve',
            'modal-instance': '$uibModalInstance',
            close: '$close($value)',
            dismiss: '$dismiss($value)'
          });
        } else {
          content = modal.content;
        }

        // Set the top modal index based on the index of the previous top modal
        topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;
        var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
        angularDomEl.attr({
          'class': 'modal',
          'template-url': modal.windowTemplateUrl,
          'window-top-class': modal.windowTopClass,
          'role': 'dialog',
          'aria-labelledby': modal.ariaLabelledBy,
          'aria-describedby': modal.ariaDescribedBy,
          'size': modal.size,
          'index': topModalIndex,
          'animate': 'animate',
          'ng-style': '{\'z-index\': 1050 + $$topModalIndex*10, display: \'block\'}',
          'tabindex': -1,
          'uib-modal-animation-class': 'fade',
          'modal-in-class': 'in'
        }).append(content);
        if (modal.windowClass) {
          angularDomEl.addClass(modal.windowClass);
        }

        if (modal.animation) {
          angularDomEl.attr('modal-animation', 'true');
        }

        appendToElement.addClass(modalBodyClass);
        if (modal.scope) {
          // we need to explicitly add the modal index to the modal scope
          // because it is needed by ngStyle to compute the zIndex property.
          modal.scope.$$topModalIndex = topModalIndex;
        }
        $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);

        openedWindows.top().value.modalDomEl = angularDomEl;
        openedWindows.top().value.modalOpener = modalOpener;

        applyAriaHidden(angularDomEl);

        function applyAriaHidden(el) {
          if (!el || el[0].tagName === 'BODY') {
            return;
          }

          getSiblings(el).forEach(function(sibling) {
            var elemIsAlreadyHidden = sibling.getAttribute('aria-hidden') === 'true',
              ariaHiddenCount = parseInt(sibling.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10);

            if (!ariaHiddenCount) {
              ariaHiddenCount = elemIsAlreadyHidden ? 1 : 0;
            }

            sibling.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, ariaHiddenCount + 1);
            sibling.setAttribute('aria-hidden', 'true');
          });

          return applyAriaHidden(el.parent());

          function getSiblings(el) {
            var children = el.parent() ? el.parent().children() : [];

            return Array.prototype.filter.call(children, function(child) {
              return child !== el[0];
            });
          }
        }
      };

      function broadcastClosing(modalWindow, resultOrReason, closing) {
        return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
      }

      function unhideBackgroundElements() {
        Array.prototype.forEach.call(
          document.querySelectorAll('[' + ARIA_HIDDEN_ATTRIBUTE_NAME + ']'),
          function(hiddenEl) {
            var ariaHiddenCount = parseInt(hiddenEl.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10),
              newHiddenCount = ariaHiddenCount - 1;
            hiddenEl.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, newHiddenCount);

            if (!newHiddenCount) {
              hiddenEl.removeAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME);
              hiddenEl.removeAttribute('aria-hidden');
            }
          }
        );
      }

      $modalStack.close = function(modalInstance, result) {
        var modalWindow = openedWindows.get(modalInstance);
        unhideBackgroundElements();
        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.resolve(result);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }

        return !modalWindow;
      };

      $modalStack.dismiss = function(modalInstance, reason) {
        var modalWindow = openedWindows.get(modalInstance);
        unhideBackgroundElements();
        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.reject(reason);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }
        return !modalWindow;
      };

      $modalStack.dismissAll = function(reason) {
        var topModal = this.getTop();
        while (topModal && this.dismiss(topModal.key, reason)) {
          topModal = this.getTop();
        }
      };

      $modalStack.getTop = function() {
        return openedWindows.top();
      };

      $modalStack.modalRendered = function(modalInstance) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow) {
          modalWindow.value.renderDeferred.resolve();
        }
      };

      $modalStack.focusFirstFocusableElement = function(list) {
        if (list.length > 0) {
          list[0].focus();
          return true;
        }
        return false;
      };

      $modalStack.focusLastFocusableElement = function(list) {
        if (list.length > 0) {
          list[list.length - 1].focus();
          return true;
        }
        return false;
      };

      $modalStack.isModalFocused = function(evt, modalWindow) {
        if (evt && modalWindow) {
          var modalDomEl = modalWindow.value.modalDomEl;
          if (modalDomEl && modalDomEl.length) {
            return (evt.target || evt.srcElement) === modalDomEl[0];
          }
        }
        return false;
      };

      $modalStack.isFocusInFirstItem = function(evt, list) {
        if (list.length > 0) {
          return (evt.target || evt.srcElement) === list[0];
        }
        return false;
      };

      $modalStack.isFocusInLastItem = function(evt, list) {
        if (list.length > 0) {
          return (evt.target || evt.srcElement) === list[list.length - 1];
        }
        return false;
      };

      $modalStack.loadFocusElementList = function(modalWindow) {
        if (modalWindow) {
          var modalDomE1 = modalWindow.value.modalDomEl;
          if (modalDomE1 && modalDomE1.length) {
            var elements = modalDomE1[0].querySelectorAll(tabbableSelector);
            return elements ?
              Array.prototype.filter.call(elements, function(element) {
                return isVisible(element);
              }) : elements;
          }
        }
      };

      return $modalStack;
    }])

  .provider('$uibModal', function() {
    var $modalProvider = {
      options: {
        animation: true,
        backdrop: true, //can also be false or 'static'
        keyboard: true
      },
      $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack',
        function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
          var $modal = {};

          function getTemplatePromise(options) {
            return options.template ? $q.when(options.template) :
              $templateRequest(angular.isFunction(options.templateUrl) ?
                options.templateUrl() : options.templateUrl);
          }

          var promiseChain = null;
          $modal.getPromiseChain = function() {
            return promiseChain;
          };

          $modal.open = function(modalOptions) {
            var modalResultDeferred = $q.defer();
            var modalOpenedDeferred = $q.defer();
            var modalClosedDeferred = $q.defer();
            var modalRenderDeferred = $q.defer();

            //prepare an instance of a modal to be injected into controllers and returned to a caller
            var modalInstance = {
              result: modalResultDeferred.promise,
              opened: modalOpenedDeferred.promise,
              closed: modalClosedDeferred.promise,
              rendered: modalRenderDeferred.promise,
              close: function (result) {
                return $modalStack.close(modalInstance, result);
              },
              dismiss: function (reason) {
                return $modalStack.dismiss(modalInstance, reason);
              }
            };

            //merge and clean up options
            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
            modalOptions.resolve = modalOptions.resolve || {};
            modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);

            if (!modalOptions.appendTo.length) {
              throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
            }

            //verify options
            if (!modalOptions.component && !modalOptions.template && !modalOptions.templateUrl) {
              throw new Error('One of component or template or templateUrl options is required.');
            }

            var templateAndResolvePromise;
            if (modalOptions.component) {
              templateAndResolvePromise = $q.when($uibResolve.resolve(modalOptions.resolve, {}, null, null));
            } else {
              templateAndResolvePromise =
                $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);
            }

            function resolveWithTemplate() {
              return templateAndResolvePromise;
            }

            // Wait for the resolution of the existing promise chain.
            // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
            // Then add to $modalStack and resolve opened.
            // Finally clean up the chain variable if no subsequent modal has overwritten it.
            var samePromise;
            samePromise = promiseChain = $q.all([promiseChain])
              .then(resolveWithTemplate, resolveWithTemplate)
              .then(function resolveSuccess(tplAndVars) {
                var providedScope = modalOptions.scope || $rootScope;

                var modalScope = providedScope.$new();
                modalScope.$close = modalInstance.close;
                modalScope.$dismiss = modalInstance.dismiss;

                modalScope.$on('$destroy', function() {
                  if (!modalScope.$$uibDestructionScheduled) {
                    modalScope.$dismiss('$uibUnscheduledDestruction');
                  }
                });

                var modal = {
                  scope: modalScope,
                  deferred: modalResultDeferred,
                  renderDeferred: modalRenderDeferred,
                  closedDeferred: modalClosedDeferred,
                  animation: modalOptions.animation,
                  backdrop: modalOptions.backdrop,
                  keyboard: modalOptions.keyboard,
                  backdropClass: modalOptions.backdropClass,
                  windowTopClass: modalOptions.windowTopClass,
                  windowClass: modalOptions.windowClass,
                  windowTemplateUrl: modalOptions.windowTemplateUrl,
                  ariaLabelledBy: modalOptions.ariaLabelledBy,
                  ariaDescribedBy: modalOptions.ariaDescribedBy,
                  size: modalOptions.size,
                  openedClass: modalOptions.openedClass,
                  appendTo: modalOptions.appendTo
                };

                var component = {};
                var ctrlInstance, ctrlInstantiate, ctrlLocals = {};

                if (modalOptions.component) {
                  constructLocals(component, false, true, false);
                  component.name = modalOptions.component;
                  modal.component = component;
                } else if (modalOptions.controller) {
                  constructLocals(ctrlLocals, true, false, true);

                  // the third param will make the controller instantiate later,private api
                  // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
                  ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true, modalOptions.controllerAs);
                  if (modalOptions.controllerAs && modalOptions.bindToController) {
                    ctrlInstance = ctrlInstantiate.instance;
                    ctrlInstance.$close = modalScope.$close;
                    ctrlInstance.$dismiss = modalScope.$dismiss;
                    angular.extend(ctrlInstance, {
                      $resolve: ctrlLocals.$scope.$resolve
                    }, providedScope);
                  }

                  ctrlInstance = ctrlInstantiate();

                  if (angular.isFunction(ctrlInstance.$onInit)) {
                    ctrlInstance.$onInit();
                  }
                }

                if (!modalOptions.component) {
                  modal.content = tplAndVars[0];
                }

                $modalStack.open(modalInstance, modal);
                modalOpenedDeferred.resolve(true);

                function constructLocals(obj, template, instanceOnScope, injectable) {
                  obj.$scope = modalScope;
                  obj.$scope.$resolve = {};
                  if (instanceOnScope) {
                    obj.$scope.$uibModalInstance = modalInstance;
                  } else {
                    obj.$uibModalInstance = modalInstance;
                  }

                  var resolves = template ? tplAndVars[1] : tplAndVars;
                  angular.forEach(resolves, function(value, key) {
                    if (injectable) {
                      obj[key] = value;
                    }

                    obj.$scope.$resolve[key] = value;
                  });
                }
            }, function resolveError(reason) {
              modalOpenedDeferred.reject(reason);
              modalResultDeferred.reject(reason);
            })['finally'](function() {
              if (promiseChain === samePromise) {
                promiseChain = null;
              }
            });

            return modalInstance;
          };

          return $modal;
        }
      ]
    };

    return $modalProvider;
  });

angular.module('ui.bootstrap.paging', [])
/**
 * Helper internal service for generating common controller code between the
 * pager and pagination components
 */
.factory('uibPaging', ['$parse', function($parse) {
  return {
    create: function(ctrl, $scope, $attrs) {
      ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
      ctrl.ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl
      ctrl._watchers = [];

      ctrl.init = function(ngModelCtrl, config) {
        ctrl.ngModelCtrl = ngModelCtrl;
        ctrl.config = config;

        ngModelCtrl.$render = function() {
          ctrl.render();
        };

        if ($attrs.itemsPerPage) {
          ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function(value) {
            ctrl.itemsPerPage = parseInt(value, 10);
            $scope.totalPages = ctrl.calculateTotalPages();
            ctrl.updatePage();
          }));
        } else {
          ctrl.itemsPerPage = config.itemsPerPage;
        }

        $scope.$watch('totalItems', function(newTotal, oldTotal) {
          if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
            $scope.totalPages = ctrl.calculateTotalPages();
            ctrl.updatePage();
          }
        });
      };

      ctrl.calculateTotalPages = function() {
        var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
        return Math.max(totalPages || 0, 1);
      };

      ctrl.render = function() {
        $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
      };

      $scope.selectPage = function(page, evt) {
        if (evt) {
          evt.preventDefault();
        }

        var clickAllowed = !$scope.ngDisabled || !evt;
        if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
          if (evt && evt.target) {
            evt.target.blur();
          }
          ctrl.ngModelCtrl.$setViewValue(page);
          ctrl.ngModelCtrl.$render();
        }
      };

      $scope.getText = function(key) {
        return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
      };

      $scope.noPrevious = function() {
        return $scope.page === 1;
      };

      $scope.noNext = function() {
        return $scope.page === $scope.totalPages;
      };

      ctrl.updatePage = function() {
        ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable

        if ($scope.page > $scope.totalPages) {
          $scope.selectPage($scope.totalPages);
        } else {
          ctrl.ngModelCtrl.$render();
        }
      };

      $scope.$on('$destroy', function() {
        while (ctrl._watchers.length) {
          ctrl._watchers.shift()();
        }
      });
    }
  };
}]);

angular.module('ui.bootstrap.pager', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])

.controller('UibPagerController', ['$scope', '$attrs', 'uibPaging', 'uibPagerConfig', function($scope, $attrs, uibPaging, uibPagerConfig) {
  $scope.align = angular.isDefined($attrs.align) ? $scope.$parent.$eval($attrs.align) : uibPagerConfig.align;

  uibPaging.create(this, $scope, $attrs);
}])

.constant('uibPagerConfig', {
  itemsPerPage: 10,
  previousText: '« Previous',
  nextText: 'Next »',
  align: true
})

.directive('uibPager', ['uibPagerConfig', function(uibPagerConfig) {
  return {
    scope: {
      totalItems: '=',
      previousText: '@',
      nextText: '@',
      ngDisabled: '='
    },
    require: ['uibPager', '?ngModel'],
    restrict: 'A',
    controller: 'UibPagerController',
    controllerAs: 'pager',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/pager/pager.html';
    },
    link: function(scope, element, attrs, ctrls) {
      element.addClass('pager');
      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (!ngModelCtrl) {
        return; // do nothing if no ng-model
      }

      paginationCtrl.init(ngModelCtrl, uibPagerConfig);
    }
  };
}]);

angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])
.controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
  var ctrl = this;
  // Setup configuration parameters
  var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
    rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
    forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
    boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
    pageLabel = angular.isDefined($attrs.pageLabel) ? function(idx) { return $scope.$parent.$eval($attrs.pageLabel, {$page: idx}); } : angular.identity;
  $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
  $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;
  $attrs.$set('role', 'menu');

  uibPaging.create(this, $scope, $attrs);

  if ($attrs.maxSize) {
    ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function(value) {
      maxSize = parseInt(value, 10);
      ctrl.render();
    }));
  }

  // Create page object used in template
  function makePage(number, text, isActive) {
    return {
      number: number,
      text: text,
      active: isActive
    };
  }

  function getPages(currentPage, totalPages) {
    var pages = [];

    // Default page limits
    var startPage = 1, endPage = totalPages;
    var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;

    // recompute if maxSize
    if (isMaxSized) {
      if (rotate) {
        // Current page is displayed in the middle of the visible ones
        startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
        endPage = startPage + maxSize - 1;

        // Adjust if limit is exceeded
        if (endPage > totalPages) {
          endPage = totalPages;
          startPage = endPage - maxSize + 1;
        }
      } else {
        // Visible pages are paginated with maxSize
        startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;

        // Adjust last page if limit is exceeded
        endPage = Math.min(startPage + maxSize - 1, totalPages);
      }
    }

    // Add page number links
    for (var number = startPage; number <= endPage; number++) {
      var page = makePage(number, pageLabel(number), number === currentPage);
      pages.push(page);
    }

    // Add links to move between page sets
    if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
      if (startPage > 1) {
        if (!boundaryLinkNumbers || startPage > 3) { //need ellipsis for all options unless range is too close to beginning
        var previousPageSet = makePage(startPage - 1, '...', false);
        pages.unshift(previousPageSet);
      }
        if (boundaryLinkNumbers) {
          if (startPage === 3) { //need to replace ellipsis when the buttons would be sequential
            var secondPageLink = makePage(2, '2', false);
            pages.unshift(secondPageLink);
          }
          //add the first page
          var firstPageLink = makePage(1, '1', false);
          pages.unshift(firstPageLink);
        }
      }

      if (endPage < totalPages) {
        if (!boundaryLinkNumbers || endPage < totalPages - 2) { //need ellipsis for all options unless range is too close to end
        var nextPageSet = makePage(endPage + 1, '...', false);
        pages.push(nextPageSet);
      }
        if (boundaryLinkNumbers) {
          if (endPage === totalPages - 2) { //need to replace ellipsis when the buttons would be sequential
            var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
            pages.push(secondToLastPageLink);
          }
          //add the last page
          var lastPageLink = makePage(totalPages, totalPages, false);
          pages.push(lastPageLink);
        }
      }
    }
    return pages;
  }

  var originalRender = this.render;
  this.render = function() {
    originalRender();
    if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
      $scope.pages = getPages($scope.page, $scope.totalPages);
    }
  };
}])

.constant('uibPaginationConfig', {
  itemsPerPage: 10,
  boundaryLinks: false,
  boundaryLinkNumbers: false,
  directionLinks: true,
  firstText: 'First',
  previousText: 'Previous',
  nextText: 'Next',
  lastText: 'Last',
  rotate: true,
  forceEllipses: false
})

.directive('uibPagination', ['$parse', 'uibPaginationConfig', function($parse, uibPaginationConfig) {
  return {
    scope: {
      totalItems: '=',
      firstText: '@',
      previousText: '@',
      nextText: '@',
      lastText: '@',
      ngDisabled:'='
    },
    require: ['uibPagination', '?ngModel'],
    restrict: 'A',
    controller: 'UibPaginationController',
    controllerAs: 'pagination',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/pagination/pagination.html';
    },
    link: function(scope, element, attrs, ctrls) {
      element.addClass('pagination');
      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (!ngModelCtrl) {
         return; // do nothing if no ng-model
      }

      paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
    }
  };
}]);

/**
 * The following features are still outstanding: animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html tooltips, and selector delegation.
 */
angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])

/**
 * The $tooltip service creates tooltip- and popover-like directives as well as
 * houses global options for them.
 */
.provider('$uibTooltip', function() {
  // The default options tooltip and popover.
  var defaultOptions = {
    placement: 'top',
    placementClassPrefix: '',
    animation: true,
    popupDelay: 0,
    popupCloseDelay: 0,
    useContentExp: false
  };

  // Default hide triggers for each show trigger
  var triggerMap = {
    'mouseenter': 'mouseleave',
    'click': 'click',
    'outsideClick': 'outsideClick',
    'focus': 'blur',
    'none': ''
  };

  // The options specified to the provider globally.
  var globalOptions = {};

  /**
   * `options({})` allows global configuration of all tooltips in the
   * application.
   *
   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
   *     // place tooltips left instead of top by default
   *     $tooltipProvider.options( { placement: 'left' } );
   *   });
   */
	this.options = function(value) {
		angular.extend(globalOptions, value);
	};

  /**
   * This allows you to extend the set of trigger mappings available. E.g.:
   *
   *   $tooltipProvider.setTriggers( { 'openTrigger': 'closeTrigger' } );
   */
  this.setTriggers = function setTriggers(triggers) {
    angular.extend(triggerMap, triggers);
  };

  /**
   * This is a helper function for translating camel-case to snake_case.
   */
  function snake_case(name) {
    var regexp = /[A-Z]/g;
    var separator = '-';
    return name.replace(regexp, function(letter, pos) {
      return (pos ? separator : '') + letter.toLowerCase();
    });
  }

  /**
   * Returns the actual instance of the $tooltip service.
   * TODO support multiple triggers
   */
  this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
    var openedTooltips = $$stackedMap.createNew();
    $document.on('keyup', keypressListener);

    $rootScope.$on('$destroy', function() {
      $document.off('keyup', keypressListener);
    });

    function keypressListener(e) {
      if (e.which === 27) {
        var last = openedTooltips.top();
        if (last) {
          last.value.close();
          last = null;
        }
      }
    }

    return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
      options = angular.extend({}, defaultOptions, globalOptions, options);

      /**
       * Returns an object of show and hide triggers.
       *
       * If a trigger is supplied,
       * it is used to show the tooltip; otherwise, it will use the `trigger`
       * option passed to the `$tooltipProvider.options` method; else it will
       * default to the trigger supplied to this directive factory.
       *
       * The hide trigger is based on the show trigger. If the `trigger` option
       * was passed to the `$tooltipProvider.options` method, it will use the
       * mapped trigger from `triggerMap` or the passed trigger if the map is
       * undefined; otherwise, it uses the `triggerMap` value of the show
       * trigger; else it will just use the show trigger.
       */
      function getTriggers(trigger) {
        var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
        var hide = show.map(function(trigger) {
          return triggerMap[trigger] || trigger;
        });
        return {
          show: show,
          hide: hide
        };
      }

      var directiveName = snake_case(ttType);

      var startSym = $interpolate.startSymbol();
      var endSym = $interpolate.endSymbol();
      var template =
        '<div '+ directiveName + '-popup ' +
          'uib-title="' + startSym + 'title' + endSym + '" ' +
          (options.useContentExp ?
            'content-exp="contentExp()" ' :
            'content="' + startSym + 'content' + endSym + '" ') +
          'origin-scope="origScope" ' +
          'class="uib-position-measure ' + prefix + '" ' +
          'tooltip-animation-class="fade"' +
          'uib-tooltip-classes ' +
          'ng-class="{ in: isOpen }" ' +
          '>' +
        '</div>';

      return {
        compile: function(tElem, tAttrs) {
          var tooltipLinker = $compile(template);

          return function link(scope, element, attrs, tooltipCtrl) {
            var tooltip;
            var tooltipLinkedScope;
            var transitionTimeout;
            var showTimeout;
            var hideTimeout;
            var positionTimeout;
            var adjustmentTimeout;
            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
            var triggers = getTriggers(undefined);
            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
            var ttScope = scope.$new(true);
            var repositionScheduled = false;
            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
            var observers = [];
            var lastPlacement;

            var positionTooltip = function() {
              // check if tooltip exists and is not empty
              if (!tooltip || !tooltip.html()) { return; }

              if (!positionTimeout) {
                positionTimeout = $timeout(function() {
                  var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
                  var initialHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
                  var elementPos = appendToBody ? $position.offset(element) : $position.position(element);
                  tooltip.css({ top: ttPosition.top + 'px', left: ttPosition.left + 'px' });
                  var placementClasses = ttPosition.placement.split('-');

                  if (!tooltip.hasClass(placementClasses[0])) {
                    tooltip.removeClass(lastPlacement.split('-')[0]);
                    tooltip.addClass(placementClasses[0]);
                  }

                  if (!tooltip.hasClass(options.placementClassPrefix + ttPosition.placement)) {
                    tooltip.removeClass(options.placementClassPrefix + lastPlacement);
                    tooltip.addClass(options.placementClassPrefix + ttPosition.placement);
                  }

                  adjustmentTimeout = $timeout(function() {
                    var currentHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
                    var adjustment = $position.adjustTop(placementClasses, elementPos, initialHeight, currentHeight);
                    if (adjustment) {
                      tooltip.css(adjustment);
                    }
                    adjustmentTimeout = null;
                  }, 0, false);

                  // first time through tt element will have the
                  // uib-position-measure class or if the placement
                  // has changed we need to position the arrow.
                  if (tooltip.hasClass('uib-position-measure')) {
                    $position.positionArrow(tooltip, ttPosition.placement);
                    tooltip.removeClass('uib-position-measure');
                  } else if (lastPlacement !== ttPosition.placement) {
                    $position.positionArrow(tooltip, ttPosition.placement);
                  }
                  lastPlacement = ttPosition.placement;

                  positionTimeout = null;
                }, 0, false);
              }
            };

            // Set up the correct scope to allow transclusion later
            ttScope.origScope = scope;

            // By default, the tooltip is not open.
            // TODO add ability to start tooltip opened
            ttScope.isOpen = false;

            function toggleTooltipBind() {
              if (!ttScope.isOpen) {
                showTooltipBind();
              } else {
                hideTooltipBind();
              }
            }

            // Show the tooltip with delay if specified, otherwise show it immediately
            function showTooltipBind() {
              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
                return;
              }

              cancelHide();
              prepareTooltip();

              if (ttScope.popupDelay) {
                // Do nothing if the tooltip was already scheduled to pop-up.
                // This happens if show is triggered multiple times before any hide is triggered.
                if (!showTimeout) {
                  showTimeout = $timeout(show, ttScope.popupDelay, false);
                }
              } else {
                show();
              }
            }

            function hideTooltipBind() {
              cancelShow();

              if (ttScope.popupCloseDelay) {
                if (!hideTimeout) {
                  hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
                }
              } else {
                hide();
              }
            }

            // Show the tooltip popup element.
            function show() {
              cancelShow();
              cancelHide();

              // Don't show empty tooltips.
              if (!ttScope.content) {
                return angular.noop;
              }

              createTooltip();

              // And show the tooltip.
              ttScope.$evalAsync(function() {
                ttScope.isOpen = true;
                assignIsOpen(true);
                positionTooltip();
              });
            }

            function cancelShow() {
              if (showTimeout) {
                $timeout.cancel(showTimeout);
                showTimeout = null;
              }

              if (positionTimeout) {
                $timeout.cancel(positionTimeout);
                positionTimeout = null;
              }
            }

            // Hide the tooltip popup element.
            function hide() {
              if (!ttScope) {
                return;
              }

              // First things first: we don't show it anymore.
              ttScope.$evalAsync(function() {
                if (ttScope) {
                  ttScope.isOpen = false;
                  assignIsOpen(false);
                  // And now we remove it from the DOM. However, if we have animation, we
                  // need to wait for it to expire beforehand.
                  // FIXME: this is a placeholder for a port of the transitions library.
                  // The fade transition in TWBS is 150ms.
                  if (ttScope.animation) {
                    if (!transitionTimeout) {
                      transitionTimeout = $timeout(removeTooltip, 150, false);
                    }
                  } else {
                    removeTooltip();
                  }
                }
              });
            }

            function cancelHide() {
              if (hideTimeout) {
                $timeout.cancel(hideTimeout);
                hideTimeout = null;
              }

              if (transitionTimeout) {
                $timeout.cancel(transitionTimeout);
                transitionTimeout = null;
              }
            }

            function createTooltip() {
              // There can only be one tooltip element per directive shown at once.
              if (tooltip) {
                return;
              }

              tooltipLinkedScope = ttScope.$new();
              tooltip = tooltipLinker(tooltipLinkedScope, function(tooltip) {
                if (appendToBody) {
                  $document.find('body').append(tooltip);
                } else {
                  element.after(tooltip);
                }
              });

              openedTooltips.add(ttScope, {
                close: hide
              });

              prepObservers();
            }

            function removeTooltip() {
              cancelShow();
              cancelHide();
              unregisterObservers();

              if (tooltip) {
                tooltip.remove();
                
                tooltip = null;
                if (adjustmentTimeout) {
                  $timeout.cancel(adjustmentTimeout);
                }
              }

              openedTooltips.remove(ttScope);
              
              if (tooltipLinkedScope) {
                tooltipLinkedScope.$destroy();
                tooltipLinkedScope = null;
              }
            }

            /**
             * Set the initial scope values. Once
             * the tooltip is created, the observers
             * will be added to keep things in sync.
             */
            function prepareTooltip() {
              ttScope.title = attrs[prefix + 'Title'];
              if (contentParse) {
                ttScope.content = contentParse(scope);
              } else {
                ttScope.content = attrs[ttType];
              }

              ttScope.popupClass = attrs[prefix + 'Class'];
              ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
              var placement = $position.parsePlacement(ttScope.placement);
              lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];

              var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
              var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
              ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
            }

            function assignIsOpen(isOpen) {
              if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
                isOpenParse.assign(scope, isOpen);
              }
            }

            ttScope.contentExp = function() {
              return ttScope.content;
            };

            /**
             * Observe the relevant attributes.
             */
            attrs.$observe('disabled', function(val) {
              if (val) {
                cancelShow();
              }

              if (val && ttScope.isOpen) {
                hide();
              }
            });

            if (isOpenParse) {
              scope.$watch(isOpenParse, function(val) {
                if (ttScope && !val === ttScope.isOpen) {
                  toggleTooltipBind();
                }
              });
            }

            function prepObservers() {
              observers.length = 0;

              if (contentParse) {
                observers.push(
                  scope.$watch(contentParse, function(val) {
                    ttScope.content = val;
                    if (!val && ttScope.isOpen) {
                      hide();
                    }
                  })
                );

                observers.push(
                  tooltipLinkedScope.$watch(function() {
                    if (!repositionScheduled) {
                      repositionScheduled = true;
                      tooltipLinkedScope.$$postDigest(function() {
                        repositionScheduled = false;
                        if (ttScope && ttScope.isOpen) {
                          positionTooltip();
                        }
                      });
                    }
                  })
                );
              } else {
                observers.push(
                  attrs.$observe(ttType, function(val) {
                    ttScope.content = val;
                    if (!val && ttScope.isOpen) {
                      hide();
                    } else {
                      positionTooltip();
                    }
                  })
                );
              }

              observers.push(
                attrs.$observe(prefix + 'Title', function(val) {
                  ttScope.title = val;
                  if (ttScope.isOpen) {
                    positionTooltip();
                  }
                })
              );

              observers.push(
                attrs.$observe(prefix + 'Placement', function(val) {
                  ttScope.placement = val ? val : options.placement;
                  if (ttScope.isOpen) {
                    positionTooltip();
                  }
                })
              );
            }

            function unregisterObservers() {
              if (observers.length) {
                angular.forEach(observers, function(observer) {
                  observer();
                });
                observers.length = 0;
              }
            }

            // hide tooltips/popovers for outsideClick trigger
            function bodyHideTooltipBind(e) {
              if (!ttScope || !ttScope.isOpen || !tooltip) {
                return;
              }
              // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
              if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {
                hideTooltipBind();
              }
            }

            // KeyboardEvent handler to hide the tooltip on Escape key press
            function hideOnEscapeKey(e) {
              if (e.which === 27) {
                hideTooltipBind();
              }
            }

            var unregisterTriggers = function() {
              triggers.show.forEach(function(trigger) {
                if (trigger === 'outsideClick') {
                  element.off('click', toggleTooltipBind);
                } else {
                  element.off(trigger, showTooltipBind);
                  element.off(trigger, toggleTooltipBind);
                }
                element.off('keypress', hideOnEscapeKey);
              });
              triggers.hide.forEach(function(trigger) {
                if (trigger === 'outsideClick') {
                  $document.off('click', bodyHideTooltipBind);
                } else {
                  element.off(trigger, hideTooltipBind);
                }
              });
            };

            function prepTriggers() {
              var showTriggers = [], hideTriggers = [];
              var val = scope.$eval(attrs[prefix + 'Trigger']);
              unregisterTriggers();

              if (angular.isObject(val)) {
                Object.keys(val).forEach(function(key) {
                  showTriggers.push(key);
                  hideTriggers.push(val[key]);
                });
                triggers = {
                  show: showTriggers,
                  hide: hideTriggers
                };
              } else {
                triggers = getTriggers(val);
              }

              if (triggers.show !== 'none') {
                triggers.show.forEach(function(trigger, idx) {
                  if (trigger === 'outsideClick') {
                    element.on('click', toggleTooltipBind);
                    $document.on('click', bodyHideTooltipBind);
                  } else if (trigger === triggers.hide[idx]) {
                    element.on(trigger, toggleTooltipBind);
                  } else if (trigger) {
                    element.on(trigger, showTooltipBind);
                    element.on(triggers.hide[idx], hideTooltipBind);
                  }
                  element.on('keypress', hideOnEscapeKey);
                });
              }
            }

            prepTriggers();

            var animation = scope.$eval(attrs[prefix + 'Animation']);
            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;

            var appendToBodyVal;
            var appendKey = prefix + 'AppendToBody';
            if (appendKey in attrs && attrs[appendKey] === undefined) {
              appendToBodyVal = true;
            } else {
              appendToBodyVal = scope.$eval(attrs[appendKey]);
            }

            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;

            // Make sure tooltip is destroyed and removed.
            scope.$on('$destroy', function onDestroyTooltip() {
              unregisterTriggers();
              removeTooltip();
              ttScope = null;
            });
          };
        }
      };
    };
  }];
})

// This is mostly ngInclude code but with a custom scope
.directive('uibTooltipTemplateTransclude', [
         '$animate', '$sce', '$compile', '$templateRequest',
function ($animate, $sce, $compile, $templateRequest) {
  return {
    link: function(scope, elem, attrs) {
      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);

      var changeCounter = 0,
        currentScope,
        previousElement,
        currentElement;

      var cleanupLastIncludeContent = function() {
        if (previousElement) {
          previousElement.remove();
          previousElement = null;
        }

        if (currentScope) {
          currentScope.$destroy();
          currentScope = null;
        }

        if (currentElement) {
          $animate.leave(currentElement).then(function() {
            previousElement = null;
          });
          previousElement = currentElement;
          currentElement = null;
        }
      };

      scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function(src) {
        var thisChangeId = ++changeCounter;

        if (src) {
          //set the 2nd param to true to ignore the template request error so that the inner
          //contents and scope can be cleaned up.
          $templateRequest(src, true).then(function(response) {
            if (thisChangeId !== changeCounter) { return; }
            var newScope = origScope.$new();
            var template = response;

            var clone = $compile(template)(newScope, function(clone) {
              cleanupLastIncludeContent();
              $animate.enter(clone, elem);
            });

            currentScope = newScope;
            currentElement = clone;

            currentScope.$emit('$includeContentLoaded', src);
          }, function() {
            if (thisChangeId === changeCounter) {
              cleanupLastIncludeContent();
              scope.$emit('$includeContentError', src);
            }
          });
          scope.$emit('$includeContentRequested', src);
        } else {
          cleanupLastIncludeContent();
        }
      });

      scope.$on('$destroy', cleanupLastIncludeContent);
    }
  };
}])

/**
 * Note that it's intentional that these classes are *not* applied through $animate.
 * They must not be animated as they're expected to be present on the tooltip on
 * initialization.
 */
.directive('uibTooltipClasses', ['$uibPosition', function($uibPosition) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      // need to set the primary position so the
      // arrow has space during position measure.
      // tooltip.positionTooltip()
      if (scope.placement) {
        // // There are no top-left etc... classes
        // // in TWBS, so we need the primary position.
        var position = $uibPosition.parsePlacement(scope.placement);
        element.addClass(position[0]);
      }

      if (scope.popupClass) {
        element.addClass(scope.popupClass);
      }

      if (scope.animation) {
        element.addClass(attrs.tooltipAnimationClass);
      }
    }
  };
}])

.directive('uibTooltipPopup', function() {
  return {
    restrict: 'A',
    scope: { content: '@' },
    templateUrl: 'uib/template/tooltip/tooltip-popup.html'
  };
})

.directive('uibTooltip', [ '$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
}])

.directive('uibTooltipTemplatePopup', function() {
  return {
    restrict: 'A',
    scope: { contentExp: '&', originScope: '&' },
    templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'
  };
})

.directive('uibTooltipTemplate', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
    useContentExp: true
  });
}])

.directive('uibTooltipHtmlPopup', function() {
  return {
    restrict: 'A',
    scope: { contentExp: '&' },
    templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
  };
})

.directive('uibTooltipHtml', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
    useContentExp: true
  });
}]);

/**
 * The following features are still outstanding: popup delay, animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, and selector delegatation.
 */
angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip'])

.directive('uibPopoverTemplatePopup', function() {
  return {
    restrict: 'A',
    scope: { uibTitle: '@', contentExp: '&', originScope: '&' },
    templateUrl: 'uib/template/popover/popover-template.html'
  };
})

.directive('uibPopoverTemplate', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {
    useContentExp: true
  });
}])

.directive('uibPopoverHtmlPopup', function() {
  return {
    restrict: 'A',
    scope: { contentExp: '&', uibTitle: '@' },
    templateUrl: 'uib/template/popover/popover-html.html'
  };
})

.directive('uibPopoverHtml', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibPopoverHtml', 'popover', 'click', {
    useContentExp: true
  });
}])

.directive('uibPopoverPopup', function() {
  return {
    restrict: 'A',
    scope: { uibTitle: '@', content: '@' },
    templateUrl: 'uib/template/popover/popover.html'
  };
})

.directive('uibPopover', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibPopover', 'popover', 'click');
}]);

angular.module('ui.bootstrap.progressbar', [])

.constant('uibProgressConfig', {
  animate: true,
  max: 100
})

.controller('UibProgressController', ['$scope', '$attrs', 'uibProgressConfig', function($scope, $attrs, progressConfig) {
  var self = this,
      animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;

  this.bars = [];
  $scope.max = getMaxOrDefault();

  this.addBar = function(bar, element, attrs) {
    if (!animate) {
      element.css({'transition': 'none'});
    }

    this.bars.push(bar);

    bar.max = getMaxOrDefault();
    bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';

    bar.$watch('value', function(value) {
      bar.recalculatePercentage();
    });

    bar.recalculatePercentage = function() {
      var totalPercentage = self.bars.reduce(function(total, bar) {
        bar.percent = +(100 * bar.value / bar.max).toFixed(2);
        return total + bar.percent;
      }, 0);

      if (totalPercentage > 100) {
        bar.percent -= totalPercentage - 100;
      }
    };

    bar.$on('$destroy', function() {
      element = null;
      self.removeBar(bar);
    });
  };

  this.removeBar = function(bar) {
    this.bars.splice(this.bars.indexOf(bar), 1);
    this.bars.forEach(function (bar) {
      bar.recalculatePercentage();
    });
  };

  //$attrs.$observe('maxParam', function(maxParam) {
  $scope.$watch('maxParam', function(maxParam) {
    self.bars.forEach(function(bar) {
      bar.max = getMaxOrDefault();
      bar.recalculatePercentage();
    });
  });

  function getMaxOrDefault () {
    return angular.isDefined($scope.maxParam) ? $scope.maxParam : progressConfig.max;
  }
}])

.directive('uibProgress', function() {
  return {
    replace: true,
    transclude: true,
    controller: 'UibProgressController',
    require: 'uibProgress',
    scope: {
      maxParam: '=?max'
    },
    templateUrl: 'uib/template/progressbar/progress.html'
  };
})

.directive('uibBar', function() {
  return {
    replace: true,
    transclude: true,
    require: '^uibProgress',
    scope: {
      value: '=',
      type: '@'
    },
    templateUrl: 'uib/template/progressbar/bar.html',
    link: function(scope, element, attrs, progressCtrl) {
      progressCtrl.addBar(scope, element, attrs);
    }
  };
})

.directive('uibProgressbar', function() {
  return {
    replace: true,
    transclude: true,
    controller: 'UibProgressController',
    scope: {
      value: '=',
      maxParam: '=?max',
      type: '@'
    },
    templateUrl: 'uib/template/progressbar/progressbar.html',
    link: function(scope, element, attrs, progressCtrl) {
      progressCtrl.addBar(scope, angular.element(element.children()[0]), {title: attrs.title});
    }
  };
});

angular.module('ui.bootstrap.rating', [])

.constant('uibRatingConfig', {
  max: 5,
  stateOn: null,
  stateOff: null,
  enableReset: true,
  titles: ['one', 'two', 'three', 'four', 'five']
})

.controller('UibRatingController', ['$scope', '$attrs', 'uibRatingConfig', function($scope, $attrs, ratingConfig) {
  var ngModelCtrl = { $setViewValue: angular.noop },
    self = this;

  this.init = function(ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = this.render;

    ngModelCtrl.$formatters.push(function(value) {
      if (angular.isNumber(value) && value << 0 !== value) {
        value = Math.round(value);
      }

      return value;
    });

    this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
    this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
    this.enableReset = angular.isDefined($attrs.enableReset) ?
      $scope.$parent.$eval($attrs.enableReset) : ratingConfig.enableReset;
    var tmpTitles = angular.isDefined($attrs.titles) ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles;
    this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ?
      tmpTitles : ratingConfig.titles;

    var ratingStates = angular.isDefined($attrs.ratingStates) ?
      $scope.$parent.$eval($attrs.ratingStates) :
      new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
    $scope.range = this.buildTemplateObjects(ratingStates);
  };

  this.buildTemplateObjects = function(states) {
    for (var i = 0, n = states.length; i < n; i++) {
      states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff, title: this.getTitle(i) }, states[i]);
    }
    return states;
  };

  this.getTitle = function(index) {
    if (index >= this.titles.length) {
      return index + 1;
    }

    return this.titles[index];
  };

  $scope.rate = function(value) {
    if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
      var newViewValue = self.enableReset && ngModelCtrl.$viewValue === value ? 0 : value;
      ngModelCtrl.$setViewValue(newViewValue);
      ngModelCtrl.$render();
    }
  };

  $scope.enter = function(value) {
    if (!$scope.readonly) {
      $scope.value = value;
    }
    $scope.onHover({value: value});
  };

  $scope.reset = function() {
    $scope.value = ngModelCtrl.$viewValue;
    $scope.onLeave();
  };

  $scope.onKeydown = function(evt) {
    if (/(37|38|39|40)/.test(evt.which)) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
    }
  };

  this.render = function() {
    $scope.value = ngModelCtrl.$viewValue;
    $scope.title = self.getTitle($scope.value - 1);
  };
}])

.directive('uibRating', function() {
  return {
    require: ['uibRating', 'ngModel'],
    restrict: 'A',
    scope: {
      readonly: '=?readOnly',
      onHover: '&',
      onLeave: '&'
    },
    controller: 'UibRatingController',
    templateUrl: 'uib/template/rating/rating.html',
    link: function(scope, element, attrs, ctrls) {
      var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
      ratingCtrl.init(ngModelCtrl);
    }
  };
});

angular.module('ui.bootstrap.tabs', [])

.controller('UibTabsetController', ['$scope', function ($scope) {
  var ctrl = this,
    oldIndex;
  ctrl.tabs = [];

  ctrl.select = function(index, evt) {
    if (!destroyed) {
      var previousIndex = findTabIndex(oldIndex);
      var previousSelected = ctrl.tabs[previousIndex];
      if (previousSelected) {
        previousSelected.tab.onDeselect({
          $event: evt,
          $selectedIndex: index
        });
        if (evt && evt.isDefaultPrevented()) {
          return;
        }
        previousSelected.tab.active = false;
      }

      var selected = ctrl.tabs[index];
      if (selected) {
        selected.tab.onSelect({
          $event: evt
        });
        selected.tab.active = true;
        ctrl.active = selected.index;
        oldIndex = selected.index;
      } else if (!selected && angular.isDefined(oldIndex)) {
        ctrl.active = null;
        oldIndex = null;
      }
    }
  };

  ctrl.addTab = function addTab(tab) {
    ctrl.tabs.push({
      tab: tab,
      index: tab.index
    });
    ctrl.tabs.sort(function(t1, t2) {
      if (t1.index > t2.index) {
        return 1;
      }

      if (t1.index < t2.index) {
        return -1;
      }

      return 0;
    });

    if (tab.index === ctrl.active || !angular.isDefined(ctrl.active) && ctrl.tabs.length === 1) {
      var newActiveIndex = findTabIndex(tab.index);
      ctrl.select(newActiveIndex);
    }
  };

  ctrl.removeTab = function removeTab(tab) {
    var index;
    for (var i = 0; i < ctrl.tabs.length; i++) {
      if (ctrl.tabs[i].tab === tab) {
        index = i;
        break;
      }
    }

    if (ctrl.tabs[index].index === ctrl.active) {
      var newActiveTabIndex = index === ctrl.tabs.length - 1 ?
        index - 1 : index + 1 % ctrl.tabs.length;
      ctrl.select(newActiveTabIndex);
    }

    ctrl.tabs.splice(index, 1);
  };

  $scope.$watch('tabset.active', function(val) {
    if (angular.isDefined(val) && val !== oldIndex) {
      ctrl.select(findTabIndex(val));
    }
  });

  var destroyed;
  $scope.$on('$destroy', function() {
    destroyed = true;
  });

  function findTabIndex(index) {
    for (var i = 0; i < ctrl.tabs.length; i++) {
      if (ctrl.tabs[i].index === index) {
        return i;
      }
    }
  }
}])

.directive('uibTabset', function() {
  return {
    transclude: true,
    replace: true,
    scope: {},
    bindToController: {
      active: '=?',
      type: '@'
    },
    controller: 'UibTabsetController',
    controllerAs: 'tabset',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/tabs/tabset.html';
    },
    link: function(scope, element, attrs) {
      scope.vertical = angular.isDefined(attrs.vertical) ?
        scope.$parent.$eval(attrs.vertical) : false;
      scope.justified = angular.isDefined(attrs.justified) ?
        scope.$parent.$eval(attrs.justified) : false;
    }
  };
})

.directive('uibTab', ['$parse', function($parse) {
  return {
    require: '^uibTabset',
    replace: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/tabs/tab.html';
    },
    transclude: true,
    scope: {
      heading: '@',
      index: '=?',
      classes: '@?',
      onSelect: '&select', //This callback is called in contentHeadingTransclude
                          //once it inserts the tab's content into the dom
      onDeselect: '&deselect'
    },
    controller: function() {
      //Empty controller so other directives can require being 'under' a tab
    },
    controllerAs: 'tab',
    link: function(scope, elm, attrs, tabsetCtrl, transclude) {
      scope.disabled = false;
      if (attrs.disable) {
        scope.$parent.$watch($parse(attrs.disable), function(value) {
          scope.disabled = !! value;
        });
      }

      if (angular.isUndefined(attrs.index)) {
        if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {
          scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function(t) { return t.index; })) + 1;
        } else {
          scope.index = 0;
        }
      }

      if (angular.isUndefined(attrs.classes)) {
        scope.classes = '';
      }

      scope.select = function(evt) {
        if (!scope.disabled) {
          var index;
          for (var i = 0; i < tabsetCtrl.tabs.length; i++) {
            if (tabsetCtrl.tabs[i].tab === scope) {
              index = i;
              break;
            }
          }

          tabsetCtrl.select(index, evt);
        }
      };

      tabsetCtrl.addTab(scope);
      scope.$on('$destroy', function() {
        tabsetCtrl.removeTab(scope);
      });

      //We need to transclude later, once the content container is ready.
      //when this link happens, we're inside a tab heading.
      scope.$transcludeFn = transclude;
    }
  };
}])

.directive('uibTabHeadingTransclude', function() {
  return {
    restrict: 'A',
    require: '^uibTab',
    link: function(scope, elm) {
      scope.$watch('headingElement', function updateHeadingElement(heading) {
        if (heading) {
          elm.html('');
          elm.append(heading);
        }
      });
    }
  };
})

.directive('uibTabContentTransclude', function() {
  return {
    restrict: 'A',
    require: '^uibTabset',
    link: function(scope, elm, attrs) {
      var tab = scope.$eval(attrs.uibTabContentTransclude).tab;

      //Now our tab is ready to be transcluded: both the tab heading area
      //and the tab content area are loaded.  Transclude 'em both.
      tab.$transcludeFn(tab.$parent, function(contents) {
        angular.forEach(contents, function(node) {
          if (isTabHeading(node)) {
            //Let tabHeadingTransclude know.
            tab.headingElement = node;
          } else {
            elm.append(node);
          }
        });
      });
    }
  };

  function isTabHeading(node) {
    return node.tagName && (
      node.hasAttribute('uib-tab-heading') ||
      node.hasAttribute('data-uib-tab-heading') ||
      node.hasAttribute('x-uib-tab-heading') ||
      node.tagName.toLowerCase() === 'uib-tab-heading' ||
      node.tagName.toLowerCase() === 'data-uib-tab-heading' ||
      node.tagName.toLowerCase() === 'x-uib-tab-heading' ||
      node.tagName.toLowerCase() === 'uib:tab-heading'
    );
  }
});

angular.module('ui.bootstrap.timepicker', [])

.constant('uibTimepickerConfig', {
  hourStep: 1,
  minuteStep: 1,
  secondStep: 1,
  showMeridian: true,
  showSeconds: false,
  meridians: null,
  readonlyInput: false,
  mousewheel: true,
  arrowkeys: true,
  showSpinners: true,
  templateUrl: 'uib/template/timepicker/timepicker.html'
})

.controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
  var hoursModelCtrl, minutesModelCtrl, secondsModelCtrl;
  var selected = new Date(),
    watchers = [],
    ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
    meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS,
    padHours = angular.isDefined($attrs.padHours) ? $scope.$parent.$eval($attrs.padHours) : true;

  $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
  $element.removeAttr('tabindex');

  this.init = function(ngModelCtrl_, inputs) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = this.render;

    ngModelCtrl.$formatters.unshift(function(modelValue) {
      return modelValue ? new Date(modelValue) : null;
    });

    var hoursInputEl = inputs.eq(0),
        minutesInputEl = inputs.eq(1),
        secondsInputEl = inputs.eq(2);

    hoursModelCtrl = hoursInputEl.controller('ngModel');
    minutesModelCtrl = minutesInputEl.controller('ngModel');
    secondsModelCtrl = secondsInputEl.controller('ngModel');

    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;

    if (mousewheel) {
      this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);
    }

    var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
    if (arrowkeys) {
      this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);
    }

    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
    this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);
  };

  var hourStep = timepickerConfig.hourStep;
  if ($attrs.hourStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function(value) {
      hourStep = +value;
    }));
  }

  var minuteStep = timepickerConfig.minuteStep;
  if ($attrs.minuteStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function(value) {
      minuteStep = +value;
    }));
  }

  var min;
  watchers.push($scope.$parent.$watch($parse($attrs.min), function(value) {
    var dt = new Date(value);
    min = isNaN(dt) ? undefined : dt;
  }));

  var max;
  watchers.push($scope.$parent.$watch($parse($attrs.max), function(value) {
    var dt = new Date(value);
    max = isNaN(dt) ? undefined : dt;
  }));

  var disabled = false;
  if ($attrs.ngDisabled) {
    watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(value) {
      disabled = value;
    }));
  }

  $scope.noIncrementHours = function() {
    var incrementedSelected = addMinutes(selected, hourStep * 60);
    return disabled || incrementedSelected > max ||
      incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementHours = function() {
    var decrementedSelected = addMinutes(selected, -hourStep * 60);
    return disabled || decrementedSelected < min ||
      decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noIncrementMinutes = function() {
    var incrementedSelected = addMinutes(selected, minuteStep);
    return disabled || incrementedSelected > max ||
      incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementMinutes = function() {
    var decrementedSelected = addMinutes(selected, -minuteStep);
    return disabled || decrementedSelected < min ||
      decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noIncrementSeconds = function() {
    var incrementedSelected = addSeconds(selected, secondStep);
    return disabled || incrementedSelected > max ||
      incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementSeconds = function() {
    var decrementedSelected = addSeconds(selected, -secondStep);
    return disabled || decrementedSelected < min ||
      decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noToggleMeridian = function() {
    if (selected.getHours() < 12) {
      return disabled || addMinutes(selected, 12 * 60) > max;
    }

    return disabled || addMinutes(selected, -12 * 60) < min;
  };

  var secondStep = timepickerConfig.secondStep;
  if ($attrs.secondStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function(value) {
      secondStep = +value;
    }));
  }

  $scope.showSeconds = timepickerConfig.showSeconds;
  if ($attrs.showSeconds) {
    watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function(value) {
      $scope.showSeconds = !!value;
    }));
  }

  // 12H / 24H mode
  $scope.showMeridian = timepickerConfig.showMeridian;
  if ($attrs.showMeridian) {
    watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function(value) {
      $scope.showMeridian = !!value;

      if (ngModelCtrl.$error.time) {
        // Evaluate from template
        var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
          selected.setHours(hours);
          refresh();
        }
      } else {
        updateTemplate();
      }
    }));
  }

  // Get $scope.hours in 24H mode if valid
  function getHoursFromTemplate() {
    var hours = +$scope.hours;
    var valid = $scope.showMeridian ? hours > 0 && hours < 13 :
      hours >= 0 && hours < 24;
    if (!valid || $scope.hours === '') {
      return undefined;
    }

    if ($scope.showMeridian) {
      if (hours === 12) {
        hours = 0;
      }
      if ($scope.meridian === meridians[1]) {
        hours = hours + 12;
      }
    }
    return hours;
  }

  function getMinutesFromTemplate() {
    var minutes = +$scope.minutes;
    var valid = minutes >= 0 && minutes < 60;
    if (!valid || $scope.minutes === '') {
      return undefined;
    }
    return minutes;
  }

  function getSecondsFromTemplate() {
    var seconds = +$scope.seconds;
    return seconds >= 0 && seconds < 60 ? seconds : undefined;
  }

  function pad(value, noPad) {
    if (value === null) {
      return '';
    }

    return angular.isDefined(value) && value.toString().length < 2 && !noPad ?
      '0' + value : value.toString();
  }

  // Respond on mousewheel spin
  this.setupMousewheelEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
    var isScrollingUp = function(e) {
      if (e.originalEvent) {
        e = e.originalEvent;
      }
      //pick correct delta variable depending on event
      var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
      return e.detail || delta > 0;
    };

    hoursInputEl.on('mousewheel wheel', function(e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
      }
      e.preventDefault();
    });

    minutesInputEl.on('mousewheel wheel', function(e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
      }
      e.preventDefault();
    });

     secondsInputEl.on('mousewheel wheel', function(e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());
      }
      e.preventDefault();
    });
  };

  // Respond on up/down arrowkeys
  this.setupArrowkeyEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
    hoursInputEl.on('keydown', function(e) {
      if (!disabled) {
        if (e.which === 38) { // up
          e.preventDefault();
          $scope.incrementHours();
          $scope.$apply();
        } else if (e.which === 40) { // down
          e.preventDefault();
          $scope.decrementHours();
          $scope.$apply();
        }
      }
    });

    minutesInputEl.on('keydown', function(e) {
      if (!disabled) {
        if (e.which === 38) { // up
          e.preventDefault();
          $scope.incrementMinutes();
          $scope.$apply();
        } else if (e.which === 40) { // down
          e.preventDefault();
          $scope.decrementMinutes();
          $scope.$apply();
        }
      }
    });

    secondsInputEl.on('keydown', function(e) {
      if (!disabled) {
        if (e.which === 38) { // up
          e.preventDefault();
          $scope.incrementSeconds();
          $scope.$apply();
        } else if (e.which === 40) { // down
          e.preventDefault();
          $scope.decrementSeconds();
          $scope.$apply();
        }
      }
    });
  };

  this.setupInputEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
    if ($scope.readonlyInput) {
      $scope.updateHours = angular.noop;
      $scope.updateMinutes = angular.noop;
      $scope.updateSeconds = angular.noop;
      return;
    }

    var invalidate = function(invalidHours, invalidMinutes, invalidSeconds) {
      ngModelCtrl.$setViewValue(null);
      ngModelCtrl.$setValidity('time', false);
      if (angular.isDefined(invalidHours)) {
        $scope.invalidHours = invalidHours;
        if (hoursModelCtrl) {
          hoursModelCtrl.$setValidity('hours', false);
        }
      }

      if (angular.isDefined(invalidMinutes)) {
        $scope.invalidMinutes = invalidMinutes;
        if (minutesModelCtrl) {
          minutesModelCtrl.$setValidity('minutes', false);
        }
      }

      if (angular.isDefined(invalidSeconds)) {
        $scope.invalidSeconds = invalidSeconds;
        if (secondsModelCtrl) {
          secondsModelCtrl.$setValidity('seconds', false);
        }
      }
    };

    $scope.updateHours = function() {
      var hours = getHoursFromTemplate(),
        minutes = getMinutesFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(hours) && angular.isDefined(minutes)) {
        selected.setHours(hours);
        selected.setMinutes(minutes);
        if (selected < min || selected > max) {
          invalidate(true);
        } else {
          refresh('h');
        }
      } else {
        invalidate(true);
      }
    };

    hoursInputEl.on('blur', function(e) {
      ngModelCtrl.$setTouched();
      if (modelIsEmpty()) {
        makeValid();
      } else if ($scope.hours === null || $scope.hours === '') {
        invalidate(true);
      } else if (!$scope.invalidHours && $scope.hours < 10) {
        $scope.$apply(function() {
          $scope.hours = pad($scope.hours, !padHours);
        });
      }
    });

    $scope.updateMinutes = function() {
      var minutes = getMinutesFromTemplate(),
        hours = getHoursFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
        selected.setHours(hours);
        selected.setMinutes(minutes);
        if (selected < min || selected > max) {
          invalidate(undefined, true);
        } else {
          refresh('m');
        }
      } else {
        invalidate(undefined, true);
      }
    };

    minutesInputEl.on('blur', function(e) {
      ngModelCtrl.$setTouched();
      if (modelIsEmpty()) {
        makeValid();
      } else if ($scope.minutes === null) {
        invalidate(undefined, true);
      } else if (!$scope.invalidMinutes && $scope.minutes < 10) {
        $scope.$apply(function() {
          $scope.minutes = pad($scope.minutes);
        });
      }
    });

    $scope.updateSeconds = function() {
      var seconds = getSecondsFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(seconds)) {
        selected.setSeconds(seconds);
        refresh('s');
      } else {
        invalidate(undefined, undefined, true);
      }
    };

    secondsInputEl.on('blur', function(e) {
      if (modelIsEmpty()) {
        makeValid();
      } else if (!$scope.invalidSeconds && $scope.seconds < 10) {
        $scope.$apply( function() {
          $scope.seconds = pad($scope.seconds);
        });
      }
    });

  };

  this.render = function() {
    var date = ngModelCtrl.$viewValue;

    if (isNaN(date)) {
      ngModelCtrl.$setValidity('time', false);
      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
    } else {
      if (date) {
        selected = date;
      }

      if (selected < min || selected > max) {
        ngModelCtrl.$setValidity('time', false);
        $scope.invalidHours = true;
        $scope.invalidMinutes = true;
      } else {
        makeValid();
      }
      updateTemplate();
    }
  };

  // Call internally when we know that model is valid.
  function refresh(keyboardChange) {
    makeValid();
    ngModelCtrl.$setViewValue(new Date(selected));
    updateTemplate(keyboardChange);
  }

  function makeValid() {
    if (hoursModelCtrl) {
      hoursModelCtrl.$setValidity('hours', true);
    }

    if (minutesModelCtrl) {
      minutesModelCtrl.$setValidity('minutes', true);
    }

    if (secondsModelCtrl) {
      secondsModelCtrl.$setValidity('seconds', true);
    }

    ngModelCtrl.$setValidity('time', true);
    $scope.invalidHours = false;
    $scope.invalidMinutes = false;
    $scope.invalidSeconds = false;
  }

  function updateTemplate(keyboardChange) {
    if (!ngModelCtrl.$modelValue) {
      $scope.hours = null;
      $scope.minutes = null;
      $scope.seconds = null;
      $scope.meridian = meridians[0];
    } else {
      var hours = selected.getHours(),
        minutes = selected.getMinutes(),
        seconds = selected.getSeconds();

      if ($scope.showMeridian) {
        hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
      }

      $scope.hours = keyboardChange === 'h' ? hours : pad(hours, !padHours);
      if (keyboardChange !== 'm') {
        $scope.minutes = pad(minutes);
      }
      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];

      if (keyboardChange !== 's') {
        $scope.seconds = pad(seconds);
      }
      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
    }
  }

  function addSecondsToSelected(seconds) {
    selected = addSeconds(selected, seconds);
    refresh();
  }

  function addMinutes(selected, minutes) {
    return addSeconds(selected, minutes*60);
  }

  function addSeconds(date, seconds) {
    var dt = new Date(date.getTime() + seconds * 1000);
    var newDate = new Date(date);
    newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());
    return newDate;
  }

  function modelIsEmpty() {
    return ($scope.hours === null || $scope.hours === '') &&
      ($scope.minutes === null || $scope.minutes === '') &&
      (!$scope.showSeconds || $scope.showSeconds && ($scope.seconds === null || $scope.seconds === ''));
  }

  $scope.showSpinners = angular.isDefined($attrs.showSpinners) ?
    $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;

  $scope.incrementHours = function() {
    if (!$scope.noIncrementHours()) {
      addSecondsToSelected(hourStep * 60 * 60);
    }
  };

  $scope.decrementHours = function() {
    if (!$scope.noDecrementHours()) {
      addSecondsToSelected(-hourStep * 60 * 60);
    }
  };

  $scope.incrementMinutes = function() {
    if (!$scope.noIncrementMinutes()) {
      addSecondsToSelected(minuteStep * 60);
    }
  };

  $scope.decrementMinutes = function() {
    if (!$scope.noDecrementMinutes()) {
      addSecondsToSelected(-minuteStep * 60);
    }
  };

  $scope.incrementSeconds = function() {
    if (!$scope.noIncrementSeconds()) {
      addSecondsToSelected(secondStep);
    }
  };

  $scope.decrementSeconds = function() {
    if (!$scope.noDecrementSeconds()) {
      addSecondsToSelected(-secondStep);
    }
  };

  $scope.toggleMeridian = function() {
    var minutes = getMinutesFromTemplate(),
        hours = getHoursFromTemplate();

    if (!$scope.noToggleMeridian()) {
      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
        addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));
      } else {
        $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];
      }
    }
  };

  $scope.blur = function() {
    ngModelCtrl.$setTouched();
  };

  $scope.$on('$destroy', function() {
    while (watchers.length) {
      watchers.shift()();
    }
  });
}])

.directive('uibTimepicker', ['uibTimepickerConfig', function(uibTimepickerConfig) {
  return {
    require: ['uibTimepicker', '?^ngModel'],
    restrict: 'A',
    controller: 'UibTimepickerController',
    controllerAs: 'timepicker',
    scope: {},
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || uibTimepickerConfig.templateUrl;
    },
    link: function(scope, element, attrs, ctrls) {
      var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (ngModelCtrl) {
        timepickerCtrl.init(ngModelCtrl, element.find('input'));
      }
    }
  };
}]);

angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.debounce', 'ui.bootstrap.position'])

/**
 * A helper service that can parse typeahead's syntax (string provided by users)
 * Extracted to a separate service for ease of unit testing
 */
  .factory('uibTypeaheadParser', ['$parse', function($parse) {
    //                      000001111111100000000000002222222200000000000000003333333333333330000000000044444444000
    var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
    return {
      parse: function(input) {
        var match = input.match(TYPEAHEAD_REGEXP);
        if (!match) {
          throw new Error(
            'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
              ' but got "' + input + '".');
        }

        return {
          itemName: match[3],
          source: $parse(match[4]),
          viewMapper: $parse(match[2] || match[1]),
          modelMapper: $parse(match[1])
        };
      }
    };
  }])

  .controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$$debounce', '$uibPosition', 'uibTypeaheadParser',
    function(originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $$debounce, $position, typeaheadParser) {
    var HOT_KEYS = [9, 13, 27, 38, 40];
    var eventDebounceTime = 200;
    var modelCtrl, ngModelOptions;
    //SUPPORTED ATTRIBUTES (OPTIONS)

    //minimal no of characters that needs to be entered before typeahead kicks-in
    var minLength = originalScope.$eval(attrs.typeaheadMinLength);
    if (!minLength && minLength !== 0) {
      minLength = 1;
    }

    originalScope.$watch(attrs.typeaheadMinLength, function (newVal) {
        minLength = !newVal && newVal !== 0 ? 1 : newVal;
    });

    //minimal wait time after last character typed before typeahead kicks-in
    var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;

    //should it restrict model values to the ones selected from the popup only?
    var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
    originalScope.$watch(attrs.typeaheadEditable, function (newVal) {
      isEditable = newVal !== false;
    });

    //binding to a variable that indicates if matches are being retrieved asynchronously
    var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

    //a function to determine if an event should cause selection
    var isSelectEvent = attrs.typeaheadShouldSelect ? $parse(attrs.typeaheadShouldSelect) : function(scope, vals) {
      var evt = vals.$event;
      return evt.which === 13 || evt.which === 9;
    };

    //a callback executed when a match is selected
    var onSelectCallback = $parse(attrs.typeaheadOnSelect);

    //should it select highlighted popup value when losing focus?
    var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;

    //binding to a variable that indicates if there were no results after the query is completed
    var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;

    var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;

    var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;

    var appendTo = attrs.typeaheadAppendTo ?
      originalScope.$eval(attrs.typeaheadAppendTo) : null;

    var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;

    //If input matches an item of the list exactly, select it automatically
    var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;

    //binding to a variable that indicates if dropdown is open
    var isOpenSetter = $parse(attrs.typeaheadIsOpen).assign || angular.noop;

    var showHint = originalScope.$eval(attrs.typeaheadShowHint) || false;

    //INTERNAL VARIABLES

    //model setter executed upon match selection
    var parsedModel = $parse(attrs.ngModel);
    var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
    var $setModelValue = function(scope, newValue) {
      if (angular.isFunction(parsedModel(originalScope)) &&
        ngModelOptions.getOption('getterSetter')) {
        return invokeModelSetter(scope, {$$$p: newValue});
      }

      return parsedModel.assign(scope, newValue);
    };

    //expressions used by typeahead
    var parserResult = typeaheadParser.parse(attrs.uibTypeahead);

    var hasFocus;

    //Used to avoid bug in iOS webview where iOS keyboard does not fire
    //mousedown & mouseup events
    //Issue #3699
    var selected;

    //create a child scope for the typeahead directive so we are not polluting original scope
    //with typeahead-specific data (matches, query etc.)
    var scope = originalScope.$new();
    var offDestroy = originalScope.$on('$destroy', function() {
      scope.$destroy();
    });
    scope.$on('$destroy', offDestroy);

    // WAI-ARIA
    var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
    element.attr({
      'aria-autocomplete': 'list',
      'aria-expanded': false,
      'aria-owns': popupId
    });

    var inputsContainer, hintInputElem;
    //add read-only input to show hint
    if (showHint) {
      inputsContainer = angular.element('<div></div>');
      inputsContainer.css('position', 'relative');
      element.after(inputsContainer);
      hintInputElem = element.clone();
      hintInputElem.attr('placeholder', '');
      hintInputElem.attr('tabindex', '-1');
      hintInputElem.val('');
      hintInputElem.css({
        'position': 'absolute',
        'top': '0px',
        'left': '0px',
        'border-color': 'transparent',
        'box-shadow': 'none',
        'opacity': 1,
        'background': 'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)',
        'color': '#999'
      });
      element.css({
        'position': 'relative',
        'vertical-align': 'top',
        'background-color': 'transparent'
      });

      if (hintInputElem.attr('id')) {
        hintInputElem.removeAttr('id'); // remove duplicate id if present.
      }
      inputsContainer.append(hintInputElem);
      hintInputElem.after(element);
    }

    //pop-up element used to display matches
    var popUpEl = angular.element('<div uib-typeahead-popup></div>');
    popUpEl.attr({
      id: popupId,
      matches: 'matches',
      active: 'activeIdx',
      select: 'select(activeIdx, evt)',
      'move-in-progress': 'moveInProgress',
      query: 'query',
      position: 'position',
      'assign-is-open': 'assignIsOpen(isOpen)',
      debounce: 'debounceUpdate'
    });
    //custom item template
    if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
      popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
    }

    if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
      popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
    }

    var resetHint = function() {
      if (showHint) {
        hintInputElem.val('');
      }
    };

    var resetMatches = function() {
      scope.matches = [];
      scope.activeIdx = -1;
      element.attr('aria-expanded', false);
      resetHint();
    };

    var getMatchId = function(index) {
      return popupId + '-option-' + index;
    };

    // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
    // This attribute is added or removed automatically when the `activeIdx` changes.
    scope.$watch('activeIdx', function(index) {
      if (index < 0) {
        element.removeAttr('aria-activedescendant');
      } else {
        element.attr('aria-activedescendant', getMatchId(index));
      }
    });

    var inputIsExactMatch = function(inputValue, index) {
      if (scope.matches.length > index && inputValue) {
        return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
      }

      return false;
    };

    var getMatchesAsync = function(inputValue, evt) {
      var locals = {$viewValue: inputValue};
      isLoadingSetter(originalScope, true);
      isNoResultsSetter(originalScope, false);
      $q.when(parserResult.source(originalScope, locals)).then(function(matches) {
        //it might happen that several async queries were in progress if a user were typing fast
        //but we are interested only in responses that correspond to the current view value
        var onCurrentRequest = inputValue === modelCtrl.$viewValue;
        if (onCurrentRequest && hasFocus) {
          if (matches && matches.length > 0) {
            scope.activeIdx = focusFirst ? 0 : -1;
            isNoResultsSetter(originalScope, false);
            scope.matches.length = 0;

            //transform labels
            for (var i = 0; i < matches.length; i++) {
              locals[parserResult.itemName] = matches[i];
              scope.matches.push({
                id: getMatchId(i),
                label: parserResult.viewMapper(scope, locals),
                model: matches[i]
              });
            }

            scope.query = inputValue;
            //position pop-up with matches - we need to re-calculate its position each time we are opening a window
            //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
            //due to other elements being rendered
            recalculatePosition();

            element.attr('aria-expanded', true);

            //Select the single remaining option if user input matches
            if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
                $$debounce(function() {
                  scope.select(0, evt);
                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
              } else {
                scope.select(0, evt);
              }
            }

            if (showHint) {
              var firstLabel = scope.matches[0].label;
              if (angular.isString(inputValue) &&
                inputValue.length > 0 &&
                firstLabel.slice(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {
                hintInputElem.val(inputValue + firstLabel.slice(inputValue.length));
              } else {
                hintInputElem.val('');
              }
            }
          } else {
            resetMatches();
            isNoResultsSetter(originalScope, true);
          }
        }
        if (onCurrentRequest) {
          isLoadingSetter(originalScope, false);
        }
      }, function() {
        resetMatches();
        isLoadingSetter(originalScope, false);
        isNoResultsSetter(originalScope, true);
      });
    };

    // bind events only if appendToBody params exist - performance feature
    if (appendToBody) {
      angular.element($window).on('resize', fireRecalculating);
      $document.find('body').on('scroll', fireRecalculating);
    }

    // Declare the debounced function outside recalculating for
    // proper debouncing
    var debouncedRecalculate = $$debounce(function() {
      // if popup is visible
      if (scope.matches.length) {
        recalculatePosition();
      }

      scope.moveInProgress = false;
    }, eventDebounceTime);

    // Default progress type
    scope.moveInProgress = false;

    function fireRecalculating() {
      if (!scope.moveInProgress) {
        scope.moveInProgress = true;
        scope.$digest();
      }

      debouncedRecalculate();
    }

    // recalculate actual position and set new values to scope
    // after digest loop is popup in right position
    function recalculatePosition() {
      scope.position = appendToBody ? $position.offset(element) : $position.position(element);
      scope.position.top += element.prop('offsetHeight');
    }

    //we need to propagate user's query so we can higlight matches
    scope.query = undefined;

    //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
    var timeoutPromise;

    var scheduleSearchWithTimeout = function(inputValue) {
      timeoutPromise = $timeout(function() {
        getMatchesAsync(inputValue);
      }, waitTime);
    };

    var cancelPreviousTimeout = function() {
      if (timeoutPromise) {
        $timeout.cancel(timeoutPromise);
      }
    };

    resetMatches();

    scope.assignIsOpen = function (isOpen) {
      isOpenSetter(originalScope, isOpen);
    };

    scope.select = function(activeIdx, evt) {
      //called from within the $digest() cycle
      var locals = {};
      var model, item;

      selected = true;
      locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
      model = parserResult.modelMapper(originalScope, locals);
      $setModelValue(originalScope, model);
      modelCtrl.$setValidity('editable', true);
      modelCtrl.$setValidity('parse', true);

      onSelectCallback(originalScope, {
        $item: item,
        $model: model,
        $label: parserResult.viewMapper(originalScope, locals),
        $event: evt
      });

      resetMatches();

      //return focus to the input element if a match was selected via a mouse click event
      // use timeout to avoid $rootScope:inprog error
      if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
        $timeout(function() { element[0].focus(); }, 0, false);
      }
    };

    //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
    element.on('keydown', function(evt) {
      //typeahead is open and an "interesting" key was pressed
      if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
        return;
      }

      var shouldSelect = isSelectEvent(originalScope, {$event: evt});

      /**
       * if there's nothing selected (i.e. focusFirst) and enter or tab is hit
       * or
       * shift + tab is pressed to bring focus to the previous element
       * then clear the results
       */
      if (scope.activeIdx === -1 && shouldSelect || evt.which === 9 && !!evt.shiftKey) {
        resetMatches();
        scope.$digest();
        return;
      }

      evt.preventDefault();
      var target;
      switch (evt.which) {
        case 27: // escape
          evt.stopPropagation();

          resetMatches();
          originalScope.$digest();
          break;
        case 38: // up arrow
          scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
          scope.$digest();
          target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
          target.parentNode.scrollTop = target.offsetTop;
          break;
        case 40: // down arrow
          scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
          scope.$digest();
          target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
          target.parentNode.scrollTop = target.offsetTop;
          break;
        default:
          if (shouldSelect) {
            scope.$apply(function() {
              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
                $$debounce(function() {
                  scope.select(scope.activeIdx, evt);
                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
              } else {
                scope.select(scope.activeIdx, evt);
              }
            });
          }
      }
    });

    element.on('focus', function (evt) {
      hasFocus = true;
      if (minLength === 0 && !modelCtrl.$viewValue) {
        $timeout(function() {
          getMatchesAsync(modelCtrl.$viewValue, evt);
        }, 0);
      }
    });

    element.on('blur', function(evt) {
      if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
        selected = true;
        scope.$apply(function() {
          if (angular.isObject(scope.debounceUpdate) && angular.isNumber(scope.debounceUpdate.blur)) {
            $$debounce(function() {
              scope.select(scope.activeIdx, evt);
            }, scope.debounceUpdate.blur);
          } else {
            scope.select(scope.activeIdx, evt);
          }
        });
      }
      if (!isEditable && modelCtrl.$error.editable) {
        modelCtrl.$setViewValue();
        scope.$apply(function() {
          // Reset validity as we are clearing
          modelCtrl.$setValidity('editable', true);
          modelCtrl.$setValidity('parse', true);
        });
        element.val('');
      }
      hasFocus = false;
      selected = false;
    });

    // Keep reference to click handler to unbind it.
    var dismissClickHandler = function(evt) {
      // Issue #3973
      // Firefox treats right click as a click on document
      if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
        resetMatches();
        if (!$rootScope.$$phase) {
          originalScope.$digest();
        }
      }
    };

    $document.on('click', dismissClickHandler);

    originalScope.$on('$destroy', function() {
      $document.off('click', dismissClickHandler);
      if (appendToBody || appendTo) {
        $popup.remove();
      }

      if (appendToBody) {
        angular.element($window).off('resize', fireRecalculating);
        $document.find('body').off('scroll', fireRecalculating);
      }
      // Prevent jQuery cache memory leak
      popUpEl.remove();

      if (showHint) {
          inputsContainer.remove();
      }
    });

    var $popup = $compile(popUpEl)(scope);

    if (appendToBody) {
      $document.find('body').append($popup);
    } else if (appendTo) {
      angular.element(appendTo).eq(0).append($popup);
    } else {
      element.after($popup);
    }

    this.init = function(_modelCtrl) {
      modelCtrl = _modelCtrl;
      ngModelOptions = extractOptions(modelCtrl);

      scope.debounceUpdate = $parse(ngModelOptions.getOption('debounce'))(originalScope);

      //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
      //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
      modelCtrl.$parsers.unshift(function(inputValue) {
        hasFocus = true;

        if (minLength === 0 || inputValue && inputValue.length >= minLength) {
          if (waitTime > 0) {
            cancelPreviousTimeout();
            scheduleSearchWithTimeout(inputValue);
          } else {
            getMatchesAsync(inputValue);
          }
        } else {
          isLoadingSetter(originalScope, false);
          cancelPreviousTimeout();
          resetMatches();
        }

        if (isEditable) {
          return inputValue;
        }

        if (!inputValue) {
          // Reset in case user had typed something previously.
          modelCtrl.$setValidity('editable', true);
          return null;
        }

        modelCtrl.$setValidity('editable', false);
        return undefined;
      });

      modelCtrl.$formatters.push(function(modelValue) {
        var candidateViewValue, emptyViewValue;
        var locals = {};

        // The validity may be set to false via $parsers (see above) if
        // the model is restricted to selected values. If the model
        // is set manually it is considered to be valid.
        if (!isEditable) {
          modelCtrl.$setValidity('editable', true);
        }

        if (inputFormatter) {
          locals.$model = modelValue;
          return inputFormatter(originalScope, locals);
        }

        //it might happen that we don't have enough info to properly render input value
        //we need to check for this situation and simply return model value if we can't apply custom formatting
        locals[parserResult.itemName] = modelValue;
        candidateViewValue = parserResult.viewMapper(originalScope, locals);
        locals[parserResult.itemName] = undefined;
        emptyViewValue = parserResult.viewMapper(originalScope, locals);

        return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
      });
    };

    function extractOptions(ngModelCtrl) {
      var ngModelOptions;

      if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
        // guarantee a value
        ngModelOptions = ngModelCtrl.$options || {};

        // mimic 1.6+ api
        ngModelOptions.getOption = function (key) {
          return ngModelOptions[key];
        };
      } else { // in angular >=1.6 $options is always present
        ngModelOptions = ngModelCtrl.$options;
      }

      return ngModelOptions;
    }
  }])

  .directive('uibTypeahead', function() {
    return {
      controller: 'UibTypeaheadController',
      require: ['ngModel', 'uibTypeahead'],
      link: function(originalScope, element, attrs, ctrls) {
        ctrls[1].init(ctrls[0]);
      }
    };
  })

  .directive('uibTypeaheadPopup', ['$$debounce', function($$debounce) {
    return {
      scope: {
        matches: '=',
        query: '=',
        active: '=',
        position: '&',
        moveInProgress: '=',
        select: '&',
        assignIsOpen: '&',
        debounce: '&'
      },
      replace: true,
      templateUrl: function(element, attrs) {
        return attrs.popupTemplateUrl || 'uib/template/typeahead/typeahead-popup.html';
      },
      link: function(scope, element, attrs) {
        scope.templateUrl = attrs.templateUrl;

        scope.isOpen = function() {
          var isDropdownOpen = scope.matches.length > 0;
          scope.assignIsOpen({ isOpen: isDropdownOpen });
          return isDropdownOpen;
        };

        scope.isActive = function(matchIdx) {
          return scope.active === matchIdx;
        };

        scope.selectActive = function(matchIdx) {
          scope.active = matchIdx;
        };

        scope.selectMatch = function(activeIdx, evt) {
          var debounce = scope.debounce();
          if (angular.isNumber(debounce) || angular.isObject(debounce)) {
            $$debounce(function() {
              scope.select({activeIdx: activeIdx, evt: evt});
            }, angular.isNumber(debounce) ? debounce : debounce['default']);
          } else {
            scope.select({activeIdx: activeIdx, evt: evt});
          }
        };
      }
    };
  }])

  .directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function($templateRequest, $compile, $parse) {
    return {
      scope: {
        index: '=',
        match: '=',
        query: '='
      },
      link: function(scope, element, attrs) {
        var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'uib/template/typeahead/typeahead-match.html';
        $templateRequest(tplUrl).then(function(tplContent) {
          var tplEl = angular.element(tplContent.trim());
          element.replaceWith(tplEl);
          $compile(tplEl)(scope);
        });
      }
    };
  }])

  .filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function($sce, $injector, $log) {
    var isSanitizePresent;
    isSanitizePresent = $injector.has('$sanitize');

    function escapeRegexp(queryToEscape) {
      // Regex: capture the whole query string and replace it with the string that will be used to match
      // the results, for example if the capture is "a" the result will be \a
      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    }

    function containsHtml(matchItem) {
      return /<.*>/g.test(matchItem);
    }

    return function(matchItem, query) {
      if (!isSanitizePresent && containsHtml(matchItem)) {
        $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
      }
      matchItem = query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
      if (!isSanitizePresent) {
        matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
      }
      return matchItem;
    };
  }]);

angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/accordion/accordion-group.html",
    "<div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" +
    "  <h4 class=\"panel-title\">\n" +
    "    <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\" ng-disabled=\"isDisabled\" uib-tabindex-toggle><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
    "  </h4>\n" +
    "</div>\n" +
    "<div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" +
    "  <div class=\"panel-body\" ng-transclude></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/accordion/accordion.html",
    "<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>");
}]);

angular.module("uib/template/alert/alert.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/alert/alert.html",
    "<button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" +
    "  <span aria-hidden=\"true\">&times;</span>\n" +
    "  <span class=\"sr-only\">Close</span>\n" +
    "</button>\n" +
    "<div ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/carousel/carousel.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/carousel/carousel.html",
    "<div class=\"carousel-inner\" ng-transclude></div>\n" +
    "<a role=\"button\" href class=\"left carousel-control\" ng-click=\"prev()\" ng-class=\"{ disabled: isPrevDisabled() }\" ng-show=\"slides.length > 1\">\n" +
    "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></span>\n" +
    "  <span class=\"sr-only\">previous</span>\n" +
    "</a>\n" +
    "<a role=\"button\" href class=\"right carousel-control\" ng-click=\"next()\" ng-class=\"{ disabled: isNextDisabled() }\" ng-show=\"slides.length > 1\">\n" +
    "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></span>\n" +
    "  <span class=\"sr-only\">next</span>\n" +
    "</a>\n" +
    "<ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
    "  <li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{ active: isActive(slide) }\" ng-click=\"select(slide)\">\n" +
    "    <span class=\"sr-only\">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=\"isActive(slide)\">, currently active</span></span>\n" +
    "  </li>\n" +
    "</ol>\n" +
    "");
}]);

angular.module("uib/template/carousel/slide.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/carousel/slide.html",
    "<div class=\"text-center\" ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/datepicker/datepicker.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepicker/datepicker.html",
    "<div ng-switch=\"datepickerMode\">\n" +
    "  <div uib-daypicker ng-switch-when=\"day\" tabindex=\"0\" class=\"uib-daypicker\"></div>\n" +
    "  <div uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\" class=\"uib-monthpicker\"></div>\n" +
    "  <div uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\" class=\"uib-yearpicker\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/datepicker/day.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepicker/day.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
    "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
    "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-weeks\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
    "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-day text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default btn-sm\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepicker/month.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepicker/month.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
    "      <th colspan=\"{{::yearHeaderColspan}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></i></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-months\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-month text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepicker/popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepicker/popup.html",
    "<div>\n" +
    "  <ul class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
    "    <li ng-transclude></li>\n" +
    "    <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" +
    "      <span class=\"btn-group pull-left\">\n" +
    "        <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
    "        <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" +
    "      </span>\n" +
    "      <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/datepicker/year.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepicker/year.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
    "      <th colspan=\"{{::columns - 2}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-years\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-year text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepickerPopup/popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepickerPopup/popup.html",
    "<ul role=\"presentation\" class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
    "  <li ng-transclude></li>\n" +
    "  <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" +
    "    <span class=\"btn-group pull-left\">\n" +
    "      <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
    "      <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" +
    "    </span>\n" +
    "    <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("uib/template/modal/backdrop.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/modal/backdrop.html",
    "<div class=\"modal-backdrop\"\n" +
    "     uib-modal-animation-class=\"fade\"\n" +
    "     modal-in-class=\"in\"\n" +
    "     ng-style=\"{'z-index': 1040 + (index && 1 || 0) + index*10}\"\n" +
    "></div>\n" +
    "");
}]);

angular.module("uib/template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/modal/window.html",
    "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
    "");
}]);

angular.module("uib/template/pager/pager.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/pager/pager.html",
    "<li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
    "<li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
    "");
}]);

angular.module("uib/template/pagination/pagination.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/pagination/pagination.html",
    "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('first')}}</a></li>\n" +
    "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
    "<li role=\"menuitem\" ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\" ng-disabled=\"ngDisabled&&!page.active\" uib-tabindex-toggle>{{page.text}}</a></li>\n" +
    "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
    "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('last')}}</a></li>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-html-popup.html",
    "<div class=\"tooltip-arrow\"></div>\n" +
    "<div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-popup.html",
    "<div class=\"tooltip-arrow\"></div>\n" +
    "<div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-template-popup.html",
    "<div class=\"tooltip-arrow\"></div>\n" +
    "<div class=\"tooltip-inner\"\n" +
    "  uib-tooltip-template-transclude=\"contentExp()\"\n" +
    "  tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover-html.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/popover/popover-html.html",
    "<div class=\"arrow\"></div>\n" +
    "\n" +
    "<div class=\"popover-inner\">\n" +
    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
    "    <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover-template.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/popover/popover-template.html",
    "<div class=\"arrow\"></div>\n" +
    "\n" +
    "<div class=\"popover-inner\">\n" +
    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
    "    <div class=\"popover-content\"\n" +
    "      uib-tooltip-template-transclude=\"contentExp()\"\n" +
    "      tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/popover/popover.html",
    "<div class=\"arrow\"></div>\n" +
    "\n" +
    "<div class=\"popover-inner\">\n" +
    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
    "    <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/progressbar/bar.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/progressbar/bar.html",
    "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/progressbar/progress.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/progressbar/progress.html",
    "<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");
}]);

angular.module("uib/template/progressbar/progressbar.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/progressbar/progressbar.html",
    "<div class=\"progress\">\n" +
    "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/rating/rating.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/rating/rating.html",
    "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\" aria-valuetext=\"{{title}}\">\n" +
    "    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
    "    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" ng-attr-title=\"{{r.title}}\"></i>\n" +
    "</span>\n" +
    "");
}]);

angular.module("uib/template/tabs/tab.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/tabs/tab.html",
    "<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\">\n" +
    "  <a href ng-click=\"select($event)\" class=\"nav-link\" uib-tab-heading-transclude>{{heading}}</a>\n" +
    "</li>\n" +
    "");
}]);

angular.module("uib/template/tabs/tabset.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/tabs/tabset.html",
    "<div>\n" +
    "  <ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
    "  <div class=\"tab-content\">\n" +
    "    <div class=\"tab-pane\"\n" +
    "         ng-repeat=\"tab in tabset.tabs\"\n" +
    "         ng-class=\"{active: tabset.active === tab.index}\"\n" +
    "         uib-tab-content-transclude=\"tab\">\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/timepicker/timepicker.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/timepicker/timepicker.html",
    "<table class=\"uib-timepicker\">\n" +
    "  <tbody>\n" +
    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
    "      <td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td>&nbsp;</td>\n" +
    "      <td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td ng-show=\"showMeridian\"></td>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <td class=\"form-group uib-time hours\" ng-class=\"{'has-error': invalidHours}\">\n" +
    "        <input type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td class=\"uib-separator\">:</td>\n" +
    "      <td class=\"form-group uib-time minutes\" ng-class=\"{'has-error': invalidMinutes}\">\n" +
    "        <input type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-separator\">:</td>\n" +
    "      <td class=\"form-group uib-time seconds\" ng-class=\"{'has-error': invalidSeconds}\" ng-show=\"showSeconds\">\n" +
    "        <input type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n" +
    "    </tr>\n" +
    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
    "      <td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td>&nbsp;</td>\n" +
    "      <td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td ng-show=\"showMeridian\"></td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/typeahead/typeahead-match.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/typeahead/typeahead-match.html",
    "<a href\n" +
    "   tabindex=\"-1\"\n" +
    "   ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"\n" +
    "   ng-attr-title=\"{{match.label}}\"></a>\n" +
    "");
}]);

angular.module("uib/template/typeahead/typeahead-popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/typeahead/typeahead-popup.html",
    "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
    "    <li class=\"uib-typeahead-match\" ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index, $event)\" role=\"option\" id=\"{{::match.id}}\">\n" +
    "        <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
    "    </li>\n" +
    "</ul>\n" +
    "");
}]);
angular.module('ui.bootstrap.carousel').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibCarouselCss && angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>'); angular.$$uibCarouselCss = true; });
angular.module('ui.bootstrap.datepicker').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-left,.uib-right{width:100%}</style>'); angular.$$uibDatepickerCss = true; });
angular.module('ui.bootstrap.position').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibPositionCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute !important;top:-9999px !important;width:50px !important;height:50px !important;overflow:scroll !important;}.uib-position-body-scrollbar-measure{overflow:scroll !important;}</style>'); angular.$$uibPositionCss = true; });
angular.module('ui.bootstrap.datepickerPopup').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerpopupCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker-popup.dropdown-menu{display:block;float:none;margin:0;}.uib-button-bar{padding:10px 9px 2px;}</style>'); angular.$$uibDatepickerpopupCss = true; });
angular.module('ui.bootstrap.tooltip').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTooltipCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-tooltip-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-bottom > .tooltip-arrow,[uib-popover-popup].popover.top-left > .arrow,[uib-popover-popup].popover.top-right > .arrow,[uib-popover-popup].popover.bottom-left > .arrow,[uib-popover-popup].popover.bottom-right > .arrow,[uib-popover-popup].popover.left-top > .arrow,[uib-popover-popup].popover.left-bottom > .arrow,[uib-popover-popup].popover.right-top > .arrow,[uib-popover-popup].popover.right-bottom > .arrow,[uib-popover-html-popup].popover.top-left > .arrow,[uib-popover-html-popup].popover.top-right > .arrow,[uib-popover-html-popup].popover.bottom-left > .arrow,[uib-popover-html-popup].popover.bottom-right > .arrow,[uib-popover-html-popup].popover.left-top > .arrow,[uib-popover-html-popup].popover.left-bottom > .arrow,[uib-popover-html-popup].popover.right-top > .arrow,[uib-popover-html-popup].popover.right-bottom > .arrow,[uib-popover-template-popup].popover.top-left > .arrow,[uib-popover-template-popup].popover.top-right > .arrow,[uib-popover-template-popup].popover.bottom-left > .arrow,[uib-popover-template-popup].popover.bottom-right > .arrow,[uib-popover-template-popup].popover.left-top > .arrow,[uib-popover-template-popup].popover.left-bottom > .arrow,[uib-popover-template-popup].popover.right-top > .arrow,[uib-popover-template-popup].popover.right-bottom > .arrow{top:auto;bottom:auto;left:auto;right:auto;margin:0;}[uib-popover-popup].popover,[uib-popover-html-popup].popover,[uib-popover-template-popup].popover{display:block !important;}</style>'); angular.$$uibTooltipCss = true; });
angular.module('ui.bootstrap.timepicker').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTimepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-time input{width:50px;}</style>'); angular.$$uibTimepickerCss = true; });
angular.module('ui.bootstrap.typeahead').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTypeaheadCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>'); angular.$$uibTypeaheadCss = true; });

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('CustomerFusionCtrl', ["$scope", "$rootScope", "$timeout", "dialog", "dialogsModel", "OtherPaymentTypeView", "Images", function ($scope, $rootScope, $timeout, dialog, dialogsModel, OtherPaymentTypeView, Images) {
    $scope.bookingStatusImage = Images.saleStatus;
    var key;
    // hook the passed data to the popin scope
    // sourceCustomerView is passed
    for (key in dialogsModel) {
        $scope[key] = dialogsModel[key];
    }
    $timeout(function () {
        angular.element('#selector-customer').trigger('focus');
    }, 250);
    $scope.customerFusion = {
        view: {
            targetCustomerView: null,
            targetCustomerLabel: ""
        }
    };
    $scope.dialog = dialog;

    $scope.cancel = function () {
        dialog.close(null);
    };
    $scope.save = function () {
        dialog.close($scope.customerFusion.view.targetCustomerView);
    };
    $scope.onCustomerSelect = function (customerView) {
        if (customerView !== $scope.sourceCustomerView) $scope.customerFusion.view.targetCustomerView = customerView;
    };
    $scope.onCustomerInputKeyDown = function (event) {
        var keyCode = event.which;
        //if key delete detected : clear customer
        if (keyCode == 8 || keyCode == 46) $scope.customerFusion.view.targetCustomerView = null;
    };
    $scope.filterOnFusion = function () {
        return function (customerView) {
            return customerView !== $scope.sourceCustomerView;
        };
    };
}]);

/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('PlanningFormConfigCtrl', ["$scope", "$rootScope", "dialog", "dialogsModel", "LanguageManager", "Brand", "OfferManager", function ($scope, $rootScope, dialog, dialogsModel, LanguageManager, Brand, OfferManager) {
    // hook the passed data to the popin scope
    for (var key in dialogsModel) {
        $scope[key] = dialogsModel[key];
    }

    $scope.brand = Brand;

    //Mock for Oui/Non toggle buttons
    $scope.isEnglishLanguage = function () {
        return LanguageManager.isEnglishLanguage();
    };

    $scope.ad = {
        offerManager: OfferManager
    };

    $scope.dd = {
        verticalZoom: "" + $scope.pTView.config.verticalZoom + "",
        hourDeltaMinute: "" + $scope.pTView.config.hourDeltaMinute + ""
    };

    $scope.planningFormConfig = {
        view: {
            tab: 1,
            mailTab: 1,
            vatEditMode: false
        }
    };
    $scope.dialog = dialog;

    $scope.cancel = function () {
        $scope.onClosewindow();
        dialog.close(false);
    };

    $scope.save = function () {
        $scope.onClosewindow();
        dialog.close(true);
    };

    $scope.onClosewindow = function () {
        if (!isNaN($scope.dd.verticalZoom)) $scope.pTView.config.verticalZoom = parseInt($scope.dd.verticalZoom);
        if (!isNaN($scope.dd.hourDeltaMinute)) $scope.pTView.config.hourDeltaMinute = parseInt($scope.dd.hourDeltaMinute);
    };
}]);

/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('PlanningPosCtrl', ["$log", "$scope", "$document", "$http", "$rootScope", "$routeParams", "$window", "$location", "$timeout", "$dialog", "HumanResourceData", "PlanningPosView", "DaySrv", "PlanningTableView", "SiteData", "DayData", "UserActionManager", "usSpinnerService", "MessageSrv", "LanguageManager", "gettextCatalog", "AppData", "AppSrv", "AppAttribute", "LaunchDarklyFeatureFlagData", "LaunchDarklyFeatureFlagList", "App", "UserActionSrv", "CustomerData", "BookingData", "BookingView", "Booking", "DayHrData", "TypeOfModification", "BookingCreator", "BookingService", "MonitoringApplication", "MonitoringSrv", "MonitoringHealthState", "MeasureStore", "Decorators", "TimeMeasures", "moment", "SaleData", "Constants", "Auth", "StoreAppCode", "UserSrv", "BasicAuthRole", "Timers", "Images", "CompanyTypes", function ($log, $scope, $document, $http, $rootScope, $routeParams, $window, $location, $timeout, $dialog, HumanResourceData, PlanningPosView, DaySrv, PlanningTableView, SiteData, DayData, UserActionManager, usSpinnerService, MessageSrv, LanguageManager, gettextCatalog, AppData, AppSrv, AppAttribute, LaunchDarklyFeatureFlagData, LaunchDarklyFeatureFlagList, App, UserActionSrv, CustomerData, BookingData, BookingView, Booking, DayHrData, TypeOfModification, BookingCreator, BookingService, MonitoringApplication, MonitoringSrv, MonitoringHealthState, MeasureStore, Decorators, TimeMeasures, moment, SaleData, Constants, Auth, StoreAppCode, UserSrv, BasicAuthRole, Timers, Images, CompanyTypes) {
    $scope.dragOrResizeBS = null; // Manage issue with conflict between click + drag + resize
    $scope.AGENDA_APP_CODE = "agenda";
    $scope.HIGH_CONTRAST_APP_ATTRIBUTE_CODE = "highContrast";
    var timers = [];

    //Define domain data :
    $scope.dd = {
        view: { //Replaced by PlanningView after Loading
            humanResourcesView: [],
            pTView: {
                loading: true
            }
        },
        bookingStatusImage: Images.saleStatus,
        bookingCreators: BookingCreator,
        basicAuthRole: BasicAuthRole,
        userActionToCancel: null, //next action than can be canceled
        userActionToCancelDisplay: false,
        userActionToCancelDisplayTimeout: null,
        userActionToRedo: null, //redo
        edited: {
            customerView: null
        }, //TODO MOVE CUSTOMER VARIABLES
        displaySubConf: 1,
        displayError: false,
        displayPhoneError: false,
        displayLandlineError: false,
        displayTable: false,
        displaySelectorLarge: false,
        time: null,
        subject: "toto",
        personne: "Mirella"
    };

    $scope.options = {
        customClass: function customClass(data) {
            var date = data.date,
                mode = data.mode;
            if (mode === 'day') {
                var dayToCheck = new Date(date).setHours(0, 0, 0, 0);
                var currentDay = new Date().setHours(0, 0, 0, 0);
                if (dayToCheck === currentDay) return 'currentDay';else {
                    if ($scope.dd.view.pTView.plgDaysViewDisplayed) {
                        for (var i = 0; i < $scope.dd.view.pTView.plgDaysViewDisplayed.length; i++) {
                            if ($scope.dd.view.pTView.plgDaysViewDisplayed[i].display) {
                                var dayOfDateToCheck = new Date($scope.dd.view.pTView.plgDaysViewDisplayed[i].date).setHours(0, 0, 0, 0);
                                if (dayOfDateToCheck === dayToCheck) {
                                    return "displayed";
                                }
                            }
                        }
                    }
                }
            }
            var day = DayData.getById(DaySrv.getIdFromDate(date));
            if (day && !day.isOpen()) return 'closed';
            return '';
        },
        showWeeks: false
        //add the other options here
    };

    $scope.dateOptions = {
        'year-format': "'yy'",
        'starting-day': 1
    };

    $scope.loyaltyCardDateOptions = {
        'year-format': "'yy'",
        'starting-day': 1,
        'minDate': new Date()
    };

    var onGlobalLoadingFinishedDestroy = $rootScope.$on('onGlobalLoadingFinished', function () {
        $scope.loadViews();
    });

    //if ($scope.ad.dataLoaded)
    $scope.loadViews = function () {
        $scope.dd.view = new PlanningPosView($scope);

        var today = new Date();
        var todayIndex = today.getDay() - 1; //day of week;
        if (todayIndex === -1) {
            todayIndex = 6;
        }
        var diff = today.getDate() - todayIndex;
        var firstDayOfWeek = new Date(today.setDate(diff)); //Start at monday

        $scope.dd.view.initSubViews($scope.dd.view.hasHr, false, $scope.getPlanningLeft(), $scope.getPlanningTop(), $scope.getPlanningWidth(), $scope.getPlanningHeight(), firstDayOfWeek, $scope.dd.view.hasPr);
        $scope.updateTimeLineAndActivityIsPast();
        //if pos active : create a new booking
        if ($scope.ad.sDm === 'pos') {
            $scope.dd.view.posView.addSaleViewNow(null);
        }
    };

    $scope.redirectToPlanningIfPosDisabled = function () {
        if ($scope.ad.loggedUser && $scope.ad.loggedUser.company.type !== CompanyTypes.CANCELED.value && $scope.ad.sDm === Constants.APP_SUB_DOMAIN.pos) {
            if (!$scope.ad.addons.sub.posAccess) {
                if ($scope.ad.domain === Constants.APP_DOMAIN.planningPos) {
                    $scope.goToSubDomain(Constants.APP_SUB_DOMAIN.planning);
                } else {
                    $scope.goToDomain(Constants.APP_DOMAIN.planningPos, Constants.APP_SUB_DOMAIN.planning);
                }
            }
        }
    };

    $scope.$watch('ad.sDm', function () {
        $scope.redirectToPlanningIfPosDisabled();
    });

    $scope.$watch('ad.dataLoaded', function (loaded) {
        if (loaded) {
            if (SiteData.defaultSite.workingPeriods.length === 0 && $scope.ad.managerMode) {
                $scope.dd.view.pTView.loading = false;
                $scope.goToDomain("site");
                return;
            }

            if ($scope.ad.firstLoadingProcess) {
                if ($rootScope.canAccessNewLoading) {
                    MeasureStore.registerStart(TimeMeasures.PLANNING_POS_GLOBAL_TIME_STARTUP);
                } else {
                    MeasureStore.registerStart(TimeMeasures.PLANNING_POS_GLOBAL_TIME);
                }

                $scope.loadViews();

                if ($rootScope.canAccessNewLoading) {
                    MeasureStore.registerEnd(TimeMeasures.PLANNING_POS_GLOBAL_TIME_STARTUP);
                    MeasureStore.registerStart(TimeMeasures.AFTER_LOADING_STARTUP_REMAINING_TIME);
                } else {
                    MeasureStore.registerEnd(TimeMeasures.PLANNING_POS_GLOBAL_TIME);
                    MonitoringSrv.logHealth(MonitoringApplication.PROBACKOFFICE, MonitoringHealthState.OK, JSON.stringify(MeasureStore));
                }
            } else {
                var timer = $timeout($scope.loadViews, 100); // Assychron load to display waiting spinner when return to planning
                timers.push(timer);
            }
        }
    });

    $scope.$on('displayUnsavedMessageOnPlanningPosCtrl', function () {
        if ($scope.dd.view.pTView instanceof PlanningTableView) {
            $scope.dd.view.pTView.displayUnsavedChangeMessage();
        }
    });

    $scope.$on('editedBookingStatusOnPlanningPosCtrl', function () {
        var isUnsaveBooking = false;
        if ($scope.dd.view.pTView instanceof PlanningTableView && $scope.dd.view.pTView.isPlanningPosUnsavedBooking()) {
            isUnsaveBooking = true;
        }
        $scope.$emit("editedBookingStatusToAppCtrl", isUnsaveBooking);
    });

    var goToDomainCalledDestroy = $rootScope.$on('goToDomainCalled', function () {
        if ($scope.dd.view && $scope.dd.view.posView && $scope.dd.view.display) {
            if ($scope.ad.sDm === 'pos') $scope.dd.view.posView.activateView();
            if ($scope.ad.sDm === 'dashboard' && $scope.dd.view.dashboardView) $scope.dd.view.dashboardView.loadData();
        }
    });

    $scope.$watch('dd.view.pTView.dim.nbDays', function (newValue, oldValue) {
        if ($scope.dd.view && $scope.dd.view.pTView && $scope.dd.view.pTView instanceof PlanningTableView && oldValue !== undefined) {
            $scope.dd.view.pTView.initPlgDaysView($scope.dd.view.pTView.firstDayIndexDisplayed);
            $scope.dd.view.pTView.saveAgendaAppParameter(oldValue, null);
        }
    });

    var onNotificationActionDestroy = $rootScope.$on('onNotificationAction', function (_, objectNotification) {
        if (objectNotification && objectNotification.data && $scope.dd.view && $scope.dd.view.pTView && $scope.dd.view.posView) //normal notifications
            {
                if (objectNotification.data.globalObjectType === "Booking") $scope.dd.view.pTView.setAndDisplayEditedBookingViewFromIndex(objectNotification.data.index);else if (objectNotification.data.globalObjectType === "Sale") $scope.dd.view.posView.setEditedSaleViewFromIndex(objectNotification.data.index);

                $scope.safeApply();
            } else if (objectNotification && objectNotification.booking && objectNotification.booking.currentVersion) {
            //userAction from getUserActionBooking
            if (objectNotification.booking.currentVersion.objectType === "Booking") {
                var index = BookingData.getIndexOf(BookingData.getById(objectNotification.booking.currentVersion.id));
                if (index !== -1) {
                    //booking ever exist
                    var booking = BookingData.getById(objectNotification.booking.currentVersion.id);
                    booking.isDeleted = false;
                    $scope.dd.view.pTView.setAndDisplayEditedBookingViewFromIndex(BookingData.getIndexOf(booking));
                    if (objectNotification.globalType === "delete") {
                        var bookingView = $scope.dd.view.pTView.edited.bookingView;
                        bookingView.bookingIndex = -1;
                        bookingView.status = "created";
                        $scope.removeBsIndexFromDeletedBookingView(bookingView);
                    }
                } else {
                    //booking not exist
                    if (objectNotification.globalType === "delete") {

                        var day = DayData.getById(objectNotification.booking.currentVersion.dayId),
                            dayIndex = DayData.getIndexOf(day),
                            plgDayView = $scope.dd.view.pTView.getPlgDayViewByDayIndex(dayIndex),
                            book = new Booking(objectNotification.booking.currentVersion, null, true, true);
                        if (objectNotification.booking.currentVersion.bookingServicesDetail != null) {
                            for (var i = 0; objectNotification.booking.currentVersion.bookingServicesDetail.length > i; i++) {
                                var bookingService = new BookingService(objectNotification.booking.currentVersion.bookingServicesDetail[i], null, true, true);
                                book.bookingServices.push(bookingService);
                            }
                        }
                        book.loadRef();
                        book.isDeleted = false;
                        var _bookingView = new BookingView(book, -1, $scope.dd.view.pTView, plgDayView, true);
                        $scope.removeBsIndexFromDeletedBookingView(_bookingView);
                        _bookingView.setSelectedByUserAuto();
                        if (_bookingView.selectedByUser && _bookingView.selectedByUser.activityView && _bookingView.selectedByUser.activityView.plgDayHrView && _bookingView.selectedByUser.activityView.plgDayHrView.hrView) _bookingView.setSelectedByUserHrView(_bookingView.selectedByUser.activityView.plgDayHrView.hrView);

                        plgDayView.addBookingView(_bookingView);
                        plgDayView.pTView.setEditedBookingView(_bookingView);
                    }
                }
                $scope.dd.view.pTView.domainView.scope.goToSubDomain('planning');
            }
        }
    });

    $scope.removeBsIndexFromDeletedBookingView = function (bookingView) {
        for (var i = 0; bookingView.bookingServicesView.length > i; i++) {
            bookingView.bookingServicesView[i].actIndex = -1;
        }
    };

    var onExternalModelChangedDestroy = $rootScope.$on('onExternalModelChanged', function (_, objectModification, isNotFromAngularEvent) {
        if ($scope.dd.view) {
            if ($scope.dd.view.onExternalModelChanged !== undefined) {
                $scope.dd.view.onExternalModelChanged(objectModification);
            } else {
                var timer = $timeout(function () {
                    if ($scope.dd.view.onExternalModelChanged !== undefined) $scope.dd.view.onExternalModelChanged(objectModification);
                }, 5000);
                timers.push(timer);
            }

            if (isNotFromAngularEvent !== undefined && isNotFromAngularEvent) $scope.safeApply();
        }
    });

    var onChangeUserActionToCancelDestroy = $rootScope.$on('onChangeUserActionToCancel', function (_, userAction) {
        console.log("$rootScope.$on('onChangeUserActionToCancel', function(_,userAction)");
        console.log($scope.dd.userActionToCancel);
        console.log(userAction);
        if (userAction && userAction.description) {
            if (userAction.globalObjectType === 'Booking') {
                userAction.userActionTagPrefix = 'booking_' + userAction.globalType;
            } else if (userAction.globalObjectType === 'Activity') {
                userAction.userActionTagPrefix = 'unavailability_' + userAction.globalType;
            } else {
                userAction.userActionTagPrefix = userAction.globalObjectType + '_' + userAction.globalType;
            }

            $scope.dd.userActionToCancelDisplay = true;

            if ($scope.dd.userActionToCancelDisplayTimeout) {
                $timeout.cancel($scope.dd.userActionToCancelDisplayTimeout);
            }
            $scope.dd.userActionToCancelDisplayTimeout = $timeout(function () {
                $scope.dd.userActionToCancelDisplay = false;
            }, 8000);
        }
        $scope.dd.userActionToCancel = userAction;
        $scope.dd.userActionToRedo = null;
    });

    var onChangeUserActionToRedoDestroy = $rootScope.$on('onChangeUserActionToRedo', function (_, userAction) {
        $scope.dd.userActionToRedo = userAction; //feature removed from interface
    });

    $scope.updateTimeLineAndActivityIsPast = Decorators.timeMeasureDecorator(function () {
        var now = new Date();
        $scope.dd.view.pTView.updateTimeLineAndActivityIsPast(now);
        var timer = $timeout($scope.updateTimeLineAndActivityIsPast, 60 * 1000);
        timers.push(timer);

        var currentTime = now.getTime();
        if ($scope.dd.time && currentTime > $scope.dd.time + 30 * 60 * 1000) {
            MessageSrv.send("warning", gettextCatalog.getString("Mise en veille détectée.") + "<br/>" + gettextCatalog.getString("Il est recommandé de recharger l'application"), false);
        }
        $scope.safeApply();
        $scope.dd.time = currentTime;
    }, TimeMeasures.TIMELINE_AND_ACTIVITY_IS_PAST);

    var doit;
    window.onresize = function () {
        clearTimeout(doit);
        doit = setTimeout($scope.onWindowResizeEnd, 500);
    };

    $scope.onWindowResizeEnd = function () {
        if ($scope.dd.view && $scope.dd.view.pTView && $scope.dd.view.pTView instanceof PlanningTableView) {
            $scope.dd.view.pTView.updateSize($scope.getPlanningLeft(), $scope.getPlanningTop(), $scope.getPlanningWidth(), $scope.getPlanningHeight());
            $scope.safeApply();
        }
        if ($scope.dd.view && $scope.dd.view.posView && $scope.ad.sDm === 'pos') {
            $scope.dd.view.posView.resizeBasket();
        }
    };

    $scope.safeApply = function (fn) {
        if ($scope.$root) {
            var phase = $scope.$root.$$phase;
            if (phase == '$apply' || phase == '$digest') {
                if (fn && typeof fn === 'function') {
                    fn();
                }
            } else {
                $scope.$apply(fn);
            }
        } else $scope.$apply(fn);
    };

    $scope.getPlanningLeft = function () {
        var planningStart = 0;
        if ($scope.dd.isStandardWeek) {
            var cfgMenuWidth = angular.element('#cfg-menu').css('width');
            var posMenuWidth = angular.element('#pos-menu').css('width');
            var menuWidthStr = '';

            if (cfgMenuWidth) {
                menuWidthStr = cfgMenuWidth;
            } else if (posMenuWidth) {
                menuWidthStr = posMenuWidth;
            }

            if (menuWidthStr) {
                menuWidthStr = menuWidthStr.replace("px");
                planningStart = parseInt(menuWidthStr);
            }
        }
        return planningStart;
    };

    $scope.getPlanningTop = function () {
        return 175; // menu only + action barre  + table titles
    };

    $scope.getPlanningWidth = function () {
        var bodyWidth = $scope.getDomainWidth();

        if ($scope.dd.isStandardWeek) {
            var menuLeft = $scope.getPlanningLeft();
            if (menuLeft) {
                bodyWidth -= menuLeft;
            }
        }

        return bodyWidth;
    };

    $scope.getPlanningHeight = function () {
        var planningHeightStr = angular.element('body').css('height');
        if (planningHeightStr == null) return 0;
        var planningHeight = parseInt(planningHeightStr.replace("px"));
        planningHeight -= $scope.getPlanningTop(); //menu + action barre + table titles
        return planningHeight;
    };

    $scope.getDomainWidth = function () {
        var bodyWidthStr = angular.element('body').css('width');
        bodyWidthStr = bodyWidthStr.replace("px");
        var bodyWidth = parseInt(bodyWidthStr);
        return bodyWidth;
    };

    $scope.displayPlanningDatePickerF = function () {
        if ($scope.dd.view.pTView.isPlanningPosUnsavedBooking()) {
            $scope.dd.view.pTView.displayUnsavedChangeMessage();
            return;
        }

        var timer = $timeout(function () {
            $scope.dd.view.pTView.datePicker = new Date($scope.dd.view.pTView.firstDateDisplayed);
            $scope.dd.view.pTView.datePickerOpened = true;
        });
        timers.push(timer);
    };

    $scope.filterNotification = function (value, index, array) {
        return value.globalType === $scope.ad.view.notificationDisplayParameters.typeModification.id || $scope.ad.view.notificationDisplayParameters.typeModification === TypeOfModification.ALL;
    };

    $scope.listenForBackofficeApp = function (event) {
        if (event && event.data) {
            if (event.data.logout) {
                Auth.logout();
            } else if (event.data.editedGiftItem) {
                $scope.dd.view.posView.setEditedGiftItemView(event.data.editedGiftItem, function () {
                    $scope.navigateToNgApp({ name: Constants.ANGULAR_EVENTS.REFRESH, value: Constants.ANGULAR_TABS.GIFT_ITEMS, customerId: event.data.customerId });
                });
            } else if (event.data.editedLoyaltyCard) {
                $scope.dd.view.posView.setEditedLoyaltyCardItemView(event.data.editedLoyaltyCard, function () {
                    $scope.navigateToNgApp({ name: Constants.ANGULAR_EVENTS.REFRESH, value: Constants.ANGULAR_TABS.LOYALTY_CARD_ITEMS, customerId: event.data.customerId });
                });
            } else if (event.data.editedCureItem) {
                $scope.dd.view.posView.openCureItemWindow(event.data.editedCureItem, function () {
                    $scope.navigateToNgApp({ name: Constants.ANGULAR_EVENTS.REFRESH, value: Constants.ANGULAR_TABS.CURE_ITEMS, customerId: event.data.customerId });
                });
            } else if (event.data.customerConfig) {
                $scope.dd.view.customerConfig.techNote = event.data.customerConfig.techNote;
                $scope.dd.view.saveCustomerParam();
            } else if (event.data.domain && event.data.sDm) {
                var APP_SUBDOMAIN = Constants.APP_SUB_DOMAIN;
                if (event.data.domain === Constants.APP_DOMAIN.planningPos) {
                    if (event.data.sDm === APP_SUBDOMAIN.planning) {
                        $scope.dd.view.pTView.setEditedBookingViewFromModel(BookingData.getById(event.data.itemId));
                        $scope.goToSubDomain(APP_SUBDOMAIN.planning);
                    } else if (event.data.sDm === APP_SUBDOMAIN.pos) {
                        $scope.dd.view.posView.setEditedSaleViewFromModel(SaleData.getById(event.data.itemId));
                        $scope.goToSubDomain(APP_SUBDOMAIN.pos);
                    }
                } else {
                    $scope.goToDomain(event.data.domain, event.data.sDm);
                }
            }
        }
    };

    $scope.storageEventListener = function (event) {
        if (event && event.key === "flxLocalState") {
            var userActionRef = JSON.parse(event.newValue);
            if (userActionRef) {
                UserActionManager.executeUserAction(userActionRef, true);
            }
        }
    };

    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    if (window[eventMethod]) {
        window[eventMethod]("message", $scope.listenForBackofficeApp);
        window[eventMethod]("storage", $scope.storageEventListener);
    }

    $scope.$on("$destroy", function () {
        window.removeEventListener("message", $scope.listenForBackofficeApp);
        window.removeEventListener("storage", $scope.storageEventListener);

        goToDomainCalledDestroy();
        onNotificationActionDestroy();
        onExternalModelChangedDestroy();
        onChangeUserActionToCancelDestroy();
        onChangeUserActionToRedoDestroy();
        onGlobalLoadingFinishedDestroy();

        Timers.cancel(timers);
    });
}]);

/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('PosFormConfigCtrl', ["$scope", "$rootScope", "dialog", "dialogsModel", "OtherPaymentTypeView", "LanguageManager", function ($scope, $rootScope, dialog, dialogsModel, OtherPaymentTypeView, LanguageManager) {
    var key;
    // hook the passed data to the popin scope
    for (key in dialogsModel) {
        $scope[key] = dialogsModel[key];
    }
    $scope.posFormConfig = {
        view: {
            tab: 1,
            vatDefaultError: false,
            otherPaymentTypesError: null,
            canCreateAnotherPayment: true
        }
    };
    $scope.dialog = dialog;
    $scope.submitting = false;
    $scope.dialogDrror = null;

    //Mock for Oui/Non toggle buttons
    $scope.isEnglishLanguage = function () {
        return LanguageManager.isEnglishLanguage();
    };

    $scope.cancel = function () {
        var opts = this.posView.domainView.otherPaymentTypesView;
        for (var i = 0; i < opts.length;) {
            if (opts[i].getModel()) {
                opts[i].reloadModel();
                i++;
            } else {
                opts.splice(i, 1);
            }
        }var vats = this.posView.domainView.vatsView;
        for (var i = 0; i < vats.length;) {
            if (vats[i].getModel()) {
                vats[i].reloadModel();
                i++;
            } else {
                vats.splice(i, 1);
            }
        }this.posView.domainView.loadPosParam();
        dialog.close(false);
    };
    $scope.save = function () {

        if ($scope.canSave()) {
            $scope.submitting = true;
            $scope.dialogDrror = null;

            if (this.posView.domainView.getDefaultVatView() == null) {
                $scope.posFormConfig.view.vatDefaultError = true;
                $scope.posFormConfig.view.tab = 1;
                return;
            }

            var opts = this.posView.domainView.otherPaymentTypesView;
            for (var i = 0; i < opts.length; i++) {
                opts[i].updateModel();
            }

            var vats = this.posView.domainView.vatsView;
            for (var _i = 0; _i < vats.length; _i++) {
                vats[_i].updateModel();
            }

            this.posView.domainView.savePosParam(function () {
                $scope.submitting = false;
                dialog.close(true);
            }, function (error) {
                $scope.submitting = false;
                $scope.dialogDrror = error;
            });
        }
    };
    $scope.createOtherPaymentTypeView = function () {
        if (this.posView) {
            if ($scope.checkPaymentTypesNotEmpty()) {
                var optView = new OtherPaymentTypeView();
                optView.order = this.posView.domainView.otherPaymentTypesView.length;
                this.posView.domainView.addOtherPaymentTypeView(optView);
            }
        }
    };

    $scope.checkPaymentTypesNotEmpty = function () {
        $scope.posFormConfig.view.canCreateAnotherPayment = true;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = this.posView.domainView.otherPaymentTypesView[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var otherPaymentTypeView = _step.value;

                if (!otherPaymentTypeView.label || !otherPaymentTypeView.label.trim()) {
                    $scope.posFormConfig.view.canCreateAnotherPayment = false;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return $scope.posFormConfig.view.canCreateAnotherPayment;
    };

    $scope.onChangeDefaultVatView = function (vatView) {
        var vats = this.posView.domainView.vatsView;
        for (var i = 0; i < vats.length; i++) {
            if (vats[i] !== vatView) {
                vats[i].isDefault = false;
            }
        }
        if (vatView.isDefault) {
            vatView.isUsable = true;
            $scope.posFormConfig.view.vatDefaultError = false;
        }
    };

    $scope.canSave = function () {
        var canSave = $scope.checkPaymentTypesNotEmpty();
        if (this.posView.domainView.advancePercent > 50 || this.posView.domainView.advancePercent < 0) {
            $scope.posFormConfig.view.tab = 5;
            canSave = false;
        } else if (this.posView.domainView.giftMonthValidity < 1 || this.posView.domainView.giftMonthValidity > 36) {
            $scope.posFormConfig.view.tab = 4;
            canSave = false;
        }
        return canSave;
    };

    $scope.updateAdvancePercentInputArrow = function (amount) {
        this.posView.domainView.advancePercent += amount;
    };

    $scope.updateGiftMonthValidityInputArrow = function (amount) {
        this.posView.domainView.giftMonthValidity += amount;
    };
}]);

/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
* Created with JetBrains WebStorm.
* User: sebastienbeaujard
* Date: 28/07/13
* Time: 09:22
* To change this template use File | Settings | File Templates.
*/

angular.module('FlexyBeautyApp.controllers').controller('PosFormCtrl', ["$scope", "TaxMode", "LanguageManager", function ($scope, TaxMode, LanguageManager) {

    $scope.onCustomerInputKeyDown = function (event) {
        var keyCode = event.which;
        //if key delete detected : clear customer
        if (keyCode == 8 || keyCode == 46) {
            if ($scope.dd.view.posView.edited.saleView) $scope.dd.view.posView.edited.saleView.customerView = null;
        }
    };

    $scope.setCurrentCategory = function (categoryView) {
        $scope.dd.view.cCategoryView = categoryView;
    };
    $scope.setCurrentProductCategory = function (categoryView) {
        $scope.dd.view.cProductCategoryView = categoryView;
    };

    $scope.openNewSale = function () {
        $scope.dd.view.display.menuMobile = false;
        $scope.dd.view.posView.sideMenu = false;
        $scope.dd.view.display.posSubMode = 1;
        $scope.dd.view.posView.loadNewSell();
    };

    $scope.openEstimation = function () {
        $scope.dd.view.display.menuMobile = false;
        $scope.dd.view.posView.sideMenu = false;
        $scope.dd.view.display.posSubMode = 1;
        $scope.dd.view.posView.loadEstimationSell();
    };

    $scope.openConfiguration = function () {
        $scope.dd.view.display.menuMobile = false;
        $scope.dd.view.posView.sideMenu = false;
        $scope.dd.view.display.posSubMode = 7;
        $scope.dd.view.posView.openConfigWindow();
    };

    $scope.taxModeList = TaxMode;

    /*var $table = $('#table-export-details'),
        $bodyCells = $table.find('tbody tr:first').children(),
        colWidth;
     // Get the tbody columns width array
    colWidth = $bodyCells.map(function () {
        return $(this).width();
    }).get();
     // Set the width of thead columns
    $table.find('thead tr').children().each(function (i, v) {
        $(v).width(colWidth[i]);
    });*/
}]);

/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('CustomerCtrl', ["$scope", "$dialog", "$rootScope", "$filter", "$log", "$route", "$timeout", "$sce", "Customer", "CustomerSrv", "CustomerData", "CustomerView", "BookingData", "SaleData", "GiftItemData", "CureItemData", "gettextCatalog", "LanguageManager", "PhoneFormat", "OptInOutView", "Constants", "LaunchDarklyFeatureFlagData", "CookieFactory", "SmsCampaignSrv", "Timers", "Images", function ($scope, $dialog, $rootScope, $filter, $log, $route, $timeout, $sce, Customer, CustomerSrv, CustomerData, CustomerView, BookingData, SaleData, GiftItemData, CureItemData, gettextCatalog, LanguageManager, PhoneFormat, OptInOutView, Constants, LaunchDarklyFeatureFlagData, CookieFactory, SmsCampaignSrv, Timers, Images) {
    $scope.bookingStatusImage = Images.saleStatus;
    $scope.isSideBarCollapsed = false;
    $scope.smsCampaignsLoading = false;
    $scope.dd.view.display = {
        customerSubMode: 1,
        fusionCustomersError: false
    };
    $scope.customerSubModes = {
        customerData: 1,
        customerSmsCampaign: 2,
        customerNotificationCampaign: 3,
        customerTrash: 4,
        configuration: 5
    };
    $scope.customerSortModes = {
        sortByName: 'lastName',
        sortByTotal: 'historyRealPaidPrice',
        sortByVisit: 'nbSoldSales'
    };
    $scope.cutomerTabNeedToOrder = true;
    $scope.customersSortValue = "lastName";
    $scope.customersOrderByReverse = false;
    $scope.customerFilterModes = {
        filterByBirthday: 'birthday',
        filterByManGender: 'M',
        filterByWomanGender: 'W',
        filterByChildGender: 'C'
    };
    $scope.customersFilterValue = "";
    $scope.myMargintop = 40;

    $scope.isAccessBackofficeCustomer = false;
    $scope.isAllCustomerViewsHistoryLoaded = false;
    var timers = [];

    $scope.fetchSmsCampaign = function () {
        $scope.smsCampaignsLoading = true;
        return SmsCampaignSrv.query(function () {
            SmsCampaignSrv.loadRef();
            $scope.smsCampaignsLoading = false;
            $scope.dd.view.loadSmsCampaignListView();
            $scope.loadAllCustomerViewsHistory();
        }, function () {
            $scope.smsCampaignsLoading = false;
        });
    };

    $scope.fetchNotificationCampaign = function () {
        $scope.dd.view.loadNotificationCampaignListViews();
        $scope.loadAllCustomerViewsHistory();
    };

    $scope.loadAllCustomerViewsHistory = function (callbackFunction) {
        if (!$scope.isAllCustomerViewsHistoryLoaded) {
            var timer = $timeout(function () {
                for (var i = 0; i < $scope.dd.view.customersView.length; i++) {
                    var customerView = $scope.dd.view.customersView[i];
                    if (!customerView.isHistoryInit) {
                        customerView.initCustomerHistoryDatas(customerView.getModel());
                    }
                }
                $scope.isAllCustomerViewsHistoryLoaded = true;
                if (callbackFunction !== undefined) {
                    callbackFunction();
                }
            }, 300);

            timers.push(timer);
        } else {
            if (callbackFunction !== undefined) {
                callbackFunction();
            }
        }
    };

    $scope.backofficeFrontendUrl = '';

    $scope.onButtonClickSubModes = function (subMode) {
        if (this.isAccessBackofficeCustomer) {
            if (subMode === $scope.customerSubModes.customerData) {
                this.navigateToNgApp({ route: Constants.ngRoutings.customer.list });
            } else if (subMode === $scope.customerSubModes.customerTrash) {
                this.navigateToNgApp({ route: Constants.ngRoutings.customer.trash });
            }
        }

        $scope.dd.view.display.customerSubMode = subMode;
        if (subMode === $scope.customerSubModes.customerSmsCampaign) {
            $scope.isSideBarCollapsed = true;
            $scope.fetchSmsCampaign();
        } else if (subMode === $scope.customerSubModes.customerNotificationCampaign) {
            $scope.isSideBarCollapsed = true;
            $scope.fetchNotificationCampaign();
        } else {
            $scope.isSideBarCollapsed = false;
        }
    };

    $scope.isSubMode = function (subMode) {
        return $scope.dd.view.display.customerSubMode === subMode;
    };

    var goToDomainCalledDestroy = $rootScope.$on('goToDomainCalled', function (_) {
        if ($scope.dd.view && $scope.dd.view.display) {
            if ($scope.ad.sDm === 'customer' && $scope.dd.view) {
                $scope.dd.view.customerFilterBirthday = false;
                $scope.onChangeCustomerFilter($scope.customersFilterValue);
            }
        }
    });

    $scope.$watch('ad.sDm', function () {
        if ($scope.dd.view && $scope.dd.view.display) {
            if ($scope.ad.sDm === 'customer' && $scope.dd.view && $scope.dd.view.customersView) {
                if ($scope.dd.view.customerFilterBirthday) {
                    $scope.customersFilterValue = $scope.customerFilterModes.filterByBirthday;
                    $scope.dd.view.customerFilterBirthday = false;
                }
                $scope.onChangeCustomerFilter($scope.customersFilterValue);
            }
        }
    });

    $scope.$watch("ad.dataLoaded", function (loaded) {
        if (loaded) {
            $scope.isAccessBackofficeCustomer = LaunchDarklyFeatureFlagData.canAccessBackofficeCustomer;
            if ($scope.isAccessBackofficeCustomer && !$scope.backofficeFrontendUrl) {
                $scope.backofficeFrontendUrl = $sce.trustAsResourceUrl('/backoffice/' + $scope.ad.loggedUser.company.localeCode + '/');
            }
        }
    });

    $scope.updateManagerModeCookie = function () {
        var currentUser = CookieFactory.getCookie("flexyBeauty-pro-user");
        if (currentUser && currentUser.hasOwnProperty("managerMode")) {
            currentUser.managerMode = $scope.ad.managerMode;
            CookieFactory.setCookie('flexyBeauty-pro-user', currentUser);
        }
    };

    $scope.$watch("ad.managerMode", function (newValue, oldValue) {
        var timer = $timeout(function () {
            if ($scope.isAccessBackofficeCustomer) {
                $scope.navigateToNgApp({ name: Constants.ANGULAR_EVENTS.MANAGER_MODE, value: $scope.ad.managerMode });
                $scope.updateManagerModeCookie();
            }
        });
        timers.push(timer);
    });

    $scope.openDeletedCustomerViewConfirmDialog = function () {
        if ($scope.dd.edited.customerView) {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/removeConfirm.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["label"] = $scope.dd.edited.customerView.label;
                        return tableModel;
                    } } };

            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) $scope.removeEditedCustomerView();
            });
        }
    };

    $scope.emptyGarbage = function () {
        var msgQuestion = gettextCatalog.getString("Voulez-vous vraiment vider la corbeille");
        var msgDescription = gettextCatalog.getString("Uniquement les clients sans rendez-vous, tickets ou chèques seront supprimés");
        var opts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: '/partials/global/generalConfirm.html',
            controller: 'DialogCtrl',
            resolve: {
                dialogsModel: function dialogsModel() {
                    var tableModel = [];
                    tableModel["question"] = msgQuestion + "?";
                    tableModel["description"] = msgDescription + ".";
                    return tableModel;
                } } };

        var d = $dialog.dialog(opts);
        d.open().then(function (result) {
            if (result) {
                var msgLabel = gettextCatalog.getString("La fonction d'envoie s'exécute sur le serveur et peut prendre jusqu'à 10 minutes. Il faudra ensuite actualiser pour constater le résultat");
                CustomerSrv.emptyGarbage();
                opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials/global/infoDialog.html',
                    controller: 'DialogCtrl',
                    resolve: {
                        dialogsModel: function dialogsModel() {
                            var tableModel = [];
                            tableModel["label"] = msgLabel + ".";
                            return tableModel;
                        } } };

                $dialog.dialog(opts).open();
            }
        });
    };

    $scope.addCustomersViewDisplayed = function (customerView) {
        if (customerView && $scope.dd.view.customersViewDisplayed.indexOf(customerView) === -1) {
            if (!customerView.isHistoryInit) {
                customerView.initCustomerHistoryDatas(customerView.getModel());
            }
            $scope.dd.view.customersViewDisplayed.push(customerView);
        }
    };

    $scope.addMoreCustomersView = function () {
        if ((!$scope.dd.view.customerFilter || $scope.dd.view.customerFilter.length < 2) && !$scope.dd.view.customerFilterBirthday) {
            if ($scope.dd.view.customersViewDisplayed && $scope.dd.view.customersView) {
                var initSize = $scope.dd.view.customersViewDisplayed.length;
                for (var i = initSize; i < $scope.dd.view.customersView.length && i < initSize + 20; i++) {
                    $scope.addCustomersViewDisplayed($scope.dd.view.customersView[i]);
                }
                $scope.onChangeCustomerFilter($scope.customersFilterValue, initSize + 20);
            }
        } else {
            $scope.onChangeCustomerFilter($scope.customersFilterValue);
        }
    };

    $scope.addMoreCustomersDeletedView = function () {
        if ($scope.dd.view.customersDeletedViewDisplayed) {
            var initSize = $scope.dd.view.customersDeletedViewDisplayed.length;
            for (var i = initSize; i < $scope.dd.view.customersDeletedView.length && i < initSize + 20; i++) {
                $scope.dd.view.customersDeletedViewDisplayed.push($scope.dd.view.customersDeletedView[i]);
            }
        }
    };

    $scope.getCfgClass = function (confItem, className) {
        if (confItem == $scope.dd.displaySubConf) {
            return className;
        }
        return "";
    };

    $scope.setEditedCustomerView = function (customerView) {
        if ($scope.dd.edited.customerView && $scope.dd.edited.customerView !== customerView) {
            $scope.dd.edited.customerView.reloadModel();
        } else if (customerView && !customerView.isHistoryInit) {
            customerView.initCustomerHistoryDatas(customerView.getModel());
        }
        $scope.myMargintop = 75;

        $scope.dd.edited.customerView = customerView;
    };

    $scope.createCustomer = function () {
        var newCustomerView = new CustomerView(null, -1, $scope.dd.view);
        $scope.dd.view.customersViewDisplayed.splice(0, 0, newCustomerView); //Insert in first place
        $scope.dd.view.customersView.splice(0, 0, newCustomerView); //Insert in first place
        $scope.dd.edited.customerView = newCustomerView;
        $scope.myMargintop = 75;
    };

    $scope.setCurrentCategory = function (categoryView) {
        $scope.dd.view.cCategoryView = categoryView;
    };

    $scope.setCurrentProductCategory = function (categoryView) {
        $scope.dd.view.cProductCategoryView = categoryView;
    };

    $scope.setCurrentCureCategory = function (categoryView) {
        $scope.dd.view.cCureCategoryView = categoryView;
    };

    $scope.setCurrentLoyaltyCategory = function (categoryView) {
        $scope.dd.view.cLoyaltyCardCategoryView = categoryView;
    };

    $scope.cancelEditedCustomerView = function () {
        if ($scope.dd.edited.customerView.cIndex != -1) {
            // retrieve old value from server
            $scope.dd.edited.customerView.reloadModel();
        } else {
            var index = $scope.dd.view.customersView.indexOf($scope.dd.edited.customerView);
            if (index !== 1) {
                $scope.dd.view.customersView.splice(index, 1);
            }
            index = $scope.dd.view.customersViewDisplayed.indexOf($scope.dd.edited.customerView);
            if (index !== 1) {
                $scope.dd.view.customersViewDisplayed.splice(index, 1);
            }
        }
        $scope.dd.edited.customerView = null;
        $scope.dd.displayError = false;
        $scope.myMargintop = 40;
    };

    $scope.saveEditedCustomerView = function () {
        if ($scope.dd.edited.customerView) {
            var isNew = $scope.dd.edited.customerView.getModel() == null; //Is a new : sort
            $scope.dd.edited.customerView.updateModel();
            if (isNew) {
                $scope.dd.edited.customerView.createInterNationalAndNationalPhoneFormat();
                $scope.dd.view.customersView = $filter('orderBy')($scope.dd.view.customersView, 'label'); //TODO OPTIMIZE
                $scope.dd.view.customersViewDisplayed = $filter('orderBy')($scope.dd.view.customersViewDisplayed, 'label'); //TODO OPTIMIZE
                var index = $scope.dd.view.customersView.indexOf($scope.dd.edited.customerView);
                if (index >= $scope.dd.view.customersViewDisplayed.length) {
                    //Must remove from displayed because it's out of current array
                    index = $scope.dd.view.customersViewDisplayed.indexOf($scope.dd.edited.customerView);
                    if (index !== 1) $scope.dd.view.customersViewDisplayed.splice(index, 1);
                }
            }
        }
        $scope.dd.displayError = false;
        $scope.dd.edited.customerView = null;
        $scope.myMargintop = 40;
    };
    $scope.removeEditedCustomerView = function () {
        if ($scope.dd.edited.customerView) {
            $scope.dd.edited.customerView.removeModel();
            var index = $scope.dd.view.customersView.indexOf($scope.dd.edited.customerView);
            if (index !== -1) {
                if ($scope.dd.view.customersDeletedView) {
                    $scope.dd.view.customersDeletedView.push($scope.dd.edited.customerView);
                    $scope.dd.view.customersDeletedViewDisplayed.push($scope.dd.edited.customerView);
                }
                $scope.dd.view.customersView.splice(index, 1);
            }
            index = $scope.dd.view.customersViewDisplayed.indexOf($scope.dd.edited.customerView);
            if (index !== -1) {
                $scope.dd.view.customersViewDisplayed.splice(index, 1);
            }
        }
        $scope.dd.edited.customerView = null;
        $scope.myMargintop = 40;
    };

    $scope.restore = function (customerView) {
        if (customerView) {
            if (customerView.cIndex !== -1) {
                customerView.restoreModel();
            }
            var index = $scope.dd.view.customersDeletedView.indexOf(customerView);
            if (index !== -1) {
                $scope.dd.view.customersDeletedView.splice(index, 1);
                if ($scope.dd.view.customersView) {
                    $scope.dd.view.customersView.push(customerView);
                }
            }
        }
    };

    $scope.exportExcelCustomer = function (object, id, title) {
        var timeout = $scope.dd.view.customersView.length > 3000 ? $scope.dd.view.customersView.length : 3000;
        $scope.createCustomerTable(true, 'table-customers-hide');
        var timer = $timeout(function () {
            $('#' + id).remove();
        }, timeout);
        timers.push(timer);

        return ExcellentExport.excel(object, id, title);
    };

    $scope.exportCsvCustomer = function (object, id) {
        var timeout = $scope.dd.view.customersView.length > 3000 ? $scope.dd.view.customersView.length : 3000;
        $scope.createCustomerTable(true, 'table-customers-hide');
        var timer = $timeout(function () {
            $('#' + id).remove();
        }, timeout);
        timers.push(timer);
        return ExcellentExport.csv(object, id, ';');
    };

    $scope.createCustomerTable = function (isExport, divId) {
        var firstDate = void 0;
        var lastDate = void 0;
        var firstSaleDate = void 0;
        var lastSaleDate = void 0;
        var nbClient = 0;
        var maxCustomerDisplay = 5000;
        var content = "";
        var tableId = "table-customers-export";

        var labelLastName = gettextCatalog.getString("Nom"),
            labelFirstName = gettextCatalog.getString("Prénom"),
            labelGenre = gettextCatalog.getString("Genre"),
            labelEmail = gettextCatalog.getString("E-mail"),
            labelMobilePhone = gettextCatalog.getString("Tél. portable"),
            labelPhone = gettextCatalog.getString("Tél. Fixe"),
            labelAddress = gettextCatalog.getString("Adresse"),
            labelZipCode = gettextCatalog.getString("Code postal"),
            labelCity = gettextCatalog.getString("Ville"),
            labelOrigin = gettextCatalog.getString("Origine"),
            labelBirthday = gettextCatalog.getString("Date de naissance"),
            labelComments = gettextCatalog.getString("Commentaire"),
            labelBReservation = gettextCatalog.getString("Nb Rdvs"),
            labelRdvKo = gettextCatalog.getString("Nb Rdvs - Pas venu"),
            labelRdvOk = gettextCatalog.getString("Nb Rdvs - Venu"),
            labelWaitingTickets = gettextCatalog.getString("Nb tickets en attente"),
            labelTickets = gettextCatalog.getString("Nb tickets encaissés"),
            labelCures = gettextCatalog.getString("Nb cures restantes"),
            labelBons = gettextCatalog.getString("Nb bons restants"),
            labelTotal = gettextCatalog.getString("Total encaissé"),
            labelFirstVisitDate = gettextCatalog.getString("Date première visite"),
            labelLastVisitDate = gettextCatalog.getString("date dernière visite"),
            labelFirstBuy = gettextCatalog.getString("date premier achat"),
            labelLastBuy = gettextCatalog.getString("date dernier achat"),
            isSmsAllowed = gettextCatalog.getString("Campagne SMS OK"),
            isMailAllowed = gettextCatalog.getString("Campagne EMAIL OK"),
            isNotifAllowed = gettextCatalog.getString("Campagne Notification OK"),
            unknowValue = gettextCatalog.getString("Non renseigné"),
            yes = gettextCatalog.getString("Oui"),
            no = gettextCatalog.getString("Non");

        if (isExport) {
            tableId = "table-customers-export-hide";
            content += "<div id=\"table-customers-hide\" style=\"display:none;\">";
        }

        content += "<table id=\"" + tableId + "\" class=\"table even-color fxb-table\"><tr> <th>Nb : " + $scope.dd.view.customersViewDisplayed.length + "</th> <th >" + labelLastName + "</th> <th >" + labelFirstName + "</th> <th >" + labelGenre + "</th> <th >" + labelEmail + "</th> <th >" + labelMobilePhone + "</th> <th>" + labelPhone + "</th><th >" + labelAddress + "</th><th >" + labelZipCode + "</th>" + "<th >" + labelCity + "</th><th >" + labelOrigin + "</th><th >" + labelBirthday + "</th> <th >" + labelComments + "</th><th >" + labelBReservation + "</th><th >" + labelRdvKo + "</th><th >" + labelRdvOk + "</th>" + "<th >" + labelWaitingTickets + "</th><th >" + labelTickets + "</th><th >" + labelCures + " </th><th >" + labelBons + "</th><th >" + labelTotal + "</th>" + "<th >" + labelFirstVisitDate + "</th><th >" + labelLastVisitDate + "</th><th >" + labelFirstBuy + "</th><th >" + labelLastBuy + "</th><th >" + isSmsAllowed + "</th><th >" + isMailAllowed + "</th><th >" + isNotifAllowed + "</th></tr>";
        var date = new Date();
        $scope.dd.view.customersView.sort(dynamicSort($scope.customersSortValue, $scope.customersOrderByReverse ? -1 : 1));
        var customersToDisplay = [];
        if (!isExport && maxCustomerDisplay && $scope.dd.view.customersView.length > maxCustomerDisplay) {
            customersToDisplay = $scope.dd.view.customersView.slice(0, maxCustomerDisplay);
        } else {
            customersToDisplay = $scope.dd.view.customersView;
        }

        for (var i = 0; i < customersToDisplay.length; i++) {
            if ($scope.customersFilterValue === '' || $scope.customersFilterValue === $scope.customerFilterModes.filterByBirthday && customersToDisplay[i].birthDate && customersToDisplay[i].birthDate.getMonth() === date.getMonth() || customersToDisplay[i].gender === $scope.customersFilterValue) {
                firstSaleDate = null;
                lastSaleDate = null;
                if (customersToDisplay[i].globalHistoryView && customersToDisplay[i].globalHistoryView.length > 0) {
                    lastDate = customersToDisplay[i].globalHistoryView[0].date;
                    firstDate = customersToDisplay[i].globalHistoryView[customersToDisplay[i].globalHistoryView.length - 1].date;

                    for (var j = 0; j < customersToDisplay[i].globalHistoryView.length; j++) {
                        if (customersToDisplay[i].globalHistoryView[j].status === "sold" && customersToDisplay[i].globalHistoryView[j].date) {
                            if (lastSaleDate == null || lastSaleDate.getTime() < customersToDisplay[i].globalHistoryView[j].date.getTime()) lastSaleDate = customersToDisplay[i].globalHistoryView[j].date;
                            if (firstSaleDate == null || firstSaleDate.getTime() > customersToDisplay[i].globalHistoryView[j].date.getTime()) firstSaleDate = customersToDisplay[i].globalHistoryView[j].date;
                        }
                    }
                } else {
                    firstDate = null;
                    lastDate = null;
                }
                content += '<tr><td>' + ++nbClient + '</td>' + '<td>' + (customersToDisplay[i].lastName ? customersToDisplay[i].lastName : '') + '</td>' + '<td>' + (customersToDisplay[i].firstName ? customersToDisplay[i].firstName : '') + '</td>' + '<td>' + (customersToDisplay[i].gender ? customersToDisplay[i].gender : '') + '</td>' + '<td>' + (customersToDisplay[i].email ? customersToDisplay[i].email : '') + '</td>' + '<td>' + (customersToDisplay[i].phoneDisplay ? customersToDisplay[i].phoneDisplay : '') + '</td>' + '<td>' + (customersToDisplay[i].landline ? customersToDisplay[i].landline : '') + '</td>' + '<td>' + (customersToDisplay[i].address1 ? customersToDisplay[i].address1 : '') + '</td>' + '<td>' + (customersToDisplay[i].postCode ? customersToDisplay[i].postCode : '') + '</td>' + '<td>' + (customersToDisplay[i].city ? customersToDisplay[i].city : '') + '</td>' + '<td>' + (customersToDisplay[i].origin ? customersToDisplay[i].origin : '') + '</td>' + '<td>' + (customersToDisplay[i].birthDate ? $filter('date')(customersToDisplay[i].birthDate, 'shortDate') : '') + '</td>' + '<td>' + (customersToDisplay[i].comment ? customersToDisplay[i].comment : '') + '</td>' + '<td>' + (customersToDisplay[i].historyBookingsView ? customersToDisplay[i].historyBookingsView.length : '') + '</td>' + '<td>' + customersToDisplay[i].nbNotCameBookings + '</td>' + '<td>' + customersToDisplay[i].nbCameBookings + '</td>' + '<td>' + customersToDisplay[i].nbWaitingSales + '</td>' + '<td>' + customersToDisplay[i].nbSoldSales + '</td>' + '<td>' + customersToDisplay[i].nbCureItemNotUsed + '</td>' + '<td>' + customersToDisplay[i].nbGiftItemsNotUsed + '</td>' + '<td>' + $filter('number')(customersToDisplay[i].historySoldPrice, 2) + '</td>' + '<td>' + (firstDate ? $filter('date')(firstDate, 'shortDate') : '') + '</td>' + '<td>' + (lastDate ? $filter('date')(lastDate, 'shortDate') : '') + '</td>' + '<td>' + (firstSaleDate ? $filter('date')(firstSaleDate, 'shortDate') : '') + '</td>' + '<td>' + (lastSaleDate ? $filter('date')(lastSaleDate, 'shortDate') : '') + '</td>' + '<td>' + (customersToDisplay[i].optInOutView.isAgreementKnown() ? customersToDisplay[i].optInOutView.isSmsCampaignAllowed ? yes : no : unknowValue) + '</td>' + '<td>' + (customersToDisplay[i].optInOutView.isAgreementKnown() ? customersToDisplay[i].optInOutView.isEmailCampaignAllowed ? yes : no : unknowValue) + '</td>' + '<td>' + (customersToDisplay[i].optInOutView.isAgreementKnown() ? customersToDisplay[i].optInOutView.isNotificationCampaignAllowed ? yes : no : unknowValue) + '</td></tr>';
            }
        }
        if (!isExport && customersToDisplay.length == maxCustomerDisplay) {
            content += '<tr><td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td>' + '<td>...</td></tr>';
        }

        if (isExport) {
            tableId = "table-customers-export-hide";
            content += "</div>";
        }
        content += "</table>";
        $("#" + divId).replaceWith(content);
        $("#" + tableId + " th:first-child")[0].innerText = "Nb :" + nbClient;
    };

    $scope.orderCustomersView = function () {
        if ($scope.cutomerTabNeedToOrder) {
            $scope.dd.view.customersView = $filter("orderBy")($scope.dd.view.customersView, $scope.customersSortValue, $scope.customersOrderByReverse);
            $scope.cutomerTabNeedToOrder = false;
        }
    };

    $scope.onChangeCustomerFilter = function (filter, nbCustomersDisplayed) {
        if ($scope.dd.view.customersView) {
            $scope.orderCustomersView();
            $scope.customersFilterValue = filter;
            if ($scope.dd.displayTable) {
                $scope.loadAllCustomerViewsHistory(function () {
                    $scope.setEditedCustomerView(null);
                    var timer = $timeout(function () {
                        $scope.createCustomerTable(false, 'table-customers-export');
                    }, 200);
                    timers.push(timer);
                });
            } else {
                var date = new Date();
                var customerFilter = $scope.dd.view.customerFilter;
                var customerFilterModes = $scope.customerFilterModes;
                if (!customerFilter || customerFilter.length < 2) {
                    //No filter : reset array to initial size

                    var nbCustomersOnScreen = 20;
                    if (nbCustomersDisplayed != null && !isNaN(nbCustomersDisplayed) && nbCustomersDisplayed > 0) {
                        nbCustomersOnScreen = nbCustomersDisplayed;
                    }
                    if ($scope.dd.displayTable) nbCustomersOnScreen = $scope.dd.view.customersView.length;

                    $scope.dd.view.customersViewDisplayed = [];

                    if ($scope.customersFilterValue === customerFilterModes.filterByBirthday) {
                        for (var i = 0; i < $scope.dd.view.customersView.length; i++) {
                            var customersView = $scope.dd.view.customersView[i];
                            if (customersView.birthDate && customersView.birthDate.getMonth() === date.getMonth()) $scope.addCustomersViewDisplayed(customersView);
                        }
                    } else if ($scope.customersFilterValue === customerFilterModes.filterByChildGender || $scope.customersFilterValue === customerFilterModes.filterByManGender || $scope.customersFilterValue === customerFilterModes.filterByWomanGender) {
                        for (var _i = 0; _i < $scope.dd.view.customersView.length; _i++) {
                            var _customersView = $scope.dd.view.customersView[_i];
                            if (_customersView.gender === $scope.customersFilterValue) $scope.addCustomersViewDisplayed(_customersView);
                        }
                    } else for (var _i2 = 0; _i2 < $scope.dd.view.customersView.length && _i2 < nbCustomersOnScreen; _i2++) {
                        var _customersView2 = $scope.dd.view.customersView[_i2];
                        $scope.addCustomersViewDisplayed(_customersView2);
                    }
                } else {
                    $scope.dd.view.customerFilterBirthday = false;
                    var start = 0;
                    var newMaxLength = $scope.dd.view.customersViewDisplayed.length + 20;
                    //Add elements to array
                    if (customerFilter.length === 0) {
                        if ($scope.dd.view.customersViewDisplayed.length !== 0) {
                            //start using first index of new element
                            start = $scope.dd.view.customersView.indexOf($scope.dd.view.customersViewDisplayed[$scope.dd.view.customersViewDisplayed.length - 1]) + 1;
                        }
                    } else {
                        $scope.dd.view.customersViewDisplayed = [];
                    }
                    var filterWithoutSpace = customerFilter.replace(/\s/g, '');

                    for (var _i3 = start; _i3 < $scope.dd.view.customersView.length && $scope.dd.view.customersViewDisplayed.length < newMaxLength; _i3++) {
                        var _customersView3 = $scope.dd.view.customersView[_i3];

                        if (($scope.customersFilterValue === '' || $scope.customersFilterValue === customerFilterModes.filterByBirthday && _customersView3.birthDate && _customersView3.birthDate.getMonth() === date.getMonth() || $scope.customersFilterValue === customerFilterModes.filterByManGender && customerFilterModes.filterByManGender === _customersView3.gender || $scope.customersFilterValue === customerFilterModes.filterByWomanGender && customerFilterModes.filterByWomanGender === _customersView3.gender || $scope.customersFilterValue === customerFilterModes.filterByChildGender && customerFilterModes.filterByChildGender === _customersView3.gender) && (_customersView3.lastName && _customersView3.lastName.toLowerCase().indexOf(customerFilter.toLowerCase()) === 0 || _customersView3.email && _customersView3.email.toLowerCase().indexOf(customerFilter.toLowerCase()) === 0 || _customersView3.firstName && _customersView3.firstName.toLowerCase().indexOf(customerFilter.toLowerCase()) === 0 || _customersView3.label && _customersView3.label.toLowerCase().indexOf(customerFilter.toLowerCase()) === 0 || _customersView3.phone && _customersView3.customerInterNationalLandlineNumber && _customersView3.customerInterNationalLandlineNumber.indexOf(filterWithoutSpace) === 0 || _customersView3.phone && _customersView3.customerNationalLandlineNumber && _customersView3.customerNationalLandlineNumber.indexOf(filterWithoutSpace) === 0 || _customersView3.phone && _customersView3.customerInterNationalMobileNumber && _customersView3.customerInterNationalMobileNumber.indexOf(filterWithoutSpace) === 0 || _customersView3.phone && _customersView3.customerNationalMobileNumber && _customersView3.customerNationalMobileNumber.indexOf(filterWithoutSpace) === 0)) {
                            $scope.addCustomersViewDisplayed(_customersView3);
                        }
                    }
                }
            }
        }
    };

    $scope.onChangeCustomerOrder = function (sortMode, sortOrder) {
        $scope.customersSortValue = sortMode;
        $scope.customersOrderByReverse = sortOrder;
        $scope.cutomerTabNeedToOrder = true;
        $scope.loadAllCustomerViewsHistory();
        $scope.onChangeCustomerFilter($scope.customersFilterValue);
    };

    var dynamicSort = function dynamicSort(property, sortOrder) {
        return function (a, b) {
            var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
            return result * sortOrder;
        };
    };

    //FIX ME: UNUSED FUNCTION
    $scope.displayError = function () {
        $scope.dd.displayError = true;
        $scope.dd.displayPhoneError = !($scope.dd.edited.customerView && $scope.dd.edited.customerView.hasValidCellPhone(false));
        $scope.dd.displayLandlineError = !($scope.dd.edited.customerView && $scope.dd.edited.customerView.hasValidLandLine());
    };

    $scope.onExternalOptInOutChange = function () {
        if (!$scope.dd.edited.customerView.optInOutView.isAgreementKnown()) {
            $scope.dd.edited.customerView.optInOutView.isSmsCampaignAllowed = true;
            $scope.dd.edited.customerView.optInOutView.origin = '';
            $scope.dd.edited.customerView.optInOutView.isNotificationCampaignAllowed = true;
            $scope.dd.edited.customerView.optInOutView.isEmailCampaignAllowed = true;
            $scope.dd.edited.customerView.optInOutView.timeModified = new Date();
            $scope.dd.edited.customerView.optInOutView.updateDateString();
        }
        var opts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: '/partials/planningPos/customer/customerExternalOptInOut.html',
            controller: 'DialogCtrl',
            resolve: {
                dialogsModel: function dialogsModel() {
                    var tableModel = [];
                    tableModel["customerView"] = $scope.dd.edited.customerView;
                    return tableModel;
                }
            } };

        var d = $dialog.dialog(opts);
        d.open().then(function (result) {
            if (result) {
                $scope.dd.edited.customerView.optInOutView.isExternalOptInOut = true;
                if ($scope.dd.edited.customerView.getModel()) $scope.dd.edited.customerView.optInOutView.updateModel(null, null, $scope.dd.edited.customerView.getModel().getId());else $scope.dd.edited.customerView.optInOutView.updateModel();
            } else {
                if ($scope.dd.edited.customerView.optInOutView.getModel()) {
                    $scope.dd.edited.customerView.optInOutView.loadDataFrom($scope.dd.edited.customerView.optInOutView.getModel());
                } else {
                    $scope.dd.edited.customerView.optInOutView = new OptInOutView(null, -1);
                }
            }
        });
    };

    $scope.fusionCustomers = function (customerSourceView, customerTargetView) {
        if (customerSourceView && customerTargetView) {
            var customerSource = customerSourceView.getModel();
            var customerTarget = customerTargetView.getModel();
            if (customerSource && customerTarget) {
                CustomerSrv.fusion(customerSource, customerTarget, function () {
                    var targetActiveLoyaltyCard = $scope.getActiveLoyaltyCard(customerTarget);

                    for (var i = 0; i < BookingData.indexBookings.length; i++) {
                        var booking = BookingData.indexBookings[i];
                        if (booking && booking.customer === customerSource) {
                            customerSource.removeBooking(booking);

                            if (booking.sale) {
                                booking.sale.inactiveUnusedLoyaltyCardItem(targetActiveLoyaltyCard);
                                booking.sale.inactiveUnusedLoyaltyCardItems(targetActiveLoyaltyCard);
                            }

                            customerTarget.addBooking(booking);
                            booking.customer = customerTarget;
                        }
                    }

                    for (var _i4 = 0; _i4 < SaleData.indexSales.length; _i4++) {
                        var sale = SaleData.indexSales[_i4];
                        if (sale && sale.customer === customerSource) {
                            sale.inactiveUnusedLoyaltyCardItem(targetActiveLoyaltyCard);
                            sale.inactiveUnusedLoyaltyCardItems(targetActiveLoyaltyCard);
                            customerSource.removeSale(sale);
                            customerTarget.addSale(sale);
                            sale.customer = customerTarget;
                        }
                    }

                    for (var _i5 = 0; _i5 < GiftItemData.indexGiftItems.length; _i5++) {
                        var giftItem = GiftItemData.indexGiftItems[_i5];
                        if (giftItem && giftItem.customer === customerSource) {
                            customerSource.removeGiftItem(giftItem);

                            if (giftItem.sale) {
                                giftItem.sale.inactiveUnusedLoyaltyCardItem(targetActiveLoyaltyCard);
                                giftItem.sale.inactiveUnusedLoyaltyCardItems(targetActiveLoyaltyCard);
                            }

                            customerTarget.addGiftItem(giftItem);
                            giftItem.customer = customerTarget;
                        }
                    }

                    for (var _i6 = 0; _i6 < CureItemData.indexCureItems.length; _i6++) {
                        var cureItem = CureItemData.indexCureItems[_i6];

                        if (cureItem.customer === customerSource) {
                            cureItem.customer = customerTarget;
                        }
                    }

                    $scope.updateCustomerAttributes(customerSource, customerTarget);
                    CustomerData.remove(customerSource);
                    $scope.ad.loading = true;
                    $route.reload();
                }, function (data) {
                    if (data == null || data.status == null || data.status !== "200") {
                        $scope.dd.view.display.fusionCustomersError = true;
                    }
                });
            }
        }
    };
    $scope.getActiveLoyaltyCard = function (customer) {
        var activeLoyaltyCardItem = null;
        for (var i = 0; i < customer.sales.length; i++) {
            var sale = customer.sales[i];

            if (sale && sale.loyaltyCardItem && !sale.loyaltyCardItem.isUsed) {
                activeLoyaltyCardItem = sale.loyaltyCardItem;
                break;
            }
        }
        return activeLoyaltyCardItem;
    };
    $scope.updateCustomerAttributes = function (customerSource, customerTarget) {

        if (!customerTarget.phone) {
            customerTarget.phone = customerSource.phone;
        }

        if (!customerTarget.landline) {
            customerTarget.landline = customerSource.landline;
        }

        if (!customerTarget.email) {
            customerTarget.email = customerSource.email;
        }

        if (!customerTarget.comment) {
            customerTarget.comment = customerSource.comment;
        }

        if (!customerTarget.gender) {
            customerTarget.gender = customerSource.gender;
        }

        if (!customerTarget.isVerified) {
            customerTarget.isVerified = customerSource.isVerified;
        }

        if (!(customerTarget.address1 && customerTarget.city && customerTarget.postCode)) {
            customerTarget.address1 = customerSource.address1;
            customerTarget.postCode = customerSource.postCode;
            customerTarget.city = customerSource.city;
        }

        if (!customerTarget.origin) {
            customerTarget.origin = customerSource.origin;
        }

        if (!customerTarget.online) {
            customerTarget.online = customerSource.online;
        }

        if (!customerTarget.birthDate) {
            customerTarget.birthDate = customerSource.birthDate;
        }

        if (!customerTarget.isCGVAccepted) {
            customerTarget.isCGVAccepted = customerSource.isCGVAccepted;
        }

        if (!customerTarget.optInOut) {
            customerTarget.optInOut = customerSource.optInOut;
        }
    };

    $scope.openFusionCustomerViewConfirmDialog = function () {
        if ($scope.dd.edited.customerView) {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/planningPos/customer/customerFusion.html',
                controller: 'CustomerFusionCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["sourceCustomerView"] = $scope.dd.edited.customerView;
                        tableModel["dd"] = $scope.dd;
                        return tableModel;
                    } } };

            var d = $dialog.dialog(opts);
            d.open().then(function (customerTarget) {
                if (customerTarget) $scope.fusionCustomers($scope.dd.edited.customerView, customerTarget);
            });
        }
    };

    $scope.$on('$destroy', function () {
        goToDomainCalledDestroy();

        Timers.cancel(timers);
    });
}]);

/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('ServiceSelectorCtrl', ["$scope", "CategoryData", "CategoryView", function ($scope, CategoryData, CategoryView) {
    $scope.setCurrentCategory = function (categoryView) {
        $scope.dd.view.cCategoryView = categoryView;
    };
}]);

/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('TestDatasInjectorCtrl', ["$scope", function ($scope) {
    var now = new Date();
    var deb = new Date();
    deb.setTime(deb.getTime() - 7 * 24 * 60 * 60 * 1000);

    $scope.mapParameters = [];

    $scope.mapParameters['TestStatInjector'] = [{
        name: "companyCode",
        label: "Code entreprise",
        value: "sdf",
        type: 'text',
        required: false
    }, {
        name: "dateDeb",
        label: "Date de début",
        value: deb,
        type: 'date',
        required: true
    }, {
        name: "dateFin",
        label: "Date de fin",
        value: now,
        type: 'date',
        required: true
    }, {
        name: "populeConfig",
        label: "populeConfig",
        value: true,
        type: 'text',
        required: true
    }];

    $scope.actionEnCours = false;
    $scope.actionTerminee = false;

    $scope.lancer = function ($event) {
        $scope.actionEnCours = true;
        $scope.actionTerminee = false;

        $("#myTable").empty();
        $scope.searchPb(0);
    };

    $scope.searchPb = function (offset, companyCode) {
        var parametersCleaner = "";
        for (var i = 0; i < $scope.mapParameters[$scope.injector].length; i++) {
            parametersCleaner += "&";
            if ($scope.mapParameters[$scope.injector][i].type != 'date') {
                parametersCleaner += $scope.mapParameters[$scope.injector][i].name + "=" + $scope.mapParameters[$scope.injector][i].value;
            } else {
                parametersCleaner += $scope.mapParameters[$scope.injector][i].name + "=" + $scope.getDateString($scope.mapParameters[$scope.injector][i].value);
            }
        }

        $.ajax({
            url: "/flexyTest/injector?type=" + $scope.injector + parametersCleaner,
            success: function success(result) {
                //var datas = jQuery.parseJSON(result );
                var datas = result;
                console.info(datas);
                if (datas && datas.listeResult && datas.listeResult.length != 0) {
                    $scope.addLines(datas.listeResult);
                }
                if (datas.parameters) {
                    $scope.addParameters(datas.parameters);
                }
            }
        });
    };

    $scope.addLines = function (datas) {
        var lignes = "";
        for (var i = 0; i < datas.length; i++) {
            if (datas[i].ccompanyStatus != "canceled" && datas[i].ccompanyStatus != "billingBlocked" && datas[i].ccompanyStatus != "blocked" && datas[i].ccompanyStatus != "internalTest" && datas[i].ccompanyStatus != "model") {
                lignes += "<tr style='background-color:" + datas[i].backgroundColor + "'>";
                lignes += "<td>" + datas[i].message + "</td>";
                //lignes += "<td>" + datas[i].userLogin + "</td>";
                //lignes += "<td><a href='/fxbAdmin/" + datas[i].companyCode + "' target='_blank'><button class='btn btn-save'><i class='fal fa-sign-in'></i>&nbsp;Page de connexion</button></a></td>";
                //lignes += "<td><input type='button' value='Réparer le salon' onclick='repareOne(\"" + datas[i].companyCode + "\")'></input></td>";
                lignes += "</tr>";
            }
        }
        $("#myTable").append(lignes);
    };

    $scope.addParameters = function (parameters) {
        var lignes = "";
        for (var i = 0; i < parameters.length; i++) {
            lignes += "<tr><td>" + parameters[i].name + "</td><td>" + parameters[i].value + "</td></tr>";
        }

        $("#myParameters").empty();
        $("#myParameters").append(lignes);
    };

    $scope.getDateString = function (dateValue) {

        var today = dateValue;
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!

        var yyyy = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        today = yyyy + '-' + mm + '-' + dd;
        return today;
    };
}]);

/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module('FlexyBeautyApp.services').factory('Environment_Constant', [function () {
    return {
        VERSION_CHECK_FREQUENCY_MILLISECOND: 30 * 60 * 1000
    };
}]);

angular.module('FlexyBeautyApp.services').factory('Environment_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/environment', {}, {
        getVersion: { method: 'GET', url: baseUrl + 'rest/environment/version' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('Environment', ["Environment_Resource", "EnvironmentData", function (Environment_Resource, EnvironmentData) {

    var Environment = function Environment(resource) {
        this.version = null;
        if (resource) {
            this.loadObject(resource);
        }
        EnvironmentData.set(this);
    };

    Environment.prototype.loadObject = function (resource) {
        this.version = resource.version;
    };

    return Environment;
}]);

angular.module('FlexyBeautyApp.services').factory('EnvironmentSrv', ['Environment_Resource', 'EnvironmentData', 'Environment', function (Environment_Resource, EnvironmentData, Environment) {
    var environmentSrv = {};

    environmentSrv.getVersion = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return Environment_Resource.getVersion().$promise.then(function (versionResponse) {
                            var versionObject = versionResponse.toJSON();
                            var environment = EnvironmentData.get();
                            if (!environment) {
                                environment = new Environment(versionObject);
                            } else {
                                environment.loadObject(versionObject);
                            }
                            return environment.version;
                        });

                    case 2:
                        return _context.abrupt('return', _context.sent);

                    case 3:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));
    return environmentSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('EnvironmentData', [function () {
    var environmentData = {
        environment: undefined
    };

    environmentData.get = function () {
        return this.environment;
    };

    environmentData.set = function (environment) {
        this.environment = environment;
        return this.environment;
    };

    return environmentData;
}]);

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* Controllers */

angular.module('FlexyBeautyApp.controllers').controller('ForgotPwdCtrl', ['$rootScope', '$scope', '$location', '$window', 'Auth', 'User', '$routeParams', 'Brand', function ($rootScope, $scope, $location, $window, Auth, User, $routeParams, Brand) {

    $scope.rememberme = true;
    $scope.processingLogin = false;
    $scope.processingRegister = false;
    $scope.alertsLogin = [];
    $scope.alertsRegister = [];
    $scope.displayErrorMessage = false;
    $scope.brand = Brand;
    $scope.userLogin = {
        email: "",
        password: "",
        confirmPassword: "",
        companyName: "",
        companyModel: "",
        role: Auth.userRoles.user
    };
    if ($routeParams.token && $routeParams.email) //received change pwd request
        {
            $scope.userLogin.email = $routeParams.email;
        }

    $scope.login = function () {
        if ($scope.userLogin.email == "" || $scope.userLogin.password == "" || $scope.userLogin.confirmPassword == "") {
            $scope.addAlertLogin('error', "Merci de renseigner les champs obligatoires");
            return;
        }
        if ($scope.userLogin.password != $scope.userLogin.confirmPassword) {
            $scope.addAlertLogin('error', "Le mot de passe et le mot de passe de confirmation ne sont pas identiques");
            return;
        }
        var user = new User($scope.userLogin);
        $scope.processingLogin = true;
        $scope.alerts = [];
        Auth.loginToProSiteOnForgetPwd(user, $routeParams.token, function (res) {
            $scope.processingLogin = false;
            $scope.addAlertLogin('success', "Connexion sécurisée établie");
            $location.path('/');
        }, function (errorMessage) {
            $scope.addAlertLogin('error', errorMessage);
            $scope.processingLogin = false;
        });
    };

    $scope.addAlertLogin = function (type, msg) {
        $scope.alertsLogin.push({ type: type, msg: msg });
    };

    $scope.closeAlertLogin = function (index) {
        $scope.alertsLogin.splice(index, 1);
    };
}]);

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by wacelBaroudi on 07/02/2019.
 */

angular.module('FlexyBeautyApp.services').factory('KycDocument_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + "rest/kyc/documents", {}, {
        query: { method: 'GET', isArray: true }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('KycDocument', ["KycDocumentData", function (KycDocumentData) {
    var KycDocument = function KycDocument(resource) {
        this.type = null;
        this.status = null;
        this.refusedReasonMessage = null;

        if (resource !== undefined && resource !== null) this.loadObject(resource);

        KycDocumentData.add(this);
    };

    KycDocument.prototype.loadObject = function (object) {
        if (object) {
            this.type = object.type;
            this.status = object.status;
            this.refusedReasonMessage = object.refusedReasonMessage;
        }
    };

    return KycDocument;
}]);

angular.module('FlexyBeautyApp.services').factory('KycDocumentSrv', ["$log", "ServerSrv", "KycDocument_Resource", "KycDocumentData", "KycDocument", function ($log, ServerSrv, KycDocument_Resource, KycDocumentData, KycDocument) {
    var KycDocumentSrv = {};

    KycDocumentSrv.query = function (successFunction, errorFunction) {
        KycDocument_Resource.query({}, function (data) {

            KycDocumentData.clear();
            for (var i = 0; i < data.length; i++) {
                new KycDocument(data[i]);
            }

            if (successFunction !== undefined) successFunction();
        }, function (data) {
            if (errorFunction !== undefined) errorFunction(data);
        });
    };

    return KycDocumentSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('KycDocumentData', ["$filter", function () {
    var kycDocumentData = {
        kycDocuments: []
    };
    kycDocumentData.getActiveList = function () {
        return this.kycDocuments;
    };
    kycDocumentData.clear = function () {
        this.kycDocuments = [];
    };
    kycDocumentData.add = function (kycDocument) {
        this.kycDocuments.push(kycDocument);
    };
    return kycDocumentData;
}]);

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('KycStatus_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + "rest/kyc/status", {}, {
        getKycStatus: { method: "GET" }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('KycStatusSrv', ["KycStatus_Resource", function (KycStatus_Resource) {
    var kycStatusSrv = {};

    kycStatusSrv.getKycStatus = function () {
        return KycStatus_Resource.getKycStatus().$promise;
    };

    return kycStatusSrv;
}]);

/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('LoaderKyc', ["KycDocumentSrv", function (KycDocumentSrv) {

    var LoaderKyc = {
        kycDocumentLoading: false,
        loadSuccess: true
    };

    LoaderKyc.afterLoad = function (success, successFunction, errorFunction) //boolean
    {
        LoaderKyc.loadSuccess &= success;
        if (!LoaderKyc.kycDocumentsLoading) {
            if (LoaderKyc.loadSuccess) {
                if (successFunction !== undefined) successFunction();
            } else {
                if (errorFunction !== undefined) errorFunction(LoaderKyc.securityError);
            }
            LoaderKyc.loaded = true;
        }
    };

    LoaderKyc.load = function (successFunction, errorFunction) {
        if (LoaderKyc.loaded) {
            if (successFunction !== undefined) successFunction();
            return;
        }

        // Load already in process
        if (LoaderKyc.kycDocumentsLoading) return;

        LoaderKyc.kycDocumentsLoading = true;
        KycDocumentSrv.query(function () {
            LoaderKyc.kycDocumentsLoading = false;
            LoaderKyc.afterLoad(true, successFunction, errorFunction);
        }, function (data) {
            if (data && data.status === 403) LoaderKyc.securityError = true;
            LoaderKyc.kycDocumentsLoading = false;
            LoaderKyc.afterLoad(false, successFunction, errorFunction);
        });
    };

    return LoaderKyc;
}]);

/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('Ubo', ["Countries", function (Countries) {
    var Ubo = function Ubo(resource) {
        this.firstName = null;
        this.lastName = null;
        this.nationalityCountryCode = Countries.FRANCE.countryCode;
        this.address = {
            addressLine1: null,
            addressLine2: null,
            city: null,
            region: null,
            postalCode: null,
            countryCode: Countries.FRANCE.countryCode
        };

        this.birth = {
            day: null,
            city: null,
            countryCode: Countries.FRANCE.countryCode
        };

        if (resource) {
            this.loadObject(resource);
        }
    };

    Ubo.prototype.loadObject = function (object) {
        if (object.id) {
            this.id = object.id;
        }
        this.firstName = object.firstName;
        this.lastName = object.lastName;
        this.nationalityCountryCode = object.nationalityCountryCode;

        if (object.address) {
            this.address = {
                addressLine1: object.address.addressLine1,
                addressLine2: object.address.addressLine2,
                city: object.address.city,
                region: object.address.region,
                postalCode: object.address.postalCode,
                countryCode: object.address.countryCode
            };
        }

        if (object.birth) {
            this.birth = {
                day: object.birth.day,
                city: object.birth.city,
                countryCode: object.birth.countryCode
            };
        }
    };

    return Ubo;
}]);

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('UboStatement_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + "rest/kyc/ubo/statements", {}, {
        query: { method: 'GET', isArray: false },
        update: { method: 'PUT' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('UboStatement', ["UboStatementData", "Ubo", "UboStatement_Resource", function (UboStatementData, Ubo, UboStatement_Resource) {
    var UboStatement = function UboStatement(resource) {
        this.id = null;
        this.details = null;
        this.status = null;
        this.timeCreated = null;
        this.ubos = [];

        if (resource) {
            this.loadObject(resource);
        }
        UboStatementData.add(this);
    };

    UboStatement.prototype.loadObject = function (object) {
        this.id = object.id;
        this.details = object.details;
        this.status = object.status;
        this.timeCreated = object.timeCreated;

        for (var i = 0; i < object.ubos.length; i++) {
            this.ubos.push(new Ubo(object.ubos[i]));
        }
    };

    UboStatement.prototype.getObjectResource = function () {
        var rsUboStatement = new UboStatement_Resource();
        if (this.id) {
            rsUboStatement.id = this.id;
        }
        rsUboStatement.ubos = this.ubos;

        return rsUboStatement;
    };

    return UboStatement;
}]);

angular.module('FlexyBeautyApp.services').factory('UboStatementSrv', ["UboStatement_Resource", "UboStatement", "UboStatementData", function (UboStatement_Resource, UboStatement, UboStatementData) {
    var uboStatementSrv = {};
    uboStatementSrv.query = function () {
        return UboStatement_Resource.query().$promise.then(function (res) {
            if (res && res.uboStatements) {
                UboStatementData.clear();
                for (var i = 0; i < res.uboStatements.length; i++) {
                    new UboStatement(res.uboStatements[i]);
                }
            }
        });
    };

    uboStatementSrv.save = function (uboStatement) {
        var uboStatementResource = uboStatement.getObjectResource();
        return uboStatementResource.$save({});
    };

    uboStatementSrv.update = function (uboStatement) {
        var uboStatementResource = uboStatement.getObjectResource();
        return uboStatementResource.$update();
    };

    return uboStatementSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('UboStatementData', function () {
    var uboStatementData = {
        uboStatements: []
    };

    uboStatementData.getById = function (id) {
        return this.uboStatements.find(function (item) {
            return item.id === id;
        });
    };

    uboStatementData.getUboStatements = function () {
        return this.uboStatements;
    };

    uboStatementData.clear = function () {
        this.uboStatements = [];
    };

    uboStatementData.add = function (ubo) {
        this.uboStatements.push(ubo);
    };
    return uboStatementData;
});

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* Directives */

angular.module('FlexyBeautyApp.directives').directive('appVersion', ['version', function (version) {
    return function (scope, elm, attrs) {
        elm.text(version);
    };
}]).directive('draggableCategory', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var categoryView = scope[attrs["draggableCategory"]];
            $(element).draggable({
                distance: 5,
                revert: "invalid",
                zIndex: 1000,
                cursorAt: { top: -5, left: -5 },
                start: function start() {
                    if (!categoryView || !categoryView.getModel()) {
                        return false;
                    }
                    // On drag set that flag to not null
                    scope.dd.view.selected.categoryView.draggedCategoryView = categoryView;
                    $("button.selector-btn-edit-image").hide();
                },
                stop: function stop() {
                    scope.dd.view.selected.categoryView.draggedCategoryView = null;
                    $("button.selector-btn-edit-image").show();
                }
            });
        }
    };
}).directive('draggableService', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var serviceView = scope[attrs["draggableService"]];
            $(element).draggable({
                distance: 5,
                opacity: 0.5,
                revert: "invalid",
                zIndex: 10,
                cursorAt: { top: -5, left: -5 },
                start: function start() {
                    if (!serviceView || !serviceView.getModel()) {
                        return false;
                    }
                    // On drag set that flag to not null
                    scope.dd.view.selected.categoryView.draggedServiceView = serviceView;
                },
                stop: function stop() {
                    scope.dd.view.selected.categoryView.draggedServiceView = null;
                }
            });
        }
    };
}).directive('draggableProduct', ["$timeout", function ($timeout) {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var productView = scope[attrs["draggableProduct"]];
            $timeout(function () {
                $(element).draggable({
                    distance: 5,
                    opacity: 0.5,
                    revert: "invalid",
                    zIndex: 10,
                    cursorAt: { top: -5, left: -5 },
                    start: function start() {
                        if (!productView || !productView.getModel()) return false;
                        // On drag set that flag to not null
                        scope.dd.view.selected.categoryView.draggedProductView = productView;
                    },
                    stop: function stop() {

                        scope.dd.view.selected.categoryView.draggedProductView = null;
                    }
                });
            }, 500);
        }
    };
}]).directive('draggableCure', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var cureView = scope[attrs["draggableCure"]];
            $(element).draggable({
                distance: 5,
                opacity: 0.5,
                revert: "invalid",
                zIndex: 10,
                cursorAt: { top: -5, left: -5 },
                start: function start() {
                    if (!cureView || !cureView.getModel()) return false;
                    // On drag set that flag to not null
                    scope.dd.view.selected.categoryView.draggedCureView = cureView;
                },
                stop: function stop() {

                    scope.dd.view.selected.categoryView.draggedCureView = null;
                }
            });
        }
    };
}).directive('draggableLoyaltyCard', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var loyaltyCardView = scope[attrs["draggableLoyaltyCard"]];
            $(element).draggable({
                distance: 5,
                opacity: 0.5,
                revert: "invalid",
                zIndex: 10,
                cursorAt: { top: -5, left: -5 },
                start: function start() {
                    if (!loyaltyCardView || !loyaltyCardView.getModel()) return false;
                    // On drag set that flag to not null
                    scope.dd.view.selected.categoryView.draggedLoyaltyCardView = loyaltyCardView;
                },
                stop: function stop() {

                    scope.dd.view.selected.categoryView.draggedLoyaltyCardView = null;
                }
            });
        }
    };
}).directive('clickCategory', ["$timeout", function ($timeout) {
    //used to stop action during drag
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var categoryView = scope[attrs["clickCategory"]];

            element.bind('click', function (event) {
                // On mobile platform, the category editing screen is displayed in front after a click, so it is impossible to handle the double click
                if (scope.ad.isMobileOrPadTouchScreen) {
                    if (categoryView.dblClickTimeout) {
                        //on double click
                        $timeout.cancel(categoryView.dblClickTimeout);
                        if (scope.dd.view.selected.categoryView && scope.dd.view.selected.categoryView.draggedCategoryView == null) {
                            scope.setCurrentCategory(categoryView);
                            categoryView.dblClickTimeout = null;
                            scope.$apply();
                        }
                    } else {
                        categoryView.dblClickTimeout = $timeout(function () {
                            if (scope.dd.view.selected.categoryView && scope.dd.view.selected.categoryView.draggedCategoryView == null) {
                                if (scope.dd.view.edited.categoryView !== categoryView) {
                                    scope.setEditedCategory(categoryView);
                                    categoryView.dblClickTimeout = null;
                                    scope.$apply();
                                }
                            }
                        }, 350);
                    }
                } else {
                    if (scope.dd.view.selected.categoryView && scope.dd.view.selected.categoryView.draggedCategoryView == null) {
                        if (scope.dd.view.edited.categoryView === categoryView) scope.setCurrentCategory(categoryView); //on double click
                        else scope.setEditedCategory(categoryView);
                    }
                    scope.$apply();
                }
            });
        }
    };
}]).directive('clickService', function () {
    //used to stop action during drag
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var serviceView = scope[attrs["clickService"]];
            element.bind('click', function (event) {
                if (scope.dd.view.selected.categoryView && scope.dd.view.selected.categoryView.draggedServiceView == null) {
                    scope.serviceClicked(serviceView);
                    scope.$apply();
                }
            });
        }
    };
}).directive('clickProduct', function () {
    //used to stop action during drag
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var productView = scope[attrs["clickProduct"]];
            element.bind('click', function (event) {
                if (scope.dd.view.selected.categoryView && scope.dd.view.selected.categoryView.draggedProductView == null) {
                    scope.productClicked(productView);
                    scope.$apply();
                }
            });
        }
    };
}).directive('clickCure', function () {
    //used to stop action during drag
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var cureView = scope[attrs["clickCure"]];
            element.bind('click', function (event) {
                if (scope.dd.view.selected.categoryView && scope.dd.view.selected.categoryView.draggedCureView == null) {
                    scope.cureClicked(cureView);
                    scope.$apply();
                }
            });
        }
    };
}).directive('clickLoyaltyCard', function () {
    //used to stop action during drag
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var loyaltyCardView = scope[attrs["clickLoyaltyCard"]];
            element.bind('click', function (event) {
                if (scope.dd.view.selected.categoryView && scope.dd.view.selected.categoryView.draggedLoyaltyCardView == null) {
                    scope.loyaltyCardClicked(loyaltyCardView);
                    scope.$apply();
                }
            });
        }
    };
}).directive('droppableCategory', ["CategorySrv", function (CategorySrv) {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var categoryView = scope[attrs["droppableCategory"]];
            $(element).droppable({
                activeClass: 'active',
                hoverClass: 'hovered',
                tolerance: 'pointer',
                drop: function drop(event, ui) {
                    if (scope.dd.view.selected.categoryView.draggedServiceView) {
                        categoryView.moveService(scope.dd.view.selected.categoryView.draggedServiceView);
                        scope.dd.view.selected.categoryView.draggedServiceView == null;
                    } else if (scope.dd.view.selected.categoryView.draggedCategoryView) {
                        categoryView.moveCategory(scope.dd.view.selected.categoryView.draggedCategoryView);
                        scope.dd.view.selected.categoryView.draggedCategoryView = null;
                    }
                    $("button.selector-btn-edit-image").show();
                    scope.$apply();
                }
            });
        }
    };
}]).directive('droppableUpCategory', ["CategorySrv", function (CategorySrv) {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            $(element).droppable({
                activeClass: 'active',
                hoverClass: 'hovered',
                tolerance: 'pointer',
                drop: function drop(event, ui) {
                    if (scope.dd.view.selected.categoryView.draggedServiceView) {
                        scope.dd.view.selected.categoryView.parentCategoryView.moveService(scope.dd.view.selected.categoryView.draggedServiceView);
                        scope.dd.view.selected.categoryView.draggedServiceView = null;
                    } else if (scope.dd.view.selected.categoryView.draggedCategoryView) {
                        scope.dd.view.selected.categoryView.parentCategoryView.moveCategory(scope.dd.view.selected.categoryView.draggedCategoryView);
                        scope.dd.view.selected.categoryView.draggedCategoryView = null;
                    }
                    $("button.selector-btn-edit-image").show();
                    scope.$apply();
                }
            });
        }
    };
}]).directive('droppableProductCategory', ["CategorySrv", function (CategorySrv) {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var categoryView = scope[attrs["droppableProductCategory"]];
            $(element).droppable({
                activeClass: 'active',
                hoverClass: 'hovered',
                tolerance: 'pointer',
                drop: function drop(event, ui) {
                    if (scope.dd.view.selected.categoryView.draggedProductView) {
                        categoryView.moveProduct(scope.dd.view.selected.categoryView.draggedProductView);
                        scope.dd.view.selected.categoryView.draggedProductView == null;
                    } else if (scope.dd.view.selected.categoryView.draggedCategoryView) {
                        categoryView.moveCategory(scope.dd.view.selected.categoryView.draggedCategoryView);
                        scope.dd.view.selected.categoryView.draggedCategoryView = null;
                    }
                    $("button.selector-btn-edit-image").show();
                    scope.$apply();
                }
            });
        }
    };
}]).directive('droppableUpProductCategory', ["CategorySrv", function (CategorySrv) {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            $(element).droppable({
                activeClass: 'active',
                hoverClass: 'hovered',
                tolerance: 'pointer',
                drop: function drop(event, ui) {
                    if (scope.dd.view.selected.categoryView.draggedProductView) {
                        scope.dd.view.selected.categoryView.parentCategoryView.moveProduct(scope.dd.view.selected.categoryView.draggedProductView);
                        scope.dd.view.selected.categoryView.draggedProductView == null;
                    } else if (scope.dd.view.selected.categoryView.draggedCategoryView) {
                        scope.dd.view.selected.categoryView.parentCategoryView.moveCategory(scope.dd.view.selected.categoryView.draggedCategoryView);
                        scope.dd.view.selected.categoryView.draggedCategoryView = null;
                    }
                    $("button.selector-btn-edit-image").show();
                    scope.$apply();
                }
            });
        }
    };
}]).directive('droppableCureCategory', ["CategorySrv", function (CategorySrv) {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var categoryView = scope[attrs["droppableCureCategory"]];
            $(element).droppable({
                activeClass: 'active',
                hoverClass: 'hovered',
                tolerance: 'pointer',
                drop: function drop(event, ui) {
                    if (scope.dd.view.selected.categoryView.draggedCureView) {
                        categoryView.moveCure(scope.dd.view.selected.categoryView.draggedCureView);
                        scope.dd.view.selected.categoryView.draggedCureView == null;
                    } else if (scope.dd.view.selected.categoryView.draggedCategoryView) {
                        categoryView.moveCategory(scope.dd.view.selected.categoryView.draggedCategoryView);
                        scope.dd.view.selected.categoryView.draggedCategoryView = null;
                    }
                    $("button.selector-btn-edit-image").show();
                    scope.$apply();
                }
            });
        }
    };
}]).directive('droppableUpCureCategory', ["CategorySrv", function (CategorySrv) {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            $(element).droppable({
                activeClass: 'active',
                hoverClass: 'hovered',
                tolerance: 'pointer',
                drop: function drop(event, ui) {
                    if (scope.dd.view.selected.categoryView.draggedCureView) {
                        scope.dd.view.selected.categoryView.parentCategoryView.moveCure(scope.dd.view.selected.categoryView.draggedCureView);
                        scope.dd.view.selected.categoryView.draggedCureView == null;
                    } else if (scope.dd.view.selected.categoryView.draggedCategoryView) {
                        scope.dd.view.selected.categoryView.parentCategoryView.moveCategory(scope.dd.view.selected.categoryView.draggedCategoryView);
                        scope.dd.view.selected.categoryView.draggedCategoryView = null;
                    }
                    $("button.selector-btn-edit-image").show();
                    scope.$apply();
                }
            });
        }
    };
}]).directive('droppableLoyaltyCardCategory', ["CategorySrv", function (CategorySrv) {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var categoryView = scope[attrs["droppableLoyaltyCardCategory"]];
            $(element).droppable({
                activeClass: 'active',
                hoverClass: 'hovered',
                tolerance: 'pointer',
                drop: function drop(event, ui) {
                    if (scope.dd.view.selected.categoryView.draggedLoyaltyCardView) {
                        categoryView.moveLoyaltyCard(scope.dd.view.selected.categoryView.draggedLoyaltyCardView);
                        scope.dd.view.selected.categoryView.draggedLoyaltyCardView == null;
                    } else if (scope.dd.view.selected.categoryView.draggedCategoryView) {
                        categoryView.moveCategory(scope.dd.view.selected.categoryView.draggedCategoryView);
                        scope.dd.view.selected.categoryView.draggedCategoryView = null;
                    }
                    $("button.selector-btn-edit-image").show();
                    scope.$apply();
                }
            });
        }
    };
}]).directive('droppableUpLoyaltyCardCategory', ["CategorySrv", function (CategorySrv) {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            $(element).droppable({
                activeClass: 'active',
                hoverClass: 'hovered',
                tolerance: 'pointer',
                drop: function drop(event, ui) {
                    if (scope.dd.view.selected.categoryView.draggedLoyaltyCardView) {
                        scope.dd.view.selected.categoryView.parentCategoryView.moveLoyaltyCard(scope.dd.view.selected.categoryView.draggedLoyaltyCardView);
                        scope.dd.view.selected.categoryView.draggedLoyaltyCardView == null;
                    } else if (scope.dd.view.selected.categoryView.draggedCategoryView) {
                        scope.dd.view.selected.categoryView.parentCategoryView.moveCategory(scope.dd.view.selected.categoryView.draggedCategoryView);
                        scope.dd.view.selected.categoryView.draggedCategoryView = null;
                    }
                    $("button.selector-btn-edit-image").show();
                    scope.$apply();
                }
            });
        }
    };
}]).directive('droppableCategoryMoveLeft', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var categoryView = scope[attrs["droppableCategoryMoveLeft"]];
            $(element).droppable({
                activeClass: 'active',
                hoverClass: 'hovered',
                tolerance: 'pointer',
                accept: ".category",
                drop: function drop(event, ui) {
                    if (scope.dd.view.selected.categoryView.draggedCategoryView) {
                        scope.dd.view.selected.categoryView.changeCategoryPosition(scope, scope.dd.view.selected.categoryView.draggedCategoryView, scope.dd.view.selected.categoryView.categoriesView.indexOf(categoryView));
                        scope.dd.view.selected.categoryView.draggedCategoryView = null;
                        $("button.selector-btn-edit-image").show();
                    }
                }
            });
        }
    };
}).directive('droppableCategoryMoveRight', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var categoryView = scope[attrs["droppableCategoryMoveRight"]];
            $(element).droppable({
                activeClass: 'active',
                hoverClass: 'hovered',
                tolerance: 'pointer',
                accept: ".category",
                drop: function drop(event, ui) {

                    if (scope.dd.view.selected.categoryView.draggedCategoryView) {
                        scope.dd.view.selected.categoryView.changeCategoryPosition(scope, scope.dd.view.selected.categoryView.draggedCategoryView, scope.dd.view.selected.categoryView.categoriesView.indexOf(categoryView) + 1);
                        scope.dd.view.selected.categoryView.draggedCategoryView = null;
                        $("button.selector-btn-edit-image").show();
                    }
                }
            });
        }
    };
}).directive('droppableServiceMoveLeft', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var serviceView = scope[attrs["droppableServiceMoveLeft"]];
            if (scope.dd.view.selected.categoryView.servicesView.indexOf(serviceView) == 0) //accept to drop also category for the first service
                $(element).droppable({
                    activeClass: 'active',
                    hoverClass: 'hovered',
                    tolerance: 'pointer',
                    drop: function drop(event, ui) {
                        if (scope.dd.view.selected.categoryView.draggedServiceView) {
                            scope.dd.view.selected.categoryView.changeServicePosition(scope, scope.dd.view.selected.categoryView.draggedServiceView, scope.dd.view.selected.categoryView.servicesView.indexOf(serviceView));
                            scope.dd.view.selected.categoryView.draggedServiceView = null;
                            $("button.selector-btn-edit-image").show();
                        }
                        if (scope.dd.view.selected.categoryView.draggedCategoryView) {
                            scope.dd.view.selected.categoryView.changeCategoryPosition(scope, scope.dd.view.selected.categoryView.draggedCategoryView, scope.dd.view.selected.categoryView.categoriesView.length); //put at the end
                            scope.dd.view.selected.categoryView.draggedCategoryView = null;
                            $("button.selector-btn-edit-image").show();
                        }
                    }
                });else $(element).droppable({
                activeClass: 'active',
                hoverClass: 'hovered',
                tolerance: 'pointer',
                accept: ".service",
                drop: function drop(event, ui) {
                    if (scope.dd.view.selected.categoryView.draggedServiceView) {
                        scope.dd.view.selected.categoryView.changeServicePosition(scope, scope.dd.view.selected.categoryView.draggedServiceView, scope.dd.view.selected.categoryView.servicesView.indexOf(serviceView));
                        scope.dd.view.selected.categoryView.draggedServiceView = null;
                        $("button.selector-btn-edit-image").show();
                    }
                }
            });
        }
    };
}).directive('droppableServiceMoveRight', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var serviceView = scope[attrs["droppableServiceMoveRight"]];
            $(element).droppable({
                activeClass: 'active',
                hoverClass: 'hovered',
                tolerance: 'pointer',
                accept: ".service",
                drop: function drop(event, ui) {
                    if (scope.dd.view.selected.categoryView.draggedServiceView) {
                        scope.dd.view.selected.categoryView.changeServicePosition(scope, scope.dd.view.selected.categoryView.draggedServiceView, scope.dd.view.selected.categoryView.servicesView.indexOf(serviceView) + 1);
                        scope.dd.view.selected.categoryView.draggedServiceView = null;
                        $("button.selector-btn-edit-image").show();
                    }
                }
            });
        }
    };
}).directive('droppableProductMoveLeft', ["$timeout", function ($timeout) {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var productView = scope[attrs["droppableProductMoveLeft"]];
            $timeout(function () {
                if (scope.dd.view.selected.categoryView.productsView.indexOf(productView) == 0) //accept to drop also category for the first productView
                    $(element).droppable({
                        activeClass: 'active',
                        hoverClass: 'hovered',
                        tolerance: 'pointer',
                        drop: function drop(event, ui) {
                            if (scope.dd.view.selected.categoryView.draggedProductView) {
                                scope.dd.view.selected.categoryView.changeProductPosition(scope, scope.dd.view.selected.categoryView.draggedProductView, scope.dd.view.selected.categoryView.productsView.indexOf(productView));
                                scope.dd.view.selected.categoryView.draggedProductView = null;
                                $("button.selector-btn-edit-image").show();
                            }
                            if (scope.dd.view.selected.categoryView.draggedCategoryView) {
                                scope.dd.view.selected.categoryView.changeCategoryPosition(scope, scope.dd.view.selected.categoryView.draggedCategoryView, scope.dd.view.selected.categoryView.categoriesView.length); //put at the end
                                scope.dd.view.selected.categoryView.draggedCategoryView = null;
                                $("button.selector-btn-edit-image").show();
                            }
                        }
                    });else $(element).droppable({
                    activeClass: 'active',
                    hoverClass: 'hovered',
                    tolerance: 'pointer',
                    accept: ".service",
                    drop: function drop(event, ui) {
                        if (scope.dd.view.selected.categoryView.draggedProductView) {
                            scope.dd.view.selected.categoryView.changeProductPosition(scope, scope.dd.view.selected.categoryView.draggedProductView, scope.dd.view.selected.categoryView.productsView.indexOf(productView));
                            scope.dd.view.selected.categoryView.draggedProductView = null;
                            $("button.selector-btn-edit-image").show();
                        }
                    }
                });
            }, 500);
        }
    };
}]).directive('droppableProductMoveRight', ["$timeout", function ($timeout) {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var productView = scope[attrs["droppableProductMoveRight"]];
            $timeout(function () {
                $(element).droppable({
                    activeClass: 'active',
                    hoverClass: 'hovered',
                    tolerance: 'pointer',
                    accept: ".service",
                    drop: function drop(event, ui) {
                        if (scope.dd.view.selected.categoryView.draggedProductView) {
                            scope.dd.view.selected.categoryView.changeProductPosition(scope, scope.dd.view.selected.categoryView.draggedProductView, scope.dd.view.selected.categoryView.productsView.indexOf(productView) + 1);
                            scope.dd.view.selected.categoryView.draggedProductView = null;
                            $("button.selector-btn-edit-image").show();
                        }
                    }
                });
            }, 500);
        }
    };
}]).directive('droppableCureMoveLeft', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var cureView = scope[attrs["droppableCureMoveLeft"]];
            if (scope.dd.view.selected.categoryView.curesView.indexOf(cureView) == 0) //accept to drop also category for the first cureView
                $(element).droppable({
                    activeClass: 'active',
                    hoverClass: 'hovered',
                    tolerance: 'pointer',
                    drop: function drop(event, ui) {
                        if (scope.dd.view.selected.categoryView.draggedCureView) {
                            scope.dd.view.selected.categoryView.changeCurePosition(scope, scope.dd.view.selected.categoryView.draggedCureView, scope.dd.view.selected.categoryView.curesView.indexOf(cureView));
                            scope.dd.view.selected.categoryView.draggedCureView = null;
                            $("button.selector-btn-edit-image").show();
                        }
                        if (scope.dd.view.selected.categoryView.draggedCategoryView) {
                            scope.dd.view.selected.categoryView.changeCategoryPosition(scope, scope.dd.view.selected.categoryView.draggedCategoryView, scope.dd.view.selected.categoryView.categoriesView.length); //put at the end
                            scope.dd.view.selected.categoryView.draggedCategoryView = null;
                            $("button.selector-btn-edit-image").show();
                        }
                    }
                });else $(element).droppable({
                activeClass: 'active',
                hoverClass: 'hovered',
                tolerance: 'pointer',
                accept: ".service",
                drop: function drop(event, ui) {
                    if (scope.dd.view.selected.categoryView.draggedCureView) {
                        scope.dd.view.selected.categoryView.changeCurePosition(scope, scope.dd.view.selected.categoryView.draggedCureView, scope.dd.view.selected.categoryView.curesView.indexOf(cureView));
                        scope.dd.view.selected.categoryView.draggedCureView = null;
                        $("button.selector-btn-edit-image").show();
                    }
                }
            });
        }
    };
}).directive('droppableCureMoveRight', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var cureView = scope[attrs["droppableCureMoveRight"]];
            $(element).droppable({
                activeClass: 'active',
                hoverClass: 'hovered',
                tolerance: 'pointer',
                accept: ".service",
                drop: function drop(event, ui) {
                    if (scope.dd.view.selected.categoryView.draggedCureView) {
                        scope.dd.view.selected.categoryView.changeCurePosition(scope, scope.dd.view.selected.categoryView.draggedCureView, scope.dd.view.selected.categoryView.curesView.indexOf(cureView) + 1);
                        scope.dd.view.selected.categoryView.draggedCureView = null;
                        $("button.selector-btn-edit-image").show();
                    }
                }
            });
        }
    };
}).directive('droppableLoyaltyCardMoveLeft', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var loyaltyCardView = scope[attrs["droppableLoyaltyCardMoveLeft"]];
            if (scope.dd.view.selected.categoryView.loyaltyCardsView.indexOf(loyaltyCardView) == 0) //accept to drop also category for the first loyaltyCardView
                $(element).droppable({
                    activeClass: 'active',
                    hoverClass: 'hovered',
                    tolerance: 'pointer',
                    drop: function drop(event, ui) {
                        if (scope.dd.view.selected.categoryView.draggedLoyaltyCardView) {
                            scope.dd.view.selected.categoryView.changeLoyaltyCardPosition(scope, scope.dd.view.selected.categoryView.draggedLoyaltyCardView, scope.dd.view.selected.categoryView.loyaltyCardsView.indexOf(loyaltyCardView));
                            scope.dd.view.selected.categoryView.draggedLoyaltyCardView = null;
                            $("button.selector-btn-edit-image").show();
                        }
                        if (scope.dd.view.selected.categoryView.draggedCategoryView) {
                            scope.dd.view.selected.categoryView.changeCategoryPosition(scope, scope.dd.view.selected.categoryView.draggedCategoryView, scope.dd.view.selected.categoryView.categoriesView.length); //put at the end
                            scope.dd.view.selected.categoryView.draggedCategoryView = null;
                            $("button.selector-btn-edit-image").show();
                        }
                    }
                });else $(element).droppable({
                activeClass: 'active',
                hoverClass: 'hovered',
                tolerance: 'pointer',
                accept: ".service",
                drop: function drop(event, ui) {
                    if (scope.dd.view.selected.categoryView.draggedLoyaltyCardView) {
                        scope.dd.view.selected.categoryView.changeLoyaltyCardPosition(scope, scope.dd.view.selected.categoryView.draggedLoyaltyCardView, scope.dd.view.selected.categoryView.loyaltyCardsView.indexOf(loyaltyCardView));
                        scope.dd.view.selected.categoryView.draggedLoyaltyCardView = null;
                        $("button.selector-btn-edit-image").show();
                    }
                }
            });
        }
    };
}).directive('droppableLoyaltyCardMoveRight', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var loyaltyCardView = scope[attrs["droppableLoyaltyCardMoveRight"]];
            $(element).droppable({
                activeClass: 'active',
                hoverClass: 'hovered',
                tolerance: 'pointer',
                accept: ".service",
                drop: function drop(event, ui) {
                    if (scope.dd.view.selected.categoryView.draggedLoyaltyCardView) {
                        scope.dd.view.selected.categoryView.changeLoyaltyCardPosition(scope, scope.dd.view.selected.categoryView.draggedLoyaltyCardView, scope.dd.view.selected.categoryView.loyaltyCardsView.indexOf(loyaltyCardView) + 1);
                        scope.dd.view.selected.categoryView.draggedLoyaltyCardView = null;
                        $("button.selector-btn-edit-image").show();
                    }
                }
            });
        }
    };
}).directive('resizable', ["$timeout", "BookingServiceView", "BookingSaveTransactionOrigin", function ($timeout, BookingServiceView, BookingSaveTransactionOrigin) {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var activityView = scope[attrs["resizable"]];
            var jqActTooltip = $("#activity-tooltip");
            var jqActTooltipHour = $("#activity-tooltip-hour");
            var jqActTooltipDay = $("#activity-tooltip-day");
            var jqActTooltipHr = $("#activity-tooltip-hr");
            var startPeriodStart = "";
            var startPeriodEnd = "";
            var jqElm = $(element);
            if (scope.dd.view.pTView && !scope.dd.view.pTView.dim.mobileFormat && !scope.ad.isMobileOrPadTouchScreen) //inactive on mobile
                $(element).resizable({
                    handles: 's',
                    containment: 'parent',
                    start: function start() {
                        if (scope.isReadOnly()) {
                            return false;
                        }
                        scope.dd.view.pTView.resizeOrDrag.activityView = activityView;
                        if (activityView.period) {
                            startPeriodStart = activityView.period.start.getLabel();
                            startPeriodEnd = activityView.period.end.getLabel();
                        }
                        jqActTooltipDay.html(activityView.plgDayHrView.plgDayView.labelDayOfWC);
                        jqActTooltipHr.html(activityView.plgDayHrView.hrView.label);
                    },
                    resize: function resize() {
                        activityView.resize($(element).height());
                        var cPeriodStart = activityView.period.start.getLabel();
                        var cPeriodEnd = activityView.period.end.getLabel();
                        jqActTooltipHour.html(cPeriodStart + " - " + cPeriodEnd);
                        if (startPeriodStart != cPeriodStart || startPeriodEnd != cPeriodEnd) jqActTooltipHour.addClass("modified");else jqActTooltipHour.removeClass("modified");
                    },
                    stop: function stop(event, ui) {
                        jqActTooltipHour.removeClass("modified");
                        if (activityView instanceof BookingServiceView) {
                            if (!scope.dd.view.pTView.getEditedBookingView()) //if not edited
                                activityView.bookingView.updateModel(null, BookingSaveTransactionOrigin.DIRECTIVES_PRO); //save all booking
                        } else activityView.updateModel();

                        scope.dd.view.pTView.resizeOrDrag.activityView = null;
                        scope.$apply();
                        $timeout(function () {

                            jqElm.animate({ 'top': activityView.position.top + 'px', 'left': activityView.position.leftPercent });
                        }, 100);
                    }

                });
        }
    };
}]).directive('fxbActivity', function () {
    return {
        restrict: 'A',
        link: function link($scope, element, attrs) {
            if ($scope.dd.view.pTView) {
                var aDayRView = $scope[attrs["fxbActivity"]];
                // var jqAct = $(element);
                $scope.dd.view.pTView.addActivityForJQ(aDayRView, element);
            }
        }
    };
}).directive('droppable', ["CategorySrv", function (CategorySrv) {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var cell = scope[attrs["droppable"]];
            $(element).droppable({
                activeClass: 'active',
                hoverClass: 'hovered',
                tolerance: 'pointer',
                drop: function drop(event, ui) {
                    if (scope.dd.view.pTView.edited) {
                        scope.$apply();
                    }
                }
            });
        }
    };
}]).directive('fxbCellTooltip', function () {
    return {
        restrict: 'A',
        link: function link($scope, element, attrs) {
            if ($scope.dd.view.pTView) {
                var cell = $scope[attrs["fxbCellTooltip"]];
                // var jqAct = $(element);
                $scope.dd.view.pTView.addCellForJQ(cell, element);
            }
        }
    };
}).directive('handsometableCustomers', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            //noinspection JSUnresolvedFunction
            var data = scope.dd.view.customersExportView;
            $(element).handsontable({
                data: data,
                colHeaders: ["Nom", "Prénom", "Téléphone", "Email"],
                rowHeaders: true,
                startRows: 10,
                manualColumnResize: true,
                minSpareRows: 1
            });
        }
    };
}).directive('handsometableBookings', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            //noinspection JSUnresolvedFunction
            var data = scope.dd.view.bookingsExportView;
            $(element).handsontable({
                data: data,
                colHeaders: ["Date et heure de début", "Date et heure de fin", "Commentaires", "Venu / pas venu", "Crée le", "Crée par", "Pris par internet", "Agenda", "Rdv proposé", "Abréviation", "Prix", "Nom", "Prénom", "Date de naissance", "E-mail", "Tél. portable"],
                rowHeaders: true,
                startRows: 10,
                manualColumnResize: true,
                minSpareRows: 1
            });
        }
    };
}).directive("filereadCsv", ["$timeout", function ($timeout) {
    return {
        scope: {
            filereadCsv: "=",
            filereadCsvLoading: '=',
            filereadCsvEndFunction: '='
        },
        link: function link(scope, element, attributes) {
            element.bind("change", function (changeEvent) {
                var reader = new FileReader();
                scope.$apply(function () {
                    scope.filereadCsvLoading = true;
                });

                reader.onload = function (loadEvent) {
                    $timeout(function () {
                        scope.$apply(function () {
                            var csv = loadEvent.target.result;
                            csv = csv.replace(/(\r\n|\n|\r)/gm, '\n');
                            var allTextLines = csv.split('\n');
                            scope.filereadCsv = [];
                            for (var i = 0; i < allTextLines.length; i++) {
                                var data = allTextLines[i].split(';');
                                var tarr = [];
                                for (var j = 0; j < data.length; j++) {
                                    tarr.push(data[j]);
                                }
                                scope.filereadCsv.push(tarr);
                            }
                            if (scope.filereadCsvEndFunction !== undefined) scope.filereadCsvEndFunction(scope.filereadCsv);
                            scope.filereadCsvLoading = false;
                        });
                    }, 200);
                };
                $timeout(function () {
                    reader.readAsText(changeEvent.target.files[0]);
                }, 200);
            });
        }
    };
}]).directive("filereadXls", ["$timeout", function ($timeout) {
    return {
        scope: {
            filereadXls: "=",
            filereadXlsLoading: '=',
            filereadXlsEndFunction: '='
        },
        link: function link(scope, element, attributes) {
            element.bind("change", function (changeEvent) {
                var reader = new FileReader();
                scope.$apply(function () {
                    scope.filereadXlsLoading = true;
                });

                reader.onload = function (loadEvent) {
                    scope.$apply(function () {
                        var data = loadEvent.target.result;
                        var workbook = XLS.read(data, { type: 'binary' });
                        var result = {};
                        var i = 0;
                        workbook.SheetNames.forEach(function (sheetName) {
                            var roa = XLS.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
                            if (roa.length > 0) {
                                result[i++] = roa;
                            }
                        });
                        scope.filereadXls = result[0];

                        if (scope.filereadXlsEndFunction !== undefined) scope.filereadXlsEndFunction(scope.filereadXls);
                        scope.filereadXlsLoading = false;
                    });
                };
                $timeout(function () {
                    reader.readAsBinaryString(changeEvent.target.files[0]);
                }, 200);
            });
        }
    };
}]).directive('fxbMessage', function () {
    var directive = { restrict: 'E', replace: true };
    directive.template = '<div class="fxb-message" ng-show="message"  ng-class="message.type">' + '<div class="message-content">' + '<div>' + '<span ng-show="message" ng-bind-html="messageHtml"/></span>' + '&nbsp;<button ng-show="message.type!=\'info\' && message.type!=\'alert\'" class="btn btn-ultra-mini" ng-click="reloadApplication()" translate>Recharger</button>' + '<button ng-show="message.type==\'info\'" class="btn btn-ultra-mini" ng-click="message=null" translate>Fermer</button>' + '</div>' + '<button class="message-close btn btn-ultra-mini" ng-click="message=null"><i class="fa fa-times"></i></button>' + '</div>' + '</div>';
    var ctrl = function ctrl($scope, $log, $rootScope, $sce) {
        $rootScope.$on('fxbMessage', function (_, message, isNotFromAngularEvent) {
            $scope.message = message;
            if (message) $scope.messageHtml = $sce.trustAsHtml(message.text);
            if (isNotFromAngularEvent !== undefined && isNotFromAngularEvent && $scope.safeApply !== undefined) $scope.safeApply();
        });
    };
    directive.controller = ('DirCtrl', ['$scope', '$log', '$rootScope', '$sce', ctrl]);

    return directive;
}).directive('editableField', function () {
    return {
        restrict: 'A',
        scope: {
            editableField: '='
        },
        template: '<input type="text" ng-show="(objectMouse.hasMouseover || objectMouse.hasFocus)" ng-model="editableField" ng-focus="objectMouse.hasFocus=true" ng-blur="objectMouse.hasFocus=false" ng-mouseleave="objectMouse.hasMouseover=false"/>' + '<span ng-show="!(objectMouse.hasMouseover || objectMouse.hasFocus)" ng-bind="editableField" ng-mouseover="objectMouse.hasMouseover=true"></span>',
        controller: ['$scope', function ($scope) {
            $scope.objectMouse = {
                hasMouseover: false,
                hasFocus: false

            };
        }]
    };
}).directive('taxParameters', function () {
    return {
        restrict: 'E',
        scope: {
            taxMode: '=taxMode',
            shortLabel: '=shortLabel',
            onTaxModeChange: '&onTaxModeChange'
        },
        templateUrl: '/partials/planningPos/pos/posTaxMode.html',
        controller: ['$scope', 'TaxMode', function ($scope, TaxMode) {
            $scope.TaxModeList = TaxMode;

            $scope.onTaxModeClick = function (newTaxMode) {
                $scope.onTaxModeChange({ newTaxMode: newTaxMode });
            };
        }]
    };
}).directive('timeParameters', function () {
    return {
        restrict: 'E',
        scope: {
            timePeriod: '=timePeriod',
            beginMoment: '=beginMoment',
            endMoment: '=endMoment',
            forceReload: '=forceReload',
            onPeriodChanged: '&onPeriodChanged',
            hidePeriodType: "=hidePeriodType"
        },
        templateUrl: '/partials/statistics/timeParameters.html',
        link: function link($scope, $elm, attrs, timeParameterCtrl) {
            $scope.$watch('forceReload', function () {
                if ($scope.forceReload) {
                    $scope.init();
                }
            });
        },
        controller: ['$scope', '$timeout', 'Day', 'DayData', 'PeriodStat', 'StatPeriodType', 'PeriodType', 'moment', function ($scope, $timeout, Day, DayData, PeriodStat, StatPeriodType, PeriodType, moment) {

            $scope.dd = {
                timePeriod: $scope.timePeriod,
                begin: null,
                end: null,
                currentPeriod: null,
                pastPeriod: null,
                goBackDisabled: null,
                goNextDisabled: null,
                firstDay: DayData.getActiveList()[0].getMomentDate()
            };

            $scope.PeriodType = PeriodType;

            $scope.init = function () {
                $scope.planningDailyDatePicker = {
                    opened: false,
                    minDate: $scope.dd.firstDay.toDate(),
                    date: new Date(),
                    dateOptions: {
                        'year-format': "'yy'",
                        'starting-day': 1,
                        'datepickerMode': 'day'
                    },
                    needToUpdateVarNow: false
                };

                $scope.planningDailyBeginDatePicker = {
                    opened: false,
                    minDate: $scope.dd.firstDay.toDate(),
                    date: new Date(),
                    dateOptions: {
                        'year-format': "'yy'",
                        'starting-day': 1,
                        'datepickerMode': 'day'
                    },
                    needToUpdateVarNow: false
                };

                $scope.planningDailyEndDatePicker = {
                    opened: false,
                    minDate: $scope.dd.firstDay.toDate(),
                    date: new Date(),
                    dateOptions: {
                        'year-format': "'yy'",
                        'starting-day': 1,
                        'datepickerMode': 'day'
                    },
                    needToUpdateVarNow: false
                };

                $scope.planningMonthlyDatePicker = {
                    opened: false,
                    minDate: $scope.dd.firstDay.toDate(),
                    date: new Date(),
                    dateOptions: {
                        'year-format': "'yy'",
                        'starting-day': 1,
                        'datepickerMode': 'month',
                        'minMode': 'month'
                    },
                    needToUpdateVarNow: false
                };

                $scope.planningYearlyDatePicker = {
                    opened: false,
                    minDate: $scope.dd.firstDay.toDate(),
                    date: new Date(),
                    dateOptions: {
                        'year-format': "'yy'",
                        'starting-day': 1,
                        'datepickerMode': 'year',
                        'minMode': 'year'
                    },
                    needToUpdateVarNow: false
                };

                if ($scope.dd.timePeriod === PeriodType.CUSTOMED) {
                    $scope.goToDate($scope.beginMoment, 'begin');
                    $scope.goToDate($scope.endMoment, 'end');
                } else {
                    $scope.goToDate($scope.beginMoment);
                }
            };

            $scope.getSelectedDatePicker = function (type) {
                var selectedDatePicker = null;

                if ($scope.dd.timePeriod === PeriodType.DAY || $scope.dd.timePeriod === PeriodType.WEEK) {
                    selectedDatePicker = $scope.planningDailyDatePicker;
                }
                if ($scope.dd.timePeriod === PeriodType.MONTH) {
                    selectedDatePicker = $scope.planningMonthlyDatePicker;
                }
                if ($scope.dd.timePeriod === PeriodType.YEAR) {
                    selectedDatePicker = $scope.planningYearlyDatePicker;
                }
                if ($scope.dd.timePeriod === PeriodType.CUSTOMED && type === 'begin') {
                    selectedDatePicker = $scope.planningDailyBeginDatePicker;
                }
                if ($scope.dd.timePeriod === PeriodType.CUSTOMED && type === 'end') {
                    selectedDatePicker = $scope.planningDailyEndDatePicker;
                }

                return selectedDatePicker;
            };

            $scope.displayPlanningDatePickerF = function (type) {
                $timeout(function () {

                    var selectedDatePicker = $scope.getSelectedDatePicker(type);

                    // used to avoid the watcher to go to $scope.goToDate() (= modifiy scope.dd.now) on the click on the click to display datepicker
                    selectedDatePicker.needToUpdateVarNow = false;

                    if ($scope.dd.timePeriod === PeriodType.CUSTOMED || type === 'end') {
                        selectedDatePicker.date = $scope.dd.end.toDate();
                    } else {
                        selectedDatePicker.date = $scope.dd.begin.toDate();
                    }
                    selectedDatePicker.opened = true;
                });
            };

            $scope.$watch('planningDailyDatePicker.date', function (date) {
                if (date && $scope.planningDailyDatePicker.needToUpdateVarNow) {
                    $scope.goToDate(new moment(date));
                } else $scope.planningDailyDatePicker.needToUpdateVarNow = true;
            });

            $scope.$watch('planningMonthlyDatePicker.date', function (date) {
                if (date && $scope.planningMonthlyDatePicker.needToUpdateVarNow) {
                    $scope.goToDate(new moment(date));
                } else $scope.planningMonthlyDatePicker.needToUpdateVarNow = true;
            });

            $scope.$watch('planningYearlyDatePicker.date', function (date) {
                if (date && $scope.planningYearlyDatePicker.needToUpdateVarNow) {
                    $scope.goToDate(new moment(date));
                } else $scope.planningYearlyDatePicker.needToUpdateVarNow = true;
            });

            $scope.$watch('planningDailyBeginDatePicker.date', function (date) {
                if (date && $scope.planningDailyBeginDatePicker.needToUpdateVarNow) {
                    $scope.goToDate(new moment(date), 'begin');
                } else $scope.planningDailyBeginDatePicker.needToUpdateVarNow = true;
            });

            $scope.$watch('planningDailyEndDatePicker.date', function (date) {
                if (date && $scope.planningDailyEndDatePicker.needToUpdateVarNow) {
                    $scope.goToDate(new moment(date), 'end');
                } else $scope.planningDailyEndDatePicker.needToUpdateVarNow = true;
            });

            $scope.setLastYearCorrespondingPeriod = function () {
                if ($scope.dd.currentPeriod.getArrayOfDays() && $scope.dd.currentPeriod.getArrayOfDays().length > 0) {
                    $scope.dd.pastPeriod = new PeriodStat(StatPeriodType.PAST, PeriodStat.getLastYearCorrespondingDay($scope.dd.currentPeriod.getArrayOfDays()[0].getMomentDate(), $scope.dd.currentPeriod.periodType), PeriodType.getLastDayOfPeriod($scope.dd.currentPeriod.periodType, PeriodStat.getLastYearCorrespondingDay($scope.dd.currentPeriod.getArrayOfDays()[0].getMomentDate(), $scope.dd.currentPeriod.periodType), $scope.dd.currentPeriod.arrayOfDays.length), $scope.dd.timePeriod);
                }
            };

            $scope.goToday = function () {
                if ($scope.dd.timePeriod === PeriodType.CUSTOMED) {
                    $scope.goToDate(new moment().startOf('month'), 'begin');
                    $scope.goToDate(new moment().endOf('day'), 'end');
                } else {
                    $scope.goToDate(new moment());
                }
            };

            $scope.goToDate = function (date, type) {
                var now = new moment();

                if ($scope.dd.timePeriod !== PeriodType.CUSTOMED) {
                    $scope.dd.begin = date.clone();
                    $scope.dd.end = date.clone();

                    if ($scope.dd.timePeriod === PeriodType.DAY) {
                        $scope.dd.begin.startOf('day');
                        $scope.dd.end.startOf('day');

                        //$scope.dd.goNextDisabled = parseInt(new moment().format('YYYYMMDD')) <= parseInt($scope.dd.begin.format('YYYYMMDD'))
                    }
                    if ($scope.dd.timePeriod === PeriodType.WEEK) {
                        $scope.dd.begin.startOf('week');
                        $scope.dd.end.endOf('week');

                        //$scope.dd.goNextDisabled = parseInt(new moment().format('YYYYMMDD')) <= parseInt($scope.dd.begin.format('YYYYMMDD'))
                    }
                    if ($scope.dd.timePeriod === PeriodType.MONTH) {
                        $scope.dd.begin.startOf('month');
                        $scope.dd.end.endOf('month');

                        //$scope.dd.goNextDisabled = parseInt(new moment().format('YYYYMMDD')) <= parseInt($scope.dd.begin.format('YYYYMMDD'))
                    }
                    if ($scope.dd.timePeriod === PeriodType.YEAR) {
                        $scope.dd.begin.startOf('year');
                        $scope.dd.end.endOf('year');
                    }

                    /*if($scope.dd.end.isAfter(now)){
                        $scope.dd.end = now.endOf('day');
                    }*/
                } else {
                    if (type === 'begin') {
                        $scope.dd.begin = date.startOf('day');
                        if (!$scope.dd.end) $scope.dd.end = date.endOf('day');
                    }
                    if (type === 'end') {
                        $scope.dd.end = date.endOf('day');
                    }
                }

                $scope.dd.goBackDisabled = parseInt($scope.dd.firstDay.format('YYYYMMDD')) >= parseInt($scope.dd.begin.format('YYYYMMDD'));
                //$scope.dd.goNextDisabled = parseInt(new moment().format('YYYYMMDD')) >= parseInt($scope.dd.begin.format('YYYYMMDD')) && parseInt(new moment().format('YYYYMMDD')) <= parseInt($scope.dd.end.format('YYYYMMDD'));

                $scope.dd.currentPeriod = new PeriodStat(StatPeriodType.CURRENT, $scope.dd.begin, $scope.dd.end, $scope.dd.timePeriod);

                $scope.setLastYearCorrespondingPeriod();

                $scope.onPeriodChanged({ newCurrentPeriod: $scope.dd.currentPeriod, newPastPeriod: $scope.dd.pastPeriod });
            };

            $scope.goPrevious = function () {
                if (!$scope.dd.goBackDisabled && $scope.dd.timePeriod !== PeriodType.CUSTOMED) {

                    var newBeginDate = $scope.dd.begin.clone();
                    if ($scope.dd.timePeriod === PeriodType.DAY) {
                        newBeginDate.subtract(1, 'days');
                    }
                    if ($scope.dd.timePeriod === PeriodType.WEEK) {
                        newBeginDate.subtract(1, 'weeks');
                        newBeginDate.startOf('week');
                    }
                    if ($scope.dd.timePeriod === PeriodType.MONTH) {
                        newBeginDate.subtract(1, 'months');
                        newBeginDate.startOf('month');
                    }
                    if ($scope.dd.timePeriod === PeriodType.YEAR) {
                        newBeginDate.subtract(1, 'years');
                        newBeginDate.startOf('year');
                    }

                    $scope.goToDate(newBeginDate);
                }
            };

            $scope.goNext = function () {
                if (!$scope.dd.goNextDisabled && $scope.dd.timePeriod !== PeriodType.CUSTOMED) {
                    var newBeginDate = $scope.dd.begin.clone();

                    if ($scope.dd.timePeriod === PeriodType.DAY) {
                        newBeginDate.add(1, 'days');
                    }
                    if ($scope.dd.timePeriod === PeriodType.WEEK) {
                        newBeginDate.add(1, 'weeks');
                        newBeginDate.startOf('week');
                    }
                    if ($scope.dd.timePeriod === PeriodType.MONTH) {
                        newBeginDate.add(1, 'months');
                        newBeginDate.startOf('month');
                    }
                    if ($scope.dd.timePeriod === PeriodType.YEAR) {
                        newBeginDate.add(1, 'years');
                        newBeginDate.startOf('year');
                    }

                    $scope.goToDate(newBeginDate);
                }
            };
            $scope.init();
        }]
    };
}).directive('flexyOldReport', function () {
    return {
        restrict: 'E',
        scope: {
            dashboardView: '=dashboardView',
            report: '=report',
            reportDataSource: '=reportDataSource'
        },
        template: '<div ng-include="getTemplateUrl()"></div>',
        controller: ['$scope', function ($scope) {

            $scope.getTemplateUrl = function () {
                return "/partials/statistics/report/oldReport/" + $scope.report.id + ".html";
            };
        }]
    };
}).directive('flexyReportPath', function () {
    return {
        restrict: 'E',
        scope: {
            reportView: '=reportView'
        },
        templateUrl: '/partials/statistics/report/reportPath.html'
    };
}).directive('customerReport', function () {
    return {
        restrict: 'E',
        scope: {
            customers: '=customers',
            showVisits: '=showVisits',
            nbPassageCustomers: '=nbPassageCustomers',
            primaryDatasType: '=primaryDatasType',
            isCommunicateView: '=isCommunicateView'
        },
        templateUrl: '/partials/statistics/report/reportPrimaryDataCustomerTemplate.html',
        controller: ['$scope', 'PrimaryDatasType', function ($scope, PrimaryDatasType) {
            $scope.exportExcel = function (objet, idTable, title) {
                return ExcellentExport.excel(objet, idTable, title);
            };

            $scope.exportCsv = function (objet, idTable) {
                return ExcellentExport.csv(objet, idTable);
            };

            $scope.PrimaryDatasType = PrimaryDatasType;
        }]
    };
}).directive('flexyReport', ["TypeOfGraph", "ColorGraph", "EltReportType", "DateFormator", "PrimaryDatasType", "$timeout", "PeriodStat", "DayData", "PeriodType", "StatPeriodType", "ReportTemporalAgregateFunctionType", "TaxMode", "$filter", "LanguageManager", "CurrencyManager", "ReportTotalAgregateFunctionType", "BookingCreator", "moment", "Brand", function (TypeOfGraph, ColorGraph, EltReportType, DateFormator, PrimaryDatasType, $timeout, PeriodStat, DayData, PeriodType, StatPeriodType, ReportTemporalAgregateFunctionType, TaxMode, $filter, LanguageManager, CurrencyManager, ReportTotalAgregateFunctionType, BookingCreator, moment, Brand) {
    return {
        restrict: 'E',
        scope: {
            dashboardView: '=dashboardView',
            reportView: '=reportView',
            position: '=position',
            taxMode: '=taxMode',
            isReportAlone: "=isReportAlone",
            onTaxModeChange: '&onTaxModeChange',
            onReportsBusinessSelected: '&onReportsBusinessSelected',
            onReportsCommunicateSelected: '&onReportsCommunicateSelected',
            onReportsDetailSelected: '&onReportsDetailSelected'
        },
        templateUrl: '/partials/statistics/report/report.html',
        controller: ['$scope', 'Images', function ($scope, Images) {
            $scope.bookingStatusImage = Images.saleStatus;
            $scope.mouseover = false;
            $scope.TypeOfGraph = TypeOfGraph;
            $scope.ColorGraph = ColorGraph;
            $scope.EltReportType = EltReportType;
            $scope.DateFormator = DateFormator;
            $scope.categoryOver = null;
            $scope.PrimaryDatasType = PrimaryDatasType;
            $scope.primaryDataTypePeriodStat = null;
            $scope.StatPeriodType = StatPeriodType;
            $scope.ReportTemporalAgregateFunctionType = ReportTemporalAgregateFunctionType;
            $scope.periodType = PeriodType;
            $scope.TaxModeList = TaxMode;
            $scope.currencySymbol = CurrencyManager.getCurrencySymbol();
            $scope.ReportTotalAgregateFunctionType = ReportTotalAgregateFunctionType;
            $scope.BookingCreator = BookingCreator;
            $scope.brand = Brand;

            this.charts = new Array();
            var self = this;

            if ($scope.reportView.getDataSource()) {

                this.reportId = $scope.reportView.id;
                this.typeOfData = $scope.reportView.typeOfData;

                //if ($scope.reportView.getDataSource().selectedPastPeriod) {

                $scope.dailyDatePicker = {
                    opened: false,
                    minDate: DayData.getByIndex(0).getDate(),
                    dateOptions: {
                        // 'year-format': "'yy'",
                        'starting-day': 1,
                        'datepickerMode': 'day'
                    }
                };

                $scope.monthlyDatePicker = {
                    opened: false,
                    minDate: DayData.getByIndex(0).getDate(),
                    dateOptions: {
                        // 'year-format': "'yy'",
                        'starting-day': 1,
                        'datepickerMode': 'month',
                        'minMode': 'month'
                    }
                };

                $scope.yearlyDatePicker = {
                    opened: false,
                    minDate: DayData.getByIndex(0).getDate(),
                    dateOptions: {
                        // 'year-format': "'yy'",
                        'starting-day': 1,
                        'datepickerMode': 'year',
                        'minMode': 'year'
                    }
                };

                $scope.pastPeriodBeginDatePicker = {
                    opened: false,
                    minDate: DayData.getByIndex(0).getDate(),
                    dateOptions: {
                        // 'year-format': "'yy'",
                        'starting-day': 1,
                        'datepickerMode': 'day'
                    }
                };

                $scope.pastPeriodEndDatePicker = {
                    opened: false,
                    minDate: DayData.getByIndex(0).getDate(),
                    dateOptions: {
                        // 'year-format': "'yy'",
                        'starting-day': 1,
                        'datepickerMode': 'day'
                    }
                };
                $scope.getReportDataSource = function () {
                    return $scope.reportView.getDataSource();
                };

                this.getReportDataSource = $scope.getReportDataSource;

                $scope.onReportTitleDbClick = function () {
                    if ($scope.dashboardView && $scope.dashboardView.hasReport($scope.reportView) && !$scope.dashboardView.isFlexy) {
                        $scope.dashboardView.editing = true;
                    }
                };

                $scope.setCategoryOver = function (categoryOver) {
                    $scope.categoryOver = categoryOver;
                };

                this.setCategoryOver = $scope.setCategoryOver;

                $scope.onCategoryDownClick = function (category, statPeriodTypeSelected, date) {
                    if (statPeriodTypeSelected && category.getSubStatCategories && category.getSubStatCategories($scope.getReportDataSource().rootCategory, $scope.getReportDataSource().getPeriod(statPeriodTypeSelected).arrayOfDay) && category.getSubStatCategories($scope.getReportDataSource().rootCategory, $scope.getReportDataSource().getPeriod(statPeriodTypeSelected).arrayOfDay).length > 0 || $scope.reportView.hasPrimaryDatas()) {
                        $scope.getReportDataSource().addCategoryToCurrentPath(category);
                        $scope.getReportDataSource().loadCategory(category);
                        $scope.reportView.setPrimaryDataTypePeriodStat(statPeriodTypeSelected);
                        if (date) {
                            $scope.reportView.setPrimaryDataDay(DayData.getById(new moment(date).format('YYYYMMDD')));
                        } else {
                            $scope.reportView.setPrimaryDataDay(null);
                        }
                    }
                };

                this.onCategoryDownClick = $scope.onCategoryDownClick;

                $scope.onCategoryUpClick = function (category) {
                    $scope.getReportDataSource().updatePath(category);
                    $scope.getReportDataSource().loadCategory(category);
                };

                this.onCategoryUpClick = $scope.onCategoryUpClick;

                $scope.displayReportDatePickerF = function (beginEnd) {

                    $timeout(function () {

                        var displayedDatePicker = null;

                        if ($scope.reportView.getDataSource().selectedPastPeriod.periodType === PeriodType.DAY || $scope.reportView.getDataSource().selectedPastPeriod.periodType === PeriodType.WEEK) {
                            displayedDatePicker = $scope.dailyDatePicker;
                        } else if ($scope.reportView.getDataSource().selectedPastPeriod.periodType === PeriodType.MONTH) {
                            displayedDatePicker = $scope.monthlyDatePicker;
                        } else if ($scope.reportView.getDataSource().selectedPastPeriod.periodType === PeriodType.YEAR) {
                            displayedDatePicker = $scope.yearlyDatePicker;
                        } else if ($scope.reportView.getDataSource().selectedPastPeriod.periodType === PeriodType.CUSTOMED) {
                            if (beginEnd === "begin") {
                                displayedDatePicker = $scope.pastPeriodBeginDatePicker;
                            } else if (beginEnd === "end") {
                                displayedDatePicker = $scope.pastPeriodEndDatePicker;
                            }
                        }

                        displayedDatePicker.date = $scope.reportView.getDataSource().selectedPastPeriod.beginMomentDay.clone().startOf('day').toDate();
                        displayedDatePicker.opened = true;
                    });
                };

                $scope.$watch('dailyDatePicker.date', function (date) {
                    if (date) {
                        //$scope.reportView.getDataSource().selectedPastPeriod = new PeriodStat(StatPeriodType.PAST, moment(date), $scope.reportView.getDataSource().currentPeriod.periodType);

                        var momentBeginPeriod = moment(date);

                        if ($scope.reportView.getDataSource().currentPeriod.periodType === PeriodType.WEEK && !momentBeginPeriod.isSame(momentBeginPeriod.clone().startOf("week"))) {
                            momentBeginPeriod.startOf("week");
                        }

                        $scope.reportView.getDataSource().selectedPastPeriod = new PeriodStat(StatPeriodType.PAST, momentBeginPeriod, PeriodType.getLastDayOfPeriod($scope.reportView.getDataSource().currentPeriod.periodType, momentBeginPeriod, $scope.reportView.getDataSource().currentPeriod.arrayOfDays.length), $scope.reportView.getDataSource().currentPeriod.periodType);

                        $scope.reportView.getDataSource().loadPastPeriod();
                    }
                });

                $scope.$watch('monthlyDatePicker.date', function (date) {
                    if (date) {
                        //$scope.reportView.getDataSource().selectedPastPeriod = new PeriodStat(StatPeriodType.PAST, moment(date), $scope.reportView.getDataSource().currentPeriod.periodType);

                        $scope.reportView.getDataSource().selectedPastPeriod = new PeriodStat(StatPeriodType.PAST, moment(date), PeriodType.getLastDayOfPeriod($scope.reportView.getDataSource().currentPeriod.periodType, moment(date), $scope.reportView.getDataSource().currentPeriod.arrayOfDays.length), $scope.reportView.getDataSource().currentPeriod.periodType);
                        $scope.reportView.getDataSource().loadPastPeriod();
                    }
                });

                $scope.$watch('yearlyDatePicker.date', function (date) {
                    if (date) {
                        //$scope.reportView.getDataSource().selectedPastPeriod = new PeriodStat(StatPeriodType.PAST, moment(date), $scope.reportView.getDataSource().currentPeriod.periodType);

                        $scope.reportView.getDataSource().selectedPastPeriod = new PeriodStat(StatPeriodType.PAST, moment(date), PeriodType.getLastDayOfPeriod($scope.reportView.getDataSource().currentPeriod.periodType, moment(date), $scope.reportView.getDataSource().currentPeriod.arrayOfDays.length), $scope.reportView.getDataSource().currentPeriod.periodType);
                        $scope.reportView.getDataSource().loadPastPeriod();
                    }
                });

                $scope.$watch('pastPeriodBeginDatePicker.date', function (date) {
                    if (date) {
                        var momentDate = moment(date);

                        $scope.reportView.getDataSource().selectedPastPeriod = new PeriodStat(StatPeriodType.PAST, momentDate, $scope.reportView.getDataSource().selectedPastPeriod.endMomentDay, $scope.reportView.getDataSource().currentPeriod.periodType);

                        $scope.reportView.getDataSource().loadPastPeriod();
                    }
                });

                $scope.$watch('pastPeriodEndDatePicker.date', function (date) {
                    if (date) {
                        var momentDate = moment(date);

                        $scope.reportView.getDataSource().selectedPastPeriod = new PeriodStat(StatPeriodType.PAST, $scope.reportView.getDataSource().selectedPastPeriod.beginMomentDay, momentDate, $scope.reportView.getDataSource().currentPeriod.periodType);

                        $scope.reportView.getDataSource().loadPastPeriod();
                    }
                });

                $scope.exportExcel = function (objet, idTable, title) {
                    return ExcellentExport.excel(objet, idTable, title);
                };

                $scope.exportCsv = function (objet, idTable) {
                    return ExcellentExport.csv(objet, idTable);
                };

                $scope.setSelectionChartCategory = function (eltReportType, activeRepresentation, index) {
                    try {
                        if (index != null) {
                            if (activeRepresentation == "pie-chart") {
                                $scope.setSelectionChart(eltReportType, index, null);
                            } else if (activeRepresentation == "column-chart") {
                                $scope.setSelectionChart(eltReportType, index, 1);
                            } else if (activeRepresentation == "stacked-column-chart" && eltReportType === EltReportType.COMPARE) {
                                $scope.setSelectionChart(eltReportType, 1, index * 2 + 1);
                            } else if (activeRepresentation == "stacked-column-chart") {
                                $scope.setSelectionChart(eltReportType, 1, index + 1);
                            }
                        } else {
                            $scope.setSelectionChart(eltReportType, null, null);
                        }
                    } catch (err) {
                        console.warn("Erreur during the setSelectionChartCategory; " + err.message);
                    }
                };

                $scope.setSelectionChart = function (eltReportType, rowIndex, columnIndex) {
                    if (rowIndex != null) {
                        if (columnIndex != null) {
                            self.charts[eltReportType].setSelection([{ row: rowIndex, column: columnIndex }]);
                        } else {
                            self.charts[eltReportType].setSelection([{ row: rowIndex }]);
                        }
                    } else {
                        self.charts[eltReportType].setSelection([{ row: null }]);
                    }
                };

                $scope.onTaxModeClick = function (newTaxMode) {
                    $scope.onTaxModeChange({ newTaxMode: newTaxMode });
                };

                $scope.onReportsBusinessClick = function (businessPage) {
                    $scope.onReportsBusinessSelected({ reportView: $scope.reportView, businessPage: businessPage });
                    $timeout($scope.scrollTo, 200);
                };

                $scope.isEnglishLanguage = function () {
                    return LanguageManager.isEnglishLanguage();
                };

                $scope.isFrenchLanguage = function () {
                    return LanguageManager.isFrenchLanguage();
                };

                $scope.onReportsCommunicateClick = function () {
                    $scope.onReportsCommunicateSelected({ reportView: $scope.reportView });
                    $timeout($scope.scrollTo, 200);
                };
                $scope.onReportsDetailClick = function () {
                    $scope.onReportsDetailSelected({ reportView: $scope.reportView });
                    $timeout($scope.scrollTo, 200);
                };
                $scope.scrollTo = function () {
                    // Get report number index+1 of report list and scroll to
                    var report = $("div.dashboard-reports-list flexy-report:nth-child(" + $scope.position + ")");
                    if (report && report.length > 0) $('.dashboard-reports-list').animate({ scrollTop: report[0].offsetTop });
                };

                $scope.scrollDown = function () {
                    $timeout(function () {
                        var dashboardReportListDiv = $('.dashboard-reports-list');
                        if (dashboardReportListDiv && dashboardReportListDiv.length > 0) {
                            var height = dashboardReportListDiv[0].scrollHeight;
                            dashboardReportListDiv.animate({ scrollTop: height });
                        }
                    }, 200);
                };

                $scope.getNbPrimaryDataOfType = function (type) {
                    return $filter('filter')($scope.reportView.getDataSource().getCurrentPeriodStat().primaryDatas, function (primaryData) {
                        var isOfGoodType = false;
                        if ($scope.PrimaryDatasType.getType(primaryData) === type) {
                            isOfGoodType = true;
                        }
                        return isOfGoodType;
                    }).length;
                };
            } else {
                console.info("DataSource non définie pour le rapport : " + $scope.reportView.id);
            }
        }]
    };
}]).directive('flexyChart', ["ColorGraph", "EltReportType", "StatPeriodType", "$locale", "$filter", "CurrencyManager", function (ColorGraph, EltReportType, StatPeriodType, $locale, $filter, CurrencyManager) {
    return {
        restrict: 'E',
        scope: {
            eltReportView: "=eltReportView",
            datas: '=datas',
            categorieTable: "=categorieTable"
        },
        require: '^^flexyReport',
        link: function link($scope, $elm, attrs, reportCtrl) {
            var chart = null,
                isStacked = false,
                dataTable = null;

            $scope.drawChart = function () {
                var height = null,

                //hAxis = {allowContainerBoundaryTextCufoff : false},
                hAxis = {},
                    vAxis = {},
                    legend = { position: "none" },
                    chartArea = { width: '100%', height: '90%', top: '7.5%' },
                    viewWindow = {},
                    colors = new Array(),
                    toolTypeIsHtml = true;

                $scope.eltReportView.activeRepresentation = $scope.eltReportView.representation;

                if ($scope.datas.datasChart.length != 0) {

                    dataTable = google.visualization.arrayToDataTable($scope.datas.datasChart);

                    if ($scope.categorieTable) {
                        for (var i = 0; i < $scope.categorieTable.length; i++) {
                            colors.push($scope.categorieTable[i].color);
                        }
                    }

                    if ($scope.eltReportView.representation == "table") {
                        chart = new google.visualization.Table($elm[0]);
                    } else if ($scope.eltReportView.representation == "pie-chart" || reportCtrl.typeOfData == "percent" && dataTable.getNumberOfRows() == 1 && EltReportType.getEltReportTypeById($scope.eltReportView.type) === EltReportType.TOTALISE) {
                        chart = new google.visualization.PieChart($elm[0]);

                        if ($scope.eltReportView.representation != "pie-chart") {
                            $scope.eltReportView.activeRepresentation = "pie-chart";

                            var tooltipValue = ""; //tooltip set to an empty string because this category is not usefull for the final user and beacuse technically, we have no libelle for the category
                            dataTable.addRow(['', 100 - dataTable.getValue(0, 1), "#f5f5f5", tooltipValue]);
                            colors.push("#f5f5f5");
                        }
                    } else if ($scope.eltReportView.representation == "column-chart" || $scope.eltReportView.representation == "stacked-column-chart") {
                        chart = new google.visualization.ColumnChart($elm[0]);
                        chartArea.top = '15px';
                        if (EltReportType.getEltReportTypeById($scope.eltReportView.type) != EltReportType.ZOOM) {
                            chartArea.width = '85%';
                            chartArea.left = '15%';
                            chartArea.height = '75%';
                        } else {
                            chartArea.width = '90%';
                            chartArea.left = '7%';
                            chartArea.height = '70%';
                        }
                        if ($scope.datas.tickLabels && $scope.eltReportView.representation == "stacked-column-chart") {
                            hAxis.minValue = 0.75;
                            hAxis.maxValue = 2;
                            hAxis.ticks = $scope.datas.tickLabels;
                        }
                        if (dataTable.getNumberOfRows() > 4) {
                            hAxis.slantedText = true;
                            //hAxis.slantedTextAngle = 90;

                            hAxis.gridlines = { count: dataTable.getNumberOfRows() };
                            hAxis.gridlines.color = '#f4f4f4';
                            hAxis.textStyle = { fontSize: 8 };
                        }
                        if (reportCtrl.typeOfData == "time") {
                            vAxis.format = '#,### h';
                            vAxis.minValue = 0;
                        }

                        if (dataTable.getColumnType(0) == "date") {
                            hAxis.format = $locale.DATETIME_FORMATS.shortDate;

                            //strange case : when we have only one date, google chart don't display well the hAxes and we have to fixe the viewWindows
                            if (dataTable.getNumberOfRows() == 1) {
                                hAxis.viewWindow = {
                                    min: new Date(dataTable.getValue(0, 0).getTime() - 24 * 60 * 60 * 1000),
                                    max: new Date(dataTable.getValue(0, 0).getTime() + 24 * 60 * 60 * 1000)
                                };
                            }
                        }

                        //in compare mode we need to manage ourself the hAxis
                        if (EltReportType.getEltReportTypeById($scope.eltReportView.type) == EltReportType.COMPARE) {
                            hAxis.textPosition = 'none';
                            hAxis.opt_axis_or_tick = '_';
                        }

                        if (reportCtrl.typeOfData == "percent") {
                            vAxis = {
                                minValue: 0,
                                maxValue: 100,
                                format: "##'%'"
                            };

                            var formatter = new google.visualization.NumberFormat({
                                fractionDigits: 2,
                                suffix: '%'
                            });

                            formatter.format(dataTable, 1);
                        } else if ($scope.eltReportView.representation == "stacked-column-chart") {
                            isStacked = true;
                        }
                    }

                    var toolip = { trigger: 'selection', isHtml: toolTypeIsHtml };
                    if (EltReportType.getEltReportTypeById($scope.eltReportView.type) == EltReportType.ZOOM) toolip.trigger = 'focus';

                    var trendlines = {},
                        finalHeight = void 0,
                        screenWith = $(window).width(),
                        finalWidth = $($elm[0]).parent().width();

                    if (screenWith < 600) {
                        //FOR MOBILE
                        finalHeight = finalWidth * 0.9;
                        if ($scope.eltReportView.representation == "pie-chart") {
                            chartArea.width = '80%';
                        }
                    } else {
                        // TODO MANAGE DYNAMICALLY
                        var addWindow = $("div.dashboard-choice-form.active"); //try to get a dashboard-choice-form.active to force with
                        if (addWindow && addWindow.length > 0) {
                            finalWidth = addWindow[0].offsetWidth - 65; //TODO set dynamic
                            if (EltReportType.getEltReportTypeById($scope.eltReportView.type) != EltReportType.ZOOM) finalWidth = finalWidth / 2; //50% of width
                        }
                        finalHeight = 235; //FORCE HEIGHT
                    }
                    var options = {
                        width: finalWidth,
                        height: finalHeight,
                        isStacked: isStacked,
                        pieHole: 0.7,
                        legend: legend,
                        hAxis: hAxis,
                        vAxis: vAxis,
                        chartArea: chartArea,
                        trendlines: trendlines,
                        pieSliceText: 'none',
                        tooltip: toolip,
                        gridlines: {
                            units: {
                                years: { format: ['yyyy'] },
                                months: { format: ['MM'] },
                                days: { format: ['d'] }
                            }
                        },
                        colors: colors.length != 0 ? colors : ColorGraph.colors,
                        pieStartAngle: -90
                    };

                    google.visualization.events.addListener(chart, 'error', function (googleError) {
                        google.visualization.errors.removeError(googleError.id);
                    });

                    // Chart selection handler
                    google.visualization.events.addListener(chart, 'select', function () {
                        var selectedItem = chart.getSelection()[0];
                        if (selectedItem) {
                            var row = selectedItem.row,
                                column = selectedItem.column,
                                category = null;
                            if ($scope.eltReportView.activeRepresentation == "pie-chart" || $scope.eltReportView.activeRepresentation == "column-chart") {
                                column = 0;
                                var value = dataTable.getValue(row, column);
                                category = reportCtrl.getReportDataSource().getCategoryByLabel(value);
                            } else {
                                category = reportCtrl.getReportDataSource().getCategoryByLabel(dataTable.getColumnLabel(column));
                            }

                            var typePeriodStatSelected = StatPeriodType.CURRENT;
                            if (EltReportType.getEltReportTypeById($scope.eltReportView.type) == EltReportType.COMPARE) {
                                if (row == 0) {
                                    typePeriodStatSelected = StatPeriodType.PAST;
                                }
                            }

                            if (category) {
                                reportCtrl.onCategoryDownClick(category, typePeriodStatSelected, dataTable.getValue(row, 0) && dataTable.getValue(row, 0) instanceof Date ? dataTable.getValue(row, 0) : null);
                                $scope.$apply();
                            }
                        }
                    });

                    google.visualization.events.addListener(chart, 'onmouseover', function (overItem) {
                        if (overItem) {
                            var row = overItem.row,
                                column = overItem.column,
                                categoryOver = null;

                            if ($scope.eltReportView.activeRepresentation == "pie-chart") {
                                column = 0;
                                var value = dataTable.getValue(row, column);
                                categoryOver = reportCtrl.getReportDataSource().getCategoryByLabel(value);
                            } else {
                                categoryOver = reportCtrl.getReportDataSource().getCategoryByLabel(dataTable.getColumnLabel(column));
                            }

                            reportCtrl.setCategoryOver(categoryOver);
                            $scope.$apply();
                        }
                    });

                    google.visualization.events.addListener(chart, 'onmouseout', function (overItem) {
                        reportCtrl.setCategoryOver(null);
                        $scope.$apply();
                    });

                    chart.draw(dataTable, options);

                    if (reportCtrl.charts) {
                        reportCtrl.charts[EltReportType.getEltReportTypeById($scope.eltReportView.type)] = chart;
                    } else {
                        console.error("Erreur lors de la génération du graphique " + $scope.eltReportView.type + " du rapport " + reportCtrl.reportId);
                    }
                }
            };

            // Watches, to refresh the chart when its data, title or dimensions change
            $scope.$watch('datas', function () {
                $scope.drawChart();
            }, true);

            $scope.$watch('eltReportView.representation', function () {
                $scope.drawChart();
            }, true); // true is for deep object equality checking

            $scope.$on('$destroy', function () {
                chart.clearChart();
            });

            $scope.drawChart();
        },
        controller: ['$scope', function ($scope) {}]
    };
}]).directive('colsChart', ["ColorGraph", function (ColorGraph) {
    return {
        restrict: 'EA',
        scope: {
            chartId: '@chartid',
            data: '=data',
            maxValue: '@maxvalue',
            dateFormat: '@dateFormat',
            typeOfData: '@typeOfData',
            height: '@height',
            colors: '=colors',
            selectFn: '&select'
        },
        link: function link($scope, $elm) {
            var chart = new google.visualization.ColumnChart($elm[0]);
            google.visualization.events.addListener(chart, 'error', function (googleError) {
                google.visualization.errors.removeError(googleError.id);
            });
            $scope.drawChart = function () {
                var dataTable = google.visualization.arrayToDataTable($scope.data);

                // get width from the parent div one to fill in max the div
                var parentWidth = $($elm[0]).parent().parent().css("width"); // .parent().parent() : get good div (class="row") in the DOM (cf dashboard.html)
                var width = parseInt(parentWidth.substr(0, parentWidth.length - 2)); // "1145px" -> 1145

                var height = $(window).height() * 2 / 3;
                if ($scope.height) height = $scope.height;

                var hAxis = {},
                    vAxis = {},
                    legend = { position: "none" },
                    chartArea = { width: '100%', height: '90%', top: '8%' },
                    viewWindow = {},
                    colors = new Array(),
                    trendlines = {},
                    toolip = { trigger: 'selection' };

                chartArea.top = '10px';
                chartArea.width = '80%';
                chartArea.left = '0px';
                chartArea.height = '70%';

                if (dataTable.getNumberOfRows() > 4) {

                    hAxis.gridlines = { count: dataTable.getNumberOfRows() };
                    hAxis.gridlines.color = '#f4f4f4';
                    hAxis.textStyle = { fontSize: 10 };
                }

                if (dataTable.getColumnType(0) == "date" && $scope.dateFormat) {
                    hAxis.format = $scope.dateFormat;

                    //strange case : when we have only one date, google chart don't display well the hAxes and we have to fixe the viewWindows
                    if (dataTable.getNumberOfRows() == 1) {
                        hAxis.viewWindow = {
                            min: new Date(dataTable.getValue(0, 0).getTime() - 24 * 60 * 60 * 1000),
                            max: new Date(dataTable.getValue(0, 0).getTime() + 24 * 60 * 60 * 1000)
                        };
                    }
                }

                var options = {
                    width: width * 3 / 5,
                    height: height,
                    legend: { position: "none" },
                    hAxis: hAxis,
                    vAxis: vAxis,
                    chartArea: chartArea,
                    trendlines: trendlines,
                    pieSliceText: 'none',
                    tooltip: toolip,
                    gridlines: {
                        units: {
                            years: { format: ['yyyy'] },
                            months: { format: ['MM'] },
                            days: { format: ['d'] }
                        }
                    },
                    colors: $scope.colors ? $scope.colors : ColorGraph.colors,
                    pieStartAngle: -90
                };

                if ($scope.typeOfData == "currency") {
                    var currencyFormater = new google.visualization.NumberFormat({ suffix: ' €' });
                    for (var i = 1; i < dataTable.getNumberOfColumns(); i++) {
                        currencyFormater.format(dataTable, i);
                    }
                }

                chart.draw(dataTable, options);
            };

            // Watches, to refresh the chart when its data, title or dimensions change
            $scope.$watch('data', function () {
                $scope.drawChart();
            }, true); // true is for deep object equality checking

            // Chart selection handler
            /*google.visualization.events.addListener(chart, 'select', function () {
                var selectedItem = chart.getSelection()[0];
                if (selectedItem) {
                    $scope.$apply(function () {
                        $scope.selectFn({chartId: parseInt($scope.chartId)});
                    });
                }
            });*/

            $scope.drawChart();
        }
    };
}]).directive('pieChart', function () {
    return {
        restrict: 'EA',
        scope: {
            data: '=data',
            selectFn: '&select'
        },
        link: function link($scope, $elm) {
            var chart = new google.visualization.PieChart($elm[0]);
            google.visualization.events.addListener(chart, 'error', function (googleError) {
                google.visualization.errors.removeError(googleError.id);
            });
            $scope.drawChart = function () {
                var data = google.visualization.arrayToDataTable($scope.data);

                // get width from the parent div one to fill in max the div
                var parentWidth = $($elm[0]).parent().css("width");
                var width = parseInt(parentWidth.substr(0, parentWidth.length - 2));

                var height = $(window).height() / 2;

                if (width < height) height = width;

                var options = {
                    title: "",
                    width: width,
                    height: height,
                    pieSliceText: 'label',
                    pieSliceTextStyle: { fontSize: 12 },
                    chartArea: { width: '90%', height: '90%' }
                };

                chart.draw(data, options);
            };

            // Watches, to refresh the chart when its data, title or dimensions change
            $scope.$watch('data', function () {
                $scope.drawChart();
            }, true); // true is for deep object equality checking

            // Chart selection handler
            google.visualization.events.addListener(chart, 'select', function () {
                var selectedItem = chart.getSelection()[0];
                if (selectedItem) {
                    $scope.$apply(function () {
                        $scope.selectFn({ selectedRowIndex: selectedItem.row + 1 });
                    });
                }
            });

            $scope.drawChart();
        }
    };
}).directive('pieChartPos', function () {
    return {
        restrict: 'EA',
        scope: {
            data: '=data',
            color: '=color',
            selectFn: '&select'
        },
        link: function link($scope, $elm) {
            var chart = new google.visualization.PieChart($elm[0]);
            google.visualization.events.addListener(chart, 'error', function (googleError) {
                google.visualization.errors.removeError(googleError.id);
            });
            $scope.drawChart = function () {
                // get width from the parent div one to fill in max the div
                var parentWidth = $($elm[0]).parent().css("width");
                var width = parseInt(parentWidth.substr(0, parentWidth.length - 2));

                var slicesColor = [];
                if ($scope.color != undefined && $scope.color != null) for (var i = 0; i < $scope.color.length; i++) {
                    slicesColor.push({ color: $scope.color[i] });
                }var data = google.visualization.arrayToDataTable($scope.data);
                var options = {
                    legend: { position: 'right', maxLines: 10, alignment: 'center', textStyle: { fontSize: 13 } },
                    title: "",
                    slices: slicesColor,
                    width: width,
                    height: 280,
                    pieHole: 0.4,
                    pieSliceText: 'none',
                    pieSliceTextStyle: { fontSize: 12 },
                    chartArea: { left: 0, width: '90%', height: '100%' }
                };

                chart.draw(data, options);
            };

            // Watches, to refresh the chart when its data, title or dimensions change
            $scope.$watch('data', function () {
                $scope.drawChart();
            }, true); // true is for deep object equality checking

            // Chart selection handler
            google.visualization.events.addListener(chart, 'select', function () {
                var selectedItem = chart.getSelection()[0];
                if (selectedItem) {
                    $scope.$apply(function () {
                        $scope.selectFn({ selectedRowIndex: selectedItem.row + 1 });
                    });
                }
            });

            $scope.drawChart();
        }
    };
}).directive('pieChartCategories', function () {
    return {
        restrict: 'EA',
        scope: {
            data: '=data',
            color: '=color',
            selectFn: '&select',
            sourceTree: '=sourcetree'
        },
        link: function link($scope, $elem) {
            var chart = new google.visualization.PieChart($elem[0]);
            google.visualization.events.addListener(chart, 'error', function (googleError) {
                google.visualization.errors.removeError(googleError.id);
            });
            $scope.drawChart = function () {
                var data = google.visualization.arrayToDataTable($scope.data);

                var slicesColor = [];

                if ($scope.color != undefined && $scope.color != null) for (var i = 0; i < $scope.color.length; i++) {
                    slicesColor.push({ color: $scope.color[i] });
                } // get width from the parent div one to fill in max the div
                var parentWidth = $($elem[0]).parent().css("width");
                var width = parseInt(parentWidth.substr(0, parentWidth.length - 2));

                var height = $(window).height() / 2;

                if (width < height) height = width;

                var options = {
                    title: "",
                    slices: slicesColor,
                    width: width,
                    height: height,
                    pieSliceText: 'label',
                    pieSliceTextStyle: { fontSize: 12 },
                    chartArea: { width: '90%', height: '90%' }
                };

                chart.draw(data, options);
            };

            // Watches, to refresh the chart when its data, title or dimensions change
            $scope.$watch('data', function () {
                $scope.drawChart();
            }, true); // true is for deep object equality checking

            // Chart selection handler
            google.visualization.events.addListener(chart, 'select', function () {
                var selectedItem = chart.getSelection()[0];
                if (selectedItem) {
                    $scope.$apply(function () {
                        $scope.selectFn({ selectedRowIndex: selectedItem.row, source: $scope.sourceTree });
                    });
                }
            });

            $scope.drawChart();
        }
    };
}).directive('barChart', function () {
    return {
        restrict: 'EA',
        scope: {
            width: '@width',
            height: '@height',
            vAxisTitle: '@titlevaxis',
            hAxisTitle: '@titlehaxis',
            data: '=data',
            selectFn: '&select'
        },
        link: function link($scope, $elm) {
            var chart = new google.visualization.BarChart($elm[0]);
            google.visualization.events.addListener(chart, 'error', function (googleError) {
                google.visualization.errors.removeError(googleError.id);
            });
            $scope.drawChart = function () {
                var data = google.visualization.arrayToDataTable($scope.data);

                var h = $scope.data.length * 30;
                var screenH = $(window).height() / 2;
                if (h > screenH) $scope.height = h;else $scope.height = screenH;

                var options = {
                    title: "",
                    vAxis: { title: $scope.vAxisTitle, titleTextStyle: { color: 'red' } },
                    hAxis: { title: $scope.hAxisTitle, maxValue: 100, minValue: 0, titleTextStyle: { color: 'red' } },
                    width: $scope.width,
                    height: $scope.height,
                    bar: { groupWidth: "75%" },
                    chartArea: { width: '60%', height: '90%', top: 10, right: 10 },
                    legend: "none"
                };

                chart.draw(data, options);
            };

            // Watches, to refresh the chart when its data, title or dimensions change
            $scope.$watch('data', function () {
                $scope.drawChart();
            }, true); // true is for deep object equality checking

            // Chart selection handler
            google.visualization.events.addListener(chart, 'select', function () {
                var selectedItem = chart.getSelection()[0];
                if (selectedItem) {
                    $scope.$apply(function () {
                        $scope.selectFn({ selectedRowIndex: selectedItem.row });
                    });
                }
            });

            $scope.drawChart();
        }
    };
}).directive('barChartStacked', ['ColorGraph', function (ColorGraph) {
    return {
        restrict: 'EA',
        scope: {
            vAxisTitle: '@titlevaxis',
            hAxisTitle: '@titlehaxis',
            data: '=data',
            selectFn: '&select'
        },
        link: function link($scope, $elm) {
            var chart = new google.visualization.BarChart($elm[0]);
            google.visualization.events.addListener(chart, 'error', function (googleError) {
                google.visualization.errors.removeError(googleError.id);
            });
            $scope.drawChart = function () {
                var data = google.visualization.arrayToDataTable($scope.data);

                var max = 0;
                for (var i = 1; i < $scope.data.length; i++) {
                    if ($scope.data[i][1] + $scope.data[i][4] > max) max = Math.round($scope.data[i][1] + $scope.data[i][4]);
                }
                var screenH = $(window).height() / 2;

                // get width from the parent div one to fill in max the div
                var parentWidth = $($elm[0]).parent().parent().css("width"); // .parent().parent() : get good div (class="row") in the DOM (cf dashboard.html)
                var width = parseInt(parentWidth.substr(0, parentWidth.length - 2)) - 20; // "1145px" -> 1145

                var options = {
                    title: "",
                    vAxis: { title: $scope.vAxisTitle, titleTextStyle: { color: 'red' } },
                    hAxis: { title: $scope.hAxisTitle, titleTextStyle: { color: 'red' }, maxValue: max, gridlines: { count: 6 } },
                    width: width,
                    height: screenH,
                    bar: { groupWidth: "75%" },
                    chartArea: { width: '70%', height: '85%', top: 10, right: 10 },
                    isStacked: true,
                    colors: ColorGraph.colors
                };
                /*var options = {
                    title: "",
                    titleTextStyle: {
                        color: "",
                        fontName: "",
                        fontSize: 15,
                        bold: true,
                        italic: true
                    },
                    tooltip: {
                        trigger: 'none'
                    },
                    width: width/3,
                    height: height,
                    bar: { groupWidth: "90%" },
                    legend: { position: "none" },
                    vAxis: {
                        maxValue: max,
                        minValue: 0,
                        textStyle: {
                            color: "",
                            fontName: "",
                            fontSize: 13,
                            bold: false,
                            italic: false
                        }
                    },
                    hAxis: {
                        textStyle: {
                            color: "",
                            fontName: "",
                            fontSize: 13,
                            bold: false,
                            italic: false
                        }
                    },
                    chartArea: { width: '60%', height: '80%' }
                    /!*,
                     animation: {
                     duration: 1000,
                     easing: 'inAndOut'
                     }*!/
                };*/

                chart.draw(data, options);
            };
            // Watches, to refresh the chart when its data, title or dimensions change
            $scope.$watch('data', function () {
                $scope.drawChart();
            }, true); // true is for deep object equality checking

            // Chart selection handler
            google.visualization.events.addListener(chart, 'select', function () {
                var selectedItem = chart.getSelection()[0];
                if (selectedItem) {
                    $scope.$apply(function () {
                        $scope.selectFn({ selectedRowIndex: selectedItem.row });
                    });
                }
            });
            $scope.drawChart();
        }
    };
}]).directive('onLongPress', ['$timeout', function ($timeout) {
    return {
        restrict: 'A',
        link: function link($scope, $elm, $attrs) {
            $elm.bind('touchstart', function (evt) {
                // Locally scoped variable that will keep track of the long press
                $scope.longPress = true;

                // We'll set a timeout for 600 ms for a long press
                $timeout(function () {
                    if ($scope.longPress) {
                        // If the touchend event hasn't fired,
                        // apply the function given in on the element's on-long-press attribute
                        $scope.$apply(function () {
                            $scope.$eval($attrs.onLongPress);
                        });
                    }
                }, 600);
            });

            $elm.bind('touchend', function (evt) {
                // Prevent the onLongPress event from firing
                $scope.longPress = false;
                // If there is an on-touch-end function attached to this element, apply it
                if ($attrs.onTouchEnd) {
                    $scope.$apply(function () {
                        $scope.$eval($attrs.onTouchEnd);
                    });
                }
            });
        }
    };
}]).directive('companyModelInput', ['gettextCatalog', function (gettextCatalog) {
    return {
        restrict: 'E',
        scope: {
            startModel: '=startModel',
            startModelLabel: "=?startModelLabel"
        },
        templateUrl: '/partials/group/company/companyModelInput.html',
        link: function link($scope) {
            $scope.onModelChange = function () {
                if (!$scope.startModelLabel && $scope.startModelLabel !== '') switch ($scope.startModel) {
                    case "flexymodel1":
                        $scope.startModelLabel = gettextCatalog.getString("Salon de coiffure");
                        break;
                    case "flexymodel2":
                        $scope.startModelLabel = gettextCatalog.getString("Institut de beauté");
                        break;
                    case "flexymodel3":
                        $scope.startModelLabel = gettextCatalog.getString("Spa");
                        break;
                    case "flexymodel5":
                        $scope.startModelLabel = gettextCatalog.getString("Salon de coiffure l'Oréal");
                        break;
                    default:
                        $scope.startModelLabel = gettextCatalog.getString("Autre");
                        break;
                }
            };
        }
    };
}]).directive("tooltipsModal", function () {
    return {
        restrict: 'E',
        scope: {
            position: '@tooltipsPosition',
            title: '@tooltipsTitle',
            description: '@tooltipsDescription',
            picture: '@tooltipsPicture',
            button: '@tooltipsButton',
            ngClick: '&tooltipsNgClick'
        },
        templateUrl: '/partials/flexyBeauty/dialog/tooltips.html'
    };
}).directive('techNoteTable', [function () {
    return {
        restrict: 'E',
        scope: {
            itemView: '=itemView',
            pTView: '=pTView',
            posView: '=posView',
            customerView: '=customerView'
        },
        templateUrl: '/partials/planningPos/customer/techNoteTable.html',
        controller: ['$scope', "Images", function ($scope, Images) {
            $scope.bookingStatusImage = Images.saleStatus;
            $scope.showBookingOrSale = function (bookingOrSaleView) {
                if (!$scope.itemView) {
                    if (bookingOrSaleView.isBooking) {
                        $scope.pTView.setAndDisplayEditedBookingViewFromIndex(bookingOrSaleView.index);
                    } else {
                        $scope.posView.setEditedSaleViewFromIndex(bookingOrSaleView.index);
                    }
                }
            };
        }]
    };
}]).directive('customerForm', ["Brand", function (Brand) {
    return {
        restrict: 'E',
        scope: {
            customer: '=customer',
            isReadOnly: '=isReadOnly',
            onlineReservationAccess: '=onlineReservationAccess',
            clientFullAccess: '=clientFullAccess',
            customClass: '@customClass',
            cancel: '&cancel',
            save: '&save'
        },
        templateUrl: '/partials/planningPos/customer/customerForm.html',
        controller: ['$scope', function ($scope) {
            $scope.dateOptions = {
                startingDay: 1,
                datepickerMode: 'day',
                language: 'fr'
            };
            $scope.displayErrorMobile = false;
            $scope.displayErrorLandline = false;
            $scope.dateOpened = false;
            $scope.brand = Brand;

            $scope.toggleOpened = function () {
                $scope.dateOpened = !$scope.dateOpened;
            };

            $scope.onCancel = function () {
                $scope.cancel();
            };

            $scope.onSave = function () {
                if ($scope.customerForm.$valid && !$scope.displayErrorMobile && !$scope.displayErrorLandline) {
                    $scope.save();
                }
            };
        }]
    };
}]);

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('ExternalServiceLoader', ["$filter", "$location", "bugsnag", "LanguageManager", "HumanResourceData", "SupportedLocales", function ($filter, $location, bugsnag, LanguageManager, HumanResourceData, SupportedLocales) {
    var externalServiceLoader = {};

    externalServiceLoader.initFullStory = function (loggedUser, currentUser) {
        try {
            if (loggedUser) {
                var fullStoryId = loggedUser.company.code + (currentUser ? "_" + currentUser.token : ""),
                    fullStoryName = loggedUser.company.name + (currentUser ? "_" + currentUser.token : "");

                if (loggedUser.company.type === 'partner') {
                    window['_fs_debug'] = false;
                    window['_fs_host'] = 'fullstory.com';
                    window['_fs_org'] = 'D6VXA';
                    window['_fs_namespace'] = 'FS';
                    (function (m, n, e, t, l, o, g, y) {
                        if (e in m) {
                            if (m.console && m.console.log) {
                                m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');
                            }
                            return;
                        }
                        g = m[e] = function (a, b) {
                            g.q ? g.q.push([a, b]) : g._api(a, b);
                        };
                        g.q = [];
                        o = n.createElement(t);
                        o.async = 1;
                        o.src = 'https://' + _fs_host + '/s/fs.js';
                        y = n.getElementsByTagName(t)[0];
                        y.parentNode.insertBefore(o, y);
                        g.identify = function (i, v) {
                            g(l, { uid: i });
                            if (v) g(l, v);
                        };
                        g.setUserVars = function (v) {
                            g(l, v);
                        };
                        g.event = function (v) {
                            g('event', { n: i, p: v });
                        };
                        g.shutdown = function () {
                            g("rec", !1);
                        };
                        g.restart = function () {
                            g("rec", !0);
                        };
                        g.consent = function (a) {
                            g("consent", !arguments.length || a);
                        };
                        g.identifyAccount = function (i, v) {
                            o = 'account';
                            v = v || {};
                            v.acctId = i;
                            g(o, v);
                        };
                        g.clearUserCookie = function () {};
                    })(window, document, window['_fs_namespace'], 'script', 'user');

                    // This is an example script - don't forget to change it!
                    FS.identify(fullStoryId, {
                        displayName: fullStoryName,
                        email: loggedUser.email,
                        // TODO: Add your own custom user variables here, details at
                        // http://help.fullstory.com/develop-js/setuservars
                        reviewsWritten_int: 14,
                        "flexyApplication": "proSite"
                    });
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    externalServiceLoader.initBugsnag = function (loggedUser) {
        try {
            if (loggedUser) {
                if (loggedUser.serverIdentification && loggedUser.serverIdentification.applicationId && loggedUser.serverIdentification.version) {
                    if (loggedUser.serverIdentification.applicationId !== "bsiflexyprod") {
                        bugsnag.releaseStage = "development";
                    }
                    bugsnag.appVersion = loggedUser.serverIdentification.version;
                }
                bugsnag.user = {
                    id: loggedUser.company.code,
                    name: loggedUser.company.name,
                    email: loggedUser.email
                };
            }
        } catch (error) {
            console.error(error);
        }
    };

    externalServiceLoader.initChameleon = function (loggedUser, activeOfferCode) {
        try {
            var CHAMELEON_DISPLAY_PERIOD = 2;
            var timeCreated = loggedUser.company.timeCreated;

            if (timeCreated) {
                var currentDate = new Date();
                var limitDateForChameleon = new Date();
                limitDateForChameleon.setFullYear(timeCreated.getFullYear());
                limitDateForChameleon.setMonth(timeCreated.getMonth() + CHAMELEON_DISPLAY_PERIOD);
                limitDateForChameleon.setDate(timeCreated.getDate());
                limitDateForChameleon.setHours(timeCreated.getHours());
                limitDateForChameleon.setMinutes(timeCreated.getMinutes());
                limitDateForChameleon.setSeconds(timeCreated.getSeconds());
                if (currentDate < limitDateForChameleon) {
                    var formattedTimeCreated = $filter('date')(timeCreated, 'yyyy-MM-ddTHH:mm:ssZ');

                    var chmlnSnippet = document.createElement('script');
                    chmlnSnippet.type = 'text/javascript';
                    chmlnSnippet.async = true;
                    chmlnSnippet.text = '/* Chameleon - better user onboarding */!function(t,n,o){var a="chmln",e="adminPreview",c="setup identify alias track clear set show on off custom help _data".split(" ");if(n[a]||(n[a]={}),n[a][e]&&(n[a][e]=!1),!n[a].root){n[a].accountToken=o,n[a].location=n.location.href.toString(),n[a].now=new Date;for(var s=0;s<c.length;s++)!function(){var t=n[a][c[s]+"_a"]=[];n[a][c[s]]=function(){t.push(arguments)}}();var i=t.createElement("script");i.src="https://fast.trychameleon.com/messo/"+o+"/messo.min.js",i.async=!0,t.head.appendChild(i)}}(document,window,"SIVZzaHSq2DTB8ETPRQZixuRPjHmFAoo9VCNFOZXBsROwa-1FnEti-AEc6qBIRcsYwH9o8");';
                    document.head.appendChild(chmlnSnippet);

                    if (activeOfferCode) {
                        chmln.identify({
                            uid: loggedUser.id, // Unique ID of each user in your database (e.g. 23443 or "590b80e5f433ea81b96c9bf6")
                            email: loggedUser.email, // Put quotes around text strings (e.g. "jim@example.com")
                            created: formattedTimeCreated,
                            company: { // For B2B products, send company / account information here
                                uid: loggedUser.company.code, // Unique ID of the company / account in your database (e.g. 9832 or "590b80e5f433ea81b96c9bf7")
                                name: loggedUser.company.type, // Send any data that appears within URLs, such as subdomains (e.g. "airbnb")
                                plan: activeOfferCode,
                                spend: LanguageManager.getLanguageCode()
                            }
                        });
                    }
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    externalServiceLoader.initLokalise = function () {
        try {
            if (LanguageManager.canAccessLiveEdit()) {
                window.LOKALISE_CONFIG = {
                    projectId: "625966535b44b267eeeae8.51499813",
                    locale: LanguageManager.locale.gettextLocale
                };
                (function () {
                    var a = document.createElement("script");
                    a.type = "text/javascript";
                    a.async = !0;
                    a.src = ["https://lokalise.co/live-js/script.min.js?", new Date().getTime()].join("");
                    document.body.appendChild(a);
                })();
            }
        } catch (error) {
            console.error(error);
        }
    };

    externalServiceLoader.initIntercom = function (loggedUser, activeOffer, intercomAppId) {
        try {
            if (loggedUser && loggedUser.company && activeOffer) {
                var arr = $location.absUrl().split("/"),
                    startUrl = arr[0] + "//" + arr[2],
                    nbHr = 1,
                    hrList = HumanResourceData.getActiveList();

                if (hrList) nbHr = hrList.length;

                if (window.Intercom && Upscope) {
                    window.Intercom("boot", {
                        app_id: intercomAppId,
                        user_id: loggedUser.id,
                        name: loggedUser.firstName + " " + loggedUser.lastName, // Full name
                        email: loggedUser.email, // Email address
                        phone: loggedUser.phone,
                        created_at: loggedUser.company.timeCreated, // Signup date as a Unix timestamp
                        company: {
                            id: loggedUser.company.code,
                            name: loggedUser.company.name,
                            type: loggedUser.company.type,
                            connectUrl: startUrl + "/fxbAdmin/" + loggedUser.company.code,
                            created_at: loggedUser.company.timeCreated,
                            plan: activeOffer.code,
                            monthly_spend: activeOffer.price,
                            industry: loggedUser.company.startModel,
                            mangopay_ID: loggedUser.company.companyPaymentData ? loggedUser.company.companyPaymentData.userId : null,
                            size: nbHr,
                            country: loggedUser.company.country,
                            website: startUrl + "/" + loggedUser.company.code
                        }
                    });
                    Upscope('init', {
                        // Optionally set the user ID below. If you don't have it, it doesn't matter,
                        // Upscope will integrate with your live chat system anyway.
                        uniqueId: loggedUser.id,
                        // Optionally set the user name or email below (e.g. ["John Smith", "john.smith@acme.com"])
                        identities: [loggedUser.firstName + " " + loggedUser.lastName, loggedUser.email]
                    });

                    if (!LanguageManager.isFrenchLanguage()) {
                        window.intercomSettings = {
                            app_id: intercomAppId,
                            language_override: SupportedLocales["en"]["GB"].languageCode
                        };
                        window.Intercom('update', intercomSettings);
                    }
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    return externalServiceLoader;
}]);

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('KycDocumentStatus', ['gettextCatalog', function (gettextCatalog) {
    return {
        VALIDATION_ASKED: {
            id: 'VALIDATION_ASKED',
            label: gettextCatalog.getString("En cours")
        },
        VALIDATED: {
            id: 'VALIDATED',
            label: gettextCatalog.getString("Document validé")
        },
        REFUSED: {
            id: 'REFUSED',
            label: gettextCatalog.getString("Document refusé")
        }
    };
}]);

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('KycDocumentType', ['gettextCatalog', function (gettextCatalog) {
    return {
        ARTICLES_OF_ASSOCIATION: {
            id: "articlesOfAssociation",
            label: gettextCatalog.getString("Une copie des statuts de l'entreprise")
        },
        IDENTITY_PROOF: {
            id: "identityProof",
            label: gettextCatalog.getString("Pièce d’identité, passeport ou permis de conduire de l’ensemble des bénéficiaires.")
        },
        REGISTRATION_PROOF: {
            id: "registrationProof",
            label: gettextCatalog.getString("K-bis de moins de 3 mois ou (document INSEE si non enregistré au registre du Commerce)."),
            link: "https://www.infogreffe.fr/documents-officiels/demande-kbis.html"
        }
    };
}]);

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('KycRefusedReason', ['gettextCatalog', function (gettextCatalog) {
    return {
        DOCUMENT_UNREADABLE: {
            id: 'DOCUMENT_UNREADABLE',
            label: gettextCatalog.getString("Le document n'est pas lisible (le scan est de mauvaise qualité et le document est flou, tronqué ou il y a un reflet).")
        },
        DOCUMENT_NOT_ACCEPTED: {
            id: 'DOCUMENT_NOT_ACCEPTED',
            label: gettextCatalog.getString("Le document n'a pas été accepté car il ne respecte pas les conditions générales de la certification (non signé, non valide, incomplet).")
        },
        DOCUMENT_HAS_EXPIRED: {
            id: 'DOCUMENT_HAS_EXPIRED',
            label: gettextCatalog.getString("Le document n'est plus valide ou n'est pas à jour (il ne contient pas les dernières modifications).")
        },
        DOCUMENT_INCOMPLETE: {
            id: 'DOCUMENT_INCOMPLETE',
            label: gettextCatalog.getString("Le document est incomplet. Il peut manquer des pages, des signatures ou des changements récents.")
        },
        DOCUMENT_DO_NOT_MATCH_ACCOUNT_DATA: {
            id: 'DOCUMENT_DO_NOT_MATCH_ACCOUNT_DATA',
            label: gettextCatalog.getString("Le nom associé au compte bancaire ne correspond pas au nom du propriétaire du compte.")
        },
        SPECIFIC_CASE: {
            id: 'SPECIFIC_CASE',
            label: gettextCatalog.getString("Aucune raison standard n’a été détectée pour ce compte.")
        },
        DOCUMENT_FALSIFIED: {
            id: 'DOCUMENT_FALSIFIED',
            label: gettextCatalog.getString("Le document est reconnu comme falsifié.")
        },
        UNDERAGE_PERSON: {
            id: 'UNDERAGE_PERSON',
            label: gettextCatalog.getString("La personne n'a pas l'age légal.")
        },
        DOCUMENT_DO_NOT_MATCH_USER_DATA: {
            id: 'DOCUMENT_DO_NOT_MATCH_USER_DATA',
            label: gettextCatalog.getString("Le nom sur le document d'identité ne correspond pas au nom associé au compte.")
        },
        DOCUMENT_MISSING: {
            id: 'DOCUMENT_MISSING',
            label: gettextCatalog.getString("Le document est manquant.")
        },
        TRIGGER_PEPS: {
            id: 'TRIGGER_PEPS',
            label: gettextCatalog.getString("Autre raison : Veuillez nous contacter.")
        },
        TRIGGER_INTERPOL: {
            id: 'TRIGGER_INTERPOL',
            label: gettextCatalog.getString("Autre raison : Veuillez nous contacter.")
        },
        TRIGGER_SANCTIONS_LISTS: {
            id: 'TRIGGER_SANCTIONS_LISTS',
            label: gettextCatalog.getString("Autre raison : Veuillez nous contacter.")
        }
    };
}]);

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('KycStatusConstants', ['gettextCatalog', function (gettextCatalog) {
    var kycStatus = {
        NOT_CERTIFIED: {
            key: 'notCertified',
            label: gettextCatalog.getString("Non certifié")
        },
        VALIDATION_ASKED: {
            key: 'validating',
            label: gettextCatalog.getString("En cours de certification")
        },
        INCOMPLETE: {
            key: 'incomplete',
            label: gettextCatalog.getString("Dossier à compléter")
        },
        CERTIFIED: {
            key: 'certified',
            label: gettextCatalog.getString("Certifié")
        }
    };

    kycStatus.getStatusByKey = function (key) {
        for (var status in kycStatus) {
            if (kycStatus[status].key === key) {
                return kycStatus[status];
            }
        }
    };

    return kycStatus;
}]);

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('LegalType', ['gettextCatalog', function (gettextCatalog) {
    return {
        SOLETRADER: {
            id: "SOLETRADER",
            label: gettextCatalog.getString("un auto-entrepreneur")
        },
        SARL: {
            id: "BUSINESS",
            label: gettextCatalog.getString("une entreprise (SARL, SA, SAS, SASU, EURL...)")
        },
        from: function from(legalType) {
            var entrepriseType = this.SARL;

            if (legalType && legalType === this.SOLETRADER.id) {
                entrepriseType = this.SOLETRADER;
            }
            return entrepriseType;
        }
    };
}]);

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('UboStatementView', ["UboStatementData", "UboStatementSrv", "UboStatement", "Ubo", "UboView", "UboStatus", function (UboStatementData, UboStatementSrv, UboStatement, Ubo, UboView, UboStatus) {
    var UboStatementView = function UboStatementView(uboStatement) {
        this.id = null;
        this.details = null;
        this.status = null;
        this.timeCreated = null;

        this.ubosView = [];

        if (uboStatement) {
            this.loadDataFrom(uboStatement);
        }
    };

    UboStatementView.prototype.loadDataFrom = function (uboStatement) {
        this.id = uboStatement.id;
        this.details = uboStatement.details;
        this.status = uboStatement.status;
        this.timeCreated = uboStatement.timeCreated;
        for (var i = 0; i < uboStatement.ubos.length; i++) {
            var uboView = new UboView(uboStatement.ubos[i]);
            if (this.status && this.status !== UboStatus.INCOMPLETE.id) {
                uboView.isReadOnly = true;
            }
            this.ubosView.push(uboView);
        }
    };

    UboStatementView.prototype.getModel = function () {
        return UboStatementData.getById(this.id) || new UboStatement();
    };

    UboStatementView.prototype.updateModel = function () {
        var uboStatement = this.getModel();
        for (var i = 0; i < this.ubosView.length; i++) {
            var ubo = uboStatement.ubos[i];
            if (!ubo) {
                ubo = new Ubo();
                uboStatement.ubos.push(ubo);
            }
            this.ubosView[i].copyDataTo(ubo);
        }

        return uboStatement.id ? UboStatementSrv.update(uboStatement) : UboStatementSrv.save(uboStatement);
    };

    return UboStatementView;
}]);

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('UboStatus', ['gettextCatalog', function (gettextCatalog) {
    return {
        VALIDATING: {
            id: 'validating',
            label: gettextCatalog.getString("Déclaration En cours")
        },
        VALIDATED: {
            id: 'validated',
            label: gettextCatalog.getString("Déclaration validée")
        },
        REFUSED: {
            id: 'refused',
            label: gettextCatalog.getString("Déclaration refusée")
        },
        INCOMPLETE: {
            id: 'incomplete',
            label: gettextCatalog.getString("Déclaration incomplète")
        },
        NOTCREATED: {
            id: 'notCreated',
            label: gettextCatalog.getString("Déclaration n'a pas été transmise à MangoPay")
        }
    };
}]);

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('UboView', ["Countries", function (Countries) {
    var UboView = function UboView(ubo) {
        this.localId = null;
        this.firstName = null;
        this.lastName = null;
        this.isReadOnly = false;
        this.nationalityCountryCode = Countries.FRANCE.countryCode;
        this.address = {
            addressLine1: null,
            addressLine2: null,
            city: null,
            region: null,
            postalCode: null,
            countryCode: Countries.FRANCE.countryCode
        };

        this.birth = {
            day: null,
            city: null,
            countryCode: Countries.FRANCE.countryCode
        };

        if (ubo) {
            this.loadDataFrom(ubo);
        }
    };

    UboView.prototype.loadDataFrom = function (ubo) {
        if (ubo.id) {
            this.id = ubo.id;
            this.localId = ubo.id;
        }

        this.firstName = ubo.firstName;
        this.lastName = ubo.lastName;
        this.nationalityCountryCode = ubo.nationalityCountryCode;
        this.address.addressLine1 = ubo.address.addressLine1;
        this.address.addressLine2 = ubo.address.addressLine2;
        this.address.city = ubo.address.city;
        this.address.region = ubo.address.region;
        this.address.postalCode = ubo.address.postalCode;
        this.address.countryCode = ubo.address.countryCode;
        this.birth.day = ubo.birth.day;
        this.birth.city = ubo.birth.city;
        this.birth.countryCode = ubo.birth.countryCode;
    };

    UboView.prototype.copyDataTo = function (ubo) {
        if (this.id) {
            ubo.id = this.id;
        }
        ubo.firstName = this.firstName;
        ubo.lastName = this.lastName;
        ubo.nationalityCountryCode = this.nationalityCountryCode;
        ubo.address.addressLine1 = this.address.addressLine1;
        ubo.address.addressLine2 = this.address.addressLine2;
        ubo.address.city = this.address.city;
        ubo.address.region = this.address.region;
        ubo.address.postalCode = this.address.postalCode;
        ubo.address.countryCode = this.address.countryCode;
        ubo.birth.day = this.birth.day;
        ubo.birth.city = this.birth.city;
        ubo.birth.countryCode = this.birth.countryCode;
    };

    return UboView;
}]);

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var specificationSync = __webpack_require__(183).SpecificationSync;

var createSpecification = function createSpecification(isSatisfiedByFunction) {
    var specificationObject = function specificationObject() {};
    specificationObject.prototype = Object.create(specificationSync);
    specificationObject.prototype.isSatisfiedBy = isSatisfiedByFunction;
    return specificationObject;
};

angular.module("FlexyBeautyApp.services").factory("KycSpecifications", ["LanguageManager", "LegalType", "KycStatusConstants", function (LanguageManager, LegalType, KycStatusConstants) {
    var specifications = {};

    specifications.KycSelfCertification = createSpecification(function () {
        return LanguageManager.isFrenchLanguage();
    });

    specifications.SelfContractor = createSpecification(function (loggedUser) {
        return loggedUser.company.legalType === LegalType.SOLETRADER.id;
    });

    specifications.KycCertification = createSpecification(function (kycLevel) {
        return kycLevel === KycStatusConstants.CERTIFIED.key;
    });

    specifications.KycNotCertified = createSpecification(function (kycLevel) {
        return kycLevel === KycStatusConstants.NOT_CERTIFIED.key;
    });

    return specifications;
}]);

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var specificationSync = __webpack_require__(183).SpecificationSync;

var createSpecification = function createSpecification(isSatisfiedByFunction) {
    var specificationObject = function specificationObject() {};
    specificationObject.prototype = Object.create(specificationSync);
    specificationObject.prototype.isSatisfiedBy = isSatisfiedByFunction;
    return specificationObject;
};

angular.module("FlexyBeautyApp.services").factory("MarketPlaceSpecifications", ["BasicAuthRole", function (BasicAuthRole) {
    var specifications = {};

    specifications.MarketPlaceCompliant = createSpecification(function (companyView, isManagerMode) {
        var marketplaceBasicAuthRole = BasicAuthRole.LE_CISEAU_ROLE;
        return marketplaceBasicAuthRole.isCompanyTypeCompliant(companyView) && marketplaceBasicAuthRole.isCountryCompliant(companyView) && marketplaceBasicAuthRole.isAccountTypeCompliant(companyView) && isManagerMode;
    });

    return specifications;
}]);

/***/ }),

/***/ 801:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(283);
__webpack_require__(312);
__webpack_require__(314);
__webpack_require__(331);
__webpack_require__(354);
__webpack_require__(344);
__webpack_require__(341);
__webpack_require__(340);
__webpack_require__(342);
__webpack_require__(343);
__webpack_require__(346);
__webpack_require__(347);
__webpack_require__(350);
__webpack_require__(348);
__webpack_require__(349);
__webpack_require__(345);
__webpack_require__(123);
__webpack_require__(333);
__webpack_require__(353);
__webpack_require__(351);
__webpack_require__(339);
__webpack_require__(335);
__webpack_require__(365);
__webpack_require__(334);
__webpack_require__(313);
__webpack_require__(40);
__webpack_require__(362);
__webpack_require__(359);
__webpack_require__(364);
__webpack_require__(363);
__webpack_require__(361);
__webpack_require__(360);
__webpack_require__(315);
__webpack_require__(366);
__webpack_require__(44);
__webpack_require__(367);
__webpack_require__(465);
__webpack_require__(467);
__webpack_require__(466);
__webpack_require__(469);
__webpack_require__(468);
__webpack_require__(397);
__webpack_require__(402);
__webpack_require__(400);
__webpack_require__(401);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(482);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(355);
__webpack_require__(444);
__webpack_require__(524);
__webpack_require__(36);
__webpack_require__(525);
__webpack_require__(337);
__webpack_require__(336);
module.exports = __webpack_require__(332);


/***/ })

},[801]);


// WEBPACK FOOTER //
// pro.bundle.min.afde57a91cf638242a95.js